/******/ (function(modules) { // webpackBootstrap
/******/ 	// The module cache
/******/ 	var installedModules = {};
/******/
/******/ 	// The require function
/******/ 	function __webpack_require__(moduleId) {
/******/
/******/ 		// Check if module is in cache
/******/ 		if(installedModules[moduleId])
/******/ 			return installedModules[moduleId].exports;
/******/
/******/ 		// Create a new module (and put it into the cache)
/******/ 		var module = installedModules[moduleId] = {
/******/ 			exports: {},
/******/ 			id: moduleId,
/******/ 			loaded: false
/******/ 		};
/******/
/******/ 		// Execute the module function
/******/ 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);
/******/
/******/ 		// Flag the module as loaded
/******/ 		module.loaded = true;
/******/
/******/ 		// Return the exports of the module
/******/ 		return module.exports;
/******/ 	}
/******/
/******/
/******/ 	// expose the modules object (__webpack_modules__)
/******/ 	__webpack_require__.m = modules;
/******/
/******/ 	// expose the module cache
/******/ 	__webpack_require__.c = installedModules;
/******/
/******/ 	// __webpack_public_path__
/******/ 	__webpack_require__.p = "/";
/******/
/******/ 	// Load entry module and return exports
/******/ 	return __webpack_require__(0);
/******/ })
/************************************************************************/
/******/ ([
/* 0 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var _vue = __webpack_require__(10);
	
	var _vue2 = _interopRequireDefault(_vue);
	
	var _App = __webpack_require__(267);
	
	var _App2 = _interopRequireDefault(_App);
	
	var _vInject = __webpack_require__(89);
	
	var _vInject2 = _interopRequireDefault(_vInject);
	
	var _TmButton = __webpack_require__(274);
	
	var _TmButton2 = _interopRequireDefault(_TmButton);
	
	var _TmSpinner = __webpack_require__(276);
	
	var _TmSpinner2 = _interopRequireDefault(_TmSpinner);
	
	var _vuikit = __webpack_require__(46);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	_vue2.default.directive('inject', _vInject2.default);
	_vue2.default.component('AdminManager', _App2.default);
	_vue2.default.component('TmButton', _TmButton2.default);
	_vue2.default.component('TmSpinner', _TmSpinner2.default);
	_vue2.default.component('VkButton', _vuikit.Button);
	_vue2.default.component('VkModal', _vuikit.Modal);
	_vue2.default.component('VkModalConfirm', _vuikit.ModalConfirm);
	
	_vue2.default.http.options.emulateHTTP = true;
	_vue2.default.http.options.emulateJSON = true;
	_vue2.default.http.interceptors.push({
	  response: function response(_response) {
	    if (_response.data !== 'OK' && !_vue2.default.util.isObject(_response.data)) {
	      _response.status = 500;
	      _response.ok = false;
	      _response.data = {
	        error: stripTags(_response.data),
	        message: 'Something went wrong with that request. Please try again\n          or contact our support for further assistance.'
	      };
	    }
	    return _response;
	  }
	});
	
	var stripTags = function stripTags(input, allowed) {
	  allowed = (((allowed || '') + '').toLowerCase().match(/<[a-z][a-z0-9]*>/g) || []).join('');
	  var tags = /<\/?([a-z][a-z0-9]*)\b[^>]*>/gi;
	  var commentsAndPhpTags = /<!--[\s\S]*?-->|<\?(?:php)?[\s\S]*?\?>/gi;
	  return input.replace(commentsAndPhpTags, '').replace(tags, function ($0, $1) {
	    return allowed.indexOf('<' + $1.toLowerCase() + '>') > -1 ? $0 : '';
	  });
	};

/***/ },
/* 1 */
/***/ function(module, exports) {

	/**
	 * Checks if `value` is classified as an `Array` object.
	 *
	 * @static
	 * @memberOf _
	 * @since 0.1.0
	 * @type {Function}
	 * @category Lang
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is correctly classified,
	 *  else `false`.
	 * @example
	 *
	 * _.isArray([1, 2, 3]);
	 * // => true
	 *
	 * _.isArray(document.body.children);
	 * // => false
	 *
	 * _.isArray('abc');
	 * // => false
	 *
	 * _.isArray(_.noop);
	 * // => false
	 */
	var isArray = Array.isArray;
	
	module.exports = isArray;


/***/ },
/* 2 */
/***/ function(module, exports, __webpack_require__) {

	var baseMatches = __webpack_require__(164),
	    baseMatchesProperty = __webpack_require__(165),
	    identity = __webpack_require__(80),
	    isArray = __webpack_require__(1),
	    property = __webpack_require__(247);
	
	/**
	 * The base implementation of `_.iteratee`.
	 *
	 * @private
	 * @param {*} [value=_.identity] The value to convert to an iteratee.
	 * @returns {Function} Returns the iteratee.
	 */
	function baseIteratee(value) {
	  // Don't store the `typeof` result in a variable to avoid a JIT bug in Safari 9.
	  // See https://bugs.webkit.org/show_bug.cgi?id=156034 for more details.
	  if (typeof value == 'function') {
	    return value;
	  }
	  if (value == null) {
	    return identity;
	  }
	  if (typeof value == 'object') {
	    return isArray(value)
	      ? baseMatchesProperty(value[0], value[1])
	      : baseMatches(value);
	  }
	  return property(value);
	}
	
	module.exports = baseIteratee;


/***/ },
/* 3 */
/***/ function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(global) {var checkGlobal = __webpack_require__(176);
	
	/** Detect free variable `global` from Node.js. */
	var freeGlobal = checkGlobal(typeof global == 'object' && global);
	
	/** Detect free variable `self`. */
	var freeSelf = checkGlobal(typeof self == 'object' && self);
	
	/** Detect `this` as the global object. */
	var thisGlobal = checkGlobal(typeof this == 'object' && this);
	
	/** Used as a reference to the global object. */
	var root = freeGlobal || freeSelf || thisGlobal || Function('return this')();
	
	module.exports = root;
	
	/* WEBPACK VAR INJECTION */}.call(exports, (function() { return this; }())))

/***/ },
/* 4 */
/***/ function(module, exports) {

	/**
	 * Checks if `value` is the
	 * [language type](http://www.ecma-international.org/ecma-262/6.0/#sec-ecmascript-language-types)
	 * of `Object`. (e.g. arrays, functions, objects, regexes, `new Number(0)`, and `new String('')`)
	 *
	 * @static
	 * @memberOf _
	 * @since 0.1.0
	 * @category Lang
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is an object, else `false`.
	 * @example
	 *
	 * _.isObject({});
	 * // => true
	 *
	 * _.isObject([1, 2, 3]);
	 * // => true
	 *
	 * _.isObject(_.noop);
	 * // => true
	 *
	 * _.isObject(null);
	 * // => false
	 */
	function isObject(value) {
	  var type = typeof value;
	  return !!value && (type == 'object' || type == 'function');
	}
	
	module.exports = isObject;


/***/ },
/* 5 */
/***/ function(module, exports, __webpack_require__) {

	var baseHas = __webpack_require__(62),
	    baseKeys = __webpack_require__(162),
	    indexKeys = __webpack_require__(72),
	    isArrayLike = __webpack_require__(8),
	    isIndex = __webpack_require__(20),
	    isPrototype = __webpack_require__(42);
	
	/**
	 * Creates an array of the own enumerable property names of `object`.
	 *
	 * **Note:** Non-object values are coerced to objects. See the
	 * [ES spec](http://ecma-international.org/ecma-262/6.0/#sec-object.keys)
	 * for more details.
	 *
	 * @static
	 * @since 0.1.0
	 * @memberOf _
	 * @category Object
	 * @param {Object} object The object to query.
	 * @returns {Array} Returns the array of property names.
	 * @example
	 *
	 * function Foo() {
	 *   this.a = 1;
	 *   this.b = 2;
	 * }
	 *
	 * Foo.prototype.c = 3;
	 *
	 * _.keys(new Foo);
	 * // => ['a', 'b'] (iteration order is not guaranteed)
	 *
	 * _.keys('hi');
	 * // => ['0', '1']
	 */
	function keys(object) {
	  var isProto = isPrototype(object);
	  if (!(isProto || isArrayLike(object))) {
	    return baseKeys(object);
	  }
	  var indexes = indexKeys(object),
	      skipIndexes = !!indexes,
	      result = indexes || [],
	      length = result.length;
	
	  for (var key in object) {
	    if (baseHas(object, key) &&
	        !(skipIndexes && (key == 'length' || isIndex(key, length))) &&
	        !(isProto && key == 'constructor')) {
	      result.push(key);
	    }
	  }
	  return result;
	}
	
	module.exports = keys;


/***/ },
/* 6 */
/***/ function(module, exports, __webpack_require__) {

	var baseForOwn = __webpack_require__(59),
	    createBaseEach = __webpack_require__(189);
	
	/**
	 * The base implementation of `_.forEach` without support for iteratee shorthands.
	 *
	 * @private
	 * @param {Array|Object} collection The collection to iterate over.
	 * @param {Function} iteratee The function invoked per iteration.
	 * @returns {Array|Object} Returns `collection`.
	 */
	var baseEach = createBaseEach(baseForOwn);
	
	module.exports = baseEach;


/***/ },
/* 7 */
/***/ function(module, exports, __webpack_require__) {

	var baseIsNative = __webpack_require__(161),
	    getValue = __webpack_require__(199);
	
	/**
	 * Gets the native function at `key` of `object`.
	 *
	 * @private
	 * @param {Object} object The object to query.
	 * @param {string} key The key of the method to get.
	 * @returns {*} Returns the function if it's native, else `undefined`.
	 */
	function getNative(object, key) {
	  var value = getValue(object, key);
	  return baseIsNative(value) ? value : undefined;
	}
	
	module.exports = getNative;


/***/ },
/* 8 */
/***/ function(module, exports, __webpack_require__) {

	var getLength = __webpack_require__(196),
	    isFunction = __webpack_require__(12),
	    isLength = __webpack_require__(26);
	
	/**
	 * Checks if `value` is array-like. A value is considered array-like if it's
	 * not a function and has a `value.length` that's an integer greater than or
	 * equal to `0` and less than or equal to `Number.MAX_SAFE_INTEGER`.
	 *
	 * @static
	 * @memberOf _
	 * @since 4.0.0
	 * @category Lang
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is array-like, else `false`.
	 * @example
	 *
	 * _.isArrayLike([1, 2, 3]);
	 * // => true
	 *
	 * _.isArrayLike(document.body.children);
	 * // => true
	 *
	 * _.isArrayLike('abc');
	 * // => true
	 *
	 * _.isArrayLike(_.noop);
	 * // => false
	 */
	function isArrayLike(value) {
	  return value != null && isLength(getLength(value)) && !isFunction(value);
	}
	
	module.exports = isArrayLike;


/***/ },
/* 9 */
/***/ function(module, exports) {

	/**
	 * Checks if `value` is object-like. A value is object-like if it's not `null`
	 * and has a `typeof` result of "object".
	 *
	 * @static
	 * @memberOf _
	 * @since 4.0.0
	 * @category Lang
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is object-like, else `false`.
	 * @example
	 *
	 * _.isObjectLike({});
	 * // => true
	 *
	 * _.isObjectLike([1, 2, 3]);
	 * // => true
	 *
	 * _.isObjectLike(_.noop);
	 * // => false
	 *
	 * _.isObjectLike(null);
	 * // => false
	 */
	function isObjectLike(value) {
	  return !!value && typeof value == 'object';
	}
	
	module.exports = isObjectLike;


/***/ },
/* 10 */
/***/ function(module, exports) {

	module.exports = Vue;

/***/ },
/* 11 */
/***/ function(module, exports, __webpack_require__) {

	var isSymbol = __webpack_require__(13);
	
	/** Used as references for various `Number` constants. */
	var INFINITY = 1 / 0;
	
	/**
	 * Converts `value` to a string key if it's not a string or symbol.
	 *
	 * @private
	 * @param {*} value The value to inspect.
	 * @returns {string|symbol} Returns the key.
	 */
	function toKey(value) {
	  if (typeof value == 'string' || isSymbol(value)) {
	    return value;
	  }
	  var result = (value + '');
	  return (result == '0' && (1 / value) == -INFINITY) ? '-0' : result;
	}
	
	module.exports = toKey;


/***/ },
/* 12 */
/***/ function(module, exports, __webpack_require__) {

	var isObject = __webpack_require__(4);
	
	/** `Object#toString` result references. */
	var funcTag = '[object Function]',
	    genTag = '[object GeneratorFunction]';
	
	/** Used for built-in method references. */
	var objectProto = Object.prototype;
	
	/**
	 * Used to resolve the
	 * [`toStringTag`](http://ecma-international.org/ecma-262/6.0/#sec-object.prototype.tostring)
	 * of values.
	 */
	var objectToString = objectProto.toString;
	
	/**
	 * Checks if `value` is classified as a `Function` object.
	 *
	 * @static
	 * @memberOf _
	 * @since 0.1.0
	 * @category Lang
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is correctly classified,
	 *  else `false`.
	 * @example
	 *
	 * _.isFunction(_);
	 * // => true
	 *
	 * _.isFunction(/abc/);
	 * // => false
	 */
	function isFunction(value) {
	  // The use of `Object#toString` avoids issues with the `typeof` operator
	  // in Safari 8 which returns 'object' for typed array and weak map constructors,
	  // and PhantomJS 1.9 which returns 'function' for `NodeList` instances.
	  var tag = isObject(value) ? objectToString.call(value) : '';
	  return tag == funcTag || tag == genTag;
	}
	
	module.exports = isFunction;


/***/ },
/* 13 */
/***/ function(module, exports, __webpack_require__) {

	var isObjectLike = __webpack_require__(9);
	
	/** `Object#toString` result references. */
	var symbolTag = '[object Symbol]';
	
	/** Used for built-in method references. */
	var objectProto = Object.prototype;
	
	/**
	 * Used to resolve the
	 * [`toStringTag`](http://ecma-international.org/ecma-262/6.0/#sec-object.prototype.tostring)
	 * of values.
	 */
	var objectToString = objectProto.toString;
	
	/**
	 * Checks if `value` is classified as a `Symbol` primitive or object.
	 *
	 * @static
	 * @memberOf _
	 * @since 4.0.0
	 * @category Lang
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is correctly classified,
	 *  else `false`.
	 * @example
	 *
	 * _.isSymbol(Symbol.iterator);
	 * // => true
	 *
	 * _.isSymbol('abc');
	 * // => false
	 */
	function isSymbol(value) {
	  return typeof value == 'symbol' ||
	    (isObjectLike(value) && objectToString.call(value) == symbolTag);
	}
	
	module.exports = isSymbol;


/***/ },
/* 14 */
/***/ function(module, exports, __webpack_require__) {

	var listCacheClear = __webpack_require__(214),
	    listCacheDelete = __webpack_require__(215),
	    listCacheGet = __webpack_require__(216),
	    listCacheHas = __webpack_require__(217),
	    listCacheSet = __webpack_require__(218);
	
	/**
	 * Creates an list cache object.
	 *
	 * @private
	 * @constructor
	 * @param {Array} [entries] The key-value pairs to cache.
	 */
	function ListCache(entries) {
	  var index = -1,
	      length = entries ? entries.length : 0;
	
	  this.clear();
	  while (++index < length) {
	    var entry = entries[index];
	    this.set(entry[0], entry[1]);
	  }
	}
	
	// Add methods to `ListCache`.
	ListCache.prototype.clear = listCacheClear;
	ListCache.prototype['delete'] = listCacheDelete;
	ListCache.prototype.get = listCacheGet;
	ListCache.prototype.has = listCacheHas;
	ListCache.prototype.set = listCacheSet;
	
	module.exports = ListCache;


/***/ },
/* 15 */
/***/ function(module, exports, __webpack_require__) {

	var ListCache = __webpack_require__(14),
	    stackClear = __webpack_require__(226),
	    stackDelete = __webpack_require__(227),
	    stackGet = __webpack_require__(228),
	    stackHas = __webpack_require__(229),
	    stackSet = __webpack_require__(230);
	
	/**
	 * Creates a stack cache object to store key-value pairs.
	 *
	 * @private
	 * @constructor
	 * @param {Array} [entries] The key-value pairs to cache.
	 */
	function Stack(entries) {
	  this.__data__ = new ListCache(entries);
	}
	
	// Add methods to `Stack`.
	Stack.prototype.clear = stackClear;
	Stack.prototype['delete'] = stackDelete;
	Stack.prototype.get = stackGet;
	Stack.prototype.has = stackHas;
	Stack.prototype.set = stackSet;
	
	module.exports = Stack;


/***/ },
/* 16 */
/***/ function(module, exports, __webpack_require__) {

	var eq = __webpack_require__(24);
	
	/**
	 * Gets the index at which the `key` is found in `array` of key-value pairs.
	 *
	 * @private
	 * @param {Array} array The array to search.
	 * @param {*} key The key to search for.
	 * @returns {number} Returns the index of the matched value, else `-1`.
	 */
	function assocIndexOf(array, key) {
	  var length = array.length;
	  while (length--) {
	    if (eq(array[length][0], key)) {
	      return length;
	    }
	  }
	  return -1;
	}
	
	module.exports = assocIndexOf;


/***/ },
/* 17 */
/***/ function(module, exports, __webpack_require__) {

	var isKeyable = __webpack_require__(211);
	
	/**
	 * Gets the data for `map`.
	 *
	 * @private
	 * @param {Object} map The map to query.
	 * @param {string} key The reference key.
	 * @returns {*} Returns the map data.
	 */
	function getMapData(map, key) {
	  var data = map.__data__;
	  return isKeyable(key)
	    ? data[typeof key == 'string' ? 'string' : 'hash']
	    : data.map;
	}
	
	module.exports = getMapData;


/***/ },
/* 18 */
/***/ function(module, exports) {

	/* Built-in method references for those with the same name as other `lodash` methods. */
	var nativeGetPrototype = Object.getPrototypeOf;
	
	/**
	 * Gets the `[[Prototype]]` of `value`.
	 *
	 * @private
	 * @param {*} value The value to query.
	 * @returns {null|Object} Returns the `[[Prototype]]`.
	 */
	function getPrototype(value) {
	  return nativeGetPrototype(Object(value));
	}
	
	module.exports = getPrototype;


/***/ },
/* 19 */
/***/ function(module, exports) {

	/**
	 * Checks if `value` is a host object in IE < 9.
	 *
	 * @private
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is a host object, else `false`.
	 */
	function isHostObject(value) {
	  // Many host objects are `Object` objects that can coerce to strings
	  // despite having improperly defined `toString` methods.
	  var result = false;
	  if (value != null && typeof value.toString != 'function') {
	    try {
	      result = !!(value + '');
	    } catch (e) {}
	  }
	  return result;
	}
	
	module.exports = isHostObject;


/***/ },
/* 20 */
/***/ function(module, exports) {

	/** Used as references for various `Number` constants. */
	var MAX_SAFE_INTEGER = 9007199254740991;
	
	/** Used to detect unsigned integer values. */
	var reIsUint = /^(?:0|[1-9]\d*)$/;
	
	/**
	 * Checks if `value` is a valid array-like index.
	 *
	 * @private
	 * @param {*} value The value to check.
	 * @param {number} [length=MAX_SAFE_INTEGER] The upper bounds of a valid index.
	 * @returns {boolean} Returns `true` if `value` is a valid index, else `false`.
	 */
	function isIndex(value, length) {
	  length = length == null ? MAX_SAFE_INTEGER : length;
	  return !!length &&
	    (typeof value == 'number' || reIsUint.test(value)) &&
	    (value > -1 && value % 1 == 0 && value < length);
	}
	
	module.exports = isIndex;


/***/ },
/* 21 */
/***/ function(module, exports, __webpack_require__) {

	var eq = __webpack_require__(24),
	    isArrayLike = __webpack_require__(8),
	    isIndex = __webpack_require__(20),
	    isObject = __webpack_require__(4);
	
	/**
	 * Checks if the given arguments are from an iteratee call.
	 *
	 * @private
	 * @param {*} value The potential iteratee value argument.
	 * @param {*} index The potential iteratee index or key argument.
	 * @param {*} object The potential iteratee object argument.
	 * @returns {boolean} Returns `true` if the arguments are from an iteratee call,
	 *  else `false`.
	 */
	function isIterateeCall(value, index, object) {
	  if (!isObject(object)) {
	    return false;
	  }
	  var type = typeof index;
	  if (type == 'number'
	        ? (isArrayLike(object) && isIndex(index, object.length))
	        : (type == 'string' && index in object)
	      ) {
	    return eq(object[index], value);
	  }
	  return false;
	}
	
	module.exports = isIterateeCall;


/***/ },
/* 22 */
/***/ function(module, exports, __webpack_require__) {

	var isArray = __webpack_require__(1),
	    isSymbol = __webpack_require__(13);
	
	/** Used to match property names within property paths. */
	var reIsDeepProp = /\.|\[(?:[^[\]]*|(["'])(?:(?!\1)[^\\]|\\.)*?\1)\]/,
	    reIsPlainProp = /^\w*$/;
	
	/**
	 * Checks if `value` is a property name and not a property path.
	 *
	 * @private
	 * @param {*} value The value to check.
	 * @param {Object} [object] The object to query keys on.
	 * @returns {boolean} Returns `true` if `value` is a property name, else `false`.
	 */
	function isKey(value, object) {
	  if (isArray(value)) {
	    return false;
	  }
	  var type = typeof value;
	  if (type == 'number' || type == 'symbol' || type == 'boolean' ||
	      value == null || isSymbol(value)) {
	    return true;
	  }
	  return reIsPlainProp.test(value) || !reIsDeepProp.test(value) ||
	    (object != null && value in Object(object));
	}
	
	module.exports = isKey;


/***/ },
/* 23 */
/***/ function(module, exports, __webpack_require__) {

	var getNative = __webpack_require__(7);
	
	/* Built-in method references that are verified to be native. */
	var nativeCreate = getNative(Object, 'create');
	
	module.exports = nativeCreate;


/***/ },
/* 24 */
/***/ function(module, exports) {

	/**
	 * Performs a
	 * [`SameValueZero`](http://ecma-international.org/ecma-262/6.0/#sec-samevaluezero)
	 * comparison between two values to determine if they are equivalent.
	 *
	 * @static
	 * @memberOf _
	 * @since 4.0.0
	 * @category Lang
	 * @param {*} value The value to compare.
	 * @param {*} other The other value to compare.
	 * @returns {boolean} Returns `true` if the values are equivalent, else `false`.
	 * @example
	 *
	 * var object = { 'user': 'fred' };
	 * var other = { 'user': 'fred' };
	 *
	 * _.eq(object, object);
	 * // => true
	 *
	 * _.eq(object, other);
	 * // => false
	 *
	 * _.eq('a', 'a');
	 * // => true
	 *
	 * _.eq('a', Object('a'));
	 * // => false
	 *
	 * _.eq(NaN, NaN);
	 * // => true
	 */
	function eq(value, other) {
	  return value === other || (value !== value && other !== other);
	}
	
	module.exports = eq;


/***/ },
/* 25 */
/***/ function(module, exports, __webpack_require__) {

	var isArrayLikeObject = __webpack_require__(81);
	
	/** `Object#toString` result references. */
	var argsTag = '[object Arguments]';
	
	/** Used for built-in method references. */
	var objectProto = Object.prototype;
	
	/** Used to check objects for own properties. */
	var hasOwnProperty = objectProto.hasOwnProperty;
	
	/**
	 * Used to resolve the
	 * [`toStringTag`](http://ecma-international.org/ecma-262/6.0/#sec-object.prototype.tostring)
	 * of values.
	 */
	var objectToString = objectProto.toString;
	
	/** Built-in value references. */
	var propertyIsEnumerable = objectProto.propertyIsEnumerable;
	
	/**
	 * Checks if `value` is likely an `arguments` object.
	 *
	 * @static
	 * @memberOf _
	 * @since 0.1.0
	 * @category Lang
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is correctly classified,
	 *  else `false`.
	 * @example
	 *
	 * _.isArguments(function() { return arguments; }());
	 * // => true
	 *
	 * _.isArguments([1, 2, 3]);
	 * // => false
	 */
	function isArguments(value) {
	  // Safari 8.1 incorrectly makes `arguments.callee` enumerable in strict mode.
	  return isArrayLikeObject(value) && hasOwnProperty.call(value, 'callee') &&
	    (!propertyIsEnumerable.call(value, 'callee') || objectToString.call(value) == argsTag);
	}
	
	module.exports = isArguments;


/***/ },
/* 26 */
/***/ function(module, exports) {

	/** Used as references for various `Number` constants. */
	var MAX_SAFE_INTEGER = 9007199254740991;
	
	/**
	 * Checks if `value` is a valid array-like length.
	 *
	 * **Note:** This function is loosely based on
	 * [`ToLength`](http://ecma-international.org/ecma-262/6.0/#sec-tolength).
	 *
	 * @static
	 * @memberOf _
	 * @since 4.0.0
	 * @category Lang
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is a valid length,
	 *  else `false`.
	 * @example
	 *
	 * _.isLength(3);
	 * // => true
	 *
	 * _.isLength(Number.MIN_VALUE);
	 * // => false
	 *
	 * _.isLength(Infinity);
	 * // => false
	 *
	 * _.isLength('3');
	 * // => false
	 */
	function isLength(value) {
	  return typeof value == 'number' &&
	    value > -1 && value % 1 == 0 && value <= MAX_SAFE_INTEGER;
	}
	
	module.exports = isLength;


/***/ },
/* 27 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.show = show;
	exports.login = login;
	exports.logout = logout;
	
	var _authentication = __webpack_require__(86);
	
	var _authentication2 = _interopRequireDefault(_authentication);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function show(_ref) {
	  var dispatch = _ref.dispatch;
	
	  dispatch('SHOW_AUTH');
	}
	
	function login(_ref2, username, password) {
	  var dispatch = _ref2.dispatch;
	  var state = _ref2.state;
	
	  dispatch('LOGIN_REQUEST');
	  return _authentication2.default.login(username, password, function (data) {
	    data.status ? dispatch('LOGIN_SUCCESS', data.user) : dispatch('LOGIN_FAILURE', data.message);
	  }, function (response) {
	    return dispatch('SHOW_MODAL', {
	      text: response.data.message,
	      requestError: response.data.error,
	      icon: ['uk-icon-times', 'uk-text-danger']
	    });
	  });
	}
	
	function logout(_ref3) {
	  var dispatch = _ref3.dispatch;
	
	  return _authentication2.default.logout(function () {
	    dispatch('LOGOUT');
	  }, function (response) {
	    return dispatch('SHOW_MODAL', {
	      text: response.data.message,
	      requestError: response.data.error,
	      icon: ['uk-icon-times', 'uk-text-danger']
	    });
	  });
	}

/***/ },
/* 28 */
/***/ function(module, exports) {

	var core = module.exports = {version: '2.4.0'};
	if(typeof __e == 'number')__e = core; // eslint-disable-line no-undef

/***/ },
/* 29 */
/***/ function(module, exports, __webpack_require__) {

	// Thank's IE8 for his funny defineProperty
	module.exports = !__webpack_require__(30)(function(){
	  return Object.defineProperty({}, 'a', {get: function(){ return 7; }}).a != 7;
	});

/***/ },
/* 30 */
/***/ function(module, exports) {

	module.exports = function(exec){
	  try {
	    return !!exec();
	  } catch(e){
	    return true;
	  }
	};

/***/ },
/* 31 */
/***/ function(module, exports) {

	// https://github.com/zloirock/core-js/issues/86#issuecomment-115759028
	var global = module.exports = typeof window != 'undefined' && window.Math == Math
	  ? window : typeof self != 'undefined' && self.Math == Math ? self : Function('return this')();
	if(typeof __g == 'number')__g = global; // eslint-disable-line no-undef

/***/ },
/* 32 */
/***/ function(module, exports) {

	module.exports = function(it){
	  return typeof it === 'object' ? it !== null : typeof it === 'function';
	};

/***/ },
/* 33 */
/***/ function(module, exports, __webpack_require__) {

	var mapCacheClear = __webpack_require__(219),
	    mapCacheDelete = __webpack_require__(220),
	    mapCacheGet = __webpack_require__(221),
	    mapCacheHas = __webpack_require__(222),
	    mapCacheSet = __webpack_require__(223);
	
	/**
	 * Creates a map cache object to store key-value pairs.
	 *
	 * @private
	 * @constructor
	 * @param {Array} [entries] The key-value pairs to cache.
	 */
	function MapCache(entries) {
	  var index = -1,
	      length = entries ? entries.length : 0;
	
	  this.clear();
	  while (++index < length) {
	    var entry = entries[index];
	    this.set(entry[0], entry[1]);
	  }
	}
	
	// Add methods to `MapCache`.
	MapCache.prototype.clear = mapCacheClear;
	MapCache.prototype['delete'] = mapCacheDelete;
	MapCache.prototype.get = mapCacheGet;
	MapCache.prototype.has = mapCacheHas;
	MapCache.prototype.set = mapCacheSet;
	
	module.exports = MapCache;


/***/ },
/* 34 */
/***/ function(module, exports, __webpack_require__) {

	var root = __webpack_require__(3);
	
	/** Built-in value references. */
	var Symbol = root.Symbol;
	
	module.exports = Symbol;


/***/ },
/* 35 */
/***/ function(module, exports) {

	/**
	 * A specialized version of `_.forEach` for arrays without support for
	 * iteratee shorthands.
	 *
	 * @private
	 * @param {Array} [array] The array to iterate over.
	 * @param {Function} iteratee The function invoked per iteration.
	 * @returns {Array} Returns `array`.
	 */
	function arrayEach(array, iteratee) {
	  var index = -1,
	      length = array ? array.length : 0;
	
	  while (++index < length) {
	    if (iteratee(array[index], index, array) === false) {
	      break;
	    }
	  }
	  return array;
	}
	
	module.exports = arrayEach;


/***/ },
/* 36 */
/***/ function(module, exports) {

	/**
	 * A specialized version of `_.map` for arrays without support for iteratee
	 * shorthands.
	 *
	 * @private
	 * @param {Array} [array] The array to iterate over.
	 * @param {Function} iteratee The function invoked per iteration.
	 * @returns {Array} Returns the new mapped array.
	 */
	function arrayMap(array, iteratee) {
	  var index = -1,
	      length = array ? array.length : 0,
	      result = Array(length);
	
	  while (++index < length) {
	    result[index] = iteratee(array[index], index, array);
	  }
	  return result;
	}
	
	module.exports = arrayMap;


/***/ },
/* 37 */
/***/ function(module, exports) {

	/**
	 * Appends the elements of `values` to `array`.
	 *
	 * @private
	 * @param {Array} array The array to modify.
	 * @param {Array} values The values to append.
	 * @returns {Array} Returns `array`.
	 */
	function arrayPush(array, values) {
	  var index = -1,
	      length = values.length,
	      offset = array.length;
	
	  while (++index < length) {
	    array[offset + index] = values[index];
	  }
	  return array;
	}
	
	module.exports = arrayPush;


/***/ },
/* 38 */
/***/ function(module, exports) {

	/**
	 * A specialized version of `_.reduce` for arrays without support for
	 * iteratee shorthands.
	 *
	 * @private
	 * @param {Array} [array] The array to iterate over.
	 * @param {Function} iteratee The function invoked per iteration.
	 * @param {*} [accumulator] The initial value.
	 * @param {boolean} [initAccum] Specify using the first element of `array` as
	 *  the initial value.
	 * @returns {*} Returns the accumulated value.
	 */
	function arrayReduce(array, iteratee, accumulator, initAccum) {
	  var index = -1,
	      length = array ? array.length : 0;
	
	  if (initAccum && length) {
	    accumulator = array[++index];
	  }
	  while (++index < length) {
	    accumulator = iteratee(accumulator, array[index], index, array);
	  }
	  return accumulator;
	}
	
	module.exports = arrayReduce;


/***/ },
/* 39 */
/***/ function(module, exports, __webpack_require__) {

	var Uint8Array = __webpack_require__(52);
	
	/**
	 * Creates a clone of `arrayBuffer`.
	 *
	 * @private
	 * @param {ArrayBuffer} arrayBuffer The array buffer to clone.
	 * @returns {ArrayBuffer} Returns the cloned array buffer.
	 */
	function cloneArrayBuffer(arrayBuffer) {
	  var result = new arrayBuffer.constructor(arrayBuffer.byteLength);
	  new Uint8Array(result).set(new Uint8Array(arrayBuffer));
	  return result;
	}
	
	module.exports = cloneArrayBuffer;


/***/ },
/* 40 */
/***/ function(module, exports, __webpack_require__) {

	var assignValue = __webpack_require__(56);
	
	/**
	 * Copies properties of `source` to `object`.
	 *
	 * @private
	 * @param {Object} source The object to copy properties from.
	 * @param {Array} props The property identifiers to copy.
	 * @param {Object} [object={}] The object to copy properties to.
	 * @param {Function} [customizer] The function to customize copied values.
	 * @returns {Object} Returns `object`.
	 */
	function copyObject(source, props, object, customizer) {
	  object || (object = {});
	
	  var index = -1,
	      length = props.length;
	
	  while (++index < length) {
	    var key = props[index];
	
	    var newValue = customizer
	      ? customizer(object[key], source[key], key, object, source)
	      : source[key];
	
	    assignValue(object, key, newValue);
	  }
	  return object;
	}
	
	module.exports = copyObject;


/***/ },
/* 41 */
/***/ function(module, exports, __webpack_require__) {

	var stubArray = __webpack_require__(251);
	
	/** Built-in value references. */
	var getOwnPropertySymbols = Object.getOwnPropertySymbols;
	
	/**
	 * Creates an array of the own enumerable symbol properties of `object`.
	 *
	 * @private
	 * @param {Object} object The object to query.
	 * @returns {Array} Returns the array of symbols.
	 */
	function getSymbols(object) {
	  // Coerce `object` to an object to avoid non-object errors in V8.
	  // See https://bugs.chromium.org/p/v8/issues/detail?id=3443 for more details.
	  return getOwnPropertySymbols(Object(object));
	}
	
	// Fallback for IE < 11.
	if (!getOwnPropertySymbols) {
	  getSymbols = stubArray;
	}
	
	module.exports = getSymbols;


/***/ },
/* 42 */
/***/ function(module, exports) {

	/** Used for built-in method references. */
	var objectProto = Object.prototype;
	
	/**
	 * Checks if `value` is likely a prototype object.
	 *
	 * @private
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is a prototype, else `false`.
	 */
	function isPrototype(value) {
	  var Ctor = value && value.constructor,
	      proto = (typeof Ctor == 'function' && Ctor.prototype) || objectProto;
	
	  return value === proto;
	}
	
	module.exports = isPrototype;


/***/ },
/* 43 */
/***/ function(module, exports, __webpack_require__) {

	var isLength = __webpack_require__(26),
	    isObjectLike = __webpack_require__(9);
	
	/** `Object#toString` result references. */
	var argsTag = '[object Arguments]',
	    arrayTag = '[object Array]',
	    boolTag = '[object Boolean]',
	    dateTag = '[object Date]',
	    errorTag = '[object Error]',
	    funcTag = '[object Function]',
	    mapTag = '[object Map]',
	    numberTag = '[object Number]',
	    objectTag = '[object Object]',
	    regexpTag = '[object RegExp]',
	    setTag = '[object Set]',
	    stringTag = '[object String]',
	    weakMapTag = '[object WeakMap]';
	
	var arrayBufferTag = '[object ArrayBuffer]',
	    dataViewTag = '[object DataView]',
	    float32Tag = '[object Float32Array]',
	    float64Tag = '[object Float64Array]',
	    int8Tag = '[object Int8Array]',
	    int16Tag = '[object Int16Array]',
	    int32Tag = '[object Int32Array]',
	    uint8Tag = '[object Uint8Array]',
	    uint8ClampedTag = '[object Uint8ClampedArray]',
	    uint16Tag = '[object Uint16Array]',
	    uint32Tag = '[object Uint32Array]';
	
	/** Used to identify `toStringTag` values of typed arrays. */
	var typedArrayTags = {};
	typedArrayTags[float32Tag] = typedArrayTags[float64Tag] =
	typedArrayTags[int8Tag] = typedArrayTags[int16Tag] =
	typedArrayTags[int32Tag] = typedArrayTags[uint8Tag] =
	typedArrayTags[uint8ClampedTag] = typedArrayTags[uint16Tag] =
	typedArrayTags[uint32Tag] = true;
	typedArrayTags[argsTag] = typedArrayTags[arrayTag] =
	typedArrayTags[arrayBufferTag] = typedArrayTags[boolTag] =
	typedArrayTags[dataViewTag] = typedArrayTags[dateTag] =
	typedArrayTags[errorTag] = typedArrayTags[funcTag] =
	typedArrayTags[mapTag] = typedArrayTags[numberTag] =
	typedArrayTags[objectTag] = typedArrayTags[regexpTag] =
	typedArrayTags[setTag] = typedArrayTags[stringTag] =
	typedArrayTags[weakMapTag] = false;
	
	/** Used for built-in method references. */
	var objectProto = Object.prototype;
	
	/**
	 * Used to resolve the
	 * [`toStringTag`](http://ecma-international.org/ecma-262/6.0/#sec-object.prototype.tostring)
	 * of values.
	 */
	var objectToString = objectProto.toString;
	
	/**
	 * Checks if `value` is classified as a typed array.
	 *
	 * @static
	 * @memberOf _
	 * @since 3.0.0
	 * @category Lang
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is correctly classified,
	 *  else `false`.
	 * @example
	 *
	 * _.isTypedArray(new Uint8Array);
	 * // => true
	 *
	 * _.isTypedArray([]);
	 * // => false
	 */
	function isTypedArray(value) {
	  return isObjectLike(value) &&
	    isLength(value.length) && !!typedArrayTags[objectToString.call(value)];
	}
	
	module.exports = isTypedArray;


/***/ },
/* 44 */
/***/ function(module, exports, __webpack_require__) {

	var baseKeysIn = __webpack_require__(163),
	    indexKeys = __webpack_require__(72),
	    isIndex = __webpack_require__(20),
	    isPrototype = __webpack_require__(42);
	
	/** Used for built-in method references. */
	var objectProto = Object.prototype;
	
	/** Used to check objects for own properties. */
	var hasOwnProperty = objectProto.hasOwnProperty;
	
	/**
	 * Creates an array of the own and inherited enumerable property names of `object`.
	 *
	 * **Note:** Non-object values are coerced to objects.
	 *
	 * @static
	 * @memberOf _
	 * @since 3.0.0
	 * @category Object
	 * @param {Object} object The object to query.
	 * @returns {Array} Returns the array of property names.
	 * @example
	 *
	 * function Foo() {
	 *   this.a = 1;
	 *   this.b = 2;
	 * }
	 *
	 * Foo.prototype.c = 3;
	 *
	 * _.keysIn(new Foo);
	 * // => ['a', 'b', 'c'] (iteration order is not guaranteed)
	 */
	function keysIn(object) {
	  var index = -1,
	      isProto = isPrototype(object),
	      props = baseKeysIn(object),
	      propsLength = props.length,
	      indexes = indexKeys(object),
	      skipIndexes = !!indexes,
	      result = indexes || [],
	      length = result.length;
	
	  while (++index < propsLength) {
	    var key = props[index];
	    if (!(skipIndexes && (key == 'length' || isIndex(key, length))) &&
	        !(key == 'constructor' && (isProto || !hasOwnProperty.call(object, key)))) {
	      result.push(key);
	    }
	  }
	  return result;
	}
	
	module.exports = keysIn;


/***/ },
/* 45 */
/***/ function(module, exports, __webpack_require__) {

	var apply = __webpack_require__(148),
	    toInteger = __webpack_require__(84);
	
	/** Used as the `TypeError` message for "Functions" methods. */
	var FUNC_ERROR_TEXT = 'Expected a function';
	
	/* Built-in method references for those with the same name as other `lodash` methods. */
	var nativeMax = Math.max;
	
	/**
	 * Creates a function that invokes `func` with the `this` binding of the
	 * created function and arguments from `start` and beyond provided as
	 * an array.
	 *
	 * **Note:** This method is based on the
	 * [rest parameter](https://mdn.io/rest_parameters).
	 *
	 * @static
	 * @memberOf _
	 * @since 4.0.0
	 * @category Function
	 * @param {Function} func The function to apply a rest parameter to.
	 * @param {number} [start=func.length-1] The start position of the rest parameter.
	 * @returns {Function} Returns the new function.
	 * @example
	 *
	 * var say = _.rest(function(what, names) {
	 *   return what + ' ' + _.initial(names).join(', ') +
	 *     (_.size(names) > 1 ? ', & ' : '') + _.last(names);
	 * });
	 *
	 * say('hello', 'fred', 'barney', 'pebbles');
	 * // => 'hello fred, barney, & pebbles'
	 */
	function rest(func, start) {
	  if (typeof func != 'function') {
	    throw new TypeError(FUNC_ERROR_TEXT);
	  }
	  start = nativeMax(start === undefined ? (func.length - 1) : toInteger(start), 0);
	  return function() {
	    var args = arguments,
	        index = -1,
	        length = nativeMax(args.length - start, 0),
	        array = Array(length);
	
	    while (++index < length) {
	      array[index] = args[start + index];
	    }
	    switch (start) {
	      case 0: return func.call(this, array);
	      case 1: return func.call(this, args[0], array);
	      case 2: return func.call(this, args[0], args[1], array);
	    }
	    var otherArgs = Array(start + 1);
	    index = -1;
	    while (++index < start) {
	      otherArgs[index] = args[index];
	    }
	    otherArgs[start] = array;
	    return apply(func, this, otherArgs);
	  };
	}
	
	module.exports = rest;


/***/ },
/* 46 */
/***/ function(module, exports, __webpack_require__) {

	/*!
	 * Vuikit v0.0.1 (https://github.com/joolanders/vuikit)
	 * (c) 2016 ZOOlanders
	 * Released under the MIT License.
	 */
	module.exports =
	/******/ (function(modules) { // webpackBootstrap
	/******/ 	// The module cache
	/******/ 	var installedModules = {};
	
	/******/ 	// The require function
	/******/ 	function __webpack_require__(moduleId) {
	
	/******/ 		// Check if module is in cache
	/******/ 		if(installedModules[moduleId])
	/******/ 			return installedModules[moduleId].exports;
	
	/******/ 		// Create a new module (and put it into the cache)
	/******/ 		var module = installedModules[moduleId] = {
	/******/ 			exports: {},
	/******/ 			id: moduleId,
	/******/ 			loaded: false
	/******/ 		};
	
	/******/ 		// Execute the module function
	/******/ 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);
	
	/******/ 		// Flag the module as loaded
	/******/ 		module.loaded = true;
	
	/******/ 		// Return the exports of the module
	/******/ 		return module.exports;
	/******/ 	}
	
	
	/******/ 	// expose the modules object (__webpack_modules__)
	/******/ 	__webpack_require__.m = modules;
	
	/******/ 	// expose the module cache
	/******/ 	__webpack_require__.c = installedModules;
	
	/******/ 	// __webpack_public_path__
	/******/ 	__webpack_require__.p = "";
	
	/******/ 	// Load entry module and return exports
	/******/ 	return __webpack_require__(0);
	/******/ })
	/************************************************************************/
	/******/ ([
	/* 0 */
	/***/ function(module, exports, __webpack_require__) {
	
		'use strict';
	
		Object.defineProperty(exports, "__esModule", {
		  value: true
		});
		exports.default = exports.TabsVertical = exports.Tabs = exports.Tab = exports.Switch = exports.Switcher = exports.SubnavItem = exports.Subnav = exports.Progress = exports.Pagination = exports.ModalConfirm = exports.ModalAlert = exports.ModalBlank = exports.ModalLightbox = exports.Modal = exports.Datepicker = exports.Calendar = exports.ButtonRadio = exports.ButtonCheckbox = exports.ButtonLink = exports.Crumb = exports.Button = exports.Breadcrumb = exports.Alert = undefined;
	
		var _keys = __webpack_require__(91);
	
		var _keys2 = _interopRequireDefault(_keys);
	
		var _Alert = __webpack_require__(226);
	
		var _Alert2 = _interopRequireDefault(_Alert);
	
		var _Breadcrumb = __webpack_require__(227);
	
		var _Breadcrumb2 = _interopRequireDefault(_Breadcrumb);
	
		var _Button = __webpack_require__(60);
	
		var _Button2 = _interopRequireDefault(_Button);
	
		var _BreadcrumbItem = __webpack_require__(228);
	
		var _BreadcrumbItem2 = _interopRequireDefault(_BreadcrumbItem);
	
		var _ButtonLink = __webpack_require__(230);
	
		var _ButtonLink2 = _interopRequireDefault(_ButtonLink);
	
		var _ButtonCheckbox = __webpack_require__(229);
	
		var _ButtonCheckbox2 = _interopRequireDefault(_ButtonCheckbox);
	
		var _ButtonRadio = __webpack_require__(231);
	
		var _ButtonRadio2 = _interopRequireDefault(_ButtonRadio);
	
		var _Calendar = __webpack_require__(61);
	
		var _Calendar2 = _interopRequireDefault(_Calendar);
	
		var _Datepicker = __webpack_require__(232);
	
		var _Datepicker2 = _interopRequireDefault(_Datepicker);
	
		var _Modal = __webpack_require__(233);
	
		var _Modal2 = _interopRequireDefault(_Modal);
	
		var _ModalLightbox = __webpack_require__(237);
	
		var _ModalLightbox2 = _interopRequireDefault(_ModalLightbox);
	
		var _ModalBlank = __webpack_require__(235);
	
		var _ModalBlank2 = _interopRequireDefault(_ModalBlank);
	
		var _ModalAlert = __webpack_require__(234);
	
		var _ModalAlert2 = _interopRequireDefault(_ModalAlert);
	
		var _ModalConfirm = __webpack_require__(236);
	
		var _ModalConfirm2 = _interopRequireDefault(_ModalConfirm);
	
		var _Pagination = __webpack_require__(238);
	
		var _Pagination2 = _interopRequireDefault(_Pagination);
	
		var _Progress = __webpack_require__(239);
	
		var _Progress2 = _interopRequireDefault(_Progress);
	
		var _Subnav = __webpack_require__(240);
	
		var _Subnav2 = _interopRequireDefault(_Subnav);
	
		var _SubnavItem = __webpack_require__(241);
	
		var _SubnavItem2 = _interopRequireDefault(_SubnavItem);
	
		var _Switcher = __webpack_require__(242);
	
		var _Switcher2 = _interopRequireDefault(_Switcher);
	
		var _SwitcherItem = __webpack_require__(243);
	
		var _SwitcherItem2 = _interopRequireDefault(_SwitcherItem);
	
		var _Tab = __webpack_require__(244);
	
		var _Tab2 = _interopRequireDefault(_Tab);
	
		var _Tabs = __webpack_require__(245);
	
		var _Tabs2 = _interopRequireDefault(_Tabs);
	
		var _TabsVertical = __webpack_require__(246);
	
		var _TabsVertical2 = _interopRequireDefault(_TabsVertical);
	
		function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
		var vuikit = {
		  Alert: _Alert2.default,
		  Breadcrumb: _Breadcrumb2.default,
		  Button: _Button2.default,
		  Crumb: _BreadcrumbItem2.default,
		  ButtonLink: _ButtonLink2.default,
		  ButtonCheckbox: _ButtonCheckbox2.default,
		  ButtonRadio: _ButtonRadio2.default,
		  Calendar: _Calendar2.default,
		  Datepicker: _Datepicker2.default,
		  Modal: _Modal2.default,
		  ModalLightbox: _ModalLightbox2.default,
		  ModalBlank: _ModalBlank2.default,
		  ModalAlert: _ModalAlert2.default,
		  ModalConfirm: _ModalConfirm2.default,
		  Pagination: _Pagination2.default,
		  Progress: _Progress2.default,
		  Subnav: _Subnav2.default,
		  SubnavItem: _SubnavItem2.default,
		  Switcher: _Switcher2.default,
		  Switch: _SwitcherItem2.default,
		  Tab: _Tab2.default,
		  Tabs: _Tabs2.default,
		  TabsVertical: _TabsVertical2.default,
		  install: function install(Vue) {
		    if (this.installed) {
		      return;
		    }
		    var keys = (0, _keys2.default)(this);
		    keys.pop();
		    var i = keys.length;
		    while (i--) {
		      Vue.component('Vk' + keys[i], this[keys[i]]);
		    }
		  }
		};
	
		if (typeof window !== 'undefined' && window.Vue) {
		  window.Vue.use(vuikit);
		}
	
		exports.Alert = _Alert2.default;
		exports.Breadcrumb = _Breadcrumb2.default;
		exports.Button = _Button2.default;
		exports.Crumb = _BreadcrumbItem2.default;
		exports.ButtonLink = _ButtonLink2.default;
		exports.ButtonCheckbox = _ButtonCheckbox2.default;
		exports.ButtonRadio = _ButtonRadio2.default;
		exports.Calendar = _Calendar2.default;
		exports.Datepicker = _Datepicker2.default;
		exports.Modal = _Modal2.default;
		exports.ModalLightbox = _ModalLightbox2.default;
		exports.ModalBlank = _ModalBlank2.default;
		exports.ModalAlert = _ModalAlert2.default;
		exports.ModalConfirm = _ModalConfirm2.default;
		exports.Pagination = _Pagination2.default;
		exports.Progress = _Progress2.default;
		exports.Subnav = _Subnav2.default;
		exports.SubnavItem = _SubnavItem2.default;
		exports.Switcher = _Switcher2.default;
		exports.Switch = _SwitcherItem2.default;
		exports.Tab = _Tab2.default;
		exports.Tabs = _Tabs2.default;
		exports.TabsVertical = _TabsVertical2.default;
		exports.default = vuikit;
	
	/***/ },
	/* 1 */
	/***/ function(module, exports, __webpack_require__) {
	
		/* WEBPACK VAR INJECTION */(function(global) {var checkGlobal = __webpack_require__(147);
	
		/** Detect free variable `global` from Node.js. */
		var freeGlobal = checkGlobal(typeof global == 'object' && global);
	
		/** Detect free variable `self`. */
		var freeSelf = checkGlobal(typeof self == 'object' && self);
	
		/** Detect `this` as the global object. */
		var thisGlobal = checkGlobal(typeof this == 'object' && this);
	
		/** Used as a reference to the global object. */
		var root = freeGlobal || freeSelf || thisGlobal || Function('return this')();
	
		module.exports = root;
	
		/* WEBPACK VAR INJECTION */}.call(exports, (function() { return this; }())))
	
	/***/ },
	/* 2 */
	/***/ function(module, exports) {
	
		/**
		 * Checks if `value` is the
		 * [language type](http://www.ecma-international.org/ecma-262/6.0/#sec-ecmascript-language-types)
		 * of `Object`. (e.g. arrays, functions, objects, regexes, `new Number(0)`, and `new String('')`)
		 *
		 * @static
		 * @memberOf _
		 * @since 0.1.0
		 * @category Lang
		 * @param {*} value The value to check.
		 * @returns {boolean} Returns `true` if `value` is an object, else `false`.
		 * @example
		 *
		 * _.isObject({});
		 * // => true
		 *
		 * _.isObject([1, 2, 3]);
		 * // => true
		 *
		 * _.isObject(_.noop);
		 * // => true
		 *
		 * _.isObject(null);
		 * // => false
		 */
		function isObject(value) {
		  var type = typeof value;
		  return !!value && (type == 'object' || type == 'function');
		}
	
		module.exports = isObject;
	
	
	/***/ },
	/* 3 */
	/***/ function(module, exports) {
	
		/**
		 * Checks if `value` is classified as an `Array` object.
		 *
		 * @static
		 * @memberOf _
		 * @since 0.1.0
		 * @type {Function}
		 * @category Lang
		 * @param {*} value The value to check.
		 * @returns {boolean} Returns `true` if `value` is correctly classified,
		 *  else `false`.
		 * @example
		 *
		 * _.isArray([1, 2, 3]);
		 * // => true
		 *
		 * _.isArray(document.body.children);
		 * // => false
		 *
		 * _.isArray('abc');
		 * // => false
		 *
		 * _.isArray(_.noop);
		 * // => false
		 */
		var isArray = Array.isArray;
	
		module.exports = isArray;
	
	
	/***/ },
	/* 4 */
	/***/ function(module, exports) {
	
		module.exports = __webpack_require__(85);
	
	/***/ },
	/* 5 */
	/***/ function(module, exports, __webpack_require__) {
	
		var baseIsNative = __webpack_require__(138),
		    getValue = __webpack_require__(161);
	
		/**
		 * Gets the native function at `key` of `object`.
		 *
		 * @private
		 * @param {Object} object The object to query.
		 * @param {string} key The key of the method to get.
		 * @returns {*} Returns the function if it's native, else `undefined`.
		 */
		function getNative(object, key) {
		  var value = getValue(object, key);
		  return baseIsNative(value) ? value : undefined;
		}
	
		module.exports = getNative;
	
	
	/***/ },
	/* 6 */
	/***/ function(module, exports) {
	
		/**
		 * Checks if `value` is object-like. A value is object-like if it's not `null`
		 * and has a `typeof` result of "object".
		 *
		 * @static
		 * @memberOf _
		 * @since 4.0.0
		 * @category Lang
		 * @param {*} value The value to check.
		 * @returns {boolean} Returns `true` if `value` is object-like, else `false`.
		 * @example
		 *
		 * _.isObjectLike({});
		 * // => true
		 *
		 * _.isObjectLike([1, 2, 3]);
		 * // => true
		 *
		 * _.isObjectLike(_.noop);
		 * // => false
		 *
		 * _.isObjectLike(null);
		 * // => false
		 */
		function isObjectLike(value) {
		  return !!value && typeof value == 'object';
		}
	
		module.exports = isObjectLike;
	
	
	/***/ },
	/* 7 */
	/***/ function(module, exports, __webpack_require__) {
	
		var __vue_script__, __vue_template__
		__vue_script__ = __webpack_require__(76)
		if (__vue_script__ &&
		    __vue_script__.__esModule &&
		    Object.keys(__vue_script__).length > 1) {
		  console.warn("[vue-loader] src/ModalBase.vue: named exports in *.vue files are ignored.")}
		module.exports = __vue_script__ || {}
		if (module.exports.__esModule) module.exports = module.exports.default
		if (__vue_template__) {
		(typeof module.exports === "function" ? (module.exports.options || (module.exports.options = {})) : module.exports).template = __vue_template__
		}
		if (false) {(function () {  module.hot.accept()
		  var hotAPI = require("vue-hot-reload-api")
		  hotAPI.install(require("vue"), false)
		  if (!hotAPI.compatible) return
		  var id = "./ModalBase.vue"
		  if (!module.hot.data) {
		    hotAPI.createRecord(id, module.exports)
		  } else {
		    hotAPI.update(id, module.exports, __vue_template__)
		  }
		})()}
	
	/***/ },
	/* 8 */
	/***/ function(module, exports) {
	
		var core = module.exports = {version: '2.4.0'};
		if(typeof __e == 'number')__e = core; // eslint-disable-line no-undef
	
	/***/ },
	/* 9 */
	/***/ function(module, exports) {
	
		module.exports = function(it){
		  return typeof it === 'object' ? it !== null : typeof it === 'function';
		};
	
	/***/ },
	/* 10 */
	/***/ function(module, exports, __webpack_require__) {
	
		var listCacheClear = __webpack_require__(173),
		    listCacheDelete = __webpack_require__(174),
		    listCacheGet = __webpack_require__(175),
		    listCacheHas = __webpack_require__(176),
		    listCacheSet = __webpack_require__(177);
	
		/**
		 * Creates an list cache object.
		 *
		 * @private
		 * @constructor
		 * @param {Array} [entries] The key-value pairs to cache.
		 */
		function ListCache(entries) {
		  var index = -1,
		      length = entries ? entries.length : 0;
	
		  this.clear();
		  while (++index < length) {
		    var entry = entries[index];
		    this.set(entry[0], entry[1]);
		  }
		}
	
		// Add methods to `ListCache`.
		ListCache.prototype.clear = listCacheClear;
		ListCache.prototype['delete'] = listCacheDelete;
		ListCache.prototype.get = listCacheGet;
		ListCache.prototype.has = listCacheHas;
		ListCache.prototype.set = listCacheSet;
	
		module.exports = ListCache;
	
	
	/***/ },
	/* 11 */
	/***/ function(module, exports, __webpack_require__) {
	
		var eq = __webpack_require__(14);
	
		/**
		 * Gets the index at which the `key` is found in `array` of key-value pairs.
		 *
		 * @private
		 * @param {Array} array The array to search.
		 * @param {*} key The key to search for.
		 * @returns {number} Returns the index of the matched value, else `-1`.
		 */
		function assocIndexOf(array, key) {
		  var length = array.length;
		  while (length--) {
		    if (eq(array[length][0], key)) {
		      return length;
		    }
		  }
		  return -1;
		}
	
		module.exports = assocIndexOf;
	
	
	/***/ },
	/* 12 */
	/***/ function(module, exports, __webpack_require__) {
	
		var isKeyable = __webpack_require__(171);
	
		/**
		 * Gets the data for `map`.
		 *
		 * @private
		 * @param {Object} map The map to query.
		 * @param {string} key The reference key.
		 * @returns {*} Returns the map data.
		 */
		function getMapData(map, key) {
		  var data = map.__data__;
		  return isKeyable(key)
		    ? data[typeof key == 'string' ? 'string' : 'hash']
		    : data.map;
		}
	
		module.exports = getMapData;
	
	
	/***/ },
	/* 13 */
	/***/ function(module, exports, __webpack_require__) {
	
		var getNative = __webpack_require__(5);
	
		/* Built-in method references that are verified to be native. */
		var nativeCreate = getNative(Object, 'create');
	
		module.exports = nativeCreate;
	
	
	/***/ },
	/* 14 */
	/***/ function(module, exports) {
	
		/**
		 * Performs a
		 * [`SameValueZero`](http://ecma-international.org/ecma-262/6.0/#sec-samevaluezero)
		 * comparison between two values to determine if they are equivalent.
		 *
		 * @static
		 * @memberOf _
		 * @since 4.0.0
		 * @category Lang
		 * @param {*} value The value to compare.
		 * @param {*} other The other value to compare.
		 * @returns {boolean} Returns `true` if the values are equivalent, else `false`.
		 * @example
		 *
		 * var object = { 'user': 'fred' };
		 * var other = { 'user': 'fred' };
		 *
		 * _.eq(object, object);
		 * // => true
		 *
		 * _.eq(object, other);
		 * // => false
		 *
		 * _.eq('a', 'a');
		 * // => true
		 *
		 * _.eq('a', Object('a'));
		 * // => false
		 *
		 * _.eq(NaN, NaN);
		 * // => true
		 */
		function eq(value, other) {
		  return value === other || (value !== value && other !== other);
		}
	
		module.exports = eq;
	
	
	/***/ },
	/* 15 */
	/***/ function(module, exports, __webpack_require__) {
	
		var getLength = __webpack_require__(160),
		    isFunction = __webpack_require__(16),
		    isLength = __webpack_require__(29);
	
		/**
		 * Checks if `value` is array-like. A value is considered array-like if it's
		 * not a function and has a `value.length` that's an integer greater than or
		 * equal to `0` and less than or equal to `Number.MAX_SAFE_INTEGER`.
		 *
		 * @static
		 * @memberOf _
		 * @since 4.0.0
		 * @category Lang
		 * @param {*} value The value to check.
		 * @returns {boolean} Returns `true` if `value` is array-like, else `false`.
		 * @example
		 *
		 * _.isArrayLike([1, 2, 3]);
		 * // => true
		 *
		 * _.isArrayLike(document.body.children);
		 * // => true
		 *
		 * _.isArrayLike('abc');
		 * // => true
		 *
		 * _.isArrayLike(_.noop);
		 * // => false
		 */
		function isArrayLike(value) {
		  return value != null && isLength(getLength(value)) && !isFunction(value);
		}
	
		module.exports = isArrayLike;
	
	
	/***/ },
	/* 16 */
	/***/ function(module, exports, __webpack_require__) {
	
		var isObject = __webpack_require__(2);
	
		/** `Object#toString` result references. */
		var funcTag = '[object Function]',
		    genTag = '[object GeneratorFunction]';
	
		/** Used for built-in method references. */
		var objectProto = Object.prototype;
	
		/**
		 * Used to resolve the
		 * [`toStringTag`](http://ecma-international.org/ecma-262/6.0/#sec-object.prototype.tostring)
		 * of values.
		 */
		var objectToString = objectProto.toString;
	
		/**
		 * Checks if `value` is classified as a `Function` object.
		 *
		 * @static
		 * @memberOf _
		 * @since 0.1.0
		 * @category Lang
		 * @param {*} value The value to check.
		 * @returns {boolean} Returns `true` if `value` is correctly classified,
		 *  else `false`.
		 * @example
		 *
		 * _.isFunction(_);
		 * // => true
		 *
		 * _.isFunction(/abc/);
		 * // => false
		 */
		function isFunction(value) {
		  // The use of `Object#toString` avoids issues with the `typeof` operator
		  // in Safari 8 which returns 'object' for typed array and weak map constructors,
		  // and PhantomJS 1.9 which returns 'function' for `NodeList` instances.
		  var tag = isObject(value) ? objectToString.call(value) : '';
		  return tag == funcTag || tag == genTag;
		}
	
		module.exports = isFunction;
	
	
	/***/ },
	/* 17 */
	/***/ function(module, exports, __webpack_require__) {
	
		var baseHas = __webpack_require__(137),
		    baseKeys = __webpack_require__(139),
		    indexKeys = __webpack_require__(48),
		    isArrayLike = __webpack_require__(15),
		    isIndex = __webpack_require__(26),
		    isPrototype = __webpack_require__(27);
	
		/**
		 * Creates an array of the own enumerable property names of `object`.
		 *
		 * **Note:** Non-object values are coerced to objects. See the
		 * [ES spec](http://ecma-international.org/ecma-262/6.0/#sec-object.keys)
		 * for more details.
		 *
		 * @static
		 * @since 0.1.0
		 * @memberOf _
		 * @category Object
		 * @param {Object} object The object to query.
		 * @returns {Array} Returns the array of property names.
		 * @example
		 *
		 * function Foo() {
		 *   this.a = 1;
		 *   this.b = 2;
		 * }
		 *
		 * Foo.prototype.c = 3;
		 *
		 * _.keys(new Foo);
		 * // => ['a', 'b'] (iteration order is not guaranteed)
		 *
		 * _.keys('hi');
		 * // => ['0', '1']
		 */
		function keys(object) {
		  var isProto = isPrototype(object);
		  if (!(isProto || isArrayLike(object))) {
		    return baseKeys(object);
		  }
		  var indexes = indexKeys(object),
		      skipIndexes = !!indexes,
		      result = indexes || [],
		      length = result.length;
	
		  for (var key in object) {
		    if (baseHas(object, key) &&
		        !(skipIndexes && (key == 'length' || isIndex(key, length))) &&
		        !(isProto && key == 'constructor')) {
		      result.push(key);
		    }
		  }
		  return result;
		}
	
		module.exports = keys;
	
	
	/***/ },
	/* 18 */
	/***/ function(module, exports, __webpack_require__) {
	
		// Thank's IE8 for his funny defineProperty
		module.exports = !__webpack_require__(19)(function(){
		  return Object.defineProperty({}, 'a', {get: function(){ return 7; }}).a != 7;
		});
	
	/***/ },
	/* 19 */
	/***/ function(module, exports) {
	
		module.exports = function(exec){
		  try {
		    return !!exec();
		  } catch(e){
		    return true;
		  }
		};
	
	/***/ },
	/* 20 */
	/***/ function(module, exports) {
	
		// https://github.com/zloirock/core-js/issues/86#issuecomment-115759028
		var global = module.exports = typeof window != 'undefined' && window.Math == Math
		  ? window : typeof self != 'undefined' && self.Math == Math ? self : Function('return this')();
		if(typeof __g == 'number')__g = global; // eslint-disable-line no-undef
	
	/***/ },
	/* 21 */
	/***/ function(module, exports, __webpack_require__) {
	
		var Uint8Array = __webpack_require__(126);
	
		/**
		 * Creates a clone of `arrayBuffer`.
		 *
		 * @private
		 * @param {ArrayBuffer} arrayBuffer The array buffer to clone.
		 * @returns {ArrayBuffer} Returns the cloned array buffer.
		 */
		function cloneArrayBuffer(arrayBuffer) {
		  var result = new arrayBuffer.constructor(arrayBuffer.byteLength);
		  new Uint8Array(result).set(new Uint8Array(arrayBuffer));
		  return result;
		}
	
		module.exports = cloneArrayBuffer;
	
	
	/***/ },
	/* 22 */
	/***/ function(module, exports) {
	
		/**
		 * Copies the values of `source` to `array`.
		 *
		 * @private
		 * @param {Array} source The array to copy values from.
		 * @param {Array} [array=[]] The array to copy values to.
		 * @returns {Array} Returns `array`.
		 */
		function copyArray(source, array) {
		  var index = -1,
		      length = source.length;
	
		  array || (array = Array(length));
		  while (++index < length) {
		    array[index] = source[index];
		  }
		  return array;
		}
	
		module.exports = copyArray;
	
	
	/***/ },
	/* 23 */
	/***/ function(module, exports, __webpack_require__) {
	
		var assignValue = __webpack_require__(45);
	
		/**
		 * Copies properties of `source` to `object`.
		 *
		 * @private
		 * @param {Object} source The object to copy properties from.
		 * @param {Array} props The property identifiers to copy.
		 * @param {Object} [object={}] The object to copy properties to.
		 * @param {Function} [customizer] The function to customize copied values.
		 * @returns {Object} Returns `object`.
		 */
		function copyObject(source, props, object, customizer) {
		  object || (object = {});
	
		  var index = -1,
		      length = props.length;
	
		  while (++index < length) {
		    var key = props[index];
	
		    var newValue = customizer
		      ? customizer(object[key], source[key], key, object, source)
		      : source[key];
	
		    assignValue(object, key, newValue);
		  }
		  return object;
		}
	
		module.exports = copyObject;
	
	
	/***/ },
	/* 24 */
	/***/ function(module, exports) {
	
		/* Built-in method references for those with the same name as other `lodash` methods. */
		var nativeGetPrototype = Object.getPrototypeOf;
	
		/**
		 * Gets the `[[Prototype]]` of `value`.
		 *
		 * @private
		 * @param {*} value The value to query.
		 * @returns {null|Object} Returns the `[[Prototype]]`.
		 */
		function getPrototype(value) {
		  return nativeGetPrototype(Object(value));
		}
	
		module.exports = getPrototype;
	
	
	/***/ },
	/* 25 */
	/***/ function(module, exports) {
	
		/**
		 * Checks if `value` is a host object in IE < 9.
		 *
		 * @private
		 * @param {*} value The value to check.
		 * @returns {boolean} Returns `true` if `value` is a host object, else `false`.
		 */
		function isHostObject(value) {
		  // Many host objects are `Object` objects that can coerce to strings
		  // despite having improperly defined `toString` methods.
		  var result = false;
		  if (value != null && typeof value.toString != 'function') {
		    try {
		      result = !!(value + '');
		    } catch (e) {}
		  }
		  return result;
		}
	
		module.exports = isHostObject;
	
	
	/***/ },
	/* 26 */
	/***/ function(module, exports) {
	
		/** Used as references for various `Number` constants. */
		var MAX_SAFE_INTEGER = 9007199254740991;
	
		/** Used to detect unsigned integer values. */
		var reIsUint = /^(?:0|[1-9]\d*)$/;
	
		/**
		 * Checks if `value` is a valid array-like index.
		 *
		 * @private
		 * @param {*} value The value to check.
		 * @param {number} [length=MAX_SAFE_INTEGER] The upper bounds of a valid index.
		 * @returns {boolean} Returns `true` if `value` is a valid index, else `false`.
		 */
		function isIndex(value, length) {
		  length = length == null ? MAX_SAFE_INTEGER : length;
		  return !!length &&
		    (typeof value == 'number' || reIsUint.test(value)) &&
		    (value > -1 && value % 1 == 0 && value < length);
		}
	
		module.exports = isIndex;
	
	
	/***/ },
	/* 27 */
	/***/ function(module, exports) {
	
		/** Used for built-in method references. */
		var objectProto = Object.prototype;
	
		/**
		 * Checks if `value` is likely a prototype object.
		 *
		 * @private
		 * @param {*} value The value to check.
		 * @returns {boolean} Returns `true` if `value` is a prototype, else `false`.
		 */
		function isPrototype(value) {
		  var Ctor = value && value.constructor,
		      proto = (typeof Ctor == 'function' && Ctor.prototype) || objectProto;
	
		  return value === proto;
		}
	
		module.exports = isPrototype;
	
	
	/***/ },
	/* 28 */
	/***/ function(module, exports, __webpack_require__) {
	
		var isArrayLikeObject = __webpack_require__(54);
	
		/** `Object#toString` result references. */
		var argsTag = '[object Arguments]';
	
		/** Used for built-in method references. */
		var objectProto = Object.prototype;
	
		/** Used to check objects for own properties. */
		var hasOwnProperty = objectProto.hasOwnProperty;
	
		/**
		 * Used to resolve the
		 * [`toStringTag`](http://ecma-international.org/ecma-262/6.0/#sec-object.prototype.tostring)
		 * of values.
		 */
		var objectToString = objectProto.toString;
	
		/** Built-in value references. */
		var propertyIsEnumerable = objectProto.propertyIsEnumerable;
	
		/**
		 * Checks if `value` is likely an `arguments` object.
		 *
		 * @static
		 * @memberOf _
		 * @since 0.1.0
		 * @category Lang
		 * @param {*} value The value to check.
		 * @returns {boolean} Returns `true` if `value` is correctly classified,
		 *  else `false`.
		 * @example
		 *
		 * _.isArguments(function() { return arguments; }());
		 * // => true
		 *
		 * _.isArguments([1, 2, 3]);
		 * // => false
		 */
		function isArguments(value) {
		  // Safari 8.1 incorrectly makes `arguments.callee` enumerable in strict mode.
		  return isArrayLikeObject(value) && hasOwnProperty.call(value, 'callee') &&
		    (!propertyIsEnumerable.call(value, 'callee') || objectToString.call(value) == argsTag);
		}
	
		module.exports = isArguments;
	
	
	/***/ },
	/* 29 */
	/***/ function(module, exports) {
	
		/** Used as references for various `Number` constants. */
		var MAX_SAFE_INTEGER = 9007199254740991;
	
		/**
		 * Checks if `value` is a valid array-like length.
		 *
		 * **Note:** This function is loosely based on
		 * [`ToLength`](http://ecma-international.org/ecma-262/6.0/#sec-tolength).
		 *
		 * @static
		 * @memberOf _
		 * @since 4.0.0
		 * @category Lang
		 * @param {*} value The value to check.
		 * @returns {boolean} Returns `true` if `value` is a valid length,
		 *  else `false`.
		 * @example
		 *
		 * _.isLength(3);
		 * // => true
		 *
		 * _.isLength(Number.MIN_VALUE);
		 * // => false
		 *
		 * _.isLength(Infinity);
		 * // => false
		 *
		 * _.isLength('3');
		 * // => false
		 */
		function isLength(value) {
		  return typeof value == 'number' &&
		    value > -1 && value % 1 == 0 && value <= MAX_SAFE_INTEGER;
		}
	
		module.exports = isLength;
	
	
	/***/ },
	/* 30 */
	/***/ function(module, exports, __webpack_require__) {
	
		var Symbol = __webpack_require__(40),
		    copyArray = __webpack_require__(22),
		    getTag = __webpack_require__(47),
		    isArrayLike = __webpack_require__(15),
		    isString = __webpack_require__(55),
		    iteratorToArray = __webpack_require__(50),
		    mapToArray = __webpack_require__(51),
		    setToArray = __webpack_require__(52),
		    stringToArray = __webpack_require__(188),
		    values = __webpack_require__(200);
	
		/** `Object#toString` result references. */
		var mapTag = '[object Map]',
		    setTag = '[object Set]';
	
		/** Built-in value references. */
		var iteratorSymbol = typeof (iteratorSymbol = Symbol && Symbol.iterator) == 'symbol' ? iteratorSymbol : undefined;
	
		/**
		 * Converts `value` to an array.
		 *
		 * @static
		 * @since 0.1.0
		 * @memberOf _
		 * @category Lang
		 * @param {*} value The value to convert.
		 * @returns {Array} Returns the converted array.
		 * @example
		 *
		 * _.toArray({ 'a': 1, 'b': 2 });
		 * // => [1, 2]
		 *
		 * _.toArray('abc');
		 * // => ['a', 'b', 'c']
		 *
		 * _.toArray(1);
		 * // => []
		 *
		 * _.toArray(null);
		 * // => []
		 */
		function toArray(value) {
		  if (!value) {
		    return [];
		  }
		  if (isArrayLike(value)) {
		    return isString(value) ? stringToArray(value) : copyArray(value);
		  }
		  if (iteratorSymbol && value[iteratorSymbol]) {
		    return iteratorToArray(value[iteratorSymbol]());
		  }
		  var tag = getTag(value),
		      func = tag == mapTag ? mapToArray : (tag == setTag ? setToArray : values);
	
		  return func(value);
		}
	
		module.exports = toArray;
	
	
	/***/ },
	/* 31 */
	/***/ function(module, exports, __webpack_require__) {
	
		/* WEBPACK VAR INJECTION */(function(module) {//! moment.js
		//! version : 2.13.0
		//! authors : Tim Wood, Iskren Chernev, Moment.js contributors
		//! license : MIT
		//! momentjs.com
	
		;(function (global, factory) {
		     true ? module.exports = factory() :
		    typeof define === 'function' && define.amd ? define(factory) :
		    global.moment = factory()
		}(this, function () { 'use strict';
	
		    var hookCallback;
	
		    function utils_hooks__hooks () {
		        return hookCallback.apply(null, arguments);
		    }
	
		    // This is done to register the method called with moment()
		    // without creating circular dependencies.
		    function setHookCallback (callback) {
		        hookCallback = callback;
		    }
	
		    function isArray(input) {
		        return input instanceof Array || Object.prototype.toString.call(input) === '[object Array]';
		    }
	
		    function isDate(input) {
		        return input instanceof Date || Object.prototype.toString.call(input) === '[object Date]';
		    }
	
		    function map(arr, fn) {
		        var res = [], i;
		        for (i = 0; i < arr.length; ++i) {
		            res.push(fn(arr[i], i));
		        }
		        return res;
		    }
	
		    function hasOwnProp(a, b) {
		        return Object.prototype.hasOwnProperty.call(a, b);
		    }
	
		    function extend(a, b) {
		        for (var i in b) {
		            if (hasOwnProp(b, i)) {
		                a[i] = b[i];
		            }
		        }
	
		        if (hasOwnProp(b, 'toString')) {
		            a.toString = b.toString;
		        }
	
		        if (hasOwnProp(b, 'valueOf')) {
		            a.valueOf = b.valueOf;
		        }
	
		        return a;
		    }
	
		    function create_utc__createUTC (input, format, locale, strict) {
		        return createLocalOrUTC(input, format, locale, strict, true).utc();
		    }
	
		    function defaultParsingFlags() {
		        // We need to deep clone this object.
		        return {
		            empty           : false,
		            unusedTokens    : [],
		            unusedInput     : [],
		            overflow        : -2,
		            charsLeftOver   : 0,
		            nullInput       : false,
		            invalidMonth    : null,
		            invalidFormat   : false,
		            userInvalidated : false,
		            iso             : false,
		            parsedDateParts : [],
		            meridiem        : null
		        };
		    }
	
		    function getParsingFlags(m) {
		        if (m._pf == null) {
		            m._pf = defaultParsingFlags();
		        }
		        return m._pf;
		    }
	
		    var some;
		    if (Array.prototype.some) {
		        some = Array.prototype.some;
		    } else {
		        some = function (fun) {
		            var t = Object(this);
		            var len = t.length >>> 0;
	
		            for (var i = 0; i < len; i++) {
		                if (i in t && fun.call(this, t[i], i, t)) {
		                    return true;
		                }
		            }
	
		            return false;
		        };
		    }
	
		    function valid__isValid(m) {
		        if (m._isValid == null) {
		            var flags = getParsingFlags(m);
		            var parsedParts = some.call(flags.parsedDateParts, function (i) {
		                return i != null;
		            });
		            m._isValid = !isNaN(m._d.getTime()) &&
		                flags.overflow < 0 &&
		                !flags.empty &&
		                !flags.invalidMonth &&
		                !flags.invalidWeekday &&
		                !flags.nullInput &&
		                !flags.invalidFormat &&
		                !flags.userInvalidated &&
		                (!flags.meridiem || (flags.meridiem && parsedParts));
	
		            if (m._strict) {
		                m._isValid = m._isValid &&
		                    flags.charsLeftOver === 0 &&
		                    flags.unusedTokens.length === 0 &&
		                    flags.bigHour === undefined;
		            }
		        }
		        return m._isValid;
		    }
	
		    function valid__createInvalid (flags) {
		        var m = create_utc__createUTC(NaN);
		        if (flags != null) {
		            extend(getParsingFlags(m), flags);
		        }
		        else {
		            getParsingFlags(m).userInvalidated = true;
		        }
	
		        return m;
		    }
	
		    function isUndefined(input) {
		        return input === void 0;
		    }
	
		    // Plugins that add properties should also add the key here (null value),
		    // so we can properly clone ourselves.
		    var momentProperties = utils_hooks__hooks.momentProperties = [];
	
		    function copyConfig(to, from) {
		        var i, prop, val;
	
		        if (!isUndefined(from._isAMomentObject)) {
		            to._isAMomentObject = from._isAMomentObject;
		        }
		        if (!isUndefined(from._i)) {
		            to._i = from._i;
		        }
		        if (!isUndefined(from._f)) {
		            to._f = from._f;
		        }
		        if (!isUndefined(from._l)) {
		            to._l = from._l;
		        }
		        if (!isUndefined(from._strict)) {
		            to._strict = from._strict;
		        }
		        if (!isUndefined(from._tzm)) {
		            to._tzm = from._tzm;
		        }
		        if (!isUndefined(from._isUTC)) {
		            to._isUTC = from._isUTC;
		        }
		        if (!isUndefined(from._offset)) {
		            to._offset = from._offset;
		        }
		        if (!isUndefined(from._pf)) {
		            to._pf = getParsingFlags(from);
		        }
		        if (!isUndefined(from._locale)) {
		            to._locale = from._locale;
		        }
	
		        if (momentProperties.length > 0) {
		            for (i in momentProperties) {
		                prop = momentProperties[i];
		                val = from[prop];
		                if (!isUndefined(val)) {
		                    to[prop] = val;
		                }
		            }
		        }
	
		        return to;
		    }
	
		    var updateInProgress = false;
	
		    // Moment prototype object
		    function Moment(config) {
		        copyConfig(this, config);
		        this._d = new Date(config._d != null ? config._d.getTime() : NaN);
		        // Prevent infinite loop in case updateOffset creates new moment
		        // objects.
		        if (updateInProgress === false) {
		            updateInProgress = true;
		            utils_hooks__hooks.updateOffset(this);
		            updateInProgress = false;
		        }
		    }
	
		    function isMoment (obj) {
		        return obj instanceof Moment || (obj != null && obj._isAMomentObject != null);
		    }
	
		    function absFloor (number) {
		        if (number < 0) {
		            return Math.ceil(number);
		        } else {
		            return Math.floor(number);
		        }
		    }
	
		    function toInt(argumentForCoercion) {
		        var coercedNumber = +argumentForCoercion,
		            value = 0;
	
		        if (coercedNumber !== 0 && isFinite(coercedNumber)) {
		            value = absFloor(coercedNumber);
		        }
	
		        return value;
		    }
	
		    // compare two arrays, return the number of differences
		    function compareArrays(array1, array2, dontConvert) {
		        var len = Math.min(array1.length, array2.length),
		            lengthDiff = Math.abs(array1.length - array2.length),
		            diffs = 0,
		            i;
		        for (i = 0; i < len; i++) {
		            if ((dontConvert && array1[i] !== array2[i]) ||
		                (!dontConvert && toInt(array1[i]) !== toInt(array2[i]))) {
		                diffs++;
		            }
		        }
		        return diffs + lengthDiff;
		    }
	
		    function warn(msg) {
		        if (utils_hooks__hooks.suppressDeprecationWarnings === false &&
		                (typeof console !==  'undefined') && console.warn) {
		            console.warn('Deprecation warning: ' + msg);
		        }
		    }
	
		    function deprecate(msg, fn) {
		        var firstTime = true;
	
		        return extend(function () {
		            if (utils_hooks__hooks.deprecationHandler != null) {
		                utils_hooks__hooks.deprecationHandler(null, msg);
		            }
		            if (firstTime) {
		                warn(msg + '\nArguments: ' + Array.prototype.slice.call(arguments).join(', ') + '\n' + (new Error()).stack);
		                firstTime = false;
		            }
		            return fn.apply(this, arguments);
		        }, fn);
		    }
	
		    var deprecations = {};
	
		    function deprecateSimple(name, msg) {
		        if (utils_hooks__hooks.deprecationHandler != null) {
		            utils_hooks__hooks.deprecationHandler(name, msg);
		        }
		        if (!deprecations[name]) {
		            warn(msg);
		            deprecations[name] = true;
		        }
		    }
	
		    utils_hooks__hooks.suppressDeprecationWarnings = false;
		    utils_hooks__hooks.deprecationHandler = null;
	
		    function isFunction(input) {
		        return input instanceof Function || Object.prototype.toString.call(input) === '[object Function]';
		    }
	
		    function isObject(input) {
		        return Object.prototype.toString.call(input) === '[object Object]';
		    }
	
		    function locale_set__set (config) {
		        var prop, i;
		        for (i in config) {
		            prop = config[i];
		            if (isFunction(prop)) {
		                this[i] = prop;
		            } else {
		                this['_' + i] = prop;
		            }
		        }
		        this._config = config;
		        // Lenient ordinal parsing accepts just a number in addition to
		        // number + (possibly) stuff coming from _ordinalParseLenient.
		        this._ordinalParseLenient = new RegExp(this._ordinalParse.source + '|' + (/\d{1,2}/).source);
		    }
	
		    function mergeConfigs(parentConfig, childConfig) {
		        var res = extend({}, parentConfig), prop;
		        for (prop in childConfig) {
		            if (hasOwnProp(childConfig, prop)) {
		                if (isObject(parentConfig[prop]) && isObject(childConfig[prop])) {
		                    res[prop] = {};
		                    extend(res[prop], parentConfig[prop]);
		                    extend(res[prop], childConfig[prop]);
		                } else if (childConfig[prop] != null) {
		                    res[prop] = childConfig[prop];
		                } else {
		                    delete res[prop];
		                }
		            }
		        }
		        return res;
		    }
	
		    function Locale(config) {
		        if (config != null) {
		            this.set(config);
		        }
		    }
	
		    var keys;
	
		    if (Object.keys) {
		        keys = Object.keys;
		    } else {
		        keys = function (obj) {
		            var i, res = [];
		            for (i in obj) {
		                if (hasOwnProp(obj, i)) {
		                    res.push(i);
		                }
		            }
		            return res;
		        };
		    }
	
		    // internal storage for locale config files
		    var locales = {};
		    var globalLocale;
	
		    function normalizeLocale(key) {
		        return key ? key.toLowerCase().replace('_', '-') : key;
		    }
	
		    // pick the locale from the array
		    // try ['en-au', 'en-gb'] as 'en-au', 'en-gb', 'en', as in move through the list trying each
		    // substring from most specific to least, but move to the next array item if it's a more specific variant than the current root
		    function chooseLocale(names) {
		        var i = 0, j, next, locale, split;
	
		        while (i < names.length) {
		            split = normalizeLocale(names[i]).split('-');
		            j = split.length;
		            next = normalizeLocale(names[i + 1]);
		            next = next ? next.split('-') : null;
		            while (j > 0) {
		                locale = loadLocale(split.slice(0, j).join('-'));
		                if (locale) {
		                    return locale;
		                }
		                if (next && next.length >= j && compareArrays(split, next, true) >= j - 1) {
		                    //the next array item is better than a shallower substring of this one
		                    break;
		                }
		                j--;
		            }
		            i++;
		        }
		        return null;
		    }
	
		    function loadLocale(name) {
		        var oldLocale = null;
		        // TODO: Find a better way to register and load all the locales in Node
		        if (!locales[name] && (typeof module !== 'undefined') &&
		                module && module.exports) {
		            try {
		                oldLocale = globalLocale._abbr;
		                !(function webpackMissingModule() { var e = new Error("Cannot find module \"./locale\""); e.code = 'MODULE_NOT_FOUND'; throw e; }());
		                // because defineLocale currently also sets the global locale, we
		                // want to undo that for lazy loaded locales
		                locale_locales__getSetGlobalLocale(oldLocale);
		            } catch (e) { }
		        }
		        return locales[name];
		    }
	
		    // This function will load locale and then set the global locale.  If
		    // no arguments are passed in, it will simply return the current global
		    // locale key.
		    function locale_locales__getSetGlobalLocale (key, values) {
		        var data;
		        if (key) {
		            if (isUndefined(values)) {
		                data = locale_locales__getLocale(key);
		            }
		            else {
		                data = defineLocale(key, values);
		            }
	
		            if (data) {
		                // moment.duration._locale = moment._locale = data;
		                globalLocale = data;
		            }
		        }
	
		        return globalLocale._abbr;
		    }
	
		    function defineLocale (name, config) {
		        if (config !== null) {
		            config.abbr = name;
		            if (locales[name] != null) {
		                deprecateSimple('defineLocaleOverride',
		                        'use moment.updateLocale(localeName, config) to change ' +
		                        'an existing locale. moment.defineLocale(localeName, ' +
		                        'config) should only be used for creating a new locale');
		                config = mergeConfigs(locales[name]._config, config);
		            } else if (config.parentLocale != null) {
		                if (locales[config.parentLocale] != null) {
		                    config = mergeConfigs(locales[config.parentLocale]._config, config);
		                } else {
		                    // treat as if there is no base config
		                    deprecateSimple('parentLocaleUndefined',
		                            'specified parentLocale is not defined yet');
		                }
		            }
		            locales[name] = new Locale(config);
	
		            // backwards compat for now: also set the locale
		            locale_locales__getSetGlobalLocale(name);
	
		            return locales[name];
		        } else {
		            // useful for testing
		            delete locales[name];
		            return null;
		        }
		    }
	
		    function updateLocale(name, config) {
		        if (config != null) {
		            var locale;
		            if (locales[name] != null) {
		                config = mergeConfigs(locales[name]._config, config);
		            }
		            locale = new Locale(config);
		            locale.parentLocale = locales[name];
		            locales[name] = locale;
	
		            // backwards compat for now: also set the locale
		            locale_locales__getSetGlobalLocale(name);
		        } else {
		            // pass null for config to unupdate, useful for tests
		            if (locales[name] != null) {
		                if (locales[name].parentLocale != null) {
		                    locales[name] = locales[name].parentLocale;
		                } else if (locales[name] != null) {
		                    delete locales[name];
		                }
		            }
		        }
		        return locales[name];
		    }
	
		    // returns locale data
		    function locale_locales__getLocale (key) {
		        var locale;
	
		        if (key && key._locale && key._locale._abbr) {
		            key = key._locale._abbr;
		        }
	
		        if (!key) {
		            return globalLocale;
		        }
	
		        if (!isArray(key)) {
		            //short-circuit everything else
		            locale = loadLocale(key);
		            if (locale) {
		                return locale;
		            }
		            key = [key];
		        }
	
		        return chooseLocale(key);
		    }
	
		    function locale_locales__listLocales() {
		        return keys(locales);
		    }
	
		    var aliases = {};
	
		    function addUnitAlias (unit, shorthand) {
		        var lowerCase = unit.toLowerCase();
		        aliases[lowerCase] = aliases[lowerCase + 's'] = aliases[shorthand] = unit;
		    }
	
		    function normalizeUnits(units) {
		        return typeof units === 'string' ? aliases[units] || aliases[units.toLowerCase()] : undefined;
		    }
	
		    function normalizeObjectUnits(inputObject) {
		        var normalizedInput = {},
		            normalizedProp,
		            prop;
	
		        for (prop in inputObject) {
		            if (hasOwnProp(inputObject, prop)) {
		                normalizedProp = normalizeUnits(prop);
		                if (normalizedProp) {
		                    normalizedInput[normalizedProp] = inputObject[prop];
		                }
		            }
		        }
	
		        return normalizedInput;
		    }
	
		    function makeGetSet (unit, keepTime) {
		        return function (value) {
		            if (value != null) {
		                get_set__set(this, unit, value);
		                utils_hooks__hooks.updateOffset(this, keepTime);
		                return this;
		            } else {
		                return get_set__get(this, unit);
		            }
		        };
		    }
	
		    function get_set__get (mom, unit) {
		        return mom.isValid() ?
		            mom._d['get' + (mom._isUTC ? 'UTC' : '') + unit]() : NaN;
		    }
	
		    function get_set__set (mom, unit, value) {
		        if (mom.isValid()) {
		            mom._d['set' + (mom._isUTC ? 'UTC' : '') + unit](value);
		        }
		    }
	
		    // MOMENTS
	
		    function getSet (units, value) {
		        var unit;
		        if (typeof units === 'object') {
		            for (unit in units) {
		                this.set(unit, units[unit]);
		            }
		        } else {
		            units = normalizeUnits(units);
		            if (isFunction(this[units])) {
		                return this[units](value);
		            }
		        }
		        return this;
		    }
	
		    function zeroFill(number, targetLength, forceSign) {
		        var absNumber = '' + Math.abs(number),
		            zerosToFill = targetLength - absNumber.length,
		            sign = number >= 0;
		        return (sign ? (forceSign ? '+' : '') : '-') +
		            Math.pow(10, Math.max(0, zerosToFill)).toString().substr(1) + absNumber;
		    }
	
		    var formattingTokens = /(\[[^\[]*\])|(\\)?([Hh]mm(ss)?|Mo|MM?M?M?|Do|DDDo|DD?D?D?|ddd?d?|do?|w[o|w]?|W[o|W]?|Qo?|YYYYYY|YYYYY|YYYY|YY|gg(ggg?)?|GG(GGG?)?|e|E|a|A|hh?|HH?|kk?|mm?|ss?|S{1,9}|x|X|zz?|ZZ?|.)/g;
	
		    var localFormattingTokens = /(\[[^\[]*\])|(\\)?(LTS|LT|LL?L?L?|l{1,4})/g;
	
		    var formatFunctions = {};
	
		    var formatTokenFunctions = {};
	
		    // token:    'M'
		    // padded:   ['MM', 2]
		    // ordinal:  'Mo'
		    // callback: function () { this.month() + 1 }
		    function addFormatToken (token, padded, ordinal, callback) {
		        var func = callback;
		        if (typeof callback === 'string') {
		            func = function () {
		                return this[callback]();
		            };
		        }
		        if (token) {
		            formatTokenFunctions[token] = func;
		        }
		        if (padded) {
		            formatTokenFunctions[padded[0]] = function () {
		                return zeroFill(func.apply(this, arguments), padded[1], padded[2]);
		            };
		        }
		        if (ordinal) {
		            formatTokenFunctions[ordinal] = function () {
		                return this.localeData().ordinal(func.apply(this, arguments), token);
		            };
		        }
		    }
	
		    function removeFormattingTokens(input) {
		        if (input.match(/\[[\s\S]/)) {
		            return input.replace(/^\[|\]$/g, '');
		        }
		        return input.replace(/\\/g, '');
		    }
	
		    function makeFormatFunction(format) {
		        var array = format.match(formattingTokens), i, length;
	
		        for (i = 0, length = array.length; i < length; i++) {
		            if (formatTokenFunctions[array[i]]) {
		                array[i] = formatTokenFunctions[array[i]];
		            } else {
		                array[i] = removeFormattingTokens(array[i]);
		            }
		        }
	
		        return function (mom) {
		            var output = '', i;
		            for (i = 0; i < length; i++) {
		                output += array[i] instanceof Function ? array[i].call(mom, format) : array[i];
		            }
		            return output;
		        };
		    }
	
		    // format date using native date object
		    function formatMoment(m, format) {
		        if (!m.isValid()) {
		            return m.localeData().invalidDate();
		        }
	
		        format = expandFormat(format, m.localeData());
		        formatFunctions[format] = formatFunctions[format] || makeFormatFunction(format);
	
		        return formatFunctions[format](m);
		    }
	
		    function expandFormat(format, locale) {
		        var i = 5;
	
		        function replaceLongDateFormatTokens(input) {
		            return locale.longDateFormat(input) || input;
		        }
	
		        localFormattingTokens.lastIndex = 0;
		        while (i >= 0 && localFormattingTokens.test(format)) {
		            format = format.replace(localFormattingTokens, replaceLongDateFormatTokens);
		            localFormattingTokens.lastIndex = 0;
		            i -= 1;
		        }
	
		        return format;
		    }
	
		    var match1         = /\d/;            //       0 - 9
		    var match2         = /\d\d/;          //      00 - 99
		    var match3         = /\d{3}/;         //     000 - 999
		    var match4         = /\d{4}/;         //    0000 - 9999
		    var match6         = /[+-]?\d{6}/;    // -999999 - 999999
		    var match1to2      = /\d\d?/;         //       0 - 99
		    var match3to4      = /\d\d\d\d?/;     //     999 - 9999
		    var match5to6      = /\d\d\d\d\d\d?/; //   99999 - 999999
		    var match1to3      = /\d{1,3}/;       //       0 - 999
		    var match1to4      = /\d{1,4}/;       //       0 - 9999
		    var match1to6      = /[+-]?\d{1,6}/;  // -999999 - 999999
	
		    var matchUnsigned  = /\d+/;           //       0 - inf
		    var matchSigned    = /[+-]?\d+/;      //    -inf - inf
	
		    var matchOffset    = /Z|[+-]\d\d:?\d\d/gi; // +00:00 -00:00 +0000 -0000 or Z
		    var matchShortOffset = /Z|[+-]\d\d(?::?\d\d)?/gi; // +00 -00 +00:00 -00:00 +0000 -0000 or Z
	
		    var matchTimestamp = /[+-]?\d+(\.\d{1,3})?/; // 123456789 123456789.123
	
		    // any word (or two) characters or numbers including two/three word month in arabic.
		    // includes scottish gaelic two word and hyphenated months
		    var matchWord = /[0-9]*['a-z\u00A0-\u05FF\u0700-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF]+|[\u0600-\u06FF\/]+(\s*?[\u0600-\u06FF]+){1,2}/i;
	
	
		    var regexes = {};
	
		    function addRegexToken (token, regex, strictRegex) {
		        regexes[token] = isFunction(regex) ? regex : function (isStrict, localeData) {
		            return (isStrict && strictRegex) ? strictRegex : regex;
		        };
		    }
	
		    function getParseRegexForToken (token, config) {
		        if (!hasOwnProp(regexes, token)) {
		            return new RegExp(unescapeFormat(token));
		        }
	
		        return regexes[token](config._strict, config._locale);
		    }
	
		    // Code from http://stackoverflow.com/questions/3561493/is-there-a-regexp-escape-function-in-javascript
		    function unescapeFormat(s) {
		        return regexEscape(s.replace('\\', '').replace(/\\(\[)|\\(\])|\[([^\]\[]*)\]|\\(.)/g, function (matched, p1, p2, p3, p4) {
		            return p1 || p2 || p3 || p4;
		        }));
		    }
	
		    function regexEscape(s) {
		        return s.replace(/[-\/\\^$*+?.()|[\]{}]/g, '\\$&');
		    }
	
		    var tokens = {};
	
		    function addParseToken (token, callback) {
		        var i, func = callback;
		        if (typeof token === 'string') {
		            token = [token];
		        }
		        if (typeof callback === 'number') {
		            func = function (input, array) {
		                array[callback] = toInt(input);
		            };
		        }
		        for (i = 0; i < token.length; i++) {
		            tokens[token[i]] = func;
		        }
		    }
	
		    function addWeekParseToken (token, callback) {
		        addParseToken(token, function (input, array, config, token) {
		            config._w = config._w || {};
		            callback(input, config._w, config, token);
		        });
		    }
	
		    function addTimeToArrayFromToken(token, input, config) {
		        if (input != null && hasOwnProp(tokens, token)) {
		            tokens[token](input, config._a, config, token);
		        }
		    }
	
		    var YEAR = 0;
		    var MONTH = 1;
		    var DATE = 2;
		    var HOUR = 3;
		    var MINUTE = 4;
		    var SECOND = 5;
		    var MILLISECOND = 6;
		    var WEEK = 7;
		    var WEEKDAY = 8;
	
		    var indexOf;
	
		    if (Array.prototype.indexOf) {
		        indexOf = Array.prototype.indexOf;
		    } else {
		        indexOf = function (o) {
		            // I know
		            var i;
		            for (i = 0; i < this.length; ++i) {
		                if (this[i] === o) {
		                    return i;
		                }
		            }
		            return -1;
		        };
		    }
	
		    function daysInMonth(year, month) {
		        return new Date(Date.UTC(year, month + 1, 0)).getUTCDate();
		    }
	
		    // FORMATTING
	
		    addFormatToken('M', ['MM', 2], 'Mo', function () {
		        return this.month() + 1;
		    });
	
		    addFormatToken('MMM', 0, 0, function (format) {
		        return this.localeData().monthsShort(this, format);
		    });
	
		    addFormatToken('MMMM', 0, 0, function (format) {
		        return this.localeData().months(this, format);
		    });
	
		    // ALIASES
	
		    addUnitAlias('month', 'M');
	
		    // PARSING
	
		    addRegexToken('M',    match1to2);
		    addRegexToken('MM',   match1to2, match2);
		    addRegexToken('MMM',  function (isStrict, locale) {
		        return locale.monthsShortRegex(isStrict);
		    });
		    addRegexToken('MMMM', function (isStrict, locale) {
		        return locale.monthsRegex(isStrict);
		    });
	
		    addParseToken(['M', 'MM'], function (input, array) {
		        array[MONTH] = toInt(input) - 1;
		    });
	
		    addParseToken(['MMM', 'MMMM'], function (input, array, config, token) {
		        var month = config._locale.monthsParse(input, token, config._strict);
		        // if we didn't find a month name, mark the date as invalid.
		        if (month != null) {
		            array[MONTH] = month;
		        } else {
		            getParsingFlags(config).invalidMonth = input;
		        }
		    });
	
		    // LOCALES
	
		    var MONTHS_IN_FORMAT = /D[oD]?(\[[^\[\]]*\]|\s+)+MMMM?/;
		    var defaultLocaleMonths = 'January_February_March_April_May_June_July_August_September_October_November_December'.split('_');
		    function localeMonths (m, format) {
		        return isArray(this._months) ? this._months[m.month()] :
		            this._months[MONTHS_IN_FORMAT.test(format) ? 'format' : 'standalone'][m.month()];
		    }
	
		    var defaultLocaleMonthsShort = 'Jan_Feb_Mar_Apr_May_Jun_Jul_Aug_Sep_Oct_Nov_Dec'.split('_');
		    function localeMonthsShort (m, format) {
		        return isArray(this._monthsShort) ? this._monthsShort[m.month()] :
		            this._monthsShort[MONTHS_IN_FORMAT.test(format) ? 'format' : 'standalone'][m.month()];
		    }
	
		    function units_month__handleStrictParse(monthName, format, strict) {
		        var i, ii, mom, llc = monthName.toLocaleLowerCase();
		        if (!this._monthsParse) {
		            // this is not used
		            this._monthsParse = [];
		            this._longMonthsParse = [];
		            this._shortMonthsParse = [];
		            for (i = 0; i < 12; ++i) {
		                mom = create_utc__createUTC([2000, i]);
		                this._shortMonthsParse[i] = this.monthsShort(mom, '').toLocaleLowerCase();
		                this._longMonthsParse[i] = this.months(mom, '').toLocaleLowerCase();
		            }
		        }
	
		        if (strict) {
		            if (format === 'MMM') {
		                ii = indexOf.call(this._shortMonthsParse, llc);
		                return ii !== -1 ? ii : null;
		            } else {
		                ii = indexOf.call(this._longMonthsParse, llc);
		                return ii !== -1 ? ii : null;
		            }
		        } else {
		            if (format === 'MMM') {
		                ii = indexOf.call(this._shortMonthsParse, llc);
		                if (ii !== -1) {
		                    return ii;
		                }
		                ii = indexOf.call(this._longMonthsParse, llc);
		                return ii !== -1 ? ii : null;
		            } else {
		                ii = indexOf.call(this._longMonthsParse, llc);
		                if (ii !== -1) {
		                    return ii;
		                }
		                ii = indexOf.call(this._shortMonthsParse, llc);
		                return ii !== -1 ? ii : null;
		            }
		        }
		    }
	
		    function localeMonthsParse (monthName, format, strict) {
		        var i, mom, regex;
	
		        if (this._monthsParseExact) {
		            return units_month__handleStrictParse.call(this, monthName, format, strict);
		        }
	
		        if (!this._monthsParse) {
		            this._monthsParse = [];
		            this._longMonthsParse = [];
		            this._shortMonthsParse = [];
		        }
	
		        // TODO: add sorting
		        // Sorting makes sure if one month (or abbr) is a prefix of another
		        // see sorting in computeMonthsParse
		        for (i = 0; i < 12; i++) {
		            // make the regex if we don't have it already
		            mom = create_utc__createUTC([2000, i]);
		            if (strict && !this._longMonthsParse[i]) {
		                this._longMonthsParse[i] = new RegExp('^' + this.months(mom, '').replace('.', '') + '$', 'i');
		                this._shortMonthsParse[i] = new RegExp('^' + this.monthsShort(mom, '').replace('.', '') + '$', 'i');
		            }
		            if (!strict && !this._monthsParse[i]) {
		                regex = '^' + this.months(mom, '') + '|^' + this.monthsShort(mom, '');
		                this._monthsParse[i] = new RegExp(regex.replace('.', ''), 'i');
		            }
		            // test the regex
		            if (strict && format === 'MMMM' && this._longMonthsParse[i].test(monthName)) {
		                return i;
		            } else if (strict && format === 'MMM' && this._shortMonthsParse[i].test(monthName)) {
		                return i;
		            } else if (!strict && this._monthsParse[i].test(monthName)) {
		                return i;
		            }
		        }
		    }
	
		    // MOMENTS
	
		    function setMonth (mom, value) {
		        var dayOfMonth;
	
		        if (!mom.isValid()) {
		            // No op
		            return mom;
		        }
	
		        if (typeof value === 'string') {
		            if (/^\d+$/.test(value)) {
		                value = toInt(value);
		            } else {
		                value = mom.localeData().monthsParse(value);
		                // TODO: Another silent failure?
		                if (typeof value !== 'number') {
		                    return mom;
		                }
		            }
		        }
	
		        dayOfMonth = Math.min(mom.date(), daysInMonth(mom.year(), value));
		        mom._d['set' + (mom._isUTC ? 'UTC' : '') + 'Month'](value, dayOfMonth);
		        return mom;
		    }
	
		    function getSetMonth (value) {
		        if (value != null) {
		            setMonth(this, value);
		            utils_hooks__hooks.updateOffset(this, true);
		            return this;
		        } else {
		            return get_set__get(this, 'Month');
		        }
		    }
	
		    function getDaysInMonth () {
		        return daysInMonth(this.year(), this.month());
		    }
	
		    var defaultMonthsShortRegex = matchWord;
		    function monthsShortRegex (isStrict) {
		        if (this._monthsParseExact) {
		            if (!hasOwnProp(this, '_monthsRegex')) {
		                computeMonthsParse.call(this);
		            }
		            if (isStrict) {
		                return this._monthsShortStrictRegex;
		            } else {
		                return this._monthsShortRegex;
		            }
		        } else {
		            return this._monthsShortStrictRegex && isStrict ?
		                this._monthsShortStrictRegex : this._monthsShortRegex;
		        }
		    }
	
		    var defaultMonthsRegex = matchWord;
		    function monthsRegex (isStrict) {
		        if (this._monthsParseExact) {
		            if (!hasOwnProp(this, '_monthsRegex')) {
		                computeMonthsParse.call(this);
		            }
		            if (isStrict) {
		                return this._monthsStrictRegex;
		            } else {
		                return this._monthsRegex;
		            }
		        } else {
		            return this._monthsStrictRegex && isStrict ?
		                this._monthsStrictRegex : this._monthsRegex;
		        }
		    }
	
		    function computeMonthsParse () {
		        function cmpLenRev(a, b) {
		            return b.length - a.length;
		        }
	
		        var shortPieces = [], longPieces = [], mixedPieces = [],
		            i, mom;
		        for (i = 0; i < 12; i++) {
		            // make the regex if we don't have it already
		            mom = create_utc__createUTC([2000, i]);
		            shortPieces.push(this.monthsShort(mom, ''));
		            longPieces.push(this.months(mom, ''));
		            mixedPieces.push(this.months(mom, ''));
		            mixedPieces.push(this.monthsShort(mom, ''));
		        }
		        // Sorting makes sure if one month (or abbr) is a prefix of another it
		        // will match the longer piece.
		        shortPieces.sort(cmpLenRev);
		        longPieces.sort(cmpLenRev);
		        mixedPieces.sort(cmpLenRev);
		        for (i = 0; i < 12; i++) {
		            shortPieces[i] = regexEscape(shortPieces[i]);
		            longPieces[i] = regexEscape(longPieces[i]);
		            mixedPieces[i] = regexEscape(mixedPieces[i]);
		        }
	
		        this._monthsRegex = new RegExp('^(' + mixedPieces.join('|') + ')', 'i');
		        this._monthsShortRegex = this._monthsRegex;
		        this._monthsStrictRegex = new RegExp('^(' + longPieces.join('|') + ')', 'i');
		        this._monthsShortStrictRegex = new RegExp('^(' + shortPieces.join('|') + ')', 'i');
		    }
	
		    function checkOverflow (m) {
		        var overflow;
		        var a = m._a;
	
		        if (a && getParsingFlags(m).overflow === -2) {
		            overflow =
		                a[MONTH]       < 0 || a[MONTH]       > 11  ? MONTH :
		                a[DATE]        < 1 || a[DATE]        > daysInMonth(a[YEAR], a[MONTH]) ? DATE :
		                a[HOUR]        < 0 || a[HOUR]        > 24 || (a[HOUR] === 24 && (a[MINUTE] !== 0 || a[SECOND] !== 0 || a[MILLISECOND] !== 0)) ? HOUR :
		                a[MINUTE]      < 0 || a[MINUTE]      > 59  ? MINUTE :
		                a[SECOND]      < 0 || a[SECOND]      > 59  ? SECOND :
		                a[MILLISECOND] < 0 || a[MILLISECOND] > 999 ? MILLISECOND :
		                -1;
	
		            if (getParsingFlags(m)._overflowDayOfYear && (overflow < YEAR || overflow > DATE)) {
		                overflow = DATE;
		            }
		            if (getParsingFlags(m)._overflowWeeks && overflow === -1) {
		                overflow = WEEK;
		            }
		            if (getParsingFlags(m)._overflowWeekday && overflow === -1) {
		                overflow = WEEKDAY;
		            }
	
		            getParsingFlags(m).overflow = overflow;
		        }
	
		        return m;
		    }
	
		    // iso 8601 regex
		    // 0000-00-00 0000-W00 or 0000-W00-0 + T + 00 or 00:00 or 00:00:00 or 00:00:00.000 + +00:00 or +0000 or +00)
		    var extendedIsoRegex = /^\s*((?:[+-]\d{6}|\d{4})-(?:\d\d-\d\d|W\d\d-\d|W\d\d|\d\d\d|\d\d))(?:(T| )(\d\d(?::\d\d(?::\d\d(?:[.,]\d+)?)?)?)([\+\-]\d\d(?::?\d\d)?|\s*Z)?)?/;
		    var basicIsoRegex = /^\s*((?:[+-]\d{6}|\d{4})(?:\d\d\d\d|W\d\d\d|W\d\d|\d\d\d|\d\d))(?:(T| )(\d\d(?:\d\d(?:\d\d(?:[.,]\d+)?)?)?)([\+\-]\d\d(?::?\d\d)?|\s*Z)?)?/;
	
		    var tzRegex = /Z|[+-]\d\d(?::?\d\d)?/;
	
		    var isoDates = [
		        ['YYYYYY-MM-DD', /[+-]\d{6}-\d\d-\d\d/],
		        ['YYYY-MM-DD', /\d{4}-\d\d-\d\d/],
		        ['GGGG-[W]WW-E', /\d{4}-W\d\d-\d/],
		        ['GGGG-[W]WW', /\d{4}-W\d\d/, false],
		        ['YYYY-DDD', /\d{4}-\d{3}/],
		        ['YYYY-MM', /\d{4}-\d\d/, false],
		        ['YYYYYYMMDD', /[+-]\d{10}/],
		        ['YYYYMMDD', /\d{8}/],
		        // YYYYMM is NOT allowed by the standard
		        ['GGGG[W]WWE', /\d{4}W\d{3}/],
		        ['GGGG[W]WW', /\d{4}W\d{2}/, false],
		        ['YYYYDDD', /\d{7}/]
		    ];
	
		    // iso time formats and regexes
		    var isoTimes = [
		        ['HH:mm:ss.SSSS', /\d\d:\d\d:\d\d\.\d+/],
		        ['HH:mm:ss,SSSS', /\d\d:\d\d:\d\d,\d+/],
		        ['HH:mm:ss', /\d\d:\d\d:\d\d/],
		        ['HH:mm', /\d\d:\d\d/],
		        ['HHmmss.SSSS', /\d\d\d\d\d\d\.\d+/],
		        ['HHmmss,SSSS', /\d\d\d\d\d\d,\d+/],
		        ['HHmmss', /\d\d\d\d\d\d/],
		        ['HHmm', /\d\d\d\d/],
		        ['HH', /\d\d/]
		    ];
	
		    var aspNetJsonRegex = /^\/?Date\((\-?\d+)/i;
	
		    // date from iso format
		    function configFromISO(config) {
		        var i, l,
		            string = config._i,
		            match = extendedIsoRegex.exec(string) || basicIsoRegex.exec(string),
		            allowTime, dateFormat, timeFormat, tzFormat;
	
		        if (match) {
		            getParsingFlags(config).iso = true;
	
		            for (i = 0, l = isoDates.length; i < l; i++) {
		                if (isoDates[i][1].exec(match[1])) {
		                    dateFormat = isoDates[i][0];
		                    allowTime = isoDates[i][2] !== false;
		                    break;
		                }
		            }
		            if (dateFormat == null) {
		                config._isValid = false;
		                return;
		            }
		            if (match[3]) {
		                for (i = 0, l = isoTimes.length; i < l; i++) {
		                    if (isoTimes[i][1].exec(match[3])) {
		                        // match[2] should be 'T' or space
		                        timeFormat = (match[2] || ' ') + isoTimes[i][0];
		                        break;
		                    }
		                }
		                if (timeFormat == null) {
		                    config._isValid = false;
		                    return;
		                }
		            }
		            if (!allowTime && timeFormat != null) {
		                config._isValid = false;
		                return;
		            }
		            if (match[4]) {
		                if (tzRegex.exec(match[4])) {
		                    tzFormat = 'Z';
		                } else {
		                    config._isValid = false;
		                    return;
		                }
		            }
		            config._f = dateFormat + (timeFormat || '') + (tzFormat || '');
		            configFromStringAndFormat(config);
		        } else {
		            config._isValid = false;
		        }
		    }
	
		    // date from iso format or fallback
		    function configFromString(config) {
		        var matched = aspNetJsonRegex.exec(config._i);
	
		        if (matched !== null) {
		            config._d = new Date(+matched[1]);
		            return;
		        }
	
		        configFromISO(config);
		        if (config._isValid === false) {
		            delete config._isValid;
		            utils_hooks__hooks.createFromInputFallback(config);
		        }
		    }
	
		    utils_hooks__hooks.createFromInputFallback = deprecate(
		        'moment construction falls back to js Date. This is ' +
		        'discouraged and will be removed in upcoming major ' +
		        'release. Please refer to ' +
		        'https://github.com/moment/moment/issues/1407 for more info.',
		        function (config) {
		            config._d = new Date(config._i + (config._useUTC ? ' UTC' : ''));
		        }
		    );
	
		    function createDate (y, m, d, h, M, s, ms) {
		        //can't just apply() to create a date:
		        //http://stackoverflow.com/questions/181348/instantiating-a-javascript-object-by-calling-prototype-constructor-apply
		        var date = new Date(y, m, d, h, M, s, ms);
	
		        //the date constructor remaps years 0-99 to 1900-1999
		        if (y < 100 && y >= 0 && isFinite(date.getFullYear())) {
		            date.setFullYear(y);
		        }
		        return date;
		    }
	
		    function createUTCDate (y) {
		        var date = new Date(Date.UTC.apply(null, arguments));
	
		        //the Date.UTC function remaps years 0-99 to 1900-1999
		        if (y < 100 && y >= 0 && isFinite(date.getUTCFullYear())) {
		            date.setUTCFullYear(y);
		        }
		        return date;
		    }
	
		    // FORMATTING
	
		    addFormatToken('Y', 0, 0, function () {
		        var y = this.year();
		        return y <= 9999 ? '' + y : '+' + y;
		    });
	
		    addFormatToken(0, ['YY', 2], 0, function () {
		        return this.year() % 100;
		    });
	
		    addFormatToken(0, ['YYYY',   4],       0, 'year');
		    addFormatToken(0, ['YYYYY',  5],       0, 'year');
		    addFormatToken(0, ['YYYYYY', 6, true], 0, 'year');
	
		    // ALIASES
	
		    addUnitAlias('year', 'y');
	
		    // PARSING
	
		    addRegexToken('Y',      matchSigned);
		    addRegexToken('YY',     match1to2, match2);
		    addRegexToken('YYYY',   match1to4, match4);
		    addRegexToken('YYYYY',  match1to6, match6);
		    addRegexToken('YYYYYY', match1to6, match6);
	
		    addParseToken(['YYYYY', 'YYYYYY'], YEAR);
		    addParseToken('YYYY', function (input, array) {
		        array[YEAR] = input.length === 2 ? utils_hooks__hooks.parseTwoDigitYear(input) : toInt(input);
		    });
		    addParseToken('YY', function (input, array) {
		        array[YEAR] = utils_hooks__hooks.parseTwoDigitYear(input);
		    });
		    addParseToken('Y', function (input, array) {
		        array[YEAR] = parseInt(input, 10);
		    });
	
		    // HELPERS
	
		    function daysInYear(year) {
		        return isLeapYear(year) ? 366 : 365;
		    }
	
		    function isLeapYear(year) {
		        return (year % 4 === 0 && year % 100 !== 0) || year % 400 === 0;
		    }
	
		    // HOOKS
	
		    utils_hooks__hooks.parseTwoDigitYear = function (input) {
		        return toInt(input) + (toInt(input) > 68 ? 1900 : 2000);
		    };
	
		    // MOMENTS
	
		    var getSetYear = makeGetSet('FullYear', true);
	
		    function getIsLeapYear () {
		        return isLeapYear(this.year());
		    }
	
		    // start-of-first-week - start-of-year
		    function firstWeekOffset(year, dow, doy) {
		        var // first-week day -- which january is always in the first week (4 for iso, 1 for other)
		            fwd = 7 + dow - doy,
		            // first-week day local weekday -- which local weekday is fwd
		            fwdlw = (7 + createUTCDate(year, 0, fwd).getUTCDay() - dow) % 7;
	
		        return -fwdlw + fwd - 1;
		    }
	
		    //http://en.wikipedia.org/wiki/ISO_week_date#Calculating_a_date_given_the_year.2C_week_number_and_weekday
		    function dayOfYearFromWeeks(year, week, weekday, dow, doy) {
		        var localWeekday = (7 + weekday - dow) % 7,
		            weekOffset = firstWeekOffset(year, dow, doy),
		            dayOfYear = 1 + 7 * (week - 1) + localWeekday + weekOffset,
		            resYear, resDayOfYear;
	
		        if (dayOfYear <= 0) {
		            resYear = year - 1;
		            resDayOfYear = daysInYear(resYear) + dayOfYear;
		        } else if (dayOfYear > daysInYear(year)) {
		            resYear = year + 1;
		            resDayOfYear = dayOfYear - daysInYear(year);
		        } else {
		            resYear = year;
		            resDayOfYear = dayOfYear;
		        }
	
		        return {
		            year: resYear,
		            dayOfYear: resDayOfYear
		        };
		    }
	
		    function weekOfYear(mom, dow, doy) {
		        var weekOffset = firstWeekOffset(mom.year(), dow, doy),
		            week = Math.floor((mom.dayOfYear() - weekOffset - 1) / 7) + 1,
		            resWeek, resYear;
	
		        if (week < 1) {
		            resYear = mom.year() - 1;
		            resWeek = week + weeksInYear(resYear, dow, doy);
		        } else if (week > weeksInYear(mom.year(), dow, doy)) {
		            resWeek = week - weeksInYear(mom.year(), dow, doy);
		            resYear = mom.year() + 1;
		        } else {
		            resYear = mom.year();
		            resWeek = week;
		        }
	
		        return {
		            week: resWeek,
		            year: resYear
		        };
		    }
	
		    function weeksInYear(year, dow, doy) {
		        var weekOffset = firstWeekOffset(year, dow, doy),
		            weekOffsetNext = firstWeekOffset(year + 1, dow, doy);
		        return (daysInYear(year) - weekOffset + weekOffsetNext) / 7;
		    }
	
		    // Pick the first defined of two or three arguments.
		    function defaults(a, b, c) {
		        if (a != null) {
		            return a;
		        }
		        if (b != null) {
		            return b;
		        }
		        return c;
		    }
	
		    function currentDateArray(config) {
		        // hooks is actually the exported moment object
		        var nowValue = new Date(utils_hooks__hooks.now());
		        if (config._useUTC) {
		            return [nowValue.getUTCFullYear(), nowValue.getUTCMonth(), nowValue.getUTCDate()];
		        }
		        return [nowValue.getFullYear(), nowValue.getMonth(), nowValue.getDate()];
		    }
	
		    // convert an array to a date.
		    // the array should mirror the parameters below
		    // note: all values past the year are optional and will default to the lowest possible value.
		    // [year, month, day , hour, minute, second, millisecond]
		    function configFromArray (config) {
		        var i, date, input = [], currentDate, yearToUse;
	
		        if (config._d) {
		            return;
		        }
	
		        currentDate = currentDateArray(config);
	
		        //compute day of the year from weeks and weekdays
		        if (config._w && config._a[DATE] == null && config._a[MONTH] == null) {
		            dayOfYearFromWeekInfo(config);
		        }
	
		        //if the day of the year is set, figure out what it is
		        if (config._dayOfYear) {
		            yearToUse = defaults(config._a[YEAR], currentDate[YEAR]);
	
		            if (config._dayOfYear > daysInYear(yearToUse)) {
		                getParsingFlags(config)._overflowDayOfYear = true;
		            }
	
		            date = createUTCDate(yearToUse, 0, config._dayOfYear);
		            config._a[MONTH] = date.getUTCMonth();
		            config._a[DATE] = date.getUTCDate();
		        }
	
		        // Default to current date.
		        // * if no year, month, day of month are given, default to today
		        // * if day of month is given, default month and year
		        // * if month is given, default only year
		        // * if year is given, don't default anything
		        for (i = 0; i < 3 && config._a[i] == null; ++i) {
		            config._a[i] = input[i] = currentDate[i];
		        }
	
		        // Zero out whatever was not defaulted, including time
		        for (; i < 7; i++) {
		            config._a[i] = input[i] = (config._a[i] == null) ? (i === 2 ? 1 : 0) : config._a[i];
		        }
	
		        // Check for 24:00:00.000
		        if (config._a[HOUR] === 24 &&
		                config._a[MINUTE] === 0 &&
		                config._a[SECOND] === 0 &&
		                config._a[MILLISECOND] === 0) {
		            config._nextDay = true;
		            config._a[HOUR] = 0;
		        }
	
		        config._d = (config._useUTC ? createUTCDate : createDate).apply(null, input);
		        // Apply timezone offset from input. The actual utcOffset can be changed
		        // with parseZone.
		        if (config._tzm != null) {
		            config._d.setUTCMinutes(config._d.getUTCMinutes() - config._tzm);
		        }
	
		        if (config._nextDay) {
		            config._a[HOUR] = 24;
		        }
		    }
	
		    function dayOfYearFromWeekInfo(config) {
		        var w, weekYear, week, weekday, dow, doy, temp, weekdayOverflow;
	
		        w = config._w;
		        if (w.GG != null || w.W != null || w.E != null) {
		            dow = 1;
		            doy = 4;
	
		            // TODO: We need to take the current isoWeekYear, but that depends on
		            // how we interpret now (local, utc, fixed offset). So create
		            // a now version of current config (take local/utc/offset flags, and
		            // create now).
		            weekYear = defaults(w.GG, config._a[YEAR], weekOfYear(local__createLocal(), 1, 4).year);
		            week = defaults(w.W, 1);
		            weekday = defaults(w.E, 1);
		            if (weekday < 1 || weekday > 7) {
		                weekdayOverflow = true;
		            }
		        } else {
		            dow = config._locale._week.dow;
		            doy = config._locale._week.doy;
	
		            weekYear = defaults(w.gg, config._a[YEAR], weekOfYear(local__createLocal(), dow, doy).year);
		            week = defaults(w.w, 1);
	
		            if (w.d != null) {
		                // weekday -- low day numbers are considered next week
		                weekday = w.d;
		                if (weekday < 0 || weekday > 6) {
		                    weekdayOverflow = true;
		                }
		            } else if (w.e != null) {
		                // local weekday -- counting starts from begining of week
		                weekday = w.e + dow;
		                if (w.e < 0 || w.e > 6) {
		                    weekdayOverflow = true;
		                }
		            } else {
		                // default to begining of week
		                weekday = dow;
		            }
		        }
		        if (week < 1 || week > weeksInYear(weekYear, dow, doy)) {
		            getParsingFlags(config)._overflowWeeks = true;
		        } else if (weekdayOverflow != null) {
		            getParsingFlags(config)._overflowWeekday = true;
		        } else {
		            temp = dayOfYearFromWeeks(weekYear, week, weekday, dow, doy);
		            config._a[YEAR] = temp.year;
		            config._dayOfYear = temp.dayOfYear;
		        }
		    }
	
		    // constant that refers to the ISO standard
		    utils_hooks__hooks.ISO_8601 = function () {};
	
		    // date from string and format string
		    function configFromStringAndFormat(config) {
		        // TODO: Move this to another part of the creation flow to prevent circular deps
		        if (config._f === utils_hooks__hooks.ISO_8601) {
		            configFromISO(config);
		            return;
		        }
	
		        config._a = [];
		        getParsingFlags(config).empty = true;
	
		        // This array is used to make a Date, either with `new Date` or `Date.UTC`
		        var string = '' + config._i,
		            i, parsedInput, tokens, token, skipped,
		            stringLength = string.length,
		            totalParsedInputLength = 0;
	
		        tokens = expandFormat(config._f, config._locale).match(formattingTokens) || [];
	
		        for (i = 0; i < tokens.length; i++) {
		            token = tokens[i];
		            parsedInput = (string.match(getParseRegexForToken(token, config)) || [])[0];
		            // console.log('token', token, 'parsedInput', parsedInput,
		            //         'regex', getParseRegexForToken(token, config));
		            if (parsedInput) {
		                skipped = string.substr(0, string.indexOf(parsedInput));
		                if (skipped.length > 0) {
		                    getParsingFlags(config).unusedInput.push(skipped);
		                }
		                string = string.slice(string.indexOf(parsedInput) + parsedInput.length);
		                totalParsedInputLength += parsedInput.length;
		            }
		            // don't parse if it's not a known token
		            if (formatTokenFunctions[token]) {
		                if (parsedInput) {
		                    getParsingFlags(config).empty = false;
		                }
		                else {
		                    getParsingFlags(config).unusedTokens.push(token);
		                }
		                addTimeToArrayFromToken(token, parsedInput, config);
		            }
		            else if (config._strict && !parsedInput) {
		                getParsingFlags(config).unusedTokens.push(token);
		            }
		        }
	
		        // add remaining unparsed input length to the string
		        getParsingFlags(config).charsLeftOver = stringLength - totalParsedInputLength;
		        if (string.length > 0) {
		            getParsingFlags(config).unusedInput.push(string);
		        }
	
		        // clear _12h flag if hour is <= 12
		        if (getParsingFlags(config).bigHour === true &&
		                config._a[HOUR] <= 12 &&
		                config._a[HOUR] > 0) {
		            getParsingFlags(config).bigHour = undefined;
		        }
	
		        getParsingFlags(config).parsedDateParts = config._a.slice(0);
		        getParsingFlags(config).meridiem = config._meridiem;
		        // handle meridiem
		        config._a[HOUR] = meridiemFixWrap(config._locale, config._a[HOUR], config._meridiem);
	
		        configFromArray(config);
		        checkOverflow(config);
		    }
	
	
		    function meridiemFixWrap (locale, hour, meridiem) {
		        var isPm;
	
		        if (meridiem == null) {
		            // nothing to do
		            return hour;
		        }
		        if (locale.meridiemHour != null) {
		            return locale.meridiemHour(hour, meridiem);
		        } else if (locale.isPM != null) {
		            // Fallback
		            isPm = locale.isPM(meridiem);
		            if (isPm && hour < 12) {
		                hour += 12;
		            }
		            if (!isPm && hour === 12) {
		                hour = 0;
		            }
		            return hour;
		        } else {
		            // this is not supposed to happen
		            return hour;
		        }
		    }
	
		    // date from string and array of format strings
		    function configFromStringAndArray(config) {
		        var tempConfig,
		            bestMoment,
	
		            scoreToBeat,
		            i,
		            currentScore;
	
		        if (config._f.length === 0) {
		            getParsingFlags(config).invalidFormat = true;
		            config._d = new Date(NaN);
		            return;
		        }
	
		        for (i = 0; i < config._f.length; i++) {
		            currentScore = 0;
		            tempConfig = copyConfig({}, config);
		            if (config._useUTC != null) {
		                tempConfig._useUTC = config._useUTC;
		            }
		            tempConfig._f = config._f[i];
		            configFromStringAndFormat(tempConfig);
	
		            if (!valid__isValid(tempConfig)) {
		                continue;
		            }
	
		            // if there is any input that was not parsed add a penalty for that format
		            currentScore += getParsingFlags(tempConfig).charsLeftOver;
	
		            //or tokens
		            currentScore += getParsingFlags(tempConfig).unusedTokens.length * 10;
	
		            getParsingFlags(tempConfig).score = currentScore;
	
		            if (scoreToBeat == null || currentScore < scoreToBeat) {
		                scoreToBeat = currentScore;
		                bestMoment = tempConfig;
		            }
		        }
	
		        extend(config, bestMoment || tempConfig);
		    }
	
		    function configFromObject(config) {
		        if (config._d) {
		            return;
		        }
	
		        var i = normalizeObjectUnits(config._i);
		        config._a = map([i.year, i.month, i.day || i.date, i.hour, i.minute, i.second, i.millisecond], function (obj) {
		            return obj && parseInt(obj, 10);
		        });
	
		        configFromArray(config);
		    }
	
		    function createFromConfig (config) {
		        var res = new Moment(checkOverflow(prepareConfig(config)));
		        if (res._nextDay) {
		            // Adding is smart enough around DST
		            res.add(1, 'd');
		            res._nextDay = undefined;
		        }
	
		        return res;
		    }
	
		    function prepareConfig (config) {
		        var input = config._i,
		            format = config._f;
	
		        config._locale = config._locale || locale_locales__getLocale(config._l);
	
		        if (input === null || (format === undefined && input === '')) {
		            return valid__createInvalid({nullInput: true});
		        }
	
		        if (typeof input === 'string') {
		            config._i = input = config._locale.preparse(input);
		        }
	
		        if (isMoment(input)) {
		            return new Moment(checkOverflow(input));
		        } else if (isArray(format)) {
		            configFromStringAndArray(config);
		        } else if (format) {
		            configFromStringAndFormat(config);
		        } else if (isDate(input)) {
		            config._d = input;
		        } else {
		            configFromInput(config);
		        }
	
		        if (!valid__isValid(config)) {
		            config._d = null;
		        }
	
		        return config;
		    }
	
		    function configFromInput(config) {
		        var input = config._i;
		        if (input === undefined) {
		            config._d = new Date(utils_hooks__hooks.now());
		        } else if (isDate(input)) {
		            config._d = new Date(input.valueOf());
		        } else if (typeof input === 'string') {
		            configFromString(config);
		        } else if (isArray(input)) {
		            config._a = map(input.slice(0), function (obj) {
		                return parseInt(obj, 10);
		            });
		            configFromArray(config);
		        } else if (typeof(input) === 'object') {
		            configFromObject(config);
		        } else if (typeof(input) === 'number') {
		            // from milliseconds
		            config._d = new Date(input);
		        } else {
		            utils_hooks__hooks.createFromInputFallback(config);
		        }
		    }
	
		    function createLocalOrUTC (input, format, locale, strict, isUTC) {
		        var c = {};
	
		        if (typeof(locale) === 'boolean') {
		            strict = locale;
		            locale = undefined;
		        }
		        // object construction must be done this way.
		        // https://github.com/moment/moment/issues/1423
		        c._isAMomentObject = true;
		        c._useUTC = c._isUTC = isUTC;
		        c._l = locale;
		        c._i = input;
		        c._f = format;
		        c._strict = strict;
	
		        return createFromConfig(c);
		    }
	
		    function local__createLocal (input, format, locale, strict) {
		        return createLocalOrUTC(input, format, locale, strict, false);
		    }
	
		    var prototypeMin = deprecate(
		         'moment().min is deprecated, use moment.max instead. https://github.com/moment/moment/issues/1548',
		         function () {
		             var other = local__createLocal.apply(null, arguments);
		             if (this.isValid() && other.isValid()) {
		                 return other < this ? this : other;
		             } else {
		                 return valid__createInvalid();
		             }
		         }
		     );
	
		    var prototypeMax = deprecate(
		        'moment().max is deprecated, use moment.min instead. https://github.com/moment/moment/issues/1548',
		        function () {
		            var other = local__createLocal.apply(null, arguments);
		            if (this.isValid() && other.isValid()) {
		                return other > this ? this : other;
		            } else {
		                return valid__createInvalid();
		            }
		        }
		    );
	
		    // Pick a moment m from moments so that m[fn](other) is true for all
		    // other. This relies on the function fn to be transitive.
		    //
		    // moments should either be an array of moment objects or an array, whose
		    // first element is an array of moment objects.
		    function pickBy(fn, moments) {
		        var res, i;
		        if (moments.length === 1 && isArray(moments[0])) {
		            moments = moments[0];
		        }
		        if (!moments.length) {
		            return local__createLocal();
		        }
		        res = moments[0];
		        for (i = 1; i < moments.length; ++i) {
		            if (!moments[i].isValid() || moments[i][fn](res)) {
		                res = moments[i];
		            }
		        }
		        return res;
		    }
	
		    // TODO: Use [].sort instead?
		    function min () {
		        var args = [].slice.call(arguments, 0);
	
		        return pickBy('isBefore', args);
		    }
	
		    function max () {
		        var args = [].slice.call(arguments, 0);
	
		        return pickBy('isAfter', args);
		    }
	
		    var now = function () {
		        return Date.now ? Date.now() : +(new Date());
		    };
	
		    function Duration (duration) {
		        var normalizedInput = normalizeObjectUnits(duration),
		            years = normalizedInput.year || 0,
		            quarters = normalizedInput.quarter || 0,
		            months = normalizedInput.month || 0,
		            weeks = normalizedInput.week || 0,
		            days = normalizedInput.day || 0,
		            hours = normalizedInput.hour || 0,
		            minutes = normalizedInput.minute || 0,
		            seconds = normalizedInput.second || 0,
		            milliseconds = normalizedInput.millisecond || 0;
	
		        // representation for dateAddRemove
		        this._milliseconds = +milliseconds +
		            seconds * 1e3 + // 1000
		            minutes * 6e4 + // 1000 * 60
		            hours * 1000 * 60 * 60; //using 1000 * 60 * 60 instead of 36e5 to avoid floating point rounding errors https://github.com/moment/moment/issues/2978
		        // Because of dateAddRemove treats 24 hours as different from a
		        // day when working around DST, we need to store them separately
		        this._days = +days +
		            weeks * 7;
		        // It is impossible translate months into days without knowing
		        // which months you are are talking about, so we have to store
		        // it separately.
		        this._months = +months +
		            quarters * 3 +
		            years * 12;
	
		        this._data = {};
	
		        this._locale = locale_locales__getLocale();
	
		        this._bubble();
		    }
	
		    function isDuration (obj) {
		        return obj instanceof Duration;
		    }
	
		    // FORMATTING
	
		    function offset (token, separator) {
		        addFormatToken(token, 0, 0, function () {
		            var offset = this.utcOffset();
		            var sign = '+';
		            if (offset < 0) {
		                offset = -offset;
		                sign = '-';
		            }
		            return sign + zeroFill(~~(offset / 60), 2) + separator + zeroFill(~~(offset) % 60, 2);
		        });
		    }
	
		    offset('Z', ':');
		    offset('ZZ', '');
	
		    // PARSING
	
		    addRegexToken('Z',  matchShortOffset);
		    addRegexToken('ZZ', matchShortOffset);
		    addParseToken(['Z', 'ZZ'], function (input, array, config) {
		        config._useUTC = true;
		        config._tzm = offsetFromString(matchShortOffset, input);
		    });
	
		    // HELPERS
	
		    // timezone chunker
		    // '+10:00' > ['10',  '00']
		    // '-1530'  > ['-15', '30']
		    var chunkOffset = /([\+\-]|\d\d)/gi;
	
		    function offsetFromString(matcher, string) {
		        var matches = ((string || '').match(matcher) || []);
		        var chunk   = matches[matches.length - 1] || [];
		        var parts   = (chunk + '').match(chunkOffset) || ['-', 0, 0];
		        var minutes = +(parts[1] * 60) + toInt(parts[2]);
	
		        return parts[0] === '+' ? minutes : -minutes;
		    }
	
		    // Return a moment from input, that is local/utc/zone equivalent to model.
		    function cloneWithOffset(input, model) {
		        var res, diff;
		        if (model._isUTC) {
		            res = model.clone();
		            diff = (isMoment(input) || isDate(input) ? input.valueOf() : local__createLocal(input).valueOf()) - res.valueOf();
		            // Use low-level api, because this fn is low-level api.
		            res._d.setTime(res._d.valueOf() + diff);
		            utils_hooks__hooks.updateOffset(res, false);
		            return res;
		        } else {
		            return local__createLocal(input).local();
		        }
		    }
	
		    function getDateOffset (m) {
		        // On Firefox.24 Date#getTimezoneOffset returns a floating point.
		        // https://github.com/moment/moment/pull/1871
		        return -Math.round(m._d.getTimezoneOffset() / 15) * 15;
		    }
	
		    // HOOKS
	
		    // This function will be called whenever a moment is mutated.
		    // It is intended to keep the offset in sync with the timezone.
		    utils_hooks__hooks.updateOffset = function () {};
	
		    // MOMENTS
	
		    // keepLocalTime = true means only change the timezone, without
		    // affecting the local hour. So 5:31:26 +0300 --[utcOffset(2, true)]-->
		    // 5:31:26 +0200 It is possible that 5:31:26 doesn't exist with offset
		    // +0200, so we adjust the time as needed, to be valid.
		    //
		    // Keeping the time actually adds/subtracts (one hour)
		    // from the actual represented time. That is why we call updateOffset
		    // a second time. In case it wants us to change the offset again
		    // _changeInProgress == true case, then we have to adjust, because
		    // there is no such time in the given timezone.
		    function getSetOffset (input, keepLocalTime) {
		        var offset = this._offset || 0,
		            localAdjust;
		        if (!this.isValid()) {
		            return input != null ? this : NaN;
		        }
		        if (input != null) {
		            if (typeof input === 'string') {
		                input = offsetFromString(matchShortOffset, input);
		            } else if (Math.abs(input) < 16) {
		                input = input * 60;
		            }
		            if (!this._isUTC && keepLocalTime) {
		                localAdjust = getDateOffset(this);
		            }
		            this._offset = input;
		            this._isUTC = true;
		            if (localAdjust != null) {
		                this.add(localAdjust, 'm');
		            }
		            if (offset !== input) {
		                if (!keepLocalTime || this._changeInProgress) {
		                    add_subtract__addSubtract(this, create__createDuration(input - offset, 'm'), 1, false);
		                } else if (!this._changeInProgress) {
		                    this._changeInProgress = true;
		                    utils_hooks__hooks.updateOffset(this, true);
		                    this._changeInProgress = null;
		                }
		            }
		            return this;
		        } else {
		            return this._isUTC ? offset : getDateOffset(this);
		        }
		    }
	
		    function getSetZone (input, keepLocalTime) {
		        if (input != null) {
		            if (typeof input !== 'string') {
		                input = -input;
		            }
	
		            this.utcOffset(input, keepLocalTime);
	
		            return this;
		        } else {
		            return -this.utcOffset();
		        }
		    }
	
		    function setOffsetToUTC (keepLocalTime) {
		        return this.utcOffset(0, keepLocalTime);
		    }
	
		    function setOffsetToLocal (keepLocalTime) {
		        if (this._isUTC) {
		            this.utcOffset(0, keepLocalTime);
		            this._isUTC = false;
	
		            if (keepLocalTime) {
		                this.subtract(getDateOffset(this), 'm');
		            }
		        }
		        return this;
		    }
	
		    function setOffsetToParsedOffset () {
		        if (this._tzm) {
		            this.utcOffset(this._tzm);
		        } else if (typeof this._i === 'string') {
		            this.utcOffset(offsetFromString(matchOffset, this._i));
		        }
		        return this;
		    }
	
		    function hasAlignedHourOffset (input) {
		        if (!this.isValid()) {
		            return false;
		        }
		        input = input ? local__createLocal(input).utcOffset() : 0;
	
		        return (this.utcOffset() - input) % 60 === 0;
		    }
	
		    function isDaylightSavingTime () {
		        return (
		            this.utcOffset() > this.clone().month(0).utcOffset() ||
		            this.utcOffset() > this.clone().month(5).utcOffset()
		        );
		    }
	
		    function isDaylightSavingTimeShifted () {
		        if (!isUndefined(this._isDSTShifted)) {
		            return this._isDSTShifted;
		        }
	
		        var c = {};
	
		        copyConfig(c, this);
		        c = prepareConfig(c);
	
		        if (c._a) {
		            var other = c._isUTC ? create_utc__createUTC(c._a) : local__createLocal(c._a);
		            this._isDSTShifted = this.isValid() &&
		                compareArrays(c._a, other.toArray()) > 0;
		        } else {
		            this._isDSTShifted = false;
		        }
	
		        return this._isDSTShifted;
		    }
	
		    function isLocal () {
		        return this.isValid() ? !this._isUTC : false;
		    }
	
		    function isUtcOffset () {
		        return this.isValid() ? this._isUTC : false;
		    }
	
		    function isUtc () {
		        return this.isValid() ? this._isUTC && this._offset === 0 : false;
		    }
	
		    // ASP.NET json date format regex
		    var aspNetRegex = /^(\-)?(?:(\d*)[. ])?(\d+)\:(\d+)(?:\:(\d+)\.?(\d{3})?\d*)?$/;
	
		    // from http://docs.closure-library.googlecode.com/git/closure_goog_date_date.js.source.html
		    // somewhat more in line with 4.4.3.2 2004 spec, but allows decimal anywhere
		    // and further modified to allow for strings containing both week and day
		    var isoRegex = /^(-)?P(?:(-?[0-9,.]*)Y)?(?:(-?[0-9,.]*)M)?(?:(-?[0-9,.]*)W)?(?:(-?[0-9,.]*)D)?(?:T(?:(-?[0-9,.]*)H)?(?:(-?[0-9,.]*)M)?(?:(-?[0-9,.]*)S)?)?$/;
	
		    function create__createDuration (input, key) {
		        var duration = input,
		            // matching against regexp is expensive, do it on demand
		            match = null,
		            sign,
		            ret,
		            diffRes;
	
		        if (isDuration(input)) {
		            duration = {
		                ms : input._milliseconds,
		                d  : input._days,
		                M  : input._months
		            };
		        } else if (typeof input === 'number') {
		            duration = {};
		            if (key) {
		                duration[key] = input;
		            } else {
		                duration.milliseconds = input;
		            }
		        } else if (!!(match = aspNetRegex.exec(input))) {
		            sign = (match[1] === '-') ? -1 : 1;
		            duration = {
		                y  : 0,
		                d  : toInt(match[DATE])        * sign,
		                h  : toInt(match[HOUR])        * sign,
		                m  : toInt(match[MINUTE])      * sign,
		                s  : toInt(match[SECOND])      * sign,
		                ms : toInt(match[MILLISECOND]) * sign
		            };
		        } else if (!!(match = isoRegex.exec(input))) {
		            sign = (match[1] === '-') ? -1 : 1;
		            duration = {
		                y : parseIso(match[2], sign),
		                M : parseIso(match[3], sign),
		                w : parseIso(match[4], sign),
		                d : parseIso(match[5], sign),
		                h : parseIso(match[6], sign),
		                m : parseIso(match[7], sign),
		                s : parseIso(match[8], sign)
		            };
		        } else if (duration == null) {// checks for null or undefined
		            duration = {};
		        } else if (typeof duration === 'object' && ('from' in duration || 'to' in duration)) {
		            diffRes = momentsDifference(local__createLocal(duration.from), local__createLocal(duration.to));
	
		            duration = {};
		            duration.ms = diffRes.milliseconds;
		            duration.M = diffRes.months;
		        }
	
		        ret = new Duration(duration);
	
		        if (isDuration(input) && hasOwnProp(input, '_locale')) {
		            ret._locale = input._locale;
		        }
	
		        return ret;
		    }
	
		    create__createDuration.fn = Duration.prototype;
	
		    function parseIso (inp, sign) {
		        // We'd normally use ~~inp for this, but unfortunately it also
		        // converts floats to ints.
		        // inp may be undefined, so careful calling replace on it.
		        var res = inp && parseFloat(inp.replace(',', '.'));
		        // apply sign while we're at it
		        return (isNaN(res) ? 0 : res) * sign;
		    }
	
		    function positiveMomentsDifference(base, other) {
		        var res = {milliseconds: 0, months: 0};
	
		        res.months = other.month() - base.month() +
		            (other.year() - base.year()) * 12;
		        if (base.clone().add(res.months, 'M').isAfter(other)) {
		            --res.months;
		        }
	
		        res.milliseconds = +other - +(base.clone().add(res.months, 'M'));
	
		        return res;
		    }
	
		    function momentsDifference(base, other) {
		        var res;
		        if (!(base.isValid() && other.isValid())) {
		            return {milliseconds: 0, months: 0};
		        }
	
		        other = cloneWithOffset(other, base);
		        if (base.isBefore(other)) {
		            res = positiveMomentsDifference(base, other);
		        } else {
		            res = positiveMomentsDifference(other, base);
		            res.milliseconds = -res.milliseconds;
		            res.months = -res.months;
		        }
	
		        return res;
		    }
	
		    function absRound (number) {
		        if (number < 0) {
		            return Math.round(-1 * number) * -1;
		        } else {
		            return Math.round(number);
		        }
		    }
	
		    // TODO: remove 'name' arg after deprecation is removed
		    function createAdder(direction, name) {
		        return function (val, period) {
		            var dur, tmp;
		            //invert the arguments, but complain about it
		            if (period !== null && !isNaN(+period)) {
		                deprecateSimple(name, 'moment().' + name  + '(period, number) is deprecated. Please use moment().' + name + '(number, period).');
		                tmp = val; val = period; period = tmp;
		            }
	
		            val = typeof val === 'string' ? +val : val;
		            dur = create__createDuration(val, period);
		            add_subtract__addSubtract(this, dur, direction);
		            return this;
		        };
		    }
	
		    function add_subtract__addSubtract (mom, duration, isAdding, updateOffset) {
		        var milliseconds = duration._milliseconds,
		            days = absRound(duration._days),
		            months = absRound(duration._months);
	
		        if (!mom.isValid()) {
		            // No op
		            return;
		        }
	
		        updateOffset = updateOffset == null ? true : updateOffset;
	
		        if (milliseconds) {
		            mom._d.setTime(mom._d.valueOf() + milliseconds * isAdding);
		        }
		        if (days) {
		            get_set__set(mom, 'Date', get_set__get(mom, 'Date') + days * isAdding);
		        }
		        if (months) {
		            setMonth(mom, get_set__get(mom, 'Month') + months * isAdding);
		        }
		        if (updateOffset) {
		            utils_hooks__hooks.updateOffset(mom, days || months);
		        }
		    }
	
		    var add_subtract__add      = createAdder(1, 'add');
		    var add_subtract__subtract = createAdder(-1, 'subtract');
	
		    function moment_calendar__calendar (time, formats) {
		        // We want to compare the start of today, vs this.
		        // Getting start-of-today depends on whether we're local/utc/offset or not.
		        var now = time || local__createLocal(),
		            sod = cloneWithOffset(now, this).startOf('day'),
		            diff = this.diff(sod, 'days', true),
		            format = diff < -6 ? 'sameElse' :
		                diff < -1 ? 'lastWeek' :
		                diff < 0 ? 'lastDay' :
		                diff < 1 ? 'sameDay' :
		                diff < 2 ? 'nextDay' :
		                diff < 7 ? 'nextWeek' : 'sameElse';
	
		        var output = formats && (isFunction(formats[format]) ? formats[format]() : formats[format]);
	
		        return this.format(output || this.localeData().calendar(format, this, local__createLocal(now)));
		    }
	
		    function clone () {
		        return new Moment(this);
		    }
	
		    function isAfter (input, units) {
		        var localInput = isMoment(input) ? input : local__createLocal(input);
		        if (!(this.isValid() && localInput.isValid())) {
		            return false;
		        }
		        units = normalizeUnits(!isUndefined(units) ? units : 'millisecond');
		        if (units === 'millisecond') {
		            return this.valueOf() > localInput.valueOf();
		        } else {
		            return localInput.valueOf() < this.clone().startOf(units).valueOf();
		        }
		    }
	
		    function isBefore (input, units) {
		        var localInput = isMoment(input) ? input : local__createLocal(input);
		        if (!(this.isValid() && localInput.isValid())) {
		            return false;
		        }
		        units = normalizeUnits(!isUndefined(units) ? units : 'millisecond');
		        if (units === 'millisecond') {
		            return this.valueOf() < localInput.valueOf();
		        } else {
		            return this.clone().endOf(units).valueOf() < localInput.valueOf();
		        }
		    }
	
		    function isBetween (from, to, units, inclusivity) {
		        inclusivity = inclusivity || '()';
		        return (inclusivity[0] === '(' ? this.isAfter(from, units) : !this.isBefore(from, units)) &&
		            (inclusivity[1] === ')' ? this.isBefore(to, units) : !this.isAfter(to, units));
		    }
	
		    function isSame (input, units) {
		        var localInput = isMoment(input) ? input : local__createLocal(input),
		            inputMs;
		        if (!(this.isValid() && localInput.isValid())) {
		            return false;
		        }
		        units = normalizeUnits(units || 'millisecond');
		        if (units === 'millisecond') {
		            return this.valueOf() === localInput.valueOf();
		        } else {
		            inputMs = localInput.valueOf();
		            return this.clone().startOf(units).valueOf() <= inputMs && inputMs <= this.clone().endOf(units).valueOf();
		        }
		    }
	
		    function isSameOrAfter (input, units) {
		        return this.isSame(input, units) || this.isAfter(input,units);
		    }
	
		    function isSameOrBefore (input, units) {
		        return this.isSame(input, units) || this.isBefore(input,units);
		    }
	
		    function diff (input, units, asFloat) {
		        var that,
		            zoneDelta,
		            delta, output;
	
		        if (!this.isValid()) {
		            return NaN;
		        }
	
		        that = cloneWithOffset(input, this);
	
		        if (!that.isValid()) {
		            return NaN;
		        }
	
		        zoneDelta = (that.utcOffset() - this.utcOffset()) * 6e4;
	
		        units = normalizeUnits(units);
	
		        if (units === 'year' || units === 'month' || units === 'quarter') {
		            output = monthDiff(this, that);
		            if (units === 'quarter') {
		                output = output / 3;
		            } else if (units === 'year') {
		                output = output / 12;
		            }
		        } else {
		            delta = this - that;
		            output = units === 'second' ? delta / 1e3 : // 1000
		                units === 'minute' ? delta / 6e4 : // 1000 * 60
		                units === 'hour' ? delta / 36e5 : // 1000 * 60 * 60
		                units === 'day' ? (delta - zoneDelta) / 864e5 : // 1000 * 60 * 60 * 24, negate dst
		                units === 'week' ? (delta - zoneDelta) / 6048e5 : // 1000 * 60 * 60 * 24 * 7, negate dst
		                delta;
		        }
		        return asFloat ? output : absFloor(output);
		    }
	
		    function monthDiff (a, b) {
		        // difference in months
		        var wholeMonthDiff = ((b.year() - a.year()) * 12) + (b.month() - a.month()),
		            // b is in (anchor - 1 month, anchor + 1 month)
		            anchor = a.clone().add(wholeMonthDiff, 'months'),
		            anchor2, adjust;
	
		        if (b - anchor < 0) {
		            anchor2 = a.clone().add(wholeMonthDiff - 1, 'months');
		            // linear across the month
		            adjust = (b - anchor) / (anchor - anchor2);
		        } else {
		            anchor2 = a.clone().add(wholeMonthDiff + 1, 'months');
		            // linear across the month
		            adjust = (b - anchor) / (anchor2 - anchor);
		        }
	
		        //check for negative zero, return zero if negative zero
		        return -(wholeMonthDiff + adjust) || 0;
		    }
	
		    utils_hooks__hooks.defaultFormat = 'YYYY-MM-DDTHH:mm:ssZ';
		    utils_hooks__hooks.defaultFormatUtc = 'YYYY-MM-DDTHH:mm:ss[Z]';
	
		    function toString () {
		        return this.clone().locale('en').format('ddd MMM DD YYYY HH:mm:ss [GMT]ZZ');
		    }
	
		    function moment_format__toISOString () {
		        var m = this.clone().utc();
		        if (0 < m.year() && m.year() <= 9999) {
		            if (isFunction(Date.prototype.toISOString)) {
		                // native implementation is ~50x faster, use it when we can
		                return this.toDate().toISOString();
		            } else {
		                return formatMoment(m, 'YYYY-MM-DD[T]HH:mm:ss.SSS[Z]');
		            }
		        } else {
		            return formatMoment(m, 'YYYYYY-MM-DD[T]HH:mm:ss.SSS[Z]');
		        }
		    }
	
		    function format (inputString) {
		        if (!inputString) {
		            inputString = this.isUtc() ? utils_hooks__hooks.defaultFormatUtc : utils_hooks__hooks.defaultFormat;
		        }
		        var output = formatMoment(this, inputString);
		        return this.localeData().postformat(output);
		    }
	
		    function from (time, withoutSuffix) {
		        if (this.isValid() &&
		                ((isMoment(time) && time.isValid()) ||
		                 local__createLocal(time).isValid())) {
		            return create__createDuration({to: this, from: time}).locale(this.locale()).humanize(!withoutSuffix);
		        } else {
		            return this.localeData().invalidDate();
		        }
		    }
	
		    function fromNow (withoutSuffix) {
		        return this.from(local__createLocal(), withoutSuffix);
		    }
	
		    function to (time, withoutSuffix) {
		        if (this.isValid() &&
		                ((isMoment(time) && time.isValid()) ||
		                 local__createLocal(time).isValid())) {
		            return create__createDuration({from: this, to: time}).locale(this.locale()).humanize(!withoutSuffix);
		        } else {
		            return this.localeData().invalidDate();
		        }
		    }
	
		    function toNow (withoutSuffix) {
		        return this.to(local__createLocal(), withoutSuffix);
		    }
	
		    // If passed a locale key, it will set the locale for this
		    // instance.  Otherwise, it will return the locale configuration
		    // variables for this instance.
		    function locale (key) {
		        var newLocaleData;
	
		        if (key === undefined) {
		            return this._locale._abbr;
		        } else {
		            newLocaleData = locale_locales__getLocale(key);
		            if (newLocaleData != null) {
		                this._locale = newLocaleData;
		            }
		            return this;
		        }
		    }
	
		    var lang = deprecate(
		        'moment().lang() is deprecated. Instead, use moment().localeData() to get the language configuration. Use moment().locale() to change languages.',
		        function (key) {
		            if (key === undefined) {
		                return this.localeData();
		            } else {
		                return this.locale(key);
		            }
		        }
		    );
	
		    function localeData () {
		        return this._locale;
		    }
	
		    function startOf (units) {
		        units = normalizeUnits(units);
		        // the following switch intentionally omits break keywords
		        // to utilize falling through the cases.
		        switch (units) {
		        case 'year':
		            this.month(0);
		            /* falls through */
		        case 'quarter':
		        case 'month':
		            this.date(1);
		            /* falls through */
		        case 'week':
		        case 'isoWeek':
		        case 'day':
		        case 'date':
		            this.hours(0);
		            /* falls through */
		        case 'hour':
		            this.minutes(0);
		            /* falls through */
		        case 'minute':
		            this.seconds(0);
		            /* falls through */
		        case 'second':
		            this.milliseconds(0);
		        }
	
		        // weeks are a special case
		        if (units === 'week') {
		            this.weekday(0);
		        }
		        if (units === 'isoWeek') {
		            this.isoWeekday(1);
		        }
	
		        // quarters are also special
		        if (units === 'quarter') {
		            this.month(Math.floor(this.month() / 3) * 3);
		        }
	
		        return this;
		    }
	
		    function endOf (units) {
		        units = normalizeUnits(units);
		        if (units === undefined || units === 'millisecond') {
		            return this;
		        }
	
		        // 'date' is an alias for 'day', so it should be considered as such.
		        if (units === 'date') {
		            units = 'day';
		        }
	
		        return this.startOf(units).add(1, (units === 'isoWeek' ? 'week' : units)).subtract(1, 'ms');
		    }
	
		    function to_type__valueOf () {
		        return this._d.valueOf() - ((this._offset || 0) * 60000);
		    }
	
		    function unix () {
		        return Math.floor(this.valueOf() / 1000);
		    }
	
		    function toDate () {
		        return this._offset ? new Date(this.valueOf()) : this._d;
		    }
	
		    function toArray () {
		        var m = this;
		        return [m.year(), m.month(), m.date(), m.hour(), m.minute(), m.second(), m.millisecond()];
		    }
	
		    function toObject () {
		        var m = this;
		        return {
		            years: m.year(),
		            months: m.month(),
		            date: m.date(),
		            hours: m.hours(),
		            minutes: m.minutes(),
		            seconds: m.seconds(),
		            milliseconds: m.milliseconds()
		        };
		    }
	
		    function toJSON () {
		        // new Date(NaN).toJSON() === null
		        return this.isValid() ? this.toISOString() : null;
		    }
	
		    function moment_valid__isValid () {
		        return valid__isValid(this);
		    }
	
		    function parsingFlags () {
		        return extend({}, getParsingFlags(this));
		    }
	
		    function invalidAt () {
		        return getParsingFlags(this).overflow;
		    }
	
		    function creationData() {
		        return {
		            input: this._i,
		            format: this._f,
		            locale: this._locale,
		            isUTC: this._isUTC,
		            strict: this._strict
		        };
		    }
	
		    // FORMATTING
	
		    addFormatToken(0, ['gg', 2], 0, function () {
		        return this.weekYear() % 100;
		    });
	
		    addFormatToken(0, ['GG', 2], 0, function () {
		        return this.isoWeekYear() % 100;
		    });
	
		    function addWeekYearFormatToken (token, getter) {
		        addFormatToken(0, [token, token.length], 0, getter);
		    }
	
		    addWeekYearFormatToken('gggg',     'weekYear');
		    addWeekYearFormatToken('ggggg',    'weekYear');
		    addWeekYearFormatToken('GGGG',  'isoWeekYear');
		    addWeekYearFormatToken('GGGGG', 'isoWeekYear');
	
		    // ALIASES
	
		    addUnitAlias('weekYear', 'gg');
		    addUnitAlias('isoWeekYear', 'GG');
	
		    // PARSING
	
		    addRegexToken('G',      matchSigned);
		    addRegexToken('g',      matchSigned);
		    addRegexToken('GG',     match1to2, match2);
		    addRegexToken('gg',     match1to2, match2);
		    addRegexToken('GGGG',   match1to4, match4);
		    addRegexToken('gggg',   match1to4, match4);
		    addRegexToken('GGGGG',  match1to6, match6);
		    addRegexToken('ggggg',  match1to6, match6);
	
		    addWeekParseToken(['gggg', 'ggggg', 'GGGG', 'GGGGG'], function (input, week, config, token) {
		        week[token.substr(0, 2)] = toInt(input);
		    });
	
		    addWeekParseToken(['gg', 'GG'], function (input, week, config, token) {
		        week[token] = utils_hooks__hooks.parseTwoDigitYear(input);
		    });
	
		    // MOMENTS
	
		    function getSetWeekYear (input) {
		        return getSetWeekYearHelper.call(this,
		                input,
		                this.week(),
		                this.weekday(),
		                this.localeData()._week.dow,
		                this.localeData()._week.doy);
		    }
	
		    function getSetISOWeekYear (input) {
		        return getSetWeekYearHelper.call(this,
		                input, this.isoWeek(), this.isoWeekday(), 1, 4);
		    }
	
		    function getISOWeeksInYear () {
		        return weeksInYear(this.year(), 1, 4);
		    }
	
		    function getWeeksInYear () {
		        var weekInfo = this.localeData()._week;
		        return weeksInYear(this.year(), weekInfo.dow, weekInfo.doy);
		    }
	
		    function getSetWeekYearHelper(input, week, weekday, dow, doy) {
		        var weeksTarget;
		        if (input == null) {
		            return weekOfYear(this, dow, doy).year;
		        } else {
		            weeksTarget = weeksInYear(input, dow, doy);
		            if (week > weeksTarget) {
		                week = weeksTarget;
		            }
		            return setWeekAll.call(this, input, week, weekday, dow, doy);
		        }
		    }
	
		    function setWeekAll(weekYear, week, weekday, dow, doy) {
		        var dayOfYearData = dayOfYearFromWeeks(weekYear, week, weekday, dow, doy),
		            date = createUTCDate(dayOfYearData.year, 0, dayOfYearData.dayOfYear);
	
		        this.year(date.getUTCFullYear());
		        this.month(date.getUTCMonth());
		        this.date(date.getUTCDate());
		        return this;
		    }
	
		    // FORMATTING
	
		    addFormatToken('Q', 0, 'Qo', 'quarter');
	
		    // ALIASES
	
		    addUnitAlias('quarter', 'Q');
	
		    // PARSING
	
		    addRegexToken('Q', match1);
		    addParseToken('Q', function (input, array) {
		        array[MONTH] = (toInt(input) - 1) * 3;
		    });
	
		    // MOMENTS
	
		    function getSetQuarter (input) {
		        return input == null ? Math.ceil((this.month() + 1) / 3) : this.month((input - 1) * 3 + this.month() % 3);
		    }
	
		    // FORMATTING
	
		    addFormatToken('w', ['ww', 2], 'wo', 'week');
		    addFormatToken('W', ['WW', 2], 'Wo', 'isoWeek');
	
		    // ALIASES
	
		    addUnitAlias('week', 'w');
		    addUnitAlias('isoWeek', 'W');
	
		    // PARSING
	
		    addRegexToken('w',  match1to2);
		    addRegexToken('ww', match1to2, match2);
		    addRegexToken('W',  match1to2);
		    addRegexToken('WW', match1to2, match2);
	
		    addWeekParseToken(['w', 'ww', 'W', 'WW'], function (input, week, config, token) {
		        week[token.substr(0, 1)] = toInt(input);
		    });
	
		    // HELPERS
	
		    // LOCALES
	
		    function localeWeek (mom) {
		        return weekOfYear(mom, this._week.dow, this._week.doy).week;
		    }
	
		    var defaultLocaleWeek = {
		        dow : 0, // Sunday is the first day of the week.
		        doy : 6  // The week that contains Jan 1st is the first week of the year.
		    };
	
		    function localeFirstDayOfWeek () {
		        return this._week.dow;
		    }
	
		    function localeFirstDayOfYear () {
		        return this._week.doy;
		    }
	
		    // MOMENTS
	
		    function getSetWeek (input) {
		        var week = this.localeData().week(this);
		        return input == null ? week : this.add((input - week) * 7, 'd');
		    }
	
		    function getSetISOWeek (input) {
		        var week = weekOfYear(this, 1, 4).week;
		        return input == null ? week : this.add((input - week) * 7, 'd');
		    }
	
		    // FORMATTING
	
		    addFormatToken('D', ['DD', 2], 'Do', 'date');
	
		    // ALIASES
	
		    addUnitAlias('date', 'D');
	
		    // PARSING
	
		    addRegexToken('D',  match1to2);
		    addRegexToken('DD', match1to2, match2);
		    addRegexToken('Do', function (isStrict, locale) {
		        return isStrict ? locale._ordinalParse : locale._ordinalParseLenient;
		    });
	
		    addParseToken(['D', 'DD'], DATE);
		    addParseToken('Do', function (input, array) {
		        array[DATE] = toInt(input.match(match1to2)[0], 10);
		    });
	
		    // MOMENTS
	
		    var getSetDayOfMonth = makeGetSet('Date', true);
	
		    // FORMATTING
	
		    addFormatToken('d', 0, 'do', 'day');
	
		    addFormatToken('dd', 0, 0, function (format) {
		        return this.localeData().weekdaysMin(this, format);
		    });
	
		    addFormatToken('ddd', 0, 0, function (format) {
		        return this.localeData().weekdaysShort(this, format);
		    });
	
		    addFormatToken('dddd', 0, 0, function (format) {
		        return this.localeData().weekdays(this, format);
		    });
	
		    addFormatToken('e', 0, 0, 'weekday');
		    addFormatToken('E', 0, 0, 'isoWeekday');
	
		    // ALIASES
	
		    addUnitAlias('day', 'd');
		    addUnitAlias('weekday', 'e');
		    addUnitAlias('isoWeekday', 'E');
	
		    // PARSING
	
		    addRegexToken('d',    match1to2);
		    addRegexToken('e',    match1to2);
		    addRegexToken('E',    match1to2);
		    addRegexToken('dd',   function (isStrict, locale) {
		        return locale.weekdaysMinRegex(isStrict);
		    });
		    addRegexToken('ddd',   function (isStrict, locale) {
		        return locale.weekdaysShortRegex(isStrict);
		    });
		    addRegexToken('dddd',   function (isStrict, locale) {
		        return locale.weekdaysRegex(isStrict);
		    });
	
		    addWeekParseToken(['dd', 'ddd', 'dddd'], function (input, week, config, token) {
		        var weekday = config._locale.weekdaysParse(input, token, config._strict);
		        // if we didn't get a weekday name, mark the date as invalid
		        if (weekday != null) {
		            week.d = weekday;
		        } else {
		            getParsingFlags(config).invalidWeekday = input;
		        }
		    });
	
		    addWeekParseToken(['d', 'e', 'E'], function (input, week, config, token) {
		        week[token] = toInt(input);
		    });
	
		    // HELPERS
	
		    function parseWeekday(input, locale) {
		        if (typeof input !== 'string') {
		            return input;
		        }
	
		        if (!isNaN(input)) {
		            return parseInt(input, 10);
		        }
	
		        input = locale.weekdaysParse(input);
		        if (typeof input === 'number') {
		            return input;
		        }
	
		        return null;
		    }
	
		    // LOCALES
	
		    var defaultLocaleWeekdays = 'Sunday_Monday_Tuesday_Wednesday_Thursday_Friday_Saturday'.split('_');
		    function localeWeekdays (m, format) {
		        return isArray(this._weekdays) ? this._weekdays[m.day()] :
		            this._weekdays[this._weekdays.isFormat.test(format) ? 'format' : 'standalone'][m.day()];
		    }
	
		    var defaultLocaleWeekdaysShort = 'Sun_Mon_Tue_Wed_Thu_Fri_Sat'.split('_');
		    function localeWeekdaysShort (m) {
		        return this._weekdaysShort[m.day()];
		    }
	
		    var defaultLocaleWeekdaysMin = 'Su_Mo_Tu_We_Th_Fr_Sa'.split('_');
		    function localeWeekdaysMin (m) {
		        return this._weekdaysMin[m.day()];
		    }
	
		    function day_of_week__handleStrictParse(weekdayName, format, strict) {
		        var i, ii, mom, llc = weekdayName.toLocaleLowerCase();
		        if (!this._weekdaysParse) {
		            this._weekdaysParse = [];
		            this._shortWeekdaysParse = [];
		            this._minWeekdaysParse = [];
	
		            for (i = 0; i < 7; ++i) {
		                mom = create_utc__createUTC([2000, 1]).day(i);
		                this._minWeekdaysParse[i] = this.weekdaysMin(mom, '').toLocaleLowerCase();
		                this._shortWeekdaysParse[i] = this.weekdaysShort(mom, '').toLocaleLowerCase();
		                this._weekdaysParse[i] = this.weekdays(mom, '').toLocaleLowerCase();
		            }
		        }
	
		        if (strict) {
		            if (format === 'dddd') {
		                ii = indexOf.call(this._weekdaysParse, llc);
		                return ii !== -1 ? ii : null;
		            } else if (format === 'ddd') {
		                ii = indexOf.call(this._shortWeekdaysParse, llc);
		                return ii !== -1 ? ii : null;
		            } else {
		                ii = indexOf.call(this._minWeekdaysParse, llc);
		                return ii !== -1 ? ii : null;
		            }
		        } else {
		            if (format === 'dddd') {
		                ii = indexOf.call(this._weekdaysParse, llc);
		                if (ii !== -1) {
		                    return ii;
		                }
		                ii = indexOf.call(this._shortWeekdaysParse, llc);
		                if (ii !== -1) {
		                    return ii;
		                }
		                ii = indexOf.call(this._minWeekdaysParse, llc);
		                return ii !== -1 ? ii : null;
		            } else if (format === 'ddd') {
		                ii = indexOf.call(this._shortWeekdaysParse, llc);
		                if (ii !== -1) {
		                    return ii;
		                }
		                ii = indexOf.call(this._weekdaysParse, llc);
		                if (ii !== -1) {
		                    return ii;
		                }
		                ii = indexOf.call(this._minWeekdaysParse, llc);
		                return ii !== -1 ? ii : null;
		            } else {
		                ii = indexOf.call(this._minWeekdaysParse, llc);
		                if (ii !== -1) {
		                    return ii;
		                }
		                ii = indexOf.call(this._weekdaysParse, llc);
		                if (ii !== -1) {
		                    return ii;
		                }
		                ii = indexOf.call(this._shortWeekdaysParse, llc);
		                return ii !== -1 ? ii : null;
		            }
		        }
		    }
	
		    function localeWeekdaysParse (weekdayName, format, strict) {
		        var i, mom, regex;
	
		        if (this._weekdaysParseExact) {
		            return day_of_week__handleStrictParse.call(this, weekdayName, format, strict);
		        }
	
		        if (!this._weekdaysParse) {
		            this._weekdaysParse = [];
		            this._minWeekdaysParse = [];
		            this._shortWeekdaysParse = [];
		            this._fullWeekdaysParse = [];
		        }
	
		        for (i = 0; i < 7; i++) {
		            // make the regex if we don't have it already
	
		            mom = create_utc__createUTC([2000, 1]).day(i);
		            if (strict && !this._fullWeekdaysParse[i]) {
		                this._fullWeekdaysParse[i] = new RegExp('^' + this.weekdays(mom, '').replace('.', '\.?') + '$', 'i');
		                this._shortWeekdaysParse[i] = new RegExp('^' + this.weekdaysShort(mom, '').replace('.', '\.?') + '$', 'i');
		                this._minWeekdaysParse[i] = new RegExp('^' + this.weekdaysMin(mom, '').replace('.', '\.?') + '$', 'i');
		            }
		            if (!this._weekdaysParse[i]) {
		                regex = '^' + this.weekdays(mom, '') + '|^' + this.weekdaysShort(mom, '') + '|^' + this.weekdaysMin(mom, '');
		                this._weekdaysParse[i] = new RegExp(regex.replace('.', ''), 'i');
		            }
		            // test the regex
		            if (strict && format === 'dddd' && this._fullWeekdaysParse[i].test(weekdayName)) {
		                return i;
		            } else if (strict && format === 'ddd' && this._shortWeekdaysParse[i].test(weekdayName)) {
		                return i;
		            } else if (strict && format === 'dd' && this._minWeekdaysParse[i].test(weekdayName)) {
		                return i;
		            } else if (!strict && this._weekdaysParse[i].test(weekdayName)) {
		                return i;
		            }
		        }
		    }
	
		    // MOMENTS
	
		    function getSetDayOfWeek (input) {
		        if (!this.isValid()) {
		            return input != null ? this : NaN;
		        }
		        var day = this._isUTC ? this._d.getUTCDay() : this._d.getDay();
		        if (input != null) {
		            input = parseWeekday(input, this.localeData());
		            return this.add(input - day, 'd');
		        } else {
		            return day;
		        }
		    }
	
		    function getSetLocaleDayOfWeek (input) {
		        if (!this.isValid()) {
		            return input != null ? this : NaN;
		        }
		        var weekday = (this.day() + 7 - this.localeData()._week.dow) % 7;
		        return input == null ? weekday : this.add(input - weekday, 'd');
		    }
	
		    function getSetISODayOfWeek (input) {
		        if (!this.isValid()) {
		            return input != null ? this : NaN;
		        }
		        // behaves the same as moment#day except
		        // as a getter, returns 7 instead of 0 (1-7 range instead of 0-6)
		        // as a setter, sunday should belong to the previous week.
		        return input == null ? this.day() || 7 : this.day(this.day() % 7 ? input : input - 7);
		    }
	
		    var defaultWeekdaysRegex = matchWord;
		    function weekdaysRegex (isStrict) {
		        if (this._weekdaysParseExact) {
		            if (!hasOwnProp(this, '_weekdaysRegex')) {
		                computeWeekdaysParse.call(this);
		            }
		            if (isStrict) {
		                return this._weekdaysStrictRegex;
		            } else {
		                return this._weekdaysRegex;
		            }
		        } else {
		            return this._weekdaysStrictRegex && isStrict ?
		                this._weekdaysStrictRegex : this._weekdaysRegex;
		        }
		    }
	
		    var defaultWeekdaysShortRegex = matchWord;
		    function weekdaysShortRegex (isStrict) {
		        if (this._weekdaysParseExact) {
		            if (!hasOwnProp(this, '_weekdaysRegex')) {
		                computeWeekdaysParse.call(this);
		            }
		            if (isStrict) {
		                return this._weekdaysShortStrictRegex;
		            } else {
		                return this._weekdaysShortRegex;
		            }
		        } else {
		            return this._weekdaysShortStrictRegex && isStrict ?
		                this._weekdaysShortStrictRegex : this._weekdaysShortRegex;
		        }
		    }
	
		    var defaultWeekdaysMinRegex = matchWord;
		    function weekdaysMinRegex (isStrict) {
		        if (this._weekdaysParseExact) {
		            if (!hasOwnProp(this, '_weekdaysRegex')) {
		                computeWeekdaysParse.call(this);
		            }
		            if (isStrict) {
		                return this._weekdaysMinStrictRegex;
		            } else {
		                return this._weekdaysMinRegex;
		            }
		        } else {
		            return this._weekdaysMinStrictRegex && isStrict ?
		                this._weekdaysMinStrictRegex : this._weekdaysMinRegex;
		        }
		    }
	
	
		    function computeWeekdaysParse () {
		        function cmpLenRev(a, b) {
		            return b.length - a.length;
		        }
	
		        var minPieces = [], shortPieces = [], longPieces = [], mixedPieces = [],
		            i, mom, minp, shortp, longp;
		        for (i = 0; i < 7; i++) {
		            // make the regex if we don't have it already
		            mom = create_utc__createUTC([2000, 1]).day(i);
		            minp = this.weekdaysMin(mom, '');
		            shortp = this.weekdaysShort(mom, '');
		            longp = this.weekdays(mom, '');
		            minPieces.push(minp);
		            shortPieces.push(shortp);
		            longPieces.push(longp);
		            mixedPieces.push(minp);
		            mixedPieces.push(shortp);
		            mixedPieces.push(longp);
		        }
		        // Sorting makes sure if one weekday (or abbr) is a prefix of another it
		        // will match the longer piece.
		        minPieces.sort(cmpLenRev);
		        shortPieces.sort(cmpLenRev);
		        longPieces.sort(cmpLenRev);
		        mixedPieces.sort(cmpLenRev);
		        for (i = 0; i < 7; i++) {
		            shortPieces[i] = regexEscape(shortPieces[i]);
		            longPieces[i] = regexEscape(longPieces[i]);
		            mixedPieces[i] = regexEscape(mixedPieces[i]);
		        }
	
		        this._weekdaysRegex = new RegExp('^(' + mixedPieces.join('|') + ')', 'i');
		        this._weekdaysShortRegex = this._weekdaysRegex;
		        this._weekdaysMinRegex = this._weekdaysRegex;
	
		        this._weekdaysStrictRegex = new RegExp('^(' + longPieces.join('|') + ')', 'i');
		        this._weekdaysShortStrictRegex = new RegExp('^(' + shortPieces.join('|') + ')', 'i');
		        this._weekdaysMinStrictRegex = new RegExp('^(' + minPieces.join('|') + ')', 'i');
		    }
	
		    // FORMATTING
	
		    addFormatToken('DDD', ['DDDD', 3], 'DDDo', 'dayOfYear');
	
		    // ALIASES
	
		    addUnitAlias('dayOfYear', 'DDD');
	
		    // PARSING
	
		    addRegexToken('DDD',  match1to3);
		    addRegexToken('DDDD', match3);
		    addParseToken(['DDD', 'DDDD'], function (input, array, config) {
		        config._dayOfYear = toInt(input);
		    });
	
		    // HELPERS
	
		    // MOMENTS
	
		    function getSetDayOfYear (input) {
		        var dayOfYear = Math.round((this.clone().startOf('day') - this.clone().startOf('year')) / 864e5) + 1;
		        return input == null ? dayOfYear : this.add((input - dayOfYear), 'd');
		    }
	
		    // FORMATTING
	
		    function hFormat() {
		        return this.hours() % 12 || 12;
		    }
	
		    function kFormat() {
		        return this.hours() || 24;
		    }
	
		    addFormatToken('H', ['HH', 2], 0, 'hour');
		    addFormatToken('h', ['hh', 2], 0, hFormat);
		    addFormatToken('k', ['kk', 2], 0, kFormat);
	
		    addFormatToken('hmm', 0, 0, function () {
		        return '' + hFormat.apply(this) + zeroFill(this.minutes(), 2);
		    });
	
		    addFormatToken('hmmss', 0, 0, function () {
		        return '' + hFormat.apply(this) + zeroFill(this.minutes(), 2) +
		            zeroFill(this.seconds(), 2);
		    });
	
		    addFormatToken('Hmm', 0, 0, function () {
		        return '' + this.hours() + zeroFill(this.minutes(), 2);
		    });
	
		    addFormatToken('Hmmss', 0, 0, function () {
		        return '' + this.hours() + zeroFill(this.minutes(), 2) +
		            zeroFill(this.seconds(), 2);
		    });
	
		    function meridiem (token, lowercase) {
		        addFormatToken(token, 0, 0, function () {
		            return this.localeData().meridiem(this.hours(), this.minutes(), lowercase);
		        });
		    }
	
		    meridiem('a', true);
		    meridiem('A', false);
	
		    // ALIASES
	
		    addUnitAlias('hour', 'h');
	
		    // PARSING
	
		    function matchMeridiem (isStrict, locale) {
		        return locale._meridiemParse;
		    }
	
		    addRegexToken('a',  matchMeridiem);
		    addRegexToken('A',  matchMeridiem);
		    addRegexToken('H',  match1to2);
		    addRegexToken('h',  match1to2);
		    addRegexToken('HH', match1to2, match2);
		    addRegexToken('hh', match1to2, match2);
	
		    addRegexToken('hmm', match3to4);
		    addRegexToken('hmmss', match5to6);
		    addRegexToken('Hmm', match3to4);
		    addRegexToken('Hmmss', match5to6);
	
		    addParseToken(['H', 'HH'], HOUR);
		    addParseToken(['a', 'A'], function (input, array, config) {
		        config._isPm = config._locale.isPM(input);
		        config._meridiem = input;
		    });
		    addParseToken(['h', 'hh'], function (input, array, config) {
		        array[HOUR] = toInt(input);
		        getParsingFlags(config).bigHour = true;
		    });
		    addParseToken('hmm', function (input, array, config) {
		        var pos = input.length - 2;
		        array[HOUR] = toInt(input.substr(0, pos));
		        array[MINUTE] = toInt(input.substr(pos));
		        getParsingFlags(config).bigHour = true;
		    });
		    addParseToken('hmmss', function (input, array, config) {
		        var pos1 = input.length - 4;
		        var pos2 = input.length - 2;
		        array[HOUR] = toInt(input.substr(0, pos1));
		        array[MINUTE] = toInt(input.substr(pos1, 2));
		        array[SECOND] = toInt(input.substr(pos2));
		        getParsingFlags(config).bigHour = true;
		    });
		    addParseToken('Hmm', function (input, array, config) {
		        var pos = input.length - 2;
		        array[HOUR] = toInt(input.substr(0, pos));
		        array[MINUTE] = toInt(input.substr(pos));
		    });
		    addParseToken('Hmmss', function (input, array, config) {
		        var pos1 = input.length - 4;
		        var pos2 = input.length - 2;
		        array[HOUR] = toInt(input.substr(0, pos1));
		        array[MINUTE] = toInt(input.substr(pos1, 2));
		        array[SECOND] = toInt(input.substr(pos2));
		    });
	
		    // LOCALES
	
		    function localeIsPM (input) {
		        // IE8 Quirks Mode & IE7 Standards Mode do not allow accessing strings like arrays
		        // Using charAt should be more compatible.
		        return ((input + '').toLowerCase().charAt(0) === 'p');
		    }
	
		    var defaultLocaleMeridiemParse = /[ap]\.?m?\.?/i;
		    function localeMeridiem (hours, minutes, isLower) {
		        if (hours > 11) {
		            return isLower ? 'pm' : 'PM';
		        } else {
		            return isLower ? 'am' : 'AM';
		        }
		    }
	
	
		    // MOMENTS
	
		    // Setting the hour should keep the time, because the user explicitly
		    // specified which hour he wants. So trying to maintain the same hour (in
		    // a new timezone) makes sense. Adding/subtracting hours does not follow
		    // this rule.
		    var getSetHour = makeGetSet('Hours', true);
	
		    // FORMATTING
	
		    addFormatToken('m', ['mm', 2], 0, 'minute');
	
		    // ALIASES
	
		    addUnitAlias('minute', 'm');
	
		    // PARSING
	
		    addRegexToken('m',  match1to2);
		    addRegexToken('mm', match1to2, match2);
		    addParseToken(['m', 'mm'], MINUTE);
	
		    // MOMENTS
	
		    var getSetMinute = makeGetSet('Minutes', false);
	
		    // FORMATTING
	
		    addFormatToken('s', ['ss', 2], 0, 'second');
	
		    // ALIASES
	
		    addUnitAlias('second', 's');
	
		    // PARSING
	
		    addRegexToken('s',  match1to2);
		    addRegexToken('ss', match1to2, match2);
		    addParseToken(['s', 'ss'], SECOND);
	
		    // MOMENTS
	
		    var getSetSecond = makeGetSet('Seconds', false);
	
		    // FORMATTING
	
		    addFormatToken('S', 0, 0, function () {
		        return ~~(this.millisecond() / 100);
		    });
	
		    addFormatToken(0, ['SS', 2], 0, function () {
		        return ~~(this.millisecond() / 10);
		    });
	
		    addFormatToken(0, ['SSS', 3], 0, 'millisecond');
		    addFormatToken(0, ['SSSS', 4], 0, function () {
		        return this.millisecond() * 10;
		    });
		    addFormatToken(0, ['SSSSS', 5], 0, function () {
		        return this.millisecond() * 100;
		    });
		    addFormatToken(0, ['SSSSSS', 6], 0, function () {
		        return this.millisecond() * 1000;
		    });
		    addFormatToken(0, ['SSSSSSS', 7], 0, function () {
		        return this.millisecond() * 10000;
		    });
		    addFormatToken(0, ['SSSSSSSS', 8], 0, function () {
		        return this.millisecond() * 100000;
		    });
		    addFormatToken(0, ['SSSSSSSSS', 9], 0, function () {
		        return this.millisecond() * 1000000;
		    });
	
	
		    // ALIASES
	
		    addUnitAlias('millisecond', 'ms');
	
		    // PARSING
	
		    addRegexToken('S',    match1to3, match1);
		    addRegexToken('SS',   match1to3, match2);
		    addRegexToken('SSS',  match1to3, match3);
	
		    var token;
		    for (token = 'SSSS'; token.length <= 9; token += 'S') {
		        addRegexToken(token, matchUnsigned);
		    }
	
		    function parseMs(input, array) {
		        array[MILLISECOND] = toInt(('0.' + input) * 1000);
		    }
	
		    for (token = 'S'; token.length <= 9; token += 'S') {
		        addParseToken(token, parseMs);
		    }
		    // MOMENTS
	
		    var getSetMillisecond = makeGetSet('Milliseconds', false);
	
		    // FORMATTING
	
		    addFormatToken('z',  0, 0, 'zoneAbbr');
		    addFormatToken('zz', 0, 0, 'zoneName');
	
		    // MOMENTS
	
		    function getZoneAbbr () {
		        return this._isUTC ? 'UTC' : '';
		    }
	
		    function getZoneName () {
		        return this._isUTC ? 'Coordinated Universal Time' : '';
		    }
	
		    var momentPrototype__proto = Moment.prototype;
	
		    momentPrototype__proto.add               = add_subtract__add;
		    momentPrototype__proto.calendar          = moment_calendar__calendar;
		    momentPrototype__proto.clone             = clone;
		    momentPrototype__proto.diff              = diff;
		    momentPrototype__proto.endOf             = endOf;
		    momentPrototype__proto.format            = format;
		    momentPrototype__proto.from              = from;
		    momentPrototype__proto.fromNow           = fromNow;
		    momentPrototype__proto.to                = to;
		    momentPrototype__proto.toNow             = toNow;
		    momentPrototype__proto.get               = getSet;
		    momentPrototype__proto.invalidAt         = invalidAt;
		    momentPrototype__proto.isAfter           = isAfter;
		    momentPrototype__proto.isBefore          = isBefore;
		    momentPrototype__proto.isBetween         = isBetween;
		    momentPrototype__proto.isSame            = isSame;
		    momentPrototype__proto.isSameOrAfter     = isSameOrAfter;
		    momentPrototype__proto.isSameOrBefore    = isSameOrBefore;
		    momentPrototype__proto.isValid           = moment_valid__isValid;
		    momentPrototype__proto.lang              = lang;
		    momentPrototype__proto.locale            = locale;
		    momentPrototype__proto.localeData        = localeData;
		    momentPrototype__proto.max               = prototypeMax;
		    momentPrototype__proto.min               = prototypeMin;
		    momentPrototype__proto.parsingFlags      = parsingFlags;
		    momentPrototype__proto.set               = getSet;
		    momentPrototype__proto.startOf           = startOf;
		    momentPrototype__proto.subtract          = add_subtract__subtract;
		    momentPrototype__proto.toArray           = toArray;
		    momentPrototype__proto.toObject          = toObject;
		    momentPrototype__proto.toDate            = toDate;
		    momentPrototype__proto.toISOString       = moment_format__toISOString;
		    momentPrototype__proto.toJSON            = toJSON;
		    momentPrototype__proto.toString          = toString;
		    momentPrototype__proto.unix              = unix;
		    momentPrototype__proto.valueOf           = to_type__valueOf;
		    momentPrototype__proto.creationData      = creationData;
	
		    // Year
		    momentPrototype__proto.year       = getSetYear;
		    momentPrototype__proto.isLeapYear = getIsLeapYear;
	
		    // Week Year
		    momentPrototype__proto.weekYear    = getSetWeekYear;
		    momentPrototype__proto.isoWeekYear = getSetISOWeekYear;
	
		    // Quarter
		    momentPrototype__proto.quarter = momentPrototype__proto.quarters = getSetQuarter;
	
		    // Month
		    momentPrototype__proto.month       = getSetMonth;
		    momentPrototype__proto.daysInMonth = getDaysInMonth;
	
		    // Week
		    momentPrototype__proto.week           = momentPrototype__proto.weeks        = getSetWeek;
		    momentPrototype__proto.isoWeek        = momentPrototype__proto.isoWeeks     = getSetISOWeek;
		    momentPrototype__proto.weeksInYear    = getWeeksInYear;
		    momentPrototype__proto.isoWeeksInYear = getISOWeeksInYear;
	
		    // Day
		    momentPrototype__proto.date       = getSetDayOfMonth;
		    momentPrototype__proto.day        = momentPrototype__proto.days             = getSetDayOfWeek;
		    momentPrototype__proto.weekday    = getSetLocaleDayOfWeek;
		    momentPrototype__proto.isoWeekday = getSetISODayOfWeek;
		    momentPrototype__proto.dayOfYear  = getSetDayOfYear;
	
		    // Hour
		    momentPrototype__proto.hour = momentPrototype__proto.hours = getSetHour;
	
		    // Minute
		    momentPrototype__proto.minute = momentPrototype__proto.minutes = getSetMinute;
	
		    // Second
		    momentPrototype__proto.second = momentPrototype__proto.seconds = getSetSecond;
	
		    // Millisecond
		    momentPrototype__proto.millisecond = momentPrototype__proto.milliseconds = getSetMillisecond;
	
		    // Offset
		    momentPrototype__proto.utcOffset            = getSetOffset;
		    momentPrototype__proto.utc                  = setOffsetToUTC;
		    momentPrototype__proto.local                = setOffsetToLocal;
		    momentPrototype__proto.parseZone            = setOffsetToParsedOffset;
		    momentPrototype__proto.hasAlignedHourOffset = hasAlignedHourOffset;
		    momentPrototype__proto.isDST                = isDaylightSavingTime;
		    momentPrototype__proto.isDSTShifted         = isDaylightSavingTimeShifted;
		    momentPrototype__proto.isLocal              = isLocal;
		    momentPrototype__proto.isUtcOffset          = isUtcOffset;
		    momentPrototype__proto.isUtc                = isUtc;
		    momentPrototype__proto.isUTC                = isUtc;
	
		    // Timezone
		    momentPrototype__proto.zoneAbbr = getZoneAbbr;
		    momentPrototype__proto.zoneName = getZoneName;
	
		    // Deprecations
		    momentPrototype__proto.dates  = deprecate('dates accessor is deprecated. Use date instead.', getSetDayOfMonth);
		    momentPrototype__proto.months = deprecate('months accessor is deprecated. Use month instead', getSetMonth);
		    momentPrototype__proto.years  = deprecate('years accessor is deprecated. Use year instead', getSetYear);
		    momentPrototype__proto.zone   = deprecate('moment().zone is deprecated, use moment().utcOffset instead. https://github.com/moment/moment/issues/1779', getSetZone);
	
		    var momentPrototype = momentPrototype__proto;
	
		    function moment__createUnix (input) {
		        return local__createLocal(input * 1000);
		    }
	
		    function moment__createInZone () {
		        return local__createLocal.apply(null, arguments).parseZone();
		    }
	
		    var defaultCalendar = {
		        sameDay : '[Today at] LT',
		        nextDay : '[Tomorrow at] LT',
		        nextWeek : 'dddd [at] LT',
		        lastDay : '[Yesterday at] LT',
		        lastWeek : '[Last] dddd [at] LT',
		        sameElse : 'L'
		    };
	
		    function locale_calendar__calendar (key, mom, now) {
		        var output = this._calendar[key];
		        return isFunction(output) ? output.call(mom, now) : output;
		    }
	
		    var defaultLongDateFormat = {
		        LTS  : 'h:mm:ss A',
		        LT   : 'h:mm A',
		        L    : 'MM/DD/YYYY',
		        LL   : 'MMMM D, YYYY',
		        LLL  : 'MMMM D, YYYY h:mm A',
		        LLLL : 'dddd, MMMM D, YYYY h:mm A'
		    };
	
		    function longDateFormat (key) {
		        var format = this._longDateFormat[key],
		            formatUpper = this._longDateFormat[key.toUpperCase()];
	
		        if (format || !formatUpper) {
		            return format;
		        }
	
		        this._longDateFormat[key] = formatUpper.replace(/MMMM|MM|DD|dddd/g, function (val) {
		            return val.slice(1);
		        });
	
		        return this._longDateFormat[key];
		    }
	
		    var defaultInvalidDate = 'Invalid date';
	
		    function invalidDate () {
		        return this._invalidDate;
		    }
	
		    var defaultOrdinal = '%d';
		    var defaultOrdinalParse = /\d{1,2}/;
	
		    function ordinal (number) {
		        return this._ordinal.replace('%d', number);
		    }
	
		    function preParsePostFormat (string) {
		        return string;
		    }
	
		    var defaultRelativeTime = {
		        future : 'in %s',
		        past   : '%s ago',
		        s  : 'a few seconds',
		        m  : 'a minute',
		        mm : '%d minutes',
		        h  : 'an hour',
		        hh : '%d hours',
		        d  : 'a day',
		        dd : '%d days',
		        M  : 'a month',
		        MM : '%d months',
		        y  : 'a year',
		        yy : '%d years'
		    };
	
		    function relative__relativeTime (number, withoutSuffix, string, isFuture) {
		        var output = this._relativeTime[string];
		        return (isFunction(output)) ?
		            output(number, withoutSuffix, string, isFuture) :
		            output.replace(/%d/i, number);
		    }
	
		    function pastFuture (diff, output) {
		        var format = this._relativeTime[diff > 0 ? 'future' : 'past'];
		        return isFunction(format) ? format(output) : format.replace(/%s/i, output);
		    }
	
		    var prototype__proto = Locale.prototype;
	
		    prototype__proto._calendar       = defaultCalendar;
		    prototype__proto.calendar        = locale_calendar__calendar;
		    prototype__proto._longDateFormat = defaultLongDateFormat;
		    prototype__proto.longDateFormat  = longDateFormat;
		    prototype__proto._invalidDate    = defaultInvalidDate;
		    prototype__proto.invalidDate     = invalidDate;
		    prototype__proto._ordinal        = defaultOrdinal;
		    prototype__proto.ordinal         = ordinal;
		    prototype__proto._ordinalParse   = defaultOrdinalParse;
		    prototype__proto.preparse        = preParsePostFormat;
		    prototype__proto.postformat      = preParsePostFormat;
		    prototype__proto._relativeTime   = defaultRelativeTime;
		    prototype__proto.relativeTime    = relative__relativeTime;
		    prototype__proto.pastFuture      = pastFuture;
		    prototype__proto.set             = locale_set__set;
	
		    // Month
		    prototype__proto.months            =        localeMonths;
		    prototype__proto._months           = defaultLocaleMonths;
		    prototype__proto.monthsShort       =        localeMonthsShort;
		    prototype__proto._monthsShort      = defaultLocaleMonthsShort;
		    prototype__proto.monthsParse       =        localeMonthsParse;
		    prototype__proto._monthsRegex      = defaultMonthsRegex;
		    prototype__proto.monthsRegex       = monthsRegex;
		    prototype__proto._monthsShortRegex = defaultMonthsShortRegex;
		    prototype__proto.monthsShortRegex  = monthsShortRegex;
	
		    // Week
		    prototype__proto.week = localeWeek;
		    prototype__proto._week = defaultLocaleWeek;
		    prototype__proto.firstDayOfYear = localeFirstDayOfYear;
		    prototype__proto.firstDayOfWeek = localeFirstDayOfWeek;
	
		    // Day of Week
		    prototype__proto.weekdays       =        localeWeekdays;
		    prototype__proto._weekdays      = defaultLocaleWeekdays;
		    prototype__proto.weekdaysMin    =        localeWeekdaysMin;
		    prototype__proto._weekdaysMin   = defaultLocaleWeekdaysMin;
		    prototype__proto.weekdaysShort  =        localeWeekdaysShort;
		    prototype__proto._weekdaysShort = defaultLocaleWeekdaysShort;
		    prototype__proto.weekdaysParse  =        localeWeekdaysParse;
	
		    prototype__proto._weekdaysRegex      = defaultWeekdaysRegex;
		    prototype__proto.weekdaysRegex       =        weekdaysRegex;
		    prototype__proto._weekdaysShortRegex = defaultWeekdaysShortRegex;
		    prototype__proto.weekdaysShortRegex  =        weekdaysShortRegex;
		    prototype__proto._weekdaysMinRegex   = defaultWeekdaysMinRegex;
		    prototype__proto.weekdaysMinRegex    =        weekdaysMinRegex;
	
		    // Hours
		    prototype__proto.isPM = localeIsPM;
		    prototype__proto._meridiemParse = defaultLocaleMeridiemParse;
		    prototype__proto.meridiem = localeMeridiem;
	
		    function lists__get (format, index, field, setter) {
		        var locale = locale_locales__getLocale();
		        var utc = create_utc__createUTC().set(setter, index);
		        return locale[field](utc, format);
		    }
	
		    function listMonthsImpl (format, index, field) {
		        if (typeof format === 'number') {
		            index = format;
		            format = undefined;
		        }
	
		        format = format || '';
	
		        if (index != null) {
		            return lists__get(format, index, field, 'month');
		        }
	
		        var i;
		        var out = [];
		        for (i = 0; i < 12; i++) {
		            out[i] = lists__get(format, i, field, 'month');
		        }
		        return out;
		    }
	
		    // ()
		    // (5)
		    // (fmt, 5)
		    // (fmt)
		    // (true)
		    // (true, 5)
		    // (true, fmt, 5)
		    // (true, fmt)
		    function listWeekdaysImpl (localeSorted, format, index, field) {
		        if (typeof localeSorted === 'boolean') {
		            if (typeof format === 'number') {
		                index = format;
		                format = undefined;
		            }
	
		            format = format || '';
		        } else {
		            format = localeSorted;
		            index = format;
		            localeSorted = false;
	
		            if (typeof format === 'number') {
		                index = format;
		                format = undefined;
		            }
	
		            format = format || '';
		        }
	
		        var locale = locale_locales__getLocale(),
		            shift = localeSorted ? locale._week.dow : 0;
	
		        if (index != null) {
		            return lists__get(format, (index + shift) % 7, field, 'day');
		        }
	
		        var i;
		        var out = [];
		        for (i = 0; i < 7; i++) {
		            out[i] = lists__get(format, (i + shift) % 7, field, 'day');
		        }
		        return out;
		    }
	
		    function lists__listMonths (format, index) {
		        return listMonthsImpl(format, index, 'months');
		    }
	
		    function lists__listMonthsShort (format, index) {
		        return listMonthsImpl(format, index, 'monthsShort');
		    }
	
		    function lists__listWeekdays (localeSorted, format, index) {
		        return listWeekdaysImpl(localeSorted, format, index, 'weekdays');
		    }
	
		    function lists__listWeekdaysShort (localeSorted, format, index) {
		        return listWeekdaysImpl(localeSorted, format, index, 'weekdaysShort');
		    }
	
		    function lists__listWeekdaysMin (localeSorted, format, index) {
		        return listWeekdaysImpl(localeSorted, format, index, 'weekdaysMin');
		    }
	
		    locale_locales__getSetGlobalLocale('en', {
		        ordinalParse: /\d{1,2}(th|st|nd|rd)/,
		        ordinal : function (number) {
		            var b = number % 10,
		                output = (toInt(number % 100 / 10) === 1) ? 'th' :
		                (b === 1) ? 'st' :
		                (b === 2) ? 'nd' :
		                (b === 3) ? 'rd' : 'th';
		            return number + output;
		        }
		    });
	
		    // Side effect imports
		    utils_hooks__hooks.lang = deprecate('moment.lang is deprecated. Use moment.locale instead.', locale_locales__getSetGlobalLocale);
		    utils_hooks__hooks.langData = deprecate('moment.langData is deprecated. Use moment.localeData instead.', locale_locales__getLocale);
	
		    var mathAbs = Math.abs;
	
		    function duration_abs__abs () {
		        var data           = this._data;
	
		        this._milliseconds = mathAbs(this._milliseconds);
		        this._days         = mathAbs(this._days);
		        this._months       = mathAbs(this._months);
	
		        data.milliseconds  = mathAbs(data.milliseconds);
		        data.seconds       = mathAbs(data.seconds);
		        data.minutes       = mathAbs(data.minutes);
		        data.hours         = mathAbs(data.hours);
		        data.months        = mathAbs(data.months);
		        data.years         = mathAbs(data.years);
	
		        return this;
		    }
	
		    function duration_add_subtract__addSubtract (duration, input, value, direction) {
		        var other = create__createDuration(input, value);
	
		        duration._milliseconds += direction * other._milliseconds;
		        duration._days         += direction * other._days;
		        duration._months       += direction * other._months;
	
		        return duration._bubble();
		    }
	
		    // supports only 2.0-style add(1, 's') or add(duration)
		    function duration_add_subtract__add (input, value) {
		        return duration_add_subtract__addSubtract(this, input, value, 1);
		    }
	
		    // supports only 2.0-style subtract(1, 's') or subtract(duration)
		    function duration_add_subtract__subtract (input, value) {
		        return duration_add_subtract__addSubtract(this, input, value, -1);
		    }
	
		    function absCeil (number) {
		        if (number < 0) {
		            return Math.floor(number);
		        } else {
		            return Math.ceil(number);
		        }
		    }
	
		    function bubble () {
		        var milliseconds = this._milliseconds;
		        var days         = this._days;
		        var months       = this._months;
		        var data         = this._data;
		        var seconds, minutes, hours, years, monthsFromDays;
	
		        // if we have a mix of positive and negative values, bubble down first
		        // check: https://github.com/moment/moment/issues/2166
		        if (!((milliseconds >= 0 && days >= 0 && months >= 0) ||
		                (milliseconds <= 0 && days <= 0 && months <= 0))) {
		            milliseconds += absCeil(monthsToDays(months) + days) * 864e5;
		            days = 0;
		            months = 0;
		        }
	
		        // The following code bubbles up values, see the tests for
		        // examples of what that means.
		        data.milliseconds = milliseconds % 1000;
	
		        seconds           = absFloor(milliseconds / 1000);
		        data.seconds      = seconds % 60;
	
		        minutes           = absFloor(seconds / 60);
		        data.minutes      = minutes % 60;
	
		        hours             = absFloor(minutes / 60);
		        data.hours        = hours % 24;
	
		        days += absFloor(hours / 24);
	
		        // convert days to months
		        monthsFromDays = absFloor(daysToMonths(days));
		        months += monthsFromDays;
		        days -= absCeil(monthsToDays(monthsFromDays));
	
		        // 12 months -> 1 year
		        years = absFloor(months / 12);
		        months %= 12;
	
		        data.days   = days;
		        data.months = months;
		        data.years  = years;
	
		        return this;
		    }
	
		    function daysToMonths (days) {
		        // 400 years have 146097 days (taking into account leap year rules)
		        // 400 years have 12 months === 4800
		        return days * 4800 / 146097;
		    }
	
		    function monthsToDays (months) {
		        // the reverse of daysToMonths
		        return months * 146097 / 4800;
		    }
	
		    function as (units) {
		        var days;
		        var months;
		        var milliseconds = this._milliseconds;
	
		        units = normalizeUnits(units);
	
		        if (units === 'month' || units === 'year') {
		            days   = this._days   + milliseconds / 864e5;
		            months = this._months + daysToMonths(days);
		            return units === 'month' ? months : months / 12;
		        } else {
		            // handle milliseconds separately because of floating point math errors (issue #1867)
		            days = this._days + Math.round(monthsToDays(this._months));
		            switch (units) {
		                case 'week'   : return days / 7     + milliseconds / 6048e5;
		                case 'day'    : return days         + milliseconds / 864e5;
		                case 'hour'   : return days * 24    + milliseconds / 36e5;
		                case 'minute' : return days * 1440  + milliseconds / 6e4;
		                case 'second' : return days * 86400 + milliseconds / 1000;
		                // Math.floor prevents floating point math errors here
		                case 'millisecond': return Math.floor(days * 864e5) + milliseconds;
		                default: throw new Error('Unknown unit ' + units);
		            }
		        }
		    }
	
		    // TODO: Use this.as('ms')?
		    function duration_as__valueOf () {
		        return (
		            this._milliseconds +
		            this._days * 864e5 +
		            (this._months % 12) * 2592e6 +
		            toInt(this._months / 12) * 31536e6
		        );
		    }
	
		    function makeAs (alias) {
		        return function () {
		            return this.as(alias);
		        };
		    }
	
		    var asMilliseconds = makeAs('ms');
		    var asSeconds      = makeAs('s');
		    var asMinutes      = makeAs('m');
		    var asHours        = makeAs('h');
		    var asDays         = makeAs('d');
		    var asWeeks        = makeAs('w');
		    var asMonths       = makeAs('M');
		    var asYears        = makeAs('y');
	
		    function duration_get__get (units) {
		        units = normalizeUnits(units);
		        return this[units + 's']();
		    }
	
		    function makeGetter(name) {
		        return function () {
		            return this._data[name];
		        };
		    }
	
		    var milliseconds = makeGetter('milliseconds');
		    var seconds      = makeGetter('seconds');
		    var minutes      = makeGetter('minutes');
		    var hours        = makeGetter('hours');
		    var days         = makeGetter('days');
		    var months       = makeGetter('months');
		    var years        = makeGetter('years');
	
		    function weeks () {
		        return absFloor(this.days() / 7);
		    }
	
		    var round = Math.round;
		    var thresholds = {
		        s: 45,  // seconds to minute
		        m: 45,  // minutes to hour
		        h: 22,  // hours to day
		        d: 26,  // days to month
		        M: 11   // months to year
		    };
	
		    // helper function for moment.fn.from, moment.fn.fromNow, and moment.duration.fn.humanize
		    function substituteTimeAgo(string, number, withoutSuffix, isFuture, locale) {
		        return locale.relativeTime(number || 1, !!withoutSuffix, string, isFuture);
		    }
	
		    function duration_humanize__relativeTime (posNegDuration, withoutSuffix, locale) {
		        var duration = create__createDuration(posNegDuration).abs();
		        var seconds  = round(duration.as('s'));
		        var minutes  = round(duration.as('m'));
		        var hours    = round(duration.as('h'));
		        var days     = round(duration.as('d'));
		        var months   = round(duration.as('M'));
		        var years    = round(duration.as('y'));
	
		        var a = seconds < thresholds.s && ['s', seconds]  ||
		                minutes <= 1           && ['m']           ||
		                minutes < thresholds.m && ['mm', minutes] ||
		                hours   <= 1           && ['h']           ||
		                hours   < thresholds.h && ['hh', hours]   ||
		                days    <= 1           && ['d']           ||
		                days    < thresholds.d && ['dd', days]    ||
		                months  <= 1           && ['M']           ||
		                months  < thresholds.M && ['MM', months]  ||
		                years   <= 1           && ['y']           || ['yy', years];
	
		        a[2] = withoutSuffix;
		        a[3] = +posNegDuration > 0;
		        a[4] = locale;
		        return substituteTimeAgo.apply(null, a);
		    }
	
		    // This function allows you to set a threshold for relative time strings
		    function duration_humanize__getSetRelativeTimeThreshold (threshold, limit) {
		        if (thresholds[threshold] === undefined) {
		            return false;
		        }
		        if (limit === undefined) {
		            return thresholds[threshold];
		        }
		        thresholds[threshold] = limit;
		        return true;
		    }
	
		    function humanize (withSuffix) {
		        var locale = this.localeData();
		        var output = duration_humanize__relativeTime(this, !withSuffix, locale);
	
		        if (withSuffix) {
		            output = locale.pastFuture(+this, output);
		        }
	
		        return locale.postformat(output);
		    }
	
		    var iso_string__abs = Math.abs;
	
		    function iso_string__toISOString() {
		        // for ISO strings we do not use the normal bubbling rules:
		        //  * milliseconds bubble up until they become hours
		        //  * days do not bubble at all
		        //  * months bubble up until they become years
		        // This is because there is no context-free conversion between hours and days
		        // (think of clock changes)
		        // and also not between days and months (28-31 days per month)
		        var seconds = iso_string__abs(this._milliseconds) / 1000;
		        var days         = iso_string__abs(this._days);
		        var months       = iso_string__abs(this._months);
		        var minutes, hours, years;
	
		        // 3600 seconds -> 60 minutes -> 1 hour
		        minutes           = absFloor(seconds / 60);
		        hours             = absFloor(minutes / 60);
		        seconds %= 60;
		        minutes %= 60;
	
		        // 12 months -> 1 year
		        years  = absFloor(months / 12);
		        months %= 12;
	
	
		        // inspired by https://github.com/dordille/moment-isoduration/blob/master/moment.isoduration.js
		        var Y = years;
		        var M = months;
		        var D = days;
		        var h = hours;
		        var m = minutes;
		        var s = seconds;
		        var total = this.asSeconds();
	
		        if (!total) {
		            // this is the same as C#'s (Noda) and python (isodate)...
		            // but not other JS (goog.date)
		            return 'P0D';
		        }
	
		        return (total < 0 ? '-' : '') +
		            'P' +
		            (Y ? Y + 'Y' : '') +
		            (M ? M + 'M' : '') +
		            (D ? D + 'D' : '') +
		            ((h || m || s) ? 'T' : '') +
		            (h ? h + 'H' : '') +
		            (m ? m + 'M' : '') +
		            (s ? s + 'S' : '');
		    }
	
		    var duration_prototype__proto = Duration.prototype;
	
		    duration_prototype__proto.abs            = duration_abs__abs;
		    duration_prototype__proto.add            = duration_add_subtract__add;
		    duration_prototype__proto.subtract       = duration_add_subtract__subtract;
		    duration_prototype__proto.as             = as;
		    duration_prototype__proto.asMilliseconds = asMilliseconds;
		    duration_prototype__proto.asSeconds      = asSeconds;
		    duration_prototype__proto.asMinutes      = asMinutes;
		    duration_prototype__proto.asHours        = asHours;
		    duration_prototype__proto.asDays         = asDays;
		    duration_prototype__proto.asWeeks        = asWeeks;
		    duration_prototype__proto.asMonths       = asMonths;
		    duration_prototype__proto.asYears        = asYears;
		    duration_prototype__proto.valueOf        = duration_as__valueOf;
		    duration_prototype__proto._bubble        = bubble;
		    duration_prototype__proto.get            = duration_get__get;
		    duration_prototype__proto.milliseconds   = milliseconds;
		    duration_prototype__proto.seconds        = seconds;
		    duration_prototype__proto.minutes        = minutes;
		    duration_prototype__proto.hours          = hours;
		    duration_prototype__proto.days           = days;
		    duration_prototype__proto.weeks          = weeks;
		    duration_prototype__proto.months         = months;
		    duration_prototype__proto.years          = years;
		    duration_prototype__proto.humanize       = humanize;
		    duration_prototype__proto.toISOString    = iso_string__toISOString;
		    duration_prototype__proto.toString       = iso_string__toISOString;
		    duration_prototype__proto.toJSON         = iso_string__toISOString;
		    duration_prototype__proto.locale         = locale;
		    duration_prototype__proto.localeData     = localeData;
	
		    // Deprecations
		    duration_prototype__proto.toIsoString = deprecate('toIsoString() is deprecated. Please use toISOString() instead (notice the capitals)', iso_string__toISOString);
		    duration_prototype__proto.lang = lang;
	
		    // Side effect imports
	
		    // FORMATTING
	
		    addFormatToken('X', 0, 0, 'unix');
		    addFormatToken('x', 0, 0, 'valueOf');
	
		    // PARSING
	
		    addRegexToken('x', matchSigned);
		    addRegexToken('X', matchTimestamp);
		    addParseToken('X', function (input, array, config) {
		        config._d = new Date(parseFloat(input, 10) * 1000);
		    });
		    addParseToken('x', function (input, array, config) {
		        config._d = new Date(toInt(input));
		    });
	
		    // Side effect imports
	
	
		    utils_hooks__hooks.version = '2.13.0';
	
		    setHookCallback(local__createLocal);
	
		    utils_hooks__hooks.fn                    = momentPrototype;
		    utils_hooks__hooks.min                   = min;
		    utils_hooks__hooks.max                   = max;
		    utils_hooks__hooks.now                   = now;
		    utils_hooks__hooks.utc                   = create_utc__createUTC;
		    utils_hooks__hooks.unix                  = moment__createUnix;
		    utils_hooks__hooks.months                = lists__listMonths;
		    utils_hooks__hooks.isDate                = isDate;
		    utils_hooks__hooks.locale                = locale_locales__getSetGlobalLocale;
		    utils_hooks__hooks.invalid               = valid__createInvalid;
		    utils_hooks__hooks.duration              = create__createDuration;
		    utils_hooks__hooks.isMoment              = isMoment;
		    utils_hooks__hooks.weekdays              = lists__listWeekdays;
		    utils_hooks__hooks.parseZone             = moment__createInZone;
		    utils_hooks__hooks.localeData            = locale_locales__getLocale;
		    utils_hooks__hooks.isDuration            = isDuration;
		    utils_hooks__hooks.monthsShort           = lists__listMonthsShort;
		    utils_hooks__hooks.weekdaysMin           = lists__listWeekdaysMin;
		    utils_hooks__hooks.defineLocale          = defineLocale;
		    utils_hooks__hooks.updateLocale          = updateLocale;
		    utils_hooks__hooks.locales               = locale_locales__listLocales;
		    utils_hooks__hooks.weekdaysShort         = lists__listWeekdaysShort;
		    utils_hooks__hooks.normalizeUnits        = normalizeUnits;
		    utils_hooks__hooks.relativeTimeThreshold = duration_humanize__getSetRelativeTimeThreshold;
		    utils_hooks__hooks.prototype             = momentPrototype;
	
		    var _moment = utils_hooks__hooks;
	
		    return _moment;
	
		}));
		/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(63)(module)))
	
	/***/ },
	/* 32 */
	/***/ function(module, exports, __webpack_require__) {
	
		'use strict';
	
		Object.defineProperty(exports, "__esModule", {
		  value: true
		});
	
		var _isObject2 = __webpack_require__(2);
	
		var _isObject3 = _interopRequireDefault(_isObject2);
	
		var _isArray2 = __webpack_require__(3);
	
		var _isArray3 = _interopRequireDefault(_isArray2);
	
		var _merge2 = __webpack_require__(58);
	
		var _merge3 = _interopRequireDefault(_merge2);
	
		var _moment = __webpack_require__(31);
	
		var _moment2 = _interopRequireDefault(_moment);
	
		var _utils = __webpack_require__(64);
	
		function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
		var defaultLocale = {
		  name: 'en',
		  week: {
		    dow: 1
		  }
		};
	
		exports.default = {
		  init: function init() {
		    if (_moment2.default === undefined) {
		      (0, _utils.warn)(this.$options.name + ' stopped executing due to missing Moment.js dependency.');
		      this.$destroy();
		    } else {
		      this.$moment = function (date) {
		        var moment = !date || (0, _isArray3.default)(date) || (0, _isObject3.default)(date) ? (0, _moment2.default)(date || undefined) : (0, _moment2.default)(date, this.format);
		        if (!moment.isValid()) {
		          (0, _utils.warn)('Moment object creation failed with date input \'' + date + '\'');
		        }
		        return moment;
		      };
		    }
		  },
		  created: function created() {
		    var locale = (0, _merge3.default)({}, defaultLocale, this.locale);
		    _moment2.default.updateLocale(locale.name, locale);
		  },
	
		  filters: {
		    format: function format(moment, _format) {
		      return moment.format(_format);
		    }
		  }
		};
	
	/***/ },
	/* 33 */
	/***/ function(module, exports, __webpack_require__) {
	
		'use strict';
	
		Object.defineProperty(exports, "__esModule", {
		  value: true
		});
	
		var _range2 = __webpack_require__(193);
	
		var _range3 = _interopRequireDefault(_range2);
	
		exports.validDate = validDate;
		exports.listYears = listYears;
		exports.listMonths = listMonths;
		exports.listWeekDays = listWeekDays;
		exports.isBetween = isBetween;
		exports.isToday = isToday;
		exports.getCalendarMatrix = getCalendarMatrix;
	
		var _moment = __webpack_require__(31);
	
		var _moment2 = _interopRequireDefault(_moment);
	
		__webpack_require__(201);
	
		function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
		function validDate(moment) {
		  return moment && (0, _moment2.default)(moment).isValid();
		}
	
		function listYears(min, max) {
		  var range = _moment2.default.range((0, _moment2.default)(min), (0, _moment2.default)(max));
		  return range.toArray('years').map(function (moment) {
		    return moment.year();
		  });
		}
	
		function listMonths(currentYear, min, max) {
		  var minDate = (0, _moment2.default)(min);
		  var maxDate = (0, _moment2.default)(max);
		  var inMinYear = currentYear === minDate.year();
		  var inMaxYear = currentYear === maxDate.year();
		  var months = {};
		  _moment2.default.months().forEach(function (name, m) {
		    if ((!inMinYear || m >= minDate.month()) && (!inMaxYear || m <= maxDate.month())) {
		      months[m] = name;
		    }
		  });
		  return months;
		}
	
		function listWeekDays() {
		  return (0, _range3.default)(0, 7).map(function (val, index) {
		    return (0, _moment2.default)().weekday(index).format('ddd');
		  });
		}
	
		function isBetween(moment, min, max) {
		  var range = _moment2.default.range((0, _moment2.default)(min), (0, _moment2.default)(max));
		  return range.contains(moment);
		}
	
		function isToday(moment) {
		  return moment.isSame((0, _moment2.default)(), 'day');
		}
	
		function getCalendarMatrix(date) {
		  var year = date.year();
		  var month = date.month();
		  var hour = date.hour();
		  var minute = date.minute();
		  var second = date.second();
		  var daysInMonth = date.daysInMonth();
		  var firstDay = (0, _moment2.default)([year, month, 1]);
		  var lastDay = (0, _moment2.default)([year, month, daysInMonth]);
		  var lastMonth = (0, _moment2.default)(firstDay).subtract(1, 'month').month();
		  var lastYear = (0, _moment2.default)(firstDay).subtract(1, 'month').year();
		  var daysInLastMonth = (0, _moment2.default)([lastYear, lastMonth]).daysInMonth();
		  var dayOfWeek = firstDay.day();
		  var firstDayOfWeek = _moment2.default.localeData().firstDayOfWeek();
		  var matrix = [];
		  var i = void 0;
		  var col = void 0;
		  var row = void 0;
		  matrix.firstDay = firstDay;
		  matrix.lastDay = lastDay;
		  for (i = 0; i < 6; i++) {
		    matrix[i] = [];
		  }
	
		  var startDay = daysInLastMonth - dayOfWeek + firstDayOfWeek + 1;
		  if (startDay > daysInLastMonth) {
		    startDay -= 7;
		  }
		  if (dayOfWeek === firstDayOfWeek) {
		    startDay = daysInLastMonth - 6;
		  }
		  var curDate = (0, _moment2.default)([lastYear, lastMonth, startDay, 12, minute, second]);
		  for (i = 0, col = 0, row = 0; i < 42; i++, col++, curDate = curDate.clone().add(24, 'hour')) {
		    if (i > 0 && col % 7 === 0) {
		      col = 0;
		      row++;
		    }
		    matrix[row][col] = curDate.clone().hour(hour).minute(minute).second(second);
		    curDate.hour(12);
		  }
		  return matrix;
		}
	
	/***/ },
	/* 34 */
	/***/ function(module, exports) {
	
		// 7.2.1 RequireObjectCoercible(argument)
		module.exports = function(it){
		  if(it == undefined)throw TypeError("Can't call method on  " + it);
		  return it;
		};
	
	/***/ },
	/* 35 */
	/***/ function(module, exports, __webpack_require__) {
	
		var global    = __webpack_require__(20)
		  , core      = __webpack_require__(8)
		  , ctx       = __webpack_require__(98)
		  , hide      = __webpack_require__(102)
		  , PROTOTYPE = 'prototype';
	
		var $export = function(type, name, source){
		  var IS_FORCED = type & $export.F
		    , IS_GLOBAL = type & $export.G
		    , IS_STATIC = type & $export.S
		    , IS_PROTO  = type & $export.P
		    , IS_BIND   = type & $export.B
		    , IS_WRAP   = type & $export.W
		    , exports   = IS_GLOBAL ? core : core[name] || (core[name] = {})
		    , expProto  = exports[PROTOTYPE]
		    , target    = IS_GLOBAL ? global : IS_STATIC ? global[name] : (global[name] || {})[PROTOTYPE]
		    , key, own, out;
		  if(IS_GLOBAL)source = name;
		  for(key in source){
		    // contains in native
		    own = !IS_FORCED && target && target[key] !== undefined;
		    if(own && key in exports)continue;
		    // export native or passed
		    out = own ? target[key] : source[key];
		    // prevent global pollution for namespaces
		    exports[key] = IS_GLOBAL && typeof target[key] != 'function' ? source[key]
		    // bind timers to global for call from export context
		    : IS_BIND && own ? ctx(out, global)
		    // wrap global constructors for prevent change them in library
		    : IS_WRAP && target[key] == out ? (function(C){
		      var F = function(a, b, c){
		        if(this instanceof C){
		          switch(arguments.length){
		            case 0: return new C;
		            case 1: return new C(a);
		            case 2: return new C(a, b);
		          } return new C(a, b, c);
		        } return C.apply(this, arguments);
		      };
		      F[PROTOTYPE] = C[PROTOTYPE];
		      return F;
		    // make static versions for prototype methods
		    })(out) : IS_PROTO && typeof out == 'function' ? ctx(Function.call, out) : out;
		    // export proto methods to core.%CONSTRUCTOR%.methods.%NAME%
		    if(IS_PROTO){
		      (exports.virtual || (exports.virtual = {}))[key] = out;
		      // export proto methods to core.%CONSTRUCTOR%.prototype.%NAME%
		      if(type & $export.R && expProto && !expProto[key])hide(expProto, key, out);
		    }
		  }
		};
		// type bitmap
		$export.F = 1;   // forced
		$export.G = 2;   // global
		$export.S = 4;   // static
		$export.P = 8;   // proto
		$export.B = 16;  // bind
		$export.W = 32;  // wrap
		$export.U = 64;  // safe
		$export.R = 128; // real proto method for `library` 
		module.exports = $export;
	
	/***/ },
	/* 36 */
	/***/ function(module, exports) {
	
		// 7.1.4 ToInteger
		var ceil  = Math.ceil
		  , floor = Math.floor;
		module.exports = function(it){
		  return isNaN(it = +it) ? 0 : (it > 0 ? floor : ceil)(it);
		};
	
	/***/ },
	/* 37 */
	/***/ function(module, exports, __webpack_require__) {
	
		// to indexed object, toObject with fallback for non-array-like ES3 strings
		var IObject = __webpack_require__(104)
		  , defined = __webpack_require__(34);
		module.exports = function(it){
		  return IObject(defined(it));
		};
	
	/***/ },
	/* 38 */
	/***/ function(module, exports, __webpack_require__) {
	
		var getNative = __webpack_require__(5),
		    root = __webpack_require__(1);
	
		/* Built-in method references that are verified to be native. */
		var Map = getNative(root, 'Map');
	
		module.exports = Map;
	
	
	/***/ },
	/* 39 */
	/***/ function(module, exports, __webpack_require__) {
	
		var ListCache = __webpack_require__(10),
		    stackClear = __webpack_require__(183),
		    stackDelete = __webpack_require__(184),
		    stackGet = __webpack_require__(185),
		    stackHas = __webpack_require__(186),
		    stackSet = __webpack_require__(187);
	
		/**
		 * Creates a stack cache object to store key-value pairs.
		 *
		 * @private
		 * @constructor
		 * @param {Array} [entries] The key-value pairs to cache.
		 */
		function Stack(entries) {
		  this.__data__ = new ListCache(entries);
		}
	
		// Add methods to `Stack`.
		Stack.prototype.clear = stackClear;
		Stack.prototype['delete'] = stackDelete;
		Stack.prototype.get = stackGet;
		Stack.prototype.has = stackHas;
		Stack.prototype.set = stackSet;
	
		module.exports = Stack;
	
	
	/***/ },
	/* 40 */
	/***/ function(module, exports, __webpack_require__) {
	
		var root = __webpack_require__(1);
	
		/** Built-in value references. */
		var Symbol = root.Symbol;
	
		module.exports = Symbol;
	
	
	/***/ },
	/* 41 */
	/***/ function(module, exports) {
	
		/**
		 * A specialized version of `_.forEach` for arrays without support for
		 * iteratee shorthands.
		 *
		 * @private
		 * @param {Array} [array] The array to iterate over.
		 * @param {Function} iteratee The function invoked per iteration.
		 * @returns {Array} Returns `array`.
		 */
		function arrayEach(array, iteratee) {
		  var index = -1,
		      length = array ? array.length : 0;
	
		  while (++index < length) {
		    if (iteratee(array[index], index, array) === false) {
		      break;
		    }
		  }
		  return array;
		}
	
		module.exports = arrayEach;
	
	
	/***/ },
	/* 42 */
	/***/ function(module, exports) {
	
		/**
		 * Appends the elements of `values` to `array`.
		 *
		 * @private
		 * @param {Array} array The array to modify.
		 * @param {Array} values The values to append.
		 * @returns {Array} Returns `array`.
		 */
		function arrayPush(array, values) {
		  var index = -1,
		      length = values.length,
		      offset = array.length;
	
		  while (++index < length) {
		    array[offset + index] = values[index];
		  }
		  return array;
		}
	
		module.exports = arrayPush;
	
	
	/***/ },
	/* 43 */
	/***/ function(module, exports) {
	
		/**
		 * A specialized version of `_.reduce` for arrays without support for
		 * iteratee shorthands.
		 *
		 * @private
		 * @param {Array} [array] The array to iterate over.
		 * @param {Function} iteratee The function invoked per iteration.
		 * @param {*} [accumulator] The initial value.
		 * @param {boolean} [initAccum] Specify using the first element of `array` as
		 *  the initial value.
		 * @returns {*} Returns the accumulated value.
		 */
		function arrayReduce(array, iteratee, accumulator, initAccum) {
		  var index = -1,
		      length = array ? array.length : 0;
	
		  if (initAccum && length) {
		    accumulator = array[++index];
		  }
		  while (++index < length) {
		    accumulator = iteratee(accumulator, array[index], index, array);
		  }
		  return accumulator;
		}
	
		module.exports = arrayReduce;
	
	
	/***/ },
	/* 44 */
	/***/ function(module, exports, __webpack_require__) {
	
		var eq = __webpack_require__(14);
	
		/**
		 * This function is like `assignValue` except that it doesn't assign
		 * `undefined` values.
		 *
		 * @private
		 * @param {Object} object The object to modify.
		 * @param {string} key The key of the property to assign.
		 * @param {*} value The value to assign.
		 */
		function assignMergeValue(object, key, value) {
		  if ((value !== undefined && !eq(object[key], value)) ||
		      (typeof key == 'number' && value === undefined && !(key in object))) {
		    object[key] = value;
		  }
		}
	
		module.exports = assignMergeValue;
	
	
	/***/ },
	/* 45 */
	/***/ function(module, exports, __webpack_require__) {
	
		var eq = __webpack_require__(14);
	
		/** Used for built-in method references. */
		var objectProto = Object.prototype;
	
		/** Used to check objects for own properties. */
		var hasOwnProperty = objectProto.hasOwnProperty;
	
		/**
		 * Assigns `value` to `key` of `object` if the existing value is not equivalent
		 * using [`SameValueZero`](http://ecma-international.org/ecma-262/6.0/#sec-samevaluezero)
		 * for equality comparisons.
		 *
		 * @private
		 * @param {Object} object The object to modify.
		 * @param {string} key The key of the property to assign.
		 * @param {*} value The value to assign.
		 */
		function assignValue(object, key, value) {
		  var objValue = object[key];
		  if (!(hasOwnProperty.call(object, key) && eq(objValue, value)) ||
		      (value === undefined && !(key in object))) {
		    object[key] = value;
		  }
		}
	
		module.exports = assignValue;
	
	
	/***/ },
	/* 46 */
	/***/ function(module, exports, __webpack_require__) {
	
		var stubArray = __webpack_require__(195);
	
		/** Built-in value references. */
		var getOwnPropertySymbols = Object.getOwnPropertySymbols;
	
		/**
		 * Creates an array of the own enumerable symbol properties of `object`.
		 *
		 * @private
		 * @param {Object} object The object to query.
		 * @returns {Array} Returns the array of symbols.
		 */
		function getSymbols(object) {
		  // Coerce `object` to an object to avoid non-object errors in V8.
		  // See https://bugs.chromium.org/p/v8/issues/detail?id=3443 for more details.
		  return getOwnPropertySymbols(Object(object));
		}
	
		// Fallback for IE < 11.
		if (!getOwnPropertySymbols) {
		  getSymbols = stubArray;
		}
	
		module.exports = getSymbols;
	
	
	/***/ },
	/* 47 */
	/***/ function(module, exports, __webpack_require__) {
	
		var DataView = __webpack_require__(120),
		    Map = __webpack_require__(38),
		    Promise = __webpack_require__(123),
		    Set = __webpack_require__(125),
		    WeakMap = __webpack_require__(127),
		    toSource = __webpack_require__(53);
	
		/** `Object#toString` result references. */
		var mapTag = '[object Map]',
		    objectTag = '[object Object]',
		    promiseTag = '[object Promise]',
		    setTag = '[object Set]',
		    weakMapTag = '[object WeakMap]';
	
		var dataViewTag = '[object DataView]';
	
		/** Used for built-in method references. */
		var objectProto = Object.prototype;
	
		/**
		 * Used to resolve the
		 * [`toStringTag`](http://ecma-international.org/ecma-262/6.0/#sec-object.prototype.tostring)
		 * of values.
		 */
		var objectToString = objectProto.toString;
	
		/** Used to detect maps, sets, and weakmaps. */
		var dataViewCtorString = toSource(DataView),
		    mapCtorString = toSource(Map),
		    promiseCtorString = toSource(Promise),
		    setCtorString = toSource(Set),
		    weakMapCtorString = toSource(WeakMap);
	
		/**
		 * Gets the `toStringTag` of `value`.
		 *
		 * @private
		 * @param {*} value The value to query.
		 * @returns {string} Returns the `toStringTag`.
		 */
		function getTag(value) {
		  return objectToString.call(value);
		}
	
		// Fallback for data views, maps, sets, and weak maps in IE 11,
		// for data views in Edge, and promises in Node.js.
		if ((DataView && getTag(new DataView(new ArrayBuffer(1))) != dataViewTag) ||
		    (Map && getTag(new Map) != mapTag) ||
		    (Promise && getTag(Promise.resolve()) != promiseTag) ||
		    (Set && getTag(new Set) != setTag) ||
		    (WeakMap && getTag(new WeakMap) != weakMapTag)) {
		  getTag = function(value) {
		    var result = objectToString.call(value),
		        Ctor = result == objectTag ? value.constructor : undefined,
		        ctorString = Ctor ? toSource(Ctor) : undefined;
	
		    if (ctorString) {
		      switch (ctorString) {
		        case dataViewCtorString: return dataViewTag;
		        case mapCtorString: return mapTag;
		        case promiseCtorString: return promiseTag;
		        case setCtorString: return setTag;
		        case weakMapCtorString: return weakMapTag;
		      }
		    }
		    return result;
		  };
		}
	
		module.exports = getTag;
	
	
	/***/ },
	/* 48 */
	/***/ function(module, exports, __webpack_require__) {
	
		var baseTimes = __webpack_require__(145),
		    isArguments = __webpack_require__(28),
		    isArray = __webpack_require__(3),
		    isLength = __webpack_require__(29),
		    isString = __webpack_require__(55);
	
		/**
		 * Creates an array of index keys for `object` values of arrays,
		 * `arguments` objects, and strings, otherwise `null` is returned.
		 *
		 * @private
		 * @param {Object} object The object to query.
		 * @returns {Array|null} Returns index keys, else `null`.
		 */
		function indexKeys(object) {
		  var length = object ? object.length : undefined;
		  if (isLength(length) &&
		      (isArray(object) || isString(object) || isArguments(object))) {
		    return baseTimes(length, String);
		  }
		  return null;
		}
	
		module.exports = indexKeys;
	
	
	/***/ },
	/* 49 */
	/***/ function(module, exports, __webpack_require__) {
	
		var eq = __webpack_require__(14),
		    isArrayLike = __webpack_require__(15),
		    isIndex = __webpack_require__(26),
		    isObject = __webpack_require__(2);
	
		/**
		 * Checks if the given arguments are from an iteratee call.
		 *
		 * @private
		 * @param {*} value The potential iteratee value argument.
		 * @param {*} index The potential iteratee index or key argument.
		 * @param {*} object The potential iteratee object argument.
		 * @returns {boolean} Returns `true` if the arguments are from an iteratee call,
		 *  else `false`.
		 */
		function isIterateeCall(value, index, object) {
		  if (!isObject(object)) {
		    return false;
		  }
		  var type = typeof index;
		  if (type == 'number'
		        ? (isArrayLike(object) && isIndex(index, object.length))
		        : (type == 'string' && index in object)
		      ) {
		    return eq(object[index], value);
		  }
		  return false;
		}
	
		module.exports = isIterateeCall;
	
	
	/***/ },
	/* 50 */
	/***/ function(module, exports) {
	
		/**
		 * Converts `iterator` to an array.
		 *
		 * @private
		 * @param {Object} iterator The iterator to convert.
		 * @returns {Array} Returns the converted array.
		 */
		function iteratorToArray(iterator) {
		  var data,
		      result = [];
	
		  while (!(data = iterator.next()).done) {
		    result.push(data.value);
		  }
		  return result;
		}
	
		module.exports = iteratorToArray;
	
	
	/***/ },
	/* 51 */
	/***/ function(module, exports) {
	
		/**
		 * Converts `map` to its key-value pairs.
		 *
		 * @private
		 * @param {Object} map The map to convert.
		 * @returns {Array} Returns the key-value pairs.
		 */
		function mapToArray(map) {
		  var index = -1,
		      result = Array(map.size);
	
		  map.forEach(function(value, key) {
		    result[++index] = [key, value];
		  });
		  return result;
		}
	
		module.exports = mapToArray;
	
	
	/***/ },
	/* 52 */
	/***/ function(module, exports) {
	
		/**
		 * Converts `set` to an array of its values.
		 *
		 * @private
		 * @param {Object} set The set to convert.
		 * @returns {Array} Returns the values.
		 */
		function setToArray(set) {
		  var index = -1,
		      result = Array(set.size);
	
		  set.forEach(function(value) {
		    result[++index] = value;
		  });
		  return result;
		}
	
		module.exports = setToArray;
	
	
	/***/ },
	/* 53 */
	/***/ function(module, exports) {
	
		/** Used to resolve the decompiled source of functions. */
		var funcToString = Function.prototype.toString;
	
		/**
		 * Converts `func` to its source code.
		 *
		 * @private
		 * @param {Function} func The function to process.
		 * @returns {string} Returns the source code.
		 */
		function toSource(func) {
		  if (func != null) {
		    try {
		      return funcToString.call(func);
		    } catch (e) {}
		    try {
		      return (func + '');
		    } catch (e) {}
		  }
		  return '';
		}
	
		module.exports = toSource;
	
	
	/***/ },
	/* 54 */
	/***/ function(module, exports, __webpack_require__) {
	
		var isArrayLike = __webpack_require__(15),
		    isObjectLike = __webpack_require__(6);
	
		/**
		 * This method is like `_.isArrayLike` except that it also checks if `value`
		 * is an object.
		 *
		 * @static
		 * @memberOf _
		 * @since 4.0.0
		 * @category Lang
		 * @param {*} value The value to check.
		 * @returns {boolean} Returns `true` if `value` is an array-like object,
		 *  else `false`.
		 * @example
		 *
		 * _.isArrayLikeObject([1, 2, 3]);
		 * // => true
		 *
		 * _.isArrayLikeObject(document.body.children);
		 * // => true
		 *
		 * _.isArrayLikeObject('abc');
		 * // => false
		 *
		 * _.isArrayLikeObject(_.noop);
		 * // => false
		 */
		function isArrayLikeObject(value) {
		  return isObjectLike(value) && isArrayLike(value);
		}
	
		module.exports = isArrayLikeObject;
	
	
	/***/ },
	/* 55 */
	/***/ function(module, exports, __webpack_require__) {
	
		var isArray = __webpack_require__(3),
		    isObjectLike = __webpack_require__(6);
	
		/** `Object#toString` result references. */
		var stringTag = '[object String]';
	
		/** Used for built-in method references. */
		var objectProto = Object.prototype;
	
		/**
		 * Used to resolve the
		 * [`toStringTag`](http://ecma-international.org/ecma-262/6.0/#sec-object.prototype.tostring)
		 * of values.
		 */
		var objectToString = objectProto.toString;
	
		/**
		 * Checks if `value` is classified as a `String` primitive or object.
		 *
		 * @static
		 * @since 0.1.0
		 * @memberOf _
		 * @category Lang
		 * @param {*} value The value to check.
		 * @returns {boolean} Returns `true` if `value` is correctly classified,
		 *  else `false`.
		 * @example
		 *
		 * _.isString('abc');
		 * // => true
		 *
		 * _.isString(1);
		 * // => false
		 */
		function isString(value) {
		  return typeof value == 'string' ||
		    (!isArray(value) && isObjectLike(value) && objectToString.call(value) == stringTag);
		}
	
		module.exports = isString;
	
	
	/***/ },
	/* 56 */
	/***/ function(module, exports, __webpack_require__) {
	
		var isLength = __webpack_require__(29),
		    isObjectLike = __webpack_require__(6);
	
		/** `Object#toString` result references. */
		var argsTag = '[object Arguments]',
		    arrayTag = '[object Array]',
		    boolTag = '[object Boolean]',
		    dateTag = '[object Date]',
		    errorTag = '[object Error]',
		    funcTag = '[object Function]',
		    mapTag = '[object Map]',
		    numberTag = '[object Number]',
		    objectTag = '[object Object]',
		    regexpTag = '[object RegExp]',
		    setTag = '[object Set]',
		    stringTag = '[object String]',
		    weakMapTag = '[object WeakMap]';
	
		var arrayBufferTag = '[object ArrayBuffer]',
		    dataViewTag = '[object DataView]',
		    float32Tag = '[object Float32Array]',
		    float64Tag = '[object Float64Array]',
		    int8Tag = '[object Int8Array]',
		    int16Tag = '[object Int16Array]',
		    int32Tag = '[object Int32Array]',
		    uint8Tag = '[object Uint8Array]',
		    uint8ClampedTag = '[object Uint8ClampedArray]',
		    uint16Tag = '[object Uint16Array]',
		    uint32Tag = '[object Uint32Array]';
	
		/** Used to identify `toStringTag` values of typed arrays. */
		var typedArrayTags = {};
		typedArrayTags[float32Tag] = typedArrayTags[float64Tag] =
		typedArrayTags[int8Tag] = typedArrayTags[int16Tag] =
		typedArrayTags[int32Tag] = typedArrayTags[uint8Tag] =
		typedArrayTags[uint8ClampedTag] = typedArrayTags[uint16Tag] =
		typedArrayTags[uint32Tag] = true;
		typedArrayTags[argsTag] = typedArrayTags[arrayTag] =
		typedArrayTags[arrayBufferTag] = typedArrayTags[boolTag] =
		typedArrayTags[dataViewTag] = typedArrayTags[dateTag] =
		typedArrayTags[errorTag] = typedArrayTags[funcTag] =
		typedArrayTags[mapTag] = typedArrayTags[numberTag] =
		typedArrayTags[objectTag] = typedArrayTags[regexpTag] =
		typedArrayTags[setTag] = typedArrayTags[stringTag] =
		typedArrayTags[weakMapTag] = false;
	
		/** Used for built-in method references. */
		var objectProto = Object.prototype;
	
		/**
		 * Used to resolve the
		 * [`toStringTag`](http://ecma-international.org/ecma-262/6.0/#sec-object.prototype.tostring)
		 * of values.
		 */
		var objectToString = objectProto.toString;
	
		/**
		 * Checks if `value` is classified as a typed array.
		 *
		 * @static
		 * @memberOf _
		 * @since 3.0.0
		 * @category Lang
		 * @param {*} value The value to check.
		 * @returns {boolean} Returns `true` if `value` is correctly classified,
		 *  else `false`.
		 * @example
		 *
		 * _.isTypedArray(new Uint8Array);
		 * // => true
		 *
		 * _.isTypedArray([]);
		 * // => false
		 */
		function isTypedArray(value) {
		  return isObjectLike(value) &&
		    isLength(value.length) && !!typedArrayTags[objectToString.call(value)];
		}
	
		module.exports = isTypedArray;
	
	
	/***/ },
	/* 57 */
	/***/ function(module, exports, __webpack_require__) {
	
		var baseKeysIn = __webpack_require__(140),
		    indexKeys = __webpack_require__(48),
		    isIndex = __webpack_require__(26),
		    isPrototype = __webpack_require__(27);
	
		/** Used for built-in method references. */
		var objectProto = Object.prototype;
	
		/** Used to check objects for own properties. */
		var hasOwnProperty = objectProto.hasOwnProperty;
	
		/**
		 * Creates an array of the own and inherited enumerable property names of `object`.
		 *
		 * **Note:** Non-object values are coerced to objects.
		 *
		 * @static
		 * @memberOf _
		 * @since 3.0.0
		 * @category Object
		 * @param {Object} object The object to query.
		 * @returns {Array} Returns the array of property names.
		 * @example
		 *
		 * function Foo() {
		 *   this.a = 1;
		 *   this.b = 2;
		 * }
		 *
		 * Foo.prototype.c = 3;
		 *
		 * _.keysIn(new Foo);
		 * // => ['a', 'b', 'c'] (iteration order is not guaranteed)
		 */
		function keysIn(object) {
		  var index = -1,
		      isProto = isPrototype(object),
		      props = baseKeysIn(object),
		      propsLength = props.length,
		      indexes = indexKeys(object),
		      skipIndexes = !!indexes,
		      result = indexes || [],
		      length = result.length;
	
		  while (++index < propsLength) {
		    var key = props[index];
		    if (!(skipIndexes && (key == 'length' || isIndex(key, length))) &&
		        !(key == 'constructor' && (isProto || !hasOwnProperty.call(object, key)))) {
		      result.push(key);
		    }
		  }
		  return result;
		}
	
		module.exports = keysIn;
	
	
	/***/ },
	/* 58 */
	/***/ function(module, exports, __webpack_require__) {
	
		var baseMerge = __webpack_require__(141),
		    createAssigner = __webpack_require__(157);
	
		/**
		 * This method is like `_.assign` except that it recursively merges own and
		 * inherited enumerable string keyed properties of source objects into the
		 * destination object. Source properties that resolve to `undefined` are
		 * skipped if a destination value exists. Array and plain object properties
		 * are merged recursively. Other objects and value types are overridden by
		 * assignment. Source objects are applied from left to right. Subsequent
		 * sources overwrite property assignments of previous sources.
		 *
		 * **Note:** This method mutates `object`.
		 *
		 * @static
		 * @memberOf _
		 * @since 0.5.0
		 * @category Object
		 * @param {Object} object The destination object.
		 * @param {...Object} [sources] The source objects.
		 * @returns {Object} Returns `object`.
		 * @example
		 *
		 * var users = {
		 *   'data': [{ 'user': 'barney' }, { 'user': 'fred' }]
		 * };
		 *
		 * var ages = {
		 *   'data': [{ 'age': 36 }, { 'age': 40 }]
		 * };
		 *
		 * _.merge(users, ages);
		 * // => { 'data': [{ 'user': 'barney', 'age': 36 }, { 'user': 'fred', 'age': 40 }] }
		 */
		var merge = createAssigner(function(object, source, srcIndex) {
		  baseMerge(object, source, srcIndex);
		});
	
		module.exports = merge;
	
	
	/***/ },
	/* 59 */
	/***/ function(module, exports, __webpack_require__) {
	
		var isFunction = __webpack_require__(16),
		    isObject = __webpack_require__(2),
		    isSymbol = __webpack_require__(192);
	
		/** Used as references for various `Number` constants. */
		var NAN = 0 / 0;
	
		/** Used to match leading and trailing whitespace. */
		var reTrim = /^\s+|\s+$/g;
	
		/** Used to detect bad signed hexadecimal string values. */
		var reIsBadHex = /^[-+]0x[0-9a-f]+$/i;
	
		/** Used to detect binary string values. */
		var reIsBinary = /^0b[01]+$/i;
	
		/** Used to detect octal string values. */
		var reIsOctal = /^0o[0-7]+$/i;
	
		/** Built-in method references without a dependency on `root`. */
		var freeParseInt = parseInt;
	
		/**
		 * Converts `value` to a number.
		 *
		 * @static
		 * @memberOf _
		 * @since 4.0.0
		 * @category Lang
		 * @param {*} value The value to process.
		 * @returns {number} Returns the number.
		 * @example
		 *
		 * _.toNumber(3.2);
		 * // => 3.2
		 *
		 * _.toNumber(Number.MIN_VALUE);
		 * // => 5e-324
		 *
		 * _.toNumber(Infinity);
		 * // => Infinity
		 *
		 * _.toNumber('3.2');
		 * // => 3.2
		 */
		function toNumber(value) {
		  if (typeof value == 'number') {
		    return value;
		  }
		  if (isSymbol(value)) {
		    return NAN;
		  }
		  if (isObject(value)) {
		    var other = isFunction(value.valueOf) ? value.valueOf() : value;
		    value = isObject(other) ? (other + '') : other;
		  }
		  if (typeof value != 'string') {
		    return value === 0 ? value : +value;
		  }
		  value = value.replace(reTrim, '');
		  var isBinary = reIsBinary.test(value);
		  return (isBinary || reIsOctal.test(value))
		    ? freeParseInt(value.slice(2), isBinary ? 2 : 8)
		    : (reIsBadHex.test(value) ? NAN : +value);
		}
	
		module.exports = toNumber;
	
	
	/***/ },
	/* 60 */
	/***/ function(module, exports, __webpack_require__) {
	
		var __vue_script__, __vue_template__
		__vue_script__ = __webpack_require__(68)
		if (__vue_script__ &&
		    __vue_script__.__esModule &&
		    Object.keys(__vue_script__).length > 1) {
		  console.warn("[vue-loader] src/Button.vue: named exports in *.vue files are ignored.")}
		__vue_template__ = __webpack_require__(205)
		module.exports = __vue_script__ || {}
		if (module.exports.__esModule) module.exports = module.exports.default
		if (__vue_template__) {
		(typeof module.exports === "function" ? (module.exports.options || (module.exports.options = {})) : module.exports).template = __vue_template__
		}
		if (false) {(function () {  module.hot.accept()
		  var hotAPI = require("vue-hot-reload-api")
		  hotAPI.install(require("vue"), false)
		  if (!hotAPI.compatible) return
		  var id = "./Button.vue"
		  if (!module.hot.data) {
		    hotAPI.createRecord(id, module.exports)
		  } else {
		    hotAPI.update(id, module.exports, __vue_template__)
		  }
		})()}
	
	/***/ },
	/* 61 */
	/***/ function(module, exports, __webpack_require__) {
	
		var __vue_script__, __vue_template__
		__vue_script__ = __webpack_require__(72)
		if (__vue_script__ &&
		    __vue_script__.__esModule &&
		    Object.keys(__vue_script__).length > 1) {
		  console.warn("[vue-loader] src/Calendar.vue: named exports in *.vue files are ignored.")}
		__vue_template__ = __webpack_require__(209)
		module.exports = __vue_script__ || {}
		if (module.exports.__esModule) module.exports = module.exports.default
		if (__vue_template__) {
		(typeof module.exports === "function" ? (module.exports.options || (module.exports.options = {})) : module.exports).template = __vue_template__
		}
		if (false) {(function () {  module.hot.accept()
		  var hotAPI = require("vue-hot-reload-api")
		  hotAPI.install(require("vue"), false)
		  if (!hotAPI.compatible) return
		  var id = "./Calendar.vue"
		  if (!module.hot.data) {
		    hotAPI.createRecord(id, module.exports)
		  } else {
		    hotAPI.update(id, module.exports, __vue_template__)
		  }
		})()}
	
	/***/ },
	/* 62 */
	/***/ function(module, exports, __webpack_require__) {
	
		var __vue_script__, __vue_template__
		__vue_script__ = __webpack_require__(87)
		if (__vue_script__ &&
		    __vue_script__.__esModule &&
		    Object.keys(__vue_script__).length > 1) {
		  console.warn("[vue-loader] src/TabHeader.vue: named exports in *.vue files are ignored.")}
		__vue_template__ = __webpack_require__(223)
		module.exports = __vue_script__ || {}
		if (module.exports.__esModule) module.exports = module.exports.default
		if (__vue_template__) {
		(typeof module.exports === "function" ? (module.exports.options || (module.exports.options = {})) : module.exports).template = __vue_template__
		}
		if (false) {(function () {  module.hot.accept()
		  var hotAPI = require("vue-hot-reload-api")
		  hotAPI.install(require("vue"), false)
		  if (!hotAPI.compatible) return
		  var id = "./TabHeader.vue"
		  if (!module.hot.data) {
		    hotAPI.createRecord(id, module.exports)
		  } else {
		    hotAPI.update(id, module.exports, __vue_template__)
		  }
		})()}
	
	/***/ },
	/* 63 */
	/***/ function(module, exports) {
	
		module.exports = function(module) {
			if(!module.webpackPolyfill) {
				module.deprecate = function() {};
				module.paths = [];
				// module.parent = undefined by default
				module.children = [];
				module.webpackPolyfill = 1;
			}
			return module;
		}
	
	
	/***/ },
	/* 64 */
	/***/ function(module, exports, __webpack_require__) {
	
		'use strict';
	
		Object.defineProperty(exports, "__esModule", {
		  value: true
		});
		var warn = void 0;
	
		if (false) {
		  (function () {
		    var hasConsole = typeof console !== 'undefined';
	
		    exports.warn = warn = function warn(msg, vm) {
		      if (hasConsole) {
		        console.error('[Vuikit warn]: ' + msg);
		      }
		    };
		  })();
		}
	
		exports.warn = warn;
	
	/***/ },
	/* 65 */
	/***/ function(module, exports, __webpack_require__) {
	
		'use strict';
	
		Object.defineProperty(exports, "__esModule", {
		  value: true
		});
	
		var _merge2 = __webpack_require__(58);
	
		var _merge3 = _interopRequireDefault(_merge2);
	
		var _uikit = __webpack_require__(4);
	
		var _uikit2 = _interopRequireDefault(_uikit);
	
		function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
		exports.default = {
		  props: {
		    show: {
		      type: Boolean,
		      default: true
		    },
	
		    color: {
		      type: String,
		      default: ''
		    },
	
		    large: {
		      type: Boolean,
		      default: false
		    },
	
		    block: {
		      type: Boolean,
		      default: false
		    },
	
		    transition: {
		      type: Object,
		      default: function _default() {
		        return {
		          duration: 200,
		          fade: true
		        };
		      }
		    }
		  },
		  computed: {
		    transitionOptions: function transitionOptions() {
		      return (0, _merge3.default)(this.$options.props.transition.default(), this.transition);
		    }
		  },
		  transitions: {
		    fade: {
		      css: false,
		      leave: function leave(el, done) {
		        if (this.transitionOptions.fade) {
		          _uikit2.default.$(el).animate({ opacity: 0 }, this.transitionOptions.duration, done);
		        } else {
		          done();
		        }
		      }
		    }
		  }
		};
	
	/***/ },
	/* 66 */
	/***/ function(module, exports) {
	
		'use strict';
	
		Object.defineProperty(exports, "__esModule", {
		  value: true
		});
		exports.default = {
		  props: {
		    location: {
		      type: String
		    }
		  },
		  ready: function ready() {
		    if (!this.location) {
		      this.location = this.$children[this.$children.length - 1].path;
		    }
		  },
		  watch: {
		    location: function location(path) {
		      this.$emit('change', path);
		    }
		  }
		};
	
	/***/ },
	/* 67 */
	/***/ function(module, exports) {
	
		"use strict";
	
		Object.defineProperty(exports, "__esModule", {
		  value: true
		});
		exports.default = {
		  props: {
		    path: {
		      type: String,
		      required: true
		    },
		    disabled: {
		      type: Boolean,
		      default: false
		    }
		  }
		};
	
	/***/ },
	/* 68 */
	/***/ function(module, exports) {
	
		'use strict';
	
		Object.defineProperty(exports, "__esModule", {
		  value: true
		});
		exports.default = {
		  props: {
		    value: {},
		    color: {
		      type: String,
		      default: ''
		    },
		    size: {
		      type: String,
		      default: ''
		    },
		    width: {
		      type: String,
		      default: ''
		    },
		    iconLeft: {
		      type: String,
		      default: ''
		    },
		    iconRight: {
		      type: String,
		      default: ''
		    },
		    active: {
		      type: Boolean,
		      default: false
		    },
		    disabled: {
		      type: Boolean,
		      default: false
		    },
		    type: {
		      type: String,
		      default: 'button'
		    }
		  },
		  computed: {
		    classes: function classes() {
		      var classes = {
		        'uk-button-primary': this.color === 'primary',
		        'uk-button-success': this.color === 'success',
		        'uk-button-danger': this.color === 'danger',
		        'uk-button-link': this.color === 'link',
	
		        'uk-button-mini': this.size === 'mini',
		        'uk-button-small': this.size === 'small',
		        'uk-button-large': this.size === 'large',
	
		        'uk-active': this.active
		      };
	
		      classes['uk-width-' + this.width] = this.width;
		      return classes;
		    }
		  }
		};
	
	/***/ },
	/* 69 */
	/***/ function(module, exports, __webpack_require__) {
	
		'use strict';
	
		Object.defineProperty(exports, "__esModule", {
		  value: true
		});
	
		var _toArray2 = __webpack_require__(30);
	
		var _toArray3 = _interopRequireDefault(_toArray2);
	
		var _uikit = __webpack_require__(4);
	
		var _uikit2 = _interopRequireDefault(_uikit);
	
		function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
		exports.default = {
		  props: {
		    value: {
		      type: Array,
		      default: function _default() {
		        return [];
		      }
		    },
		    group: {
		      type: Boolean,
		      default: true
		    }
		  },
		  computed: {
		    buttons: function buttons() {
		      return this.$children.filter(function (btn) {
		        return btn.$options.name === 'VkButton';
		      });
		    }
		  },
		  ready: function ready() {
		    var _this = this;
	
		    this.buttons.filter(function (btn) {
		      return btn.active;
		    }).forEach(function (btn) {
		      _this.value.push(btn.value);
		    });
	
		    _uikit2.default.$(this.$el).on('click', function () {
		      var actives = (0, _toArray3.default)(_this.$el.querySelectorAll('.uk-active'));
	
		      _this.value = actives.map(function (btn) {
		        return btn.__vue__.value;
		      });
	
		      _this.$emit('change', _this.value);
		    });
	
		    this.$watch('value', function (value) {
		      this.buttons.forEach(function (btn) {
		        btn.active = value && value.indexOf(btn.value) !== -1;
		      });
		    }, { immediate: true });
		  }
		};
	
	/***/ },
	/* 70 */
	/***/ function(module, exports, __webpack_require__) {
	
		'use strict';
	
		Object.defineProperty(exports, "__esModule", {
		  value: true
		});
	
		var _Button = __webpack_require__(60);
	
		var _Button2 = _interopRequireDefault(_Button);
	
		function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
		exports.default = {
		  extends: _Button2.default,
		  props: {
		    href: {
		      type: String,
		      default: ''
		    }
		  }
		};
	
	/***/ },
	/* 71 */
	/***/ function(module, exports, __webpack_require__) {
	
		'use strict';
	
		Object.defineProperty(exports, "__esModule", {
		  value: true
		});
	
		var _uikit = __webpack_require__(4);
	
		var _uikit2 = _interopRequireDefault(_uikit);
	
		function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
		exports.default = {
		  props: {
		    value: {},
		    group: {
		      type: Boolean,
		      default: true
		    }
		  },
		  computed: {
		    buttons: function buttons() {
		      return this.$children.filter(function (btn) {
		        return btn.$options.name === 'VkButton';
		      });
		    },
		    active: function active() {
		      var active = this.buttons.filter(function (btn) {
		        return btn.active;
		      });
		      return active[0] ? active[0] : false;
		    }
		  },
		  ready: function ready() {
		    var _this = this;
	
		    if (this.active) {
		      this.value = this.active.value;
		    }
	
		    _uikit2.default.$(this.$el).on('change.uk.button', function () {
		      var selected = _this.$el.querySelector('.uk-active').__vue__;
	
		      _this.value = selected.value;
	
		      _this.$emit('change', _this.value);
		    });
	
		    this.$watch('value', function (value) {
		      this.buttons.forEach(function (btn) {
		        btn.active = btn.value === value;
		      });
		    }, { immediate: true });
		  }
		};
	
	/***/ },
	/* 72 */
	/***/ function(module, exports, __webpack_require__) {
	
		'use strict';
	
		Object.defineProperty(exports, "__esModule", {
		  value: true
		});
	
		var _moment = __webpack_require__(32);
	
		var _moment2 = _interopRequireDefault(_moment);
	
		var _dates = __webpack_require__(33);
	
		function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
		exports.default = {
		  mixins: [_moment2.default],
		  props: {
		    year: {
		      type: Number,
		      default: function _default() {
		        return new Date().getFullYear();
		      }
		    },
	
		    month: {
		      type: Number, default: function _default() {
		        return new Date().getMonth();
		      }
		    },
	
		    min: {
		      type: [String, Object, Array],
		      default: '1980-01-01',
		      validator: _dates.validDate
		    },
	
		    max: {
		      type: [String, Object, Array],
		      default: '2050-12-31',
		      validator: _dates.validDate
		    },
	
		    disabledDates: {
		      type: Array,
		      default: function _default() {
		        return [];
		      }
		    },
	
		    selectedDates: {
		      type: Array,
		      default: function _default() {
		        return [];
		      }
		    },
		    locale: {
		      type: Object,
		      default: function _default() {
		        return {};
		      }
		    }
		  },
		  computed: {
		    yearsList: function yearsList() {
		      return (0, _dates.listYears)(this.min, this.max);
		    },
		    monthsList: function monthsList() {
		      return (0, _dates.listMonths)(this.date.year(), this.min, this.max);
		    },
	
		    listWeekDays: _dates.listWeekDays,
		    date: {
		      get: function get() {
		        return this.$moment().set({ year: this.year, month: this.month });
		      },
		      set: function set(moment) {
		        this.year = moment.year();
		        this.month = moment.month();
		      }
		    },
		    matrix: function matrix() {
		      var _this = this;
	
		      this.$nextTick(function () {
		        return _this.$emit('update');
		      });
		      return (0, _dates.getCalendarMatrix)(this.date);
		    },
		    prevMonth: function prevMonth() {
		      return this.date.clone().subtract(1, 'month');
		    },
		    nextMonth: function nextMonth() {
		      return this.date.clone().add(1, 'month');
		    },
		    _disabledDates: function _disabledDates() {
		      var _this2 = this;
	
		      return this.disabledDates.map(function (date) {
		        return _this2.$moment(date);
		      });
		    },
		    _selectedDates: function _selectedDates() {
		      var _this3 = this;
	
		      return this.selectedDates.map(function (date) {
		        return _this3.$moment(date);
		      });
		    }
		  },
		  methods: {
		    isToday: _dates.isToday,
		    isDisabled: function isDisabled(moment) {
		      return this._disabledDates.some(function (date) {
		        return moment.isSame(date, 'day');
		      });
		    },
		    isSelected: function isSelected(moment) {
		      return this._selectedDates.some(function (date) {
		        return moment.isSame(date, 'day');
		      });
		    },
		    isDisplayable: function isDisplayable(moment) {
		      return (0, _dates.isBetween)(moment, this.min, this.max);
		    },
		    isInCurrentMonth: function isInCurrentMonth(moment) {
		      return moment.isSame(this.date, 'month');
		    }
		  }
		};
	
	/***/ },
	/* 73 */
	/***/ function(module, exports, __webpack_require__) {
	
		'use strict';
	
		Object.defineProperty(exports, "__esModule", {
		  value: true
		});
	
		var _isInteger = __webpack_require__(90);
	
		var _isInteger2 = _interopRequireDefault(_isInteger);
	
		var _flatten2 = __webpack_require__(189);
	
		var _flatten3 = _interopRequireDefault(_flatten2);
	
		var _Calendar = __webpack_require__(61);
	
		var _Calendar2 = _interopRequireDefault(_Calendar);
	
		var _moment = __webpack_require__(32);
	
		var _moment2 = _interopRequireDefault(_moment);
	
		var _uikit = __webpack_require__(4);
	
		var _uikit2 = _interopRequireDefault(_uikit);
	
		var _dates = __webpack_require__(33);
	
		function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
		exports.default = {
		  components: {
		    Calendar: _Calendar2.default
		  },
		  init: function init() {},
	
		  mixins: [_moment2.default],
		  ready: function ready() {
		    var vm = this;
	
		    if (this.renderDropdown) {
		      _uikit2.default.$html.on('click focus', '*', function (e) {
		        if (vm.show && e.target !== vm.$els.dropdown && e.target !== vm.$els.input && !_uikit2.default.$(e.target).parents('.uk-datepicker:first').length) {
		          vm.show = false;
		        }
		      });
		    }
		  },
	
		  props: {
		    value: {
		      type: String,
		      default: ''
		    },
	
		    position: {
		      type: String,
		      default: 'auto' },
	
		    offsetTop: {
		      type: Number,
		      default: 5
		    },
	
		    mobile: {
		      type: Boolean,
		      default: false
		    },
	
		    minDate: {
		      type: [String, Number],
		      default: '1980-01-01'
		    },
	
		    maxDate: {
		      type: [String, Number],
		      default: '2050-12-31'
		    },
		    format: {
		      type: String,
		      default: 'YYYY-MM-DD'
		    },
		    locale: {
		      type: Object,
		      default: function _default() {
		        return {};
		      }
		    }
		  },
		  data: function data() {
		    return {
		      show: false
		    };
		  },
	
		  computed: {
		    selected: {
		      get: function get() {
		        return this.value && this.$moment(this.value).isValid() ? this.$moment(this.value) : null;
		      },
	
		      set: function set(moment) {
		        this.value = moment.format(this.format);
		      }
		    },
		    renderDropdown: function renderDropdown() {
		      return this.mobile || !_uikit2.default.support.touch && _uikit2.default.$(this.$els.input).attr('type') !== 'date';
		    },
		    dropdownCss: function dropdownCss() {
		      if (!this.show) {
		        return { display: 'none' };
		      }
		      var input = _uikit2.default.$(this.$els.input);
		      var dropdown = _uikit2.default.$(this.$els.dropdown);
		      var offset = input.offset();
		      var posTop = offset.top - input.outerHeight() + input.height() - this.offsetTop - dropdown.outerHeight();
		      var posBottom = offset.top + input.outerHeight() + this.offsetTop;
		      var css = { left: offset.left, right: '' };
		      if (_uikit2.default.langdirection === 'right') {
		        css.right = window.innerWidth - (css.left + input.outerWidth());
		        css.left = '';
		      }
		      css.top = posBottom;
		      if (this.position === 'top') {
		        css.top = posTop;
		      } else if (this.position === 'auto' && window.innerHeight - posBottom - dropdown.outerHeight() < 0 && posTop >= 0) {
		        css.top = posTop;
		      }
		      return {
		        top: css.top + 'px',
		        left: css.left + 'px',
		        right: css.right + 'px',
		        display: 'block'
		      };
		    },
		    minDateMoment: function minDateMoment() {
		      return (0, _isInteger2.default)(this.minDate) ? this.$moment().add(-this.minDate - 1, 'days') : this.$moment(this.minDate || this.$options.props.minDate.default);
		    },
		    maxDateMoment: function maxDateMoment() {
		      return (0, _isInteger2.default)(this.maxDate) ? this.$moment().add(this.maxDate, 'days') : this.$moment(this.maxDate || this.$options.props.maxDate.default);
		    },
		    selectedDates: function selectedDates() {
		      return this.selected ? [this.selected] : [];
		    },
		    disabledDates: function disabledDates() {
		      var min = this.minDateMoment;
		      var max = this.maxDateMoment;
		      var matrix = (0, _dates.getCalendarMatrix)(this.selected ? this.selected : this.$moment());
		      return (0, _flatten3.default)(matrix).filter(function (moment) {
		        return !(0, _dates.isBetween)(moment, min, max);
		      });
		    }
		  },
		  methods: {
		    isDisabled: function isDisabled(moment) {
		      return this.disabledDates.some(function (date) {
		        return moment.isSame(date, 'day');
		      });
		    },
		    select: function select(moment) {
		      var _this = this;
	
		      this.$emit('select', moment);
		      if (!this.isDisabled(moment) && !moment.isSame(this.selected, 'day')) {
		        this.selected = moment.clone();
	
		        this.$nextTick(function () {
		          return _this.$emit('change', _this.selected);
		        });
	
		        this.show = false;
		      }
		    }
		  },
		  watch: {
		    show: function show(value) {
		      var _this2 = this;
	
		      this.$nextTick(function () {
		        return _this2.$emit(value ? 'show' : 'hide');
		      });
		    }
		  },
		  events: {
		    hide: function hide() {
		      this.$refs.calendar.month = this.selected ? this.selected.month() : this.$moment().month();
		    }
		  }
		};
	
	/***/ },
	/* 74 */
	/***/ function(module, exports, __webpack_require__) {
	
		'use strict';
	
		Object.defineProperty(exports, "__esModule", {
		  value: true
		});
	
		var _ModalBase = __webpack_require__(7);
	
		var _ModalBase2 = _interopRequireDefault(_ModalBase);
	
		function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
		exports.default = {
		  extends: _ModalBase2.default,
		  props: {
		    overflow: {
		      type: Boolean,
		      default: false
		    },
		    closeBtn: {
		      type: Boolean,
		      default: true
		    },
		    large: {
		      type: Boolean,
		      default: false
		    },
		    bgClose: {
		      type: Boolean,
		      default: true
		    }
		  },
		  ready: function ready() {
		    if (!this.isModalSlotSet('header')) {
		      this.removeModalSlot('header');
		    }
		    if (!this.isModalSlotSet('content')) {
		      this.removeModalSlot('content');
		    }
		    if (!this.isModalSlotSet('footer')) {
		      this.removeModalSlot('footer');
		    }
		    if (!this.isModalSlotSet('caption')) {
		      this.removeModalSlot('caption');
		    }
	
		    this.initModal();
		  },
		  methods: {
		    removeModalSlot: function removeModalSlot(slot) {
		      if (this.$els[slot]) {
		        this.$els[slot].parentNode.removeChild(this.$els[slot]);
		      }
		    },
		    isModalSlotSet: function isModalSlotSet(slot) {
		      return this.$els[slot] && this.$els[slot].innerHTML.trim() !== '';
		    }
		  }
		};
	
	/***/ },
	/* 75 */
	/***/ function(module, exports, __webpack_require__) {
	
		'use strict';
	
		Object.defineProperty(exports, "__esModule", {
		  value: true
		});
	
		var _ModalBase = __webpack_require__(7);
	
		var _ModalBase2 = _interopRequireDefault(_ModalBase);
	
		function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
		exports.default = {
		  extends: _ModalBase2.default,
		  props: {
		    text: {
		      type: String,
		      default: ''
		    }
		  }
		};
	
	/***/ },
	/* 76 */
	/***/ function(module, exports, __webpack_require__) {
	
		'use strict';
	
		Object.defineProperty(exports, "__esModule", {
		  value: true
		});
	
		var _uikit = __webpack_require__(4);
	
		var _uikit2 = _interopRequireDefault(_uikit);
	
		function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
		exports.default = {
		  props: {
		    show: {
		      type: Boolean,
		      default: false
		    },
		    block: {
		      type: Boolean,
		      default: false
		    },
		    keyboard: {
		      type: Boolean,
		      default: true
		    },
		    center: {
		      type: Boolean,
		      default: false
		    }
		  },
		  computed: {
		    options: function options() {
		      return {
		        keyboard: this.keyboard,
		        center: this.center,
		        bgclose: this.bgClose
		      };
		    }
		  },
		  watch: {
		    show: function show(state) {
		      if (state) {
		        this.UImodal.show();
		      } else if (this.UImodal.isActive()) {
		        this.UImodal.hide();
		      }
		    },
		    block: function block(state) {
		      if (state) {
		        this.UImodal.options.bgclose = false;
		        this.UImodal.options.keyboard = false;
		        this.UImodal.options.modal = false;
		      } else {
		        this.UImodal.options.bgclose = true;
		        this.UImodal.options.keyboard = true;
		        this.UImodal.options.modal = true;
		      }
		    },
		    center: function center(state) {
		      this.UImodal.options.center = state;
		    },
		    bgClose: function bgClose(state) {
		      this.UImodal.options.bgclose = state;
		    },
		    keyboard: function keyboard(state) {
		      this.UImodal.options.keyboard = state;
		    }
		  },
		  ready: function ready() {
		    this.initModal();
		  },
		  methods: {
		    initModal: function initModal() {
		      var vm = this;
		      this.UImodal = _uikit2.default.modal(this.$els.modal, this.options);
		      this.UImodal.on('show.uk.modal', function () {
		        vm.show = true;
		        vm.$emit('show');
		        setTimeout(function () {
		          vm.UImodal.resize();
		        }, 1);
		      });
		      this.UImodal.on('hide.uk.modal', function () {
		        vm.show = false;
		        vm.$emit('hide');
		      });
		    }
		  }
		};
	
	/***/ },
	/* 77 */
	/***/ function(module, exports, __webpack_require__) {
	
		'use strict';
	
		Object.defineProperty(exports, "__esModule", {
		  value: true
		});
	
		var _ModalBase = __webpack_require__(7);
	
		var _ModalBase2 = _interopRequireDefault(_ModalBase);
	
		function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
		exports.default = {
		  extends: _ModalBase2.default
		};
	
	/***/ },
	/* 78 */
	/***/ function(module, exports, __webpack_require__) {
	
		'use strict';
	
		Object.defineProperty(exports, "__esModule", {
		  value: true
		});
	
		var _ModalBase = __webpack_require__(7);
	
		var _ModalBase2 = _interopRequireDefault(_ModalBase);
	
		function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
		exports.default = {
		  extends: _ModalBase2.default,
		  props: {
		    text: {
		      type: String,
		      default: ''
		    }
		  },
		  data: function data() {
		    return {
		      state: false
		    };
		  },
		  events: {
		    hide: function hide() {
		      if (!this.state) {
		        this.$emit('dismiss');
		      }
		    }
		  },
		  methods: {
		    confirm: function confirm() {
		      this.state = true;
		      this.show = false;
		      this.$emit('confirm');
		    }
		  }
		};
	
	/***/ },
	/* 79 */
	/***/ function(module, exports, __webpack_require__) {
	
		'use strict';
	
		Object.defineProperty(exports, "__esModule", {
		  value: true
		});
	
		var _ModalBase = __webpack_require__(7);
	
		var _ModalBase2 = _interopRequireDefault(_ModalBase);
	
		function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
		exports.default = {
		  extends: _ModalBase2.default,
		  props: {
		    closeBtn: {
		      type: Boolean,
		      default: true
		    },
		    bgClose: {
		      type: Boolean,
		      default: true
		    }
		  }
		};
	
	/***/ },
	/* 80 */
	/***/ function(module, exports) {
	
		'use strict';
	
		Object.defineProperty(exports, "__esModule", {
		  value: true
		});
		exports.default = {
		  props: {
		    align: {
		      type: String,
		      default: ''
		    },
	
		    compact: {
		      type: Boolean,
		      default: false
		    },
	
		    current: {
		      type: Number,
		      default: 1
		    },
	
		    edges: {
		      type: Number,
		      default: 3
		    },
	
		    items: {
		      type: Number,
		      default: 1
		    },
	
		    itemsOnPage: {
		      type: Number,
		      default: 1
		    },
	
		    visiblePages: {
		      type: Number,
		      default: 3
		    }
		  },
		  computed: {
		    index: function index() {
		      return this.current - 1;
		    },
		    prevPage: function prevPage() {
		      return this.current - 1 !== 0 ? this.current - 1 : null;
		    },
		    nextPage: function nextPage() {
		      return this.current + 1 <= this.totalPages ? this.current + 1 : null;
		    },
		    lastPage: function lastPage() {
		      return this.totalPages - 1;
		    },
		    totalPages: function totalPages() {
		      return Math.ceil(this.items / this.itemsOnPage) ? Math.ceil(this.items / this.itemsOnPage) : 1;
		    },
		    interval: function interval() {
		      var pages = this.totalPages;
		      var halfDisplayed = this.visiblePages / 2;
		      return {
		        start: Math.ceil(this.index > halfDisplayed ? Math.max(Math.min(this.index - halfDisplayed, pages - this.visiblePages), 0) : 0),
	
		        end: Math.ceil(this.index > halfDisplayed ? Math.min(this.index + halfDisplayed, pages) : Math.min(this.visiblePages, pages))
		      };
		    },
		    pages: function pages() {
		      var pages = [];
		      var interval = this.interval;
		      var i;
		      for (i = interval.start; i < interval.end; i++) {
		        pages.push(i + 1);
		      }
		      return pages;
		    },
		    prePages: function prePages() {
		      var pages = [];
		      var interval = this.interval;
		      var edges = this.edges;
		      var end = Math.min(edges, interval.start);
		      var i;
		      if (interval.start > 0 && edges > 0) {
		        for (i = 0; i < end; i++) {
		          pages.push(i + 1);
		        }
		      }
		      return pages;
		    },
		    postPages: function postPages() {
		      var pages = [];
		      var totalPages = this.totalPages;
		      var interval = this.interval;
		      var edges = this.edges;
		      var begin = Math.max(totalPages - edges, interval.end);
		      var i;
		      if (interval.end < totalPages && edges > 0) {
		        for (i = begin; i < totalPages; i++) {
		          pages.push(i + 1);
		        }
		      }
		      return pages;
		    }
		  },
		  watch: {
		    current: function current(page) {
		      this.$emit('change', page);
		    }
		  }
		};
	
	/***/ },
	/* 81 */
	/***/ function(module, exports) {
	
		'use strict';
	
		Object.defineProperty(exports, "__esModule", {
		  value: true
		});
		exports.default = {
		  props: {
		    progress: {
		      type: Number,
		      default: 0
		    },
	
		    color: {
		      type: String,
		      default: ''
		    },
	
		    size: {
		      type: String,
		      default: ''
		    },
	
		    stripe: {
		      type: [Boolean, String],
		      default: false
		    },
	
		    stripeAnimate: {
		      type: Boolean,
		      default: false
		    }
		  }
		};
	
	/***/ },
	/* 82 */
	/***/ function(module, exports) {
	
		'use strict';
	
		Object.defineProperty(exports, "__esModule", {
		  value: true
		});
		exports.default = {
		  props: {
		    line: {
		      type: Boolean,
		      default: false
		    },
	
		    pill: {
		      type: Boolean,
		      default: false
		    }
		  },
		  data: function data() {
		    return {
		      active: null
		    };
		  },
		  watch: {
		    active: function active(item) {
		      this.$emit('change', item);
	
		      this.$children.forEach(function (child) {
		        child.active = child._uid === item._uid;
		      });
		    }
		  }
		};
	
	/***/ },
	/* 83 */
	/***/ function(module, exports) {
	
		"use strict";
	
		Object.defineProperty(exports, "__esModule", {
		  value: true
		});
		exports.default = {
		  created: function created() {
		    if (this.active || !this.$parent.active) {
		      this.$parent.active = this;
		    }
		  },
	
		  props: {
		    active: {
		      type: Boolean,
		      default: false
		    },
		    disabled: {
		      type: Boolean,
		      default: false
		    }
		  }
		};
	
	/***/ },
	/* 84 */
	/***/ function(module, exports, __webpack_require__) {
	
		'use strict';
	
		Object.defineProperty(exports, "__esModule", {
		  value: true
		});
	
		var _isObject2 = __webpack_require__(2);
	
		var _isObject3 = _interopRequireDefault(_isObject2);
	
		var _uikit = __webpack_require__(4);
	
		var _uikit2 = _interopRequireDefault(_uikit);
	
		function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
		exports.default = {
		  props: {
		    connect: {
		      required: true
		    },
		    animation: {
		      type: String,
		      default: ''
		    },
		    swiping: {
		      type: Boolean,
		      default: true
		    }
		  },
		  computed: {
		    nav: function nav() {
		      return (0, _isObject3.default)(this.connect) && this.connect.$el ? this.connect.$el : this.connect;
		    }
		  },
		  ready: function ready() {
		    var vm = this;
	
		    _uikit2.default.switcher(this.nav, _uikit2.default.Utils.options({
		      connect: this.$el,
		      animation: this.animation,
		      swiping: this.swiping
		    })).on('show.uk.switcher', function (event, area) {
		      vm.$emit('change');
		    });
		  }
		};
	
	/***/ },
	/* 85 */
	/***/ function(module, exports) {
	
		"use strict";
	
		Object.defineProperty(exports, "__esModule", {
		  value: true
		});
		exports.default = {};
	
	/***/ },
	/* 86 */
	/***/ function(module, exports) {
	
		'use strict';
	
		Object.defineProperty(exports, "__esModule", {
		  value: true
		});
		exports.default = {
		  props: {
		    label: {
		      type: String,
		      default: ''
		    },
		    disabled: {
		      type: Boolean,
		      default: false
		    },
		    active: {
		      type: Boolean,
		      default: false
		    }
		  }
		};
	
	/***/ },
	/* 87 */
	/***/ function(module, exports) {
	
		'use strict';
	
		Object.defineProperty(exports, "__esModule", {
		  value: true
		});
		exports.default = {
		  name: 'vk-tab-header',
		  props: {
		    label: {
		      type: String,
		      default: ''
		    },
		    width: {
		      type: String,
		      default: ''
		    },
		    disabled: {
		      type: Boolean,
		      default: false
		    },
		    active: {
		      type: Boolean,
		      default: false
		    }
		  },
		  computed: {
		    classes: function classes() {
		      var classes = {};
		      classes['uk-width-' + this.width] = this.width;
		      classes['uk-disabled'] = this.disabled;
		      classes['uk-active'] = this.active;
		      return classes;
		    }
		  }
		};
	
	/***/ },
	/* 88 */
	/***/ function(module, exports, __webpack_require__) {
	
		'use strict';
	
		Object.defineProperty(exports, "__esModule", {
		  value: true
		});
	
		var _toArray2 = __webpack_require__(30);
	
		var _toArray3 = _interopRequireDefault(_toArray2);
	
		var _TabHeader = __webpack_require__(62);
	
		var _TabHeader2 = _interopRequireDefault(_TabHeader);
	
		var _uikit = __webpack_require__(4);
	
		var _uikit2 = _interopRequireDefault(_uikit);
	
		function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
		exports.default = {
		  components: {
		    TabHeader: _TabHeader2.default
		  },
		  props: {
		    flip: {
		      type: Boolean,
		      default: false
		    },
	
		    center: {
		      type: Boolean,
		      default: false
		    },
	
		    bottom: {
		      type: Boolean,
		      default: false
		    },
	
		    width: {
		      type: String,
		      default: ''
		    }
		  },
		  data: function data() {
		    return {
		      tabs: []
		    };
		  },
		  computed: {
		    id: function id() {
		      return 'vk-tabs-' + this._uid;
		    }
		  },
		  ready: function ready() {
		    var _this = this;
	
		    this.tabs = (0, _toArray3.default)(this.$els.tabsBody.querySelectorAll(':scope > li')).map(function (el) {
		      return el.__vue__;
		    });
	
		    _uikit2.default.$(this.$el).on('change.uk.tab', function () {
		      _this.$emit('change');
		    });
		  }
		};
	
	/***/ },
	/* 89 */
	/***/ function(module, exports, __webpack_require__) {
	
		'use strict';
	
		Object.defineProperty(exports, "__esModule", {
		  value: true
		});
	
		var _toArray2 = __webpack_require__(30);
	
		var _toArray3 = _interopRequireDefault(_toArray2);
	
		var _TabHeader = __webpack_require__(62);
	
		var _TabHeader2 = _interopRequireDefault(_TabHeader);
	
		var _uikit = __webpack_require__(4);
	
		var _uikit2 = _interopRequireDefault(_uikit);
	
		function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
		exports.default = {
		  components: {
		    TabHeader: _TabHeader2.default
		  },
		  props: {
		    align: {
		      type: String,
		      default: 'left'
		    },
		    headerWidth: {
		      type: String,
		      default: '1-3'
		    },
		    bodyWidth: {
		      type: String,
		      default: '2-3'
		    }
		  },
		  data: function data() {
		    return {
		      tabs: []
		    };
		  },
		  computed: {
		    id: function id() {
		      return 'vk-tabs-' + this._uid;
		    }
		  },
		  ready: function ready() {
		    var _this = this;
	
		    this.tabs = (0, _toArray3.default)(this.$els.tabsBody.querySelectorAll(':scope > li')).map(function (el) {
		      return el.__vue__;
		    });
	
		    _uikit2.default.$(this.$el).on('change.uk.tab', function () {
		      _this.$emit('change');
		    });
		  }
		};
	
	/***/ },
	/* 90 */
	/***/ function(module, exports, __webpack_require__) {
	
		module.exports = { "default": __webpack_require__(92), __esModule: true };
	
	/***/ },
	/* 91 */
	/***/ function(module, exports, __webpack_require__) {
	
		module.exports = { "default": __webpack_require__(93), __esModule: true };
	
	/***/ },
	/* 92 */
	/***/ function(module, exports, __webpack_require__) {
	
		__webpack_require__(118);
		module.exports = __webpack_require__(8).Number.isInteger;
	
	/***/ },
	/* 93 */
	/***/ function(module, exports, __webpack_require__) {
	
		__webpack_require__(119);
		module.exports = __webpack_require__(8).Object.keys;
	
	/***/ },
	/* 94 */
	/***/ function(module, exports) {
	
		module.exports = function(it){
		  if(typeof it != 'function')throw TypeError(it + ' is not a function!');
		  return it;
		};
	
	/***/ },
	/* 95 */
	/***/ function(module, exports, __webpack_require__) {
	
		var isObject = __webpack_require__(9);
		module.exports = function(it){
		  if(!isObject(it))throw TypeError(it + ' is not an object!');
		  return it;
		};
	
	/***/ },
	/* 96 */
	/***/ function(module, exports, __webpack_require__) {
	
		// false -> Array#indexOf
		// true  -> Array#includes
		var toIObject = __webpack_require__(37)
		  , toLength  = __webpack_require__(114)
		  , toIndex   = __webpack_require__(113);
		module.exports = function(IS_INCLUDES){
		  return function($this, el, fromIndex){
		    var O      = toIObject($this)
		      , length = toLength(O.length)
		      , index  = toIndex(fromIndex, length)
		      , value;
		    // Array#includes uses SameValueZero equality algorithm
		    if(IS_INCLUDES && el != el)while(length > index){
		      value = O[index++];
		      if(value != value)return true;
		    // Array#toIndex ignores holes, Array#includes - not
		    } else for(;length > index; index++)if(IS_INCLUDES || index in O){
		      if(O[index] === el)return IS_INCLUDES || index || 0;
		    } return !IS_INCLUDES && -1;
		  };
		};
	
	/***/ },
	/* 97 */
	/***/ function(module, exports) {
	
		var toString = {}.toString;
	
		module.exports = function(it){
		  return toString.call(it).slice(8, -1);
		};
	
	/***/ },
	/* 98 */
	/***/ function(module, exports, __webpack_require__) {
	
		// optional / simple context binding
		var aFunction = __webpack_require__(94);
		module.exports = function(fn, that, length){
		  aFunction(fn);
		  if(that === undefined)return fn;
		  switch(length){
		    case 1: return function(a){
		      return fn.call(that, a);
		    };
		    case 2: return function(a, b){
		      return fn.call(that, a, b);
		    };
		    case 3: return function(a, b, c){
		      return fn.call(that, a, b, c);
		    };
		  }
		  return function(/* ...args */){
		    return fn.apply(that, arguments);
		  };
		};
	
	/***/ },
	/* 99 */
	/***/ function(module, exports, __webpack_require__) {
	
		var isObject = __webpack_require__(9)
		  , document = __webpack_require__(20).document
		  // in old IE typeof document.createElement is 'object'
		  , is = isObject(document) && isObject(document.createElement);
		module.exports = function(it){
		  return is ? document.createElement(it) : {};
		};
	
	/***/ },
	/* 100 */
	/***/ function(module, exports) {
	
		// IE 8- don't enum bug keys
		module.exports = (
		  'constructor,hasOwnProperty,isPrototypeOf,propertyIsEnumerable,toLocaleString,toString,valueOf'
		).split(',');
	
	/***/ },
	/* 101 */
	/***/ function(module, exports) {
	
		var hasOwnProperty = {}.hasOwnProperty;
		module.exports = function(it, key){
		  return hasOwnProperty.call(it, key);
		};
	
	/***/ },
	/* 102 */
	/***/ function(module, exports, __webpack_require__) {
	
		var dP         = __webpack_require__(106)
		  , createDesc = __webpack_require__(110);
		module.exports = __webpack_require__(18) ? function(object, key, value){
		  return dP.f(object, key, createDesc(1, value));
		} : function(object, key, value){
		  object[key] = value;
		  return object;
		};
	
	/***/ },
	/* 103 */
	/***/ function(module, exports, __webpack_require__) {
	
		module.exports = !__webpack_require__(18) && !__webpack_require__(19)(function(){
		  return Object.defineProperty(__webpack_require__(99)('div'), 'a', {get: function(){ return 7; }}).a != 7;
		});
	
	/***/ },
	/* 104 */
	/***/ function(module, exports, __webpack_require__) {
	
		// fallback for non-array-like ES3 and non-enumerable old V8 strings
		var cof = __webpack_require__(97);
		module.exports = Object('z').propertyIsEnumerable(0) ? Object : function(it){
		  return cof(it) == 'String' ? it.split('') : Object(it);
		};
	
	/***/ },
	/* 105 */
	/***/ function(module, exports, __webpack_require__) {
	
		// 20.1.2.3 Number.isInteger(number)
		var isObject = __webpack_require__(9)
		  , floor    = Math.floor;
		module.exports = function isInteger(it){
		  return !isObject(it) && isFinite(it) && floor(it) === it;
		};
	
	/***/ },
	/* 106 */
	/***/ function(module, exports, __webpack_require__) {
	
		var anObject       = __webpack_require__(95)
		  , IE8_DOM_DEFINE = __webpack_require__(103)
		  , toPrimitive    = __webpack_require__(116)
		  , dP             = Object.defineProperty;
	
		exports.f = __webpack_require__(18) ? Object.defineProperty : function defineProperty(O, P, Attributes){
		  anObject(O);
		  P = toPrimitive(P, true);
		  anObject(Attributes);
		  if(IE8_DOM_DEFINE)try {
		    return dP(O, P, Attributes);
		  } catch(e){ /* empty */ }
		  if('get' in Attributes || 'set' in Attributes)throw TypeError('Accessors not supported!');
		  if('value' in Attributes)O[P] = Attributes.value;
		  return O;
		};
	
	/***/ },
	/* 107 */
	/***/ function(module, exports, __webpack_require__) {
	
		var has          = __webpack_require__(101)
		  , toIObject    = __webpack_require__(37)
		  , arrayIndexOf = __webpack_require__(96)(false)
		  , IE_PROTO     = __webpack_require__(111)('IE_PROTO');
	
		module.exports = function(object, names){
		  var O      = toIObject(object)
		    , i      = 0
		    , result = []
		    , key;
		  for(key in O)if(key != IE_PROTO)has(O, key) && result.push(key);
		  // Don't enum bug & hidden keys
		  while(names.length > i)if(has(O, key = names[i++])){
		    ~arrayIndexOf(result, key) || result.push(key);
		  }
		  return result;
		};
	
	/***/ },
	/* 108 */
	/***/ function(module, exports, __webpack_require__) {
	
		// 19.1.2.14 / 15.2.3.14 Object.keys(O)
		var $keys       = __webpack_require__(107)
		  , enumBugKeys = __webpack_require__(100);
	
		module.exports = Object.keys || function keys(O){
		  return $keys(O, enumBugKeys);
		};
	
	/***/ },
	/* 109 */
	/***/ function(module, exports, __webpack_require__) {
	
		// most Object methods by ES6 should accept primitives
		var $export = __webpack_require__(35)
		  , core    = __webpack_require__(8)
		  , fails   = __webpack_require__(19);
		module.exports = function(KEY, exec){
		  var fn  = (core.Object || {})[KEY] || Object[KEY]
		    , exp = {};
		  exp[KEY] = exec(fn);
		  $export($export.S + $export.F * fails(function(){ fn(1); }), 'Object', exp);
		};
	
	/***/ },
	/* 110 */
	/***/ function(module, exports) {
	
		module.exports = function(bitmap, value){
		  return {
		    enumerable  : !(bitmap & 1),
		    configurable: !(bitmap & 2),
		    writable    : !(bitmap & 4),
		    value       : value
		  };
		};
	
	/***/ },
	/* 111 */
	/***/ function(module, exports, __webpack_require__) {
	
		var shared = __webpack_require__(112)('keys')
		  , uid    = __webpack_require__(117);
		module.exports = function(key){
		  return shared[key] || (shared[key] = uid(key));
		};
	
	/***/ },
	/* 112 */
	/***/ function(module, exports, __webpack_require__) {
	
		var global = __webpack_require__(20)
		  , SHARED = '__core-js_shared__'
		  , store  = global[SHARED] || (global[SHARED] = {});
		module.exports = function(key){
		  return store[key] || (store[key] = {});
		};
	
	/***/ },
	/* 113 */
	/***/ function(module, exports, __webpack_require__) {
	
		var toInteger = __webpack_require__(36)
		  , max       = Math.max
		  , min       = Math.min;
		module.exports = function(index, length){
		  index = toInteger(index);
		  return index < 0 ? max(index + length, 0) : min(index, length);
		};
	
	/***/ },
	/* 114 */
	/***/ function(module, exports, __webpack_require__) {
	
		// 7.1.15 ToLength
		var toInteger = __webpack_require__(36)
		  , min       = Math.min;
		module.exports = function(it){
		  return it > 0 ? min(toInteger(it), 0x1fffffffffffff) : 0; // pow(2, 53) - 1 == 9007199254740991
		};
	
	/***/ },
	/* 115 */
	/***/ function(module, exports, __webpack_require__) {
	
		// 7.1.13 ToObject(argument)
		var defined = __webpack_require__(34);
		module.exports = function(it){
		  return Object(defined(it));
		};
	
	/***/ },
	/* 116 */
	/***/ function(module, exports, __webpack_require__) {
	
		// 7.1.1 ToPrimitive(input [, PreferredType])
		var isObject = __webpack_require__(9);
		// instead of the ES6 spec version, we didn't implement @@toPrimitive case
		// and the second argument - flag - preferred type is a string
		module.exports = function(it, S){
		  if(!isObject(it))return it;
		  var fn, val;
		  if(S && typeof (fn = it.toString) == 'function' && !isObject(val = fn.call(it)))return val;
		  if(typeof (fn = it.valueOf) == 'function' && !isObject(val = fn.call(it)))return val;
		  if(!S && typeof (fn = it.toString) == 'function' && !isObject(val = fn.call(it)))return val;
		  throw TypeError("Can't convert object to primitive value");
		};
	
	/***/ },
	/* 117 */
	/***/ function(module, exports) {
	
		var id = 0
		  , px = Math.random();
		module.exports = function(key){
		  return 'Symbol('.concat(key === undefined ? '' : key, ')_', (++id + px).toString(36));
		};
	
	/***/ },
	/* 118 */
	/***/ function(module, exports, __webpack_require__) {
	
		// 20.1.2.3 Number.isInteger(number)
		var $export = __webpack_require__(35);
	
		$export($export.S, 'Number', {isInteger: __webpack_require__(105)});
	
	/***/ },
	/* 119 */
	/***/ function(module, exports, __webpack_require__) {
	
		// 19.1.2.14 Object.keys(O)
		var toObject = __webpack_require__(115)
		  , $keys    = __webpack_require__(108);
	
		__webpack_require__(109)('keys', function(){
		  return function keys(it){
		    return $keys(toObject(it));
		  };
		});
	
	/***/ },
	/* 120 */
	/***/ function(module, exports, __webpack_require__) {
	
		var getNative = __webpack_require__(5),
		    root = __webpack_require__(1);
	
		/* Built-in method references that are verified to be native. */
		var DataView = getNative(root, 'DataView');
	
		module.exports = DataView;
	
	
	/***/ },
	/* 121 */
	/***/ function(module, exports, __webpack_require__) {
	
		var hashClear = __webpack_require__(162),
		    hashDelete = __webpack_require__(163),
		    hashGet = __webpack_require__(164),
		    hashHas = __webpack_require__(165),
		    hashSet = __webpack_require__(166);
	
		/**
		 * Creates a hash object.
		 *
		 * @private
		 * @constructor
		 * @param {Array} [entries] The key-value pairs to cache.
		 */
		function Hash(entries) {
		  var index = -1,
		      length = entries ? entries.length : 0;
	
		  this.clear();
		  while (++index < length) {
		    var entry = entries[index];
		    this.set(entry[0], entry[1]);
		  }
		}
	
		// Add methods to `Hash`.
		Hash.prototype.clear = hashClear;
		Hash.prototype['delete'] = hashDelete;
		Hash.prototype.get = hashGet;
		Hash.prototype.has = hashHas;
		Hash.prototype.set = hashSet;
	
		module.exports = Hash;
	
	
	/***/ },
	/* 122 */
	/***/ function(module, exports, __webpack_require__) {
	
		var mapCacheClear = __webpack_require__(178),
		    mapCacheDelete = __webpack_require__(179),
		    mapCacheGet = __webpack_require__(180),
		    mapCacheHas = __webpack_require__(181),
		    mapCacheSet = __webpack_require__(182);
	
		/**
		 * Creates a map cache object to store key-value pairs.
		 *
		 * @private
		 * @constructor
		 * @param {Array} [entries] The key-value pairs to cache.
		 */
		function MapCache(entries) {
		  var index = -1,
		      length = entries ? entries.length : 0;
	
		  this.clear();
		  while (++index < length) {
		    var entry = entries[index];
		    this.set(entry[0], entry[1]);
		  }
		}
	
		// Add methods to `MapCache`.
		MapCache.prototype.clear = mapCacheClear;
		MapCache.prototype['delete'] = mapCacheDelete;
		MapCache.prototype.get = mapCacheGet;
		MapCache.prototype.has = mapCacheHas;
		MapCache.prototype.set = mapCacheSet;
	
		module.exports = MapCache;
	
	
	/***/ },
	/* 123 */
	/***/ function(module, exports, __webpack_require__) {
	
		var getNative = __webpack_require__(5),
		    root = __webpack_require__(1);
	
		/* Built-in method references that are verified to be native. */
		var Promise = getNative(root, 'Promise');
	
		module.exports = Promise;
	
	
	/***/ },
	/* 124 */
	/***/ function(module, exports, __webpack_require__) {
	
		var root = __webpack_require__(1);
	
		/** Built-in value references. */
		var Reflect = root.Reflect;
	
		module.exports = Reflect;
	
	
	/***/ },
	/* 125 */
	/***/ function(module, exports, __webpack_require__) {
	
		var getNative = __webpack_require__(5),
		    root = __webpack_require__(1);
	
		/* Built-in method references that are verified to be native. */
		var Set = getNative(root, 'Set');
	
		module.exports = Set;
	
	
	/***/ },
	/* 126 */
	/***/ function(module, exports, __webpack_require__) {
	
		var root = __webpack_require__(1);
	
		/** Built-in value references. */
		var Uint8Array = root.Uint8Array;
	
		module.exports = Uint8Array;
	
	
	/***/ },
	/* 127 */
	/***/ function(module, exports, __webpack_require__) {
	
		var getNative = __webpack_require__(5),
		    root = __webpack_require__(1);
	
		/* Built-in method references that are verified to be native. */
		var WeakMap = getNative(root, 'WeakMap');
	
		module.exports = WeakMap;
	
	
	/***/ },
	/* 128 */
	/***/ function(module, exports) {
	
		/**
		 * Adds the key-value `pair` to `map`.
		 *
		 * @private
		 * @param {Object} map The map to modify.
		 * @param {Array} pair The key-value pair to add.
		 * @returns {Object} Returns `map`.
		 */
		function addMapEntry(map, pair) {
		  // Don't return `Map#set` because it doesn't return the map instance in IE 11.
		  map.set(pair[0], pair[1]);
		  return map;
		}
	
		module.exports = addMapEntry;
	
	
	/***/ },
	/* 129 */
	/***/ function(module, exports) {
	
		/**
		 * Adds `value` to `set`.
		 *
		 * @private
		 * @param {Object} set The set to modify.
		 * @param {*} value The value to add.
		 * @returns {Object} Returns `set`.
		 */
		function addSetEntry(set, value) {
		  set.add(value);
		  return set;
		}
	
		module.exports = addSetEntry;
	
	
	/***/ },
	/* 130 */
	/***/ function(module, exports) {
	
		/**
		 * A faster alternative to `Function#apply`, this function invokes `func`
		 * with the `this` binding of `thisArg` and the arguments of `args`.
		 *
		 * @private
		 * @param {Function} func The function to invoke.
		 * @param {*} thisArg The `this` binding of `func`.
		 * @param {Array} args The arguments to invoke `func` with.
		 * @returns {*} Returns the result of `func`.
		 */
		function apply(func, thisArg, args) {
		  var length = args.length;
		  switch (length) {
		    case 0: return func.call(thisArg);
		    case 1: return func.call(thisArg, args[0]);
		    case 2: return func.call(thisArg, args[0], args[1]);
		    case 3: return func.call(thisArg, args[0], args[1], args[2]);
		  }
		  return func.apply(thisArg, args);
		}
	
		module.exports = apply;
	
	
	/***/ },
	/* 131 */
	/***/ function(module, exports) {
	
		/**
		 * A specialized version of `_.map` for arrays without support for iteratee
		 * shorthands.
		 *
		 * @private
		 * @param {Array} [array] The array to iterate over.
		 * @param {Function} iteratee The function invoked per iteration.
		 * @returns {Array} Returns the new mapped array.
		 */
		function arrayMap(array, iteratee) {
		  var index = -1,
		      length = array ? array.length : 0,
		      result = Array(length);
	
		  while (++index < length) {
		    result[index] = iteratee(array[index], index, array);
		  }
		  return result;
		}
	
		module.exports = arrayMap;
	
	
	/***/ },
	/* 132 */
	/***/ function(module, exports, __webpack_require__) {
	
		var copyObject = __webpack_require__(23),
		    keys = __webpack_require__(17);
	
		/**
		 * The base implementation of `_.assign` without support for multiple sources
		 * or `customizer` functions.
		 *
		 * @private
		 * @param {Object} object The destination object.
		 * @param {Object} source The source object.
		 * @returns {Object} Returns `object`.
		 */
		function baseAssign(object, source) {
		  return object && copyObject(source, keys(source), object);
		}
	
		module.exports = baseAssign;
	
	
	/***/ },
	/* 133 */
	/***/ function(module, exports, __webpack_require__) {
	
		var Stack = __webpack_require__(39),
		    arrayEach = __webpack_require__(41),
		    assignValue = __webpack_require__(45),
		    baseAssign = __webpack_require__(132),
		    cloneBuffer = __webpack_require__(148),
		    copyArray = __webpack_require__(22),
		    copySymbols = __webpack_require__(155),
		    getAllKeys = __webpack_require__(159),
		    getTag = __webpack_require__(47),
		    initCloneArray = __webpack_require__(167),
		    initCloneByTag = __webpack_require__(168),
		    initCloneObject = __webpack_require__(169),
		    isArray = __webpack_require__(3),
		    isBuffer = __webpack_require__(190),
		    isHostObject = __webpack_require__(25),
		    isObject = __webpack_require__(2),
		    keys = __webpack_require__(17);
	
		/** `Object#toString` result references. */
		var argsTag = '[object Arguments]',
		    arrayTag = '[object Array]',
		    boolTag = '[object Boolean]',
		    dateTag = '[object Date]',
		    errorTag = '[object Error]',
		    funcTag = '[object Function]',
		    genTag = '[object GeneratorFunction]',
		    mapTag = '[object Map]',
		    numberTag = '[object Number]',
		    objectTag = '[object Object]',
		    regexpTag = '[object RegExp]',
		    setTag = '[object Set]',
		    stringTag = '[object String]',
		    symbolTag = '[object Symbol]',
		    weakMapTag = '[object WeakMap]';
	
		var arrayBufferTag = '[object ArrayBuffer]',
		    dataViewTag = '[object DataView]',
		    float32Tag = '[object Float32Array]',
		    float64Tag = '[object Float64Array]',
		    int8Tag = '[object Int8Array]',
		    int16Tag = '[object Int16Array]',
		    int32Tag = '[object Int32Array]',
		    uint8Tag = '[object Uint8Array]',
		    uint8ClampedTag = '[object Uint8ClampedArray]',
		    uint16Tag = '[object Uint16Array]',
		    uint32Tag = '[object Uint32Array]';
	
		/** Used to identify `toStringTag` values supported by `_.clone`. */
		var cloneableTags = {};
		cloneableTags[argsTag] = cloneableTags[arrayTag] =
		cloneableTags[arrayBufferTag] = cloneableTags[dataViewTag] =
		cloneableTags[boolTag] = cloneableTags[dateTag] =
		cloneableTags[float32Tag] = cloneableTags[float64Tag] =
		cloneableTags[int8Tag] = cloneableTags[int16Tag] =
		cloneableTags[int32Tag] = cloneableTags[mapTag] =
		cloneableTags[numberTag] = cloneableTags[objectTag] =
		cloneableTags[regexpTag] = cloneableTags[setTag] =
		cloneableTags[stringTag] = cloneableTags[symbolTag] =
		cloneableTags[uint8Tag] = cloneableTags[uint8ClampedTag] =
		cloneableTags[uint16Tag] = cloneableTags[uint32Tag] = true;
		cloneableTags[errorTag] = cloneableTags[funcTag] =
		cloneableTags[weakMapTag] = false;
	
		/**
		 * The base implementation of `_.clone` and `_.cloneDeep` which tracks
		 * traversed objects.
		 *
		 * @private
		 * @param {*} value The value to clone.
		 * @param {boolean} [isDeep] Specify a deep clone.
		 * @param {boolean} [isFull] Specify a clone including symbols.
		 * @param {Function} [customizer] The function to customize cloning.
		 * @param {string} [key] The key of `value`.
		 * @param {Object} [object] The parent object of `value`.
		 * @param {Object} [stack] Tracks traversed objects and their clone counterparts.
		 * @returns {*} Returns the cloned value.
		 */
		function baseClone(value, isDeep, isFull, customizer, key, object, stack) {
		  var result;
		  if (customizer) {
		    result = object ? customizer(value, key, object, stack) : customizer(value);
		  }
		  if (result !== undefined) {
		    return result;
		  }
		  if (!isObject(value)) {
		    return value;
		  }
		  var isArr = isArray(value);
		  if (isArr) {
		    result = initCloneArray(value);
		    if (!isDeep) {
		      return copyArray(value, result);
		    }
		  } else {
		    var tag = getTag(value),
		        isFunc = tag == funcTag || tag == genTag;
	
		    if (isBuffer(value)) {
		      return cloneBuffer(value, isDeep);
		    }
		    if (tag == objectTag || tag == argsTag || (isFunc && !object)) {
		      if (isHostObject(value)) {
		        return object ? value : {};
		      }
		      result = initCloneObject(isFunc ? {} : value);
		      if (!isDeep) {
		        return copySymbols(value, baseAssign(result, value));
		      }
		    } else {
		      if (!cloneableTags[tag]) {
		        return object ? value : {};
		      }
		      result = initCloneByTag(value, tag, baseClone, isDeep);
		    }
		  }
		  // Check for circular references and return its corresponding clone.
		  stack || (stack = new Stack);
		  var stacked = stack.get(value);
		  if (stacked) {
		    return stacked;
		  }
		  stack.set(value, result);
	
		  if (!isArr) {
		    var props = isFull ? getAllKeys(value) : keys(value);
		  }
		  // Recursively populate clone (susceptible to call stack limits).
		  arrayEach(props || value, function(subValue, key) {
		    if (props) {
		      key = subValue;
		      subValue = value[key];
		    }
		    assignValue(result, key, baseClone(subValue, isDeep, isFull, customizer, key, value, stack));
		  });
		  return result;
		}
	
		module.exports = baseClone;
	
	
	/***/ },
	/* 134 */
	/***/ function(module, exports, __webpack_require__) {
	
		var isObject = __webpack_require__(2);
	
		/** Built-in value references. */
		var objectCreate = Object.create;
	
		/**
		 * The base implementation of `_.create` without support for assigning
		 * properties to the created object.
		 *
		 * @private
		 * @param {Object} prototype The object to inherit from.
		 * @returns {Object} Returns the new object.
		 */
		function baseCreate(proto) {
		  return isObject(proto) ? objectCreate(proto) : {};
		}
	
		module.exports = baseCreate;
	
	
	/***/ },
	/* 135 */
	/***/ function(module, exports, __webpack_require__) {
	
		var arrayPush = __webpack_require__(42),
		    isFlattenable = __webpack_require__(170);
	
		/**
		 * The base implementation of `_.flatten` with support for restricting flattening.
		 *
		 * @private
		 * @param {Array} array The array to flatten.
		 * @param {number} depth The maximum recursion depth.
		 * @param {boolean} [predicate=isFlattenable] The function invoked per iteration.
		 * @param {boolean} [isStrict] Restrict to values that pass `predicate` checks.
		 * @param {Array} [result=[]] The initial result value.
		 * @returns {Array} Returns the new flattened array.
		 */
		function baseFlatten(array, depth, predicate, isStrict, result) {
		  var index = -1,
		      length = array.length;
	
		  predicate || (predicate = isFlattenable);
		  result || (result = []);
	
		  while (++index < length) {
		    var value = array[index];
		    if (depth > 0 && predicate(value)) {
		      if (depth > 1) {
		        // Recursively flatten arrays (susceptible to call stack limits).
		        baseFlatten(value, depth - 1, predicate, isStrict, result);
		      } else {
		        arrayPush(result, value);
		      }
		    } else if (!isStrict) {
		      result[result.length] = value;
		    }
		  }
		  return result;
		}
	
		module.exports = baseFlatten;
	
	
	/***/ },
	/* 136 */
	/***/ function(module, exports, __webpack_require__) {
	
		var arrayPush = __webpack_require__(42),
		    isArray = __webpack_require__(3);
	
		/**
		 * The base implementation of `getAllKeys` and `getAllKeysIn` which uses
		 * `keysFunc` and `symbolsFunc` to get the enumerable property names and
		 * symbols of `object`.
		 *
		 * @private
		 * @param {Object} object The object to query.
		 * @param {Function} keysFunc The function to get the keys of `object`.
		 * @param {Function} symbolsFunc The function to get the symbols of `object`.
		 * @returns {Array} Returns the array of property names and symbols.
		 */
		function baseGetAllKeys(object, keysFunc, symbolsFunc) {
		  var result = keysFunc(object);
		  return isArray(object) ? result : arrayPush(result, symbolsFunc(object));
		}
	
		module.exports = baseGetAllKeys;
	
	
	/***/ },
	/* 137 */
	/***/ function(module, exports, __webpack_require__) {
	
		var getPrototype = __webpack_require__(24);
	
		/** Used for built-in method references. */
		var objectProto = Object.prototype;
	
		/** Used to check objects for own properties. */
		var hasOwnProperty = objectProto.hasOwnProperty;
	
		/**
		 * The base implementation of `_.has` without support for deep paths.
		 *
		 * @private
		 * @param {Object} [object] The object to query.
		 * @param {Array|string} key The key to check.
		 * @returns {boolean} Returns `true` if `key` exists, else `false`.
		 */
		function baseHas(object, key) {
		  // Avoid a bug in IE 10-11 where objects with a [[Prototype]] of `null`,
		  // that are composed entirely of index properties, return `false` for
		  // `hasOwnProperty` checks of them.
		  return object != null &&
		    (hasOwnProperty.call(object, key) ||
		      (typeof object == 'object' && key in object && getPrototype(object) === null));
		}
	
		module.exports = baseHas;
	
	
	/***/ },
	/* 138 */
	/***/ function(module, exports, __webpack_require__) {
	
		var isFunction = __webpack_require__(16),
		    isHostObject = __webpack_require__(25),
		    isMasked = __webpack_require__(172),
		    isObject = __webpack_require__(2),
		    toSource = __webpack_require__(53);
	
		/**
		 * Used to match `RegExp`
		 * [syntax characters](http://ecma-international.org/ecma-262/6.0/#sec-patterns).
		 */
		var reRegExpChar = /[\\^$.*+?()[\]{}|]/g;
	
		/** Used to detect host constructors (Safari). */
		var reIsHostCtor = /^\[object .+?Constructor\]$/;
	
		/** Used for built-in method references. */
		var objectProto = Object.prototype;
	
		/** Used to resolve the decompiled source of functions. */
		var funcToString = Function.prototype.toString;
	
		/** Used to check objects for own properties. */
		var hasOwnProperty = objectProto.hasOwnProperty;
	
		/** Used to detect if a method is native. */
		var reIsNative = RegExp('^' +
		  funcToString.call(hasOwnProperty).replace(reRegExpChar, '\\$&')
		  .replace(/hasOwnProperty|(function).*?(?=\\\()| for .+?(?=\\\])/g, '$1.*?') + '$'
		);
	
		/**
		 * The base implementation of `_.isNative` without bad shim checks.
		 *
		 * @private
		 * @param {*} value The value to check.
		 * @returns {boolean} Returns `true` if `value` is a native function,
		 *  else `false`.
		 */
		function baseIsNative(value) {
		  if (!isObject(value) || isMasked(value)) {
		    return false;
		  }
		  var pattern = (isFunction(value) || isHostObject(value)) ? reIsNative : reIsHostCtor;
		  return pattern.test(toSource(value));
		}
	
		module.exports = baseIsNative;
	
	
	/***/ },
	/* 139 */
	/***/ function(module, exports) {
	
		/* Built-in method references for those with the same name as other `lodash` methods. */
		var nativeKeys = Object.keys;
	
		/**
		 * The base implementation of `_.keys` which doesn't skip the constructor
		 * property of prototypes or treat sparse arrays as dense.
		 *
		 * @private
		 * @param {Object} object The object to query.
		 * @returns {Array} Returns the array of property names.
		 */
		function baseKeys(object) {
		  return nativeKeys(Object(object));
		}
	
		module.exports = baseKeys;
	
	
	/***/ },
	/* 140 */
	/***/ function(module, exports, __webpack_require__) {
	
		var Reflect = __webpack_require__(124),
		    iteratorToArray = __webpack_require__(50);
	
		/** Used for built-in method references. */
		var objectProto = Object.prototype;
	
		/** Built-in value references. */
		var enumerate = Reflect ? Reflect.enumerate : undefined,
		    propertyIsEnumerable = objectProto.propertyIsEnumerable;
	
		/**
		 * The base implementation of `_.keysIn` which doesn't skip the constructor
		 * property of prototypes or treat sparse arrays as dense.
		 *
		 * @private
		 * @param {Object} object The object to query.
		 * @returns {Array} Returns the array of property names.
		 */
		function baseKeysIn(object) {
		  object = object == null ? object : Object(object);
	
		  var result = [];
		  for (var key in object) {
		    result.push(key);
		  }
		  return result;
		}
	
		// Fallback for IE < 9 with es6-shim.
		if (enumerate && !propertyIsEnumerable.call({ 'valueOf': 1 }, 'valueOf')) {
		  baseKeysIn = function(object) {
		    return iteratorToArray(enumerate(object));
		  };
		}
	
		module.exports = baseKeysIn;
	
	
	/***/ },
	/* 141 */
	/***/ function(module, exports, __webpack_require__) {
	
		var Stack = __webpack_require__(39),
		    arrayEach = __webpack_require__(41),
		    assignMergeValue = __webpack_require__(44),
		    baseMergeDeep = __webpack_require__(142),
		    isArray = __webpack_require__(3),
		    isObject = __webpack_require__(2),
		    isTypedArray = __webpack_require__(56),
		    keysIn = __webpack_require__(57);
	
		/**
		 * The base implementation of `_.merge` without support for multiple sources.
		 *
		 * @private
		 * @param {Object} object The destination object.
		 * @param {Object} source The source object.
		 * @param {number} srcIndex The index of `source`.
		 * @param {Function} [customizer] The function to customize merged values.
		 * @param {Object} [stack] Tracks traversed source values and their merged
		 *  counterparts.
		 */
		function baseMerge(object, source, srcIndex, customizer, stack) {
		  if (object === source) {
		    return;
		  }
		  if (!(isArray(source) || isTypedArray(source))) {
		    var props = keysIn(source);
		  }
		  arrayEach(props || source, function(srcValue, key) {
		    if (props) {
		      key = srcValue;
		      srcValue = source[key];
		    }
		    if (isObject(srcValue)) {
		      stack || (stack = new Stack);
		      baseMergeDeep(object, source, key, srcIndex, baseMerge, customizer, stack);
		    }
		    else {
		      var newValue = customizer
		        ? customizer(object[key], srcValue, (key + ''), object, source, stack)
		        : undefined;
	
		      if (newValue === undefined) {
		        newValue = srcValue;
		      }
		      assignMergeValue(object, key, newValue);
		    }
		  });
		}
	
		module.exports = baseMerge;
	
	
	/***/ },
	/* 142 */
	/***/ function(module, exports, __webpack_require__) {
	
		var assignMergeValue = __webpack_require__(44),
		    baseClone = __webpack_require__(133),
		    copyArray = __webpack_require__(22),
		    isArguments = __webpack_require__(28),
		    isArray = __webpack_require__(3),
		    isArrayLikeObject = __webpack_require__(54),
		    isFunction = __webpack_require__(16),
		    isObject = __webpack_require__(2),
		    isPlainObject = __webpack_require__(191),
		    isTypedArray = __webpack_require__(56),
		    toPlainObject = __webpack_require__(199);
	
		/**
		 * A specialized version of `baseMerge` for arrays and objects which performs
		 * deep merges and tracks traversed objects enabling objects with circular
		 * references to be merged.
		 *
		 * @private
		 * @param {Object} object The destination object.
		 * @param {Object} source The source object.
		 * @param {string} key The key of the value to merge.
		 * @param {number} srcIndex The index of `source`.
		 * @param {Function} mergeFunc The function to merge values.
		 * @param {Function} [customizer] The function to customize assigned values.
		 * @param {Object} [stack] Tracks traversed source values and their merged
		 *  counterparts.
		 */
		function baseMergeDeep(object, source, key, srcIndex, mergeFunc, customizer, stack) {
		  var objValue = object[key],
		      srcValue = source[key],
		      stacked = stack.get(srcValue);
	
		  if (stacked) {
		    assignMergeValue(object, key, stacked);
		    return;
		  }
		  var newValue = customizer
		    ? customizer(objValue, srcValue, (key + ''), object, source, stack)
		    : undefined;
	
		  var isCommon = newValue === undefined;
	
		  if (isCommon) {
		    newValue = srcValue;
		    if (isArray(srcValue) || isTypedArray(srcValue)) {
		      if (isArray(objValue)) {
		        newValue = objValue;
		      }
		      else if (isArrayLikeObject(objValue)) {
		        newValue = copyArray(objValue);
		      }
		      else {
		        isCommon = false;
		        newValue = baseClone(srcValue, true);
		      }
		    }
		    else if (isPlainObject(srcValue) || isArguments(srcValue)) {
		      if (isArguments(objValue)) {
		        newValue = toPlainObject(objValue);
		      }
		      else if (!isObject(objValue) || (srcIndex && isFunction(objValue))) {
		        isCommon = false;
		        newValue = baseClone(srcValue, true);
		      }
		      else {
		        newValue = objValue;
		      }
		    }
		    else {
		      isCommon = false;
		    }
		  }
		  stack.set(srcValue, newValue);
	
		  if (isCommon) {
		    // Recursively merge objects and arrays (susceptible to call stack limits).
		    mergeFunc(newValue, srcValue, srcIndex, customizer, stack);
		  }
		  stack['delete'](srcValue);
		  assignMergeValue(object, key, newValue);
		}
	
		module.exports = baseMergeDeep;
	
	
	/***/ },
	/* 143 */
	/***/ function(module, exports) {
	
		/**
		 * The base implementation of `_.property` without support for deep paths.
		 *
		 * @private
		 * @param {string} key The key of the property to get.
		 * @returns {Function} Returns the new accessor function.
		 */
		function baseProperty(key) {
		  return function(object) {
		    return object == null ? undefined : object[key];
		  };
		}
	
		module.exports = baseProperty;
	
	
	/***/ },
	/* 144 */
	/***/ function(module, exports) {
	
		/* Built-in method references for those with the same name as other `lodash` methods. */
		var nativeCeil = Math.ceil,
		    nativeMax = Math.max;
	
		/**
		 * The base implementation of `_.range` and `_.rangeRight` which doesn't
		 * coerce arguments to numbers.
		 *
		 * @private
		 * @param {number} start The start of the range.
		 * @param {number} end The end of the range.
		 * @param {number} step The value to increment or decrement by.
		 * @param {boolean} [fromRight] Specify iterating from right to left.
		 * @returns {Array} Returns the range of numbers.
		 */
		function baseRange(start, end, step, fromRight) {
		  var index = -1,
		      length = nativeMax(nativeCeil((end - start) / (step || 1)), 0),
		      result = Array(length);
	
		  while (length--) {
		    result[fromRight ? length : ++index] = start;
		    start += step;
		  }
		  return result;
		}
	
		module.exports = baseRange;
	
	
	/***/ },
	/* 145 */
	/***/ function(module, exports) {
	
		/**
		 * The base implementation of `_.times` without support for iteratee shorthands
		 * or max array length checks.
		 *
		 * @private
		 * @param {number} n The number of times to invoke `iteratee`.
		 * @param {Function} iteratee The function invoked per iteration.
		 * @returns {Array} Returns the array of results.
		 */
		function baseTimes(n, iteratee) {
		  var index = -1,
		      result = Array(n);
	
		  while (++index < n) {
		    result[index] = iteratee(index);
		  }
		  return result;
		}
	
		module.exports = baseTimes;
	
	
	/***/ },
	/* 146 */
	/***/ function(module, exports, __webpack_require__) {
	
		var arrayMap = __webpack_require__(131);
	
		/**
		 * The base implementation of `_.values` and `_.valuesIn` which creates an
		 * array of `object` property values corresponding to the property names
		 * of `props`.
		 *
		 * @private
		 * @param {Object} object The object to query.
		 * @param {Array} props The property names to get values for.
		 * @returns {Object} Returns the array of property values.
		 */
		function baseValues(object, props) {
		  return arrayMap(props, function(key) {
		    return object[key];
		  });
		}
	
		module.exports = baseValues;
	
	
	/***/ },
	/* 147 */
	/***/ function(module, exports) {
	
		/**
		 * Checks if `value` is a global object.
		 *
		 * @private
		 * @param {*} value The value to check.
		 * @returns {null|Object} Returns `value` if it's a global object, else `null`.
		 */
		function checkGlobal(value) {
		  return (value && value.Object === Object) ? value : null;
		}
	
		module.exports = checkGlobal;
	
	
	/***/ },
	/* 148 */
	/***/ function(module, exports) {
	
		/**
		 * Creates a clone of  `buffer`.
		 *
		 * @private
		 * @param {Buffer} buffer The buffer to clone.
		 * @param {boolean} [isDeep] Specify a deep clone.
		 * @returns {Buffer} Returns the cloned buffer.
		 */
		function cloneBuffer(buffer, isDeep) {
		  if (isDeep) {
		    return buffer.slice();
		  }
		  var result = new buffer.constructor(buffer.length);
		  buffer.copy(result);
		  return result;
		}
	
		module.exports = cloneBuffer;
	
	
	/***/ },
	/* 149 */
	/***/ function(module, exports, __webpack_require__) {
	
		var cloneArrayBuffer = __webpack_require__(21);
	
		/**
		 * Creates a clone of `dataView`.
		 *
		 * @private
		 * @param {Object} dataView The data view to clone.
		 * @param {boolean} [isDeep] Specify a deep clone.
		 * @returns {Object} Returns the cloned data view.
		 */
		function cloneDataView(dataView, isDeep) {
		  var buffer = isDeep ? cloneArrayBuffer(dataView.buffer) : dataView.buffer;
		  return new dataView.constructor(buffer, dataView.byteOffset, dataView.byteLength);
		}
	
		module.exports = cloneDataView;
	
	
	/***/ },
	/* 150 */
	/***/ function(module, exports, __webpack_require__) {
	
		var addMapEntry = __webpack_require__(128),
		    arrayReduce = __webpack_require__(43),
		    mapToArray = __webpack_require__(51);
	
		/**
		 * Creates a clone of `map`.
		 *
		 * @private
		 * @param {Object} map The map to clone.
		 * @param {Function} cloneFunc The function to clone values.
		 * @param {boolean} [isDeep] Specify a deep clone.
		 * @returns {Object} Returns the cloned map.
		 */
		function cloneMap(map, isDeep, cloneFunc) {
		  var array = isDeep ? cloneFunc(mapToArray(map), true) : mapToArray(map);
		  return arrayReduce(array, addMapEntry, new map.constructor);
		}
	
		module.exports = cloneMap;
	
	
	/***/ },
	/* 151 */
	/***/ function(module, exports) {
	
		/** Used to match `RegExp` flags from their coerced string values. */
		var reFlags = /\w*$/;
	
		/**
		 * Creates a clone of `regexp`.
		 *
		 * @private
		 * @param {Object} regexp The regexp to clone.
		 * @returns {Object} Returns the cloned regexp.
		 */
		function cloneRegExp(regexp) {
		  var result = new regexp.constructor(regexp.source, reFlags.exec(regexp));
		  result.lastIndex = regexp.lastIndex;
		  return result;
		}
	
		module.exports = cloneRegExp;
	
	
	/***/ },
	/* 152 */
	/***/ function(module, exports, __webpack_require__) {
	
		var addSetEntry = __webpack_require__(129),
		    arrayReduce = __webpack_require__(43),
		    setToArray = __webpack_require__(52);
	
		/**
		 * Creates a clone of `set`.
		 *
		 * @private
		 * @param {Object} set The set to clone.
		 * @param {Function} cloneFunc The function to clone values.
		 * @param {boolean} [isDeep] Specify a deep clone.
		 * @returns {Object} Returns the cloned set.
		 */
		function cloneSet(set, isDeep, cloneFunc) {
		  var array = isDeep ? cloneFunc(setToArray(set), true) : setToArray(set);
		  return arrayReduce(array, addSetEntry, new set.constructor);
		}
	
		module.exports = cloneSet;
	
	
	/***/ },
	/* 153 */
	/***/ function(module, exports, __webpack_require__) {
	
		var Symbol = __webpack_require__(40);
	
		/** Used to convert symbols to primitives and strings. */
		var symbolProto = Symbol ? Symbol.prototype : undefined,
		    symbolValueOf = symbolProto ? symbolProto.valueOf : undefined;
	
		/**
		 * Creates a clone of the `symbol` object.
		 *
		 * @private
		 * @param {Object} symbol The symbol object to clone.
		 * @returns {Object} Returns the cloned symbol object.
		 */
		function cloneSymbol(symbol) {
		  return symbolValueOf ? Object(symbolValueOf.call(symbol)) : {};
		}
	
		module.exports = cloneSymbol;
	
	
	/***/ },
	/* 154 */
	/***/ function(module, exports, __webpack_require__) {
	
		var cloneArrayBuffer = __webpack_require__(21);
	
		/**
		 * Creates a clone of `typedArray`.
		 *
		 * @private
		 * @param {Object} typedArray The typed array to clone.
		 * @param {boolean} [isDeep] Specify a deep clone.
		 * @returns {Object} Returns the cloned typed array.
		 */
		function cloneTypedArray(typedArray, isDeep) {
		  var buffer = isDeep ? cloneArrayBuffer(typedArray.buffer) : typedArray.buffer;
		  return new typedArray.constructor(buffer, typedArray.byteOffset, typedArray.length);
		}
	
		module.exports = cloneTypedArray;
	
	
	/***/ },
	/* 155 */
	/***/ function(module, exports, __webpack_require__) {
	
		var copyObject = __webpack_require__(23),
		    getSymbols = __webpack_require__(46);
	
		/**
		 * Copies own symbol properties of `source` to `object`.
		 *
		 * @private
		 * @param {Object} source The object to copy symbols from.
		 * @param {Object} [object={}] The object to copy symbols to.
		 * @returns {Object} Returns `object`.
		 */
		function copySymbols(source, object) {
		  return copyObject(source, getSymbols(source), object);
		}
	
		module.exports = copySymbols;
	
	
	/***/ },
	/* 156 */
	/***/ function(module, exports, __webpack_require__) {
	
		var root = __webpack_require__(1);
	
		/** Used to detect overreaching core-js shims. */
		var coreJsData = root['__core-js_shared__'];
	
		module.exports = coreJsData;
	
	
	/***/ },
	/* 157 */
	/***/ function(module, exports, __webpack_require__) {
	
		var isIterateeCall = __webpack_require__(49),
		    rest = __webpack_require__(194);
	
		/**
		 * Creates a function like `_.assign`.
		 *
		 * @private
		 * @param {Function} assigner The function to assign values.
		 * @returns {Function} Returns the new assigner function.
		 */
		function createAssigner(assigner) {
		  return rest(function(object, sources) {
		    var index = -1,
		        length = sources.length,
		        customizer = length > 1 ? sources[length - 1] : undefined,
		        guard = length > 2 ? sources[2] : undefined;
	
		    customizer = (assigner.length > 3 && typeof customizer == 'function')
		      ? (length--, customizer)
		      : undefined;
	
		    if (guard && isIterateeCall(sources[0], sources[1], guard)) {
		      customizer = length < 3 ? undefined : customizer;
		      length = 1;
		    }
		    object = Object(object);
		    while (++index < length) {
		      var source = sources[index];
		      if (source) {
		        assigner(object, source, index, customizer);
		      }
		    }
		    return object;
		  });
		}
	
		module.exports = createAssigner;
	
	
	/***/ },
	/* 158 */
	/***/ function(module, exports, __webpack_require__) {
	
		var baseRange = __webpack_require__(144),
		    isIterateeCall = __webpack_require__(49),
		    toNumber = __webpack_require__(59);
	
		/**
		 * Creates a `_.range` or `_.rangeRight` function.
		 *
		 * @private
		 * @param {boolean} [fromRight] Specify iterating from right to left.
		 * @returns {Function} Returns the new range function.
		 */
		function createRange(fromRight) {
		  return function(start, end, step) {
		    if (step && typeof step != 'number' && isIterateeCall(start, end, step)) {
		      end = step = undefined;
		    }
		    // Ensure the sign of `-0` is preserved.
		    start = toNumber(start);
		    start = start === start ? start : 0;
		    if (end === undefined) {
		      end = start;
		      start = 0;
		    } else {
		      end = toNumber(end) || 0;
		    }
		    step = step === undefined ? (start < end ? 1 : -1) : (toNumber(step) || 0);
		    return baseRange(start, end, step, fromRight);
		  };
		}
	
		module.exports = createRange;
	
	
	/***/ },
	/* 159 */
	/***/ function(module, exports, __webpack_require__) {
	
		var baseGetAllKeys = __webpack_require__(136),
		    getSymbols = __webpack_require__(46),
		    keys = __webpack_require__(17);
	
		/**
		 * Creates an array of own enumerable property names and symbols of `object`.
		 *
		 * @private
		 * @param {Object} object The object to query.
		 * @returns {Array} Returns the array of property names and symbols.
		 */
		function getAllKeys(object) {
		  return baseGetAllKeys(object, keys, getSymbols);
		}
	
		module.exports = getAllKeys;
	
	
	/***/ },
	/* 160 */
	/***/ function(module, exports, __webpack_require__) {
	
		var baseProperty = __webpack_require__(143);
	
		/**
		 * Gets the "length" property value of `object`.
		 *
		 * **Note:** This function is used to avoid a
		 * [JIT bug](https://bugs.webkit.org/show_bug.cgi?id=142792) that affects
		 * Safari on at least iOS 8.1-8.3 ARM64.
		 *
		 * @private
		 * @param {Object} object The object to query.
		 * @returns {*} Returns the "length" value.
		 */
		var getLength = baseProperty('length');
	
		module.exports = getLength;
	
	
	/***/ },
	/* 161 */
	/***/ function(module, exports) {
	
		/**
		 * Gets the value at `key` of `object`.
		 *
		 * @private
		 * @param {Object} [object] The object to query.
		 * @param {string} key The key of the property to get.
		 * @returns {*} Returns the property value.
		 */
		function getValue(object, key) {
		  return object == null ? undefined : object[key];
		}
	
		module.exports = getValue;
	
	
	/***/ },
	/* 162 */
	/***/ function(module, exports, __webpack_require__) {
	
		var nativeCreate = __webpack_require__(13);
	
		/**
		 * Removes all key-value entries from the hash.
		 *
		 * @private
		 * @name clear
		 * @memberOf Hash
		 */
		function hashClear() {
		  this.__data__ = nativeCreate ? nativeCreate(null) : {};
		}
	
		module.exports = hashClear;
	
	
	/***/ },
	/* 163 */
	/***/ function(module, exports) {
	
		/**
		 * Removes `key` and its value from the hash.
		 *
		 * @private
		 * @name delete
		 * @memberOf Hash
		 * @param {Object} hash The hash to modify.
		 * @param {string} key The key of the value to remove.
		 * @returns {boolean} Returns `true` if the entry was removed, else `false`.
		 */
		function hashDelete(key) {
		  return this.has(key) && delete this.__data__[key];
		}
	
		module.exports = hashDelete;
	
	
	/***/ },
	/* 164 */
	/***/ function(module, exports, __webpack_require__) {
	
		var nativeCreate = __webpack_require__(13);
	
		/** Used to stand-in for `undefined` hash values. */
		var HASH_UNDEFINED = '__lodash_hash_undefined__';
	
		/** Used for built-in method references. */
		var objectProto = Object.prototype;
	
		/** Used to check objects for own properties. */
		var hasOwnProperty = objectProto.hasOwnProperty;
	
		/**
		 * Gets the hash value for `key`.
		 *
		 * @private
		 * @name get
		 * @memberOf Hash
		 * @param {string} key The key of the value to get.
		 * @returns {*} Returns the entry value.
		 */
		function hashGet(key) {
		  var data = this.__data__;
		  if (nativeCreate) {
		    var result = data[key];
		    return result === HASH_UNDEFINED ? undefined : result;
		  }
		  return hasOwnProperty.call(data, key) ? data[key] : undefined;
		}
	
		module.exports = hashGet;
	
	
	/***/ },
	/* 165 */
	/***/ function(module, exports, __webpack_require__) {
	
		var nativeCreate = __webpack_require__(13);
	
		/** Used for built-in method references. */
		var objectProto = Object.prototype;
	
		/** Used to check objects for own properties. */
		var hasOwnProperty = objectProto.hasOwnProperty;
	
		/**
		 * Checks if a hash value for `key` exists.
		 *
		 * @private
		 * @name has
		 * @memberOf Hash
		 * @param {string} key The key of the entry to check.
		 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
		 */
		function hashHas(key) {
		  var data = this.__data__;
		  return nativeCreate ? data[key] !== undefined : hasOwnProperty.call(data, key);
		}
	
		module.exports = hashHas;
	
	
	/***/ },
	/* 166 */
	/***/ function(module, exports, __webpack_require__) {
	
		var nativeCreate = __webpack_require__(13);
	
		/** Used to stand-in for `undefined` hash values. */
		var HASH_UNDEFINED = '__lodash_hash_undefined__';
	
		/**
		 * Sets the hash `key` to `value`.
		 *
		 * @private
		 * @name set
		 * @memberOf Hash
		 * @param {string} key The key of the value to set.
		 * @param {*} value The value to set.
		 * @returns {Object} Returns the hash instance.
		 */
		function hashSet(key, value) {
		  var data = this.__data__;
		  data[key] = (nativeCreate && value === undefined) ? HASH_UNDEFINED : value;
		  return this;
		}
	
		module.exports = hashSet;
	
	
	/***/ },
	/* 167 */
	/***/ function(module, exports) {
	
		/** Used for built-in method references. */
		var objectProto = Object.prototype;
	
		/** Used to check objects for own properties. */
		var hasOwnProperty = objectProto.hasOwnProperty;
	
		/**
		 * Initializes an array clone.
		 *
		 * @private
		 * @param {Array} array The array to clone.
		 * @returns {Array} Returns the initialized clone.
		 */
		function initCloneArray(array) {
		  var length = array.length,
		      result = array.constructor(length);
	
		  // Add properties assigned by `RegExp#exec`.
		  if (length && typeof array[0] == 'string' && hasOwnProperty.call(array, 'index')) {
		    result.index = array.index;
		    result.input = array.input;
		  }
		  return result;
		}
	
		module.exports = initCloneArray;
	
	
	/***/ },
	/* 168 */
	/***/ function(module, exports, __webpack_require__) {
	
		var cloneArrayBuffer = __webpack_require__(21),
		    cloneDataView = __webpack_require__(149),
		    cloneMap = __webpack_require__(150),
		    cloneRegExp = __webpack_require__(151),
		    cloneSet = __webpack_require__(152),
		    cloneSymbol = __webpack_require__(153),
		    cloneTypedArray = __webpack_require__(154);
	
		/** `Object#toString` result references. */
		var boolTag = '[object Boolean]',
		    dateTag = '[object Date]',
		    mapTag = '[object Map]',
		    numberTag = '[object Number]',
		    regexpTag = '[object RegExp]',
		    setTag = '[object Set]',
		    stringTag = '[object String]',
		    symbolTag = '[object Symbol]';
	
		var arrayBufferTag = '[object ArrayBuffer]',
		    dataViewTag = '[object DataView]',
		    float32Tag = '[object Float32Array]',
		    float64Tag = '[object Float64Array]',
		    int8Tag = '[object Int8Array]',
		    int16Tag = '[object Int16Array]',
		    int32Tag = '[object Int32Array]',
		    uint8Tag = '[object Uint8Array]',
		    uint8ClampedTag = '[object Uint8ClampedArray]',
		    uint16Tag = '[object Uint16Array]',
		    uint32Tag = '[object Uint32Array]';
	
		/**
		 * Initializes an object clone based on its `toStringTag`.
		 *
		 * **Note:** This function only supports cloning values with tags of
		 * `Boolean`, `Date`, `Error`, `Number`, `RegExp`, or `String`.
		 *
		 * @private
		 * @param {Object} object The object to clone.
		 * @param {string} tag The `toStringTag` of the object to clone.
		 * @param {Function} cloneFunc The function to clone values.
		 * @param {boolean} [isDeep] Specify a deep clone.
		 * @returns {Object} Returns the initialized clone.
		 */
		function initCloneByTag(object, tag, cloneFunc, isDeep) {
		  var Ctor = object.constructor;
		  switch (tag) {
		    case arrayBufferTag:
		      return cloneArrayBuffer(object);
	
		    case boolTag:
		    case dateTag:
		      return new Ctor(+object);
	
		    case dataViewTag:
		      return cloneDataView(object, isDeep);
	
		    case float32Tag: case float64Tag:
		    case int8Tag: case int16Tag: case int32Tag:
		    case uint8Tag: case uint8ClampedTag: case uint16Tag: case uint32Tag:
		      return cloneTypedArray(object, isDeep);
	
		    case mapTag:
		      return cloneMap(object, isDeep, cloneFunc);
	
		    case numberTag:
		    case stringTag:
		      return new Ctor(object);
	
		    case regexpTag:
		      return cloneRegExp(object);
	
		    case setTag:
		      return cloneSet(object, isDeep, cloneFunc);
	
		    case symbolTag:
		      return cloneSymbol(object);
		  }
		}
	
		module.exports = initCloneByTag;
	
	
	/***/ },
	/* 169 */
	/***/ function(module, exports, __webpack_require__) {
	
		var baseCreate = __webpack_require__(134),
		    getPrototype = __webpack_require__(24),
		    isPrototype = __webpack_require__(27);
	
		/**
		 * Initializes an object clone.
		 *
		 * @private
		 * @param {Object} object The object to clone.
		 * @returns {Object} Returns the initialized clone.
		 */
		function initCloneObject(object) {
		  return (typeof object.constructor == 'function' && !isPrototype(object))
		    ? baseCreate(getPrototype(object))
		    : {};
		}
	
		module.exports = initCloneObject;
	
	
	/***/ },
	/* 170 */
	/***/ function(module, exports, __webpack_require__) {
	
		var isArguments = __webpack_require__(28),
		    isArray = __webpack_require__(3);
	
		/**
		 * Checks if `value` is a flattenable `arguments` object or array.
		 *
		 * @private
		 * @param {*} value The value to check.
		 * @returns {boolean} Returns `true` if `value` is flattenable, else `false`.
		 */
		function isFlattenable(value) {
		  return isArray(value) || isArguments(value);
		}
	
		module.exports = isFlattenable;
	
	
	/***/ },
	/* 171 */
	/***/ function(module, exports) {
	
		/**
		 * Checks if `value` is suitable for use as unique object key.
		 *
		 * @private
		 * @param {*} value The value to check.
		 * @returns {boolean} Returns `true` if `value` is suitable, else `false`.
		 */
		function isKeyable(value) {
		  var type = typeof value;
		  return (type == 'string' || type == 'number' || type == 'symbol' || type == 'boolean')
		    ? (value !== '__proto__')
		    : (value === null);
		}
	
		module.exports = isKeyable;
	
	
	/***/ },
	/* 172 */
	/***/ function(module, exports, __webpack_require__) {
	
		var coreJsData = __webpack_require__(156);
	
		/** Used to detect methods masquerading as native. */
		var maskSrcKey = (function() {
		  var uid = /[^.]+$/.exec(coreJsData && coreJsData.keys && coreJsData.keys.IE_PROTO || '');
		  return uid ? ('Symbol(src)_1.' + uid) : '';
		}());
	
		/**
		 * Checks if `func` has its source masked.
		 *
		 * @private
		 * @param {Function} func The function to check.
		 * @returns {boolean} Returns `true` if `func` is masked, else `false`.
		 */
		function isMasked(func) {
		  return !!maskSrcKey && (maskSrcKey in func);
		}
	
		module.exports = isMasked;
	
	
	/***/ },
	/* 173 */
	/***/ function(module, exports) {
	
		/**
		 * Removes all key-value entries from the list cache.
		 *
		 * @private
		 * @name clear
		 * @memberOf ListCache
		 */
		function listCacheClear() {
		  this.__data__ = [];
		}
	
		module.exports = listCacheClear;
	
	
	/***/ },
	/* 174 */
	/***/ function(module, exports, __webpack_require__) {
	
		var assocIndexOf = __webpack_require__(11);
	
		/** Used for built-in method references. */
		var arrayProto = Array.prototype;
	
		/** Built-in value references. */
		var splice = arrayProto.splice;
	
		/**
		 * Removes `key` and its value from the list cache.
		 *
		 * @private
		 * @name delete
		 * @memberOf ListCache
		 * @param {string} key The key of the value to remove.
		 * @returns {boolean} Returns `true` if the entry was removed, else `false`.
		 */
		function listCacheDelete(key) {
		  var data = this.__data__,
		      index = assocIndexOf(data, key);
	
		  if (index < 0) {
		    return false;
		  }
		  var lastIndex = data.length - 1;
		  if (index == lastIndex) {
		    data.pop();
		  } else {
		    splice.call(data, index, 1);
		  }
		  return true;
		}
	
		module.exports = listCacheDelete;
	
	
	/***/ },
	/* 175 */
	/***/ function(module, exports, __webpack_require__) {
	
		var assocIndexOf = __webpack_require__(11);
	
		/**
		 * Gets the list cache value for `key`.
		 *
		 * @private
		 * @name get
		 * @memberOf ListCache
		 * @param {string} key The key of the value to get.
		 * @returns {*} Returns the entry value.
		 */
		function listCacheGet(key) {
		  var data = this.__data__,
		      index = assocIndexOf(data, key);
	
		  return index < 0 ? undefined : data[index][1];
		}
	
		module.exports = listCacheGet;
	
	
	/***/ },
	/* 176 */
	/***/ function(module, exports, __webpack_require__) {
	
		var assocIndexOf = __webpack_require__(11);
	
		/**
		 * Checks if a list cache value for `key` exists.
		 *
		 * @private
		 * @name has
		 * @memberOf ListCache
		 * @param {string} key The key of the entry to check.
		 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
		 */
		function listCacheHas(key) {
		  return assocIndexOf(this.__data__, key) > -1;
		}
	
		module.exports = listCacheHas;
	
	
	/***/ },
	/* 177 */
	/***/ function(module, exports, __webpack_require__) {
	
		var assocIndexOf = __webpack_require__(11);
	
		/**
		 * Sets the list cache `key` to `value`.
		 *
		 * @private
		 * @name set
		 * @memberOf ListCache
		 * @param {string} key The key of the value to set.
		 * @param {*} value The value to set.
		 * @returns {Object} Returns the list cache instance.
		 */
		function listCacheSet(key, value) {
		  var data = this.__data__,
		      index = assocIndexOf(data, key);
	
		  if (index < 0) {
		    data.push([key, value]);
		  } else {
		    data[index][1] = value;
		  }
		  return this;
		}
	
		module.exports = listCacheSet;
	
	
	/***/ },
	/* 178 */
	/***/ function(module, exports, __webpack_require__) {
	
		var Hash = __webpack_require__(121),
		    ListCache = __webpack_require__(10),
		    Map = __webpack_require__(38);
	
		/**
		 * Removes all key-value entries from the map.
		 *
		 * @private
		 * @name clear
		 * @memberOf MapCache
		 */
		function mapCacheClear() {
		  this.__data__ = {
		    'hash': new Hash,
		    'map': new (Map || ListCache),
		    'string': new Hash
		  };
		}
	
		module.exports = mapCacheClear;
	
	
	/***/ },
	/* 179 */
	/***/ function(module, exports, __webpack_require__) {
	
		var getMapData = __webpack_require__(12);
	
		/**
		 * Removes `key` and its value from the map.
		 *
		 * @private
		 * @name delete
		 * @memberOf MapCache
		 * @param {string} key The key of the value to remove.
		 * @returns {boolean} Returns `true` if the entry was removed, else `false`.
		 */
		function mapCacheDelete(key) {
		  return getMapData(this, key)['delete'](key);
		}
	
		module.exports = mapCacheDelete;
	
	
	/***/ },
	/* 180 */
	/***/ function(module, exports, __webpack_require__) {
	
		var getMapData = __webpack_require__(12);
	
		/**
		 * Gets the map value for `key`.
		 *
		 * @private
		 * @name get
		 * @memberOf MapCache
		 * @param {string} key The key of the value to get.
		 * @returns {*} Returns the entry value.
		 */
		function mapCacheGet(key) {
		  return getMapData(this, key).get(key);
		}
	
		module.exports = mapCacheGet;
	
	
	/***/ },
	/* 181 */
	/***/ function(module, exports, __webpack_require__) {
	
		var getMapData = __webpack_require__(12);
	
		/**
		 * Checks if a map value for `key` exists.
		 *
		 * @private
		 * @name has
		 * @memberOf MapCache
		 * @param {string} key The key of the entry to check.
		 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
		 */
		function mapCacheHas(key) {
		  return getMapData(this, key).has(key);
		}
	
		module.exports = mapCacheHas;
	
	
	/***/ },
	/* 182 */
	/***/ function(module, exports, __webpack_require__) {
	
		var getMapData = __webpack_require__(12);
	
		/**
		 * Sets the map `key` to `value`.
		 *
		 * @private
		 * @name set
		 * @memberOf MapCache
		 * @param {string} key The key of the value to set.
		 * @param {*} value The value to set.
		 * @returns {Object} Returns the map cache instance.
		 */
		function mapCacheSet(key, value) {
		  getMapData(this, key).set(key, value);
		  return this;
		}
	
		module.exports = mapCacheSet;
	
	
	/***/ },
	/* 183 */
	/***/ function(module, exports, __webpack_require__) {
	
		var ListCache = __webpack_require__(10);
	
		/**
		 * Removes all key-value entries from the stack.
		 *
		 * @private
		 * @name clear
		 * @memberOf Stack
		 */
		function stackClear() {
		  this.__data__ = new ListCache;
		}
	
		module.exports = stackClear;
	
	
	/***/ },
	/* 184 */
	/***/ function(module, exports) {
	
		/**
		 * Removes `key` and its value from the stack.
		 *
		 * @private
		 * @name delete
		 * @memberOf Stack
		 * @param {string} key The key of the value to remove.
		 * @returns {boolean} Returns `true` if the entry was removed, else `false`.
		 */
		function stackDelete(key) {
		  return this.__data__['delete'](key);
		}
	
		module.exports = stackDelete;
	
	
	/***/ },
	/* 185 */
	/***/ function(module, exports) {
	
		/**
		 * Gets the stack value for `key`.
		 *
		 * @private
		 * @name get
		 * @memberOf Stack
		 * @param {string} key The key of the value to get.
		 * @returns {*} Returns the entry value.
		 */
		function stackGet(key) {
		  return this.__data__.get(key);
		}
	
		module.exports = stackGet;
	
	
	/***/ },
	/* 186 */
	/***/ function(module, exports) {
	
		/**
		 * Checks if a stack value for `key` exists.
		 *
		 * @private
		 * @name has
		 * @memberOf Stack
		 * @param {string} key The key of the entry to check.
		 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
		 */
		function stackHas(key) {
		  return this.__data__.has(key);
		}
	
		module.exports = stackHas;
	
	
	/***/ },
	/* 187 */
	/***/ function(module, exports, __webpack_require__) {
	
		var ListCache = __webpack_require__(10),
		    MapCache = __webpack_require__(122);
	
		/** Used as the size to enable large array optimizations. */
		var LARGE_ARRAY_SIZE = 200;
	
		/**
		 * Sets the stack `key` to `value`.
		 *
		 * @private
		 * @name set
		 * @memberOf Stack
		 * @param {string} key The key of the value to set.
		 * @param {*} value The value to set.
		 * @returns {Object} Returns the stack cache instance.
		 */
		function stackSet(key, value) {
		  var cache = this.__data__;
		  if (cache instanceof ListCache && cache.__data__.length == LARGE_ARRAY_SIZE) {
		    cache = this.__data__ = new MapCache(cache.__data__);
		  }
		  cache.set(key, value);
		  return this;
		}
	
		module.exports = stackSet;
	
	
	/***/ },
	/* 188 */
	/***/ function(module, exports) {
	
		/** Used to compose unicode character classes. */
		var rsAstralRange = '\\ud800-\\udfff',
		    rsComboMarksRange = '\\u0300-\\u036f\\ufe20-\\ufe23',
		    rsComboSymbolsRange = '\\u20d0-\\u20f0',
		    rsVarRange = '\\ufe0e\\ufe0f';
	
		/** Used to compose unicode capture groups. */
		var rsAstral = '[' + rsAstralRange + ']',
		    rsCombo = '[' + rsComboMarksRange + rsComboSymbolsRange + ']',
		    rsFitz = '\\ud83c[\\udffb-\\udfff]',
		    rsModifier = '(?:' + rsCombo + '|' + rsFitz + ')',
		    rsNonAstral = '[^' + rsAstralRange + ']',
		    rsRegional = '(?:\\ud83c[\\udde6-\\uddff]){2}',
		    rsSurrPair = '[\\ud800-\\udbff][\\udc00-\\udfff]',
		    rsZWJ = '\\u200d';
	
		/** Used to compose unicode regexes. */
		var reOptMod = rsModifier + '?',
		    rsOptVar = '[' + rsVarRange + ']?',
		    rsOptJoin = '(?:' + rsZWJ + '(?:' + [rsNonAstral, rsRegional, rsSurrPair].join('|') + ')' + rsOptVar + reOptMod + ')*',
		    rsSeq = rsOptVar + reOptMod + rsOptJoin,
		    rsSymbol = '(?:' + [rsNonAstral + rsCombo + '?', rsCombo, rsRegional, rsSurrPair, rsAstral].join('|') + ')';
	
		/** Used to match [string symbols](https://mathiasbynens.be/notes/javascript-unicode). */
		var reComplexSymbol = RegExp(rsFitz + '(?=' + rsFitz + ')|' + rsSymbol + rsSeq, 'g');
	
		/**
		 * Converts `string` to an array.
		 *
		 * @private
		 * @param {string} string The string to convert.
		 * @returns {Array} Returns the converted array.
		 */
		function stringToArray(string) {
		  return string.match(reComplexSymbol);
		}
	
		module.exports = stringToArray;
	
	
	/***/ },
	/* 189 */
	/***/ function(module, exports, __webpack_require__) {
	
		var baseFlatten = __webpack_require__(135);
	
		/**
		 * Flattens `array` a single level deep.
		 *
		 * @static
		 * @memberOf _
		 * @since 0.1.0
		 * @category Array
		 * @param {Array} array The array to flatten.
		 * @returns {Array} Returns the new flattened array.
		 * @example
		 *
		 * _.flatten([1, [2, [3, [4]], 5]]);
		 * // => [1, 2, [3, [4]], 5]
		 */
		function flatten(array) {
		  var length = array ? array.length : 0;
		  return length ? baseFlatten(array, 1) : [];
		}
	
		module.exports = flatten;
	
	
	/***/ },
	/* 190 */
	/***/ function(module, exports, __webpack_require__) {
	
		/* WEBPACK VAR INJECTION */(function(module) {var root = __webpack_require__(1),
		    stubFalse = __webpack_require__(196);
	
		/** Detect free variable `exports`. */
		var freeExports = typeof exports == 'object' && exports;
	
		/** Detect free variable `module`. */
		var freeModule = freeExports && typeof module == 'object' && module;
	
		/** Detect the popular CommonJS extension `module.exports`. */
		var moduleExports = freeModule && freeModule.exports === freeExports;
	
		/** Built-in value references. */
		var Buffer = moduleExports ? root.Buffer : undefined;
	
		/**
		 * Checks if `value` is a buffer.
		 *
		 * @static
		 * @memberOf _
		 * @since 4.3.0
		 * @category Lang
		 * @param {*} value The value to check.
		 * @returns {boolean} Returns `true` if `value` is a buffer, else `false`.
		 * @example
		 *
		 * _.isBuffer(new Buffer(2));
		 * // => true
		 *
		 * _.isBuffer(new Uint8Array(2));
		 * // => false
		 */
		var isBuffer = !Buffer ? stubFalse : function(value) {
		  return value instanceof Buffer;
		};
	
		module.exports = isBuffer;
	
		/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(63)(module)))
	
	/***/ },
	/* 191 */
	/***/ function(module, exports, __webpack_require__) {
	
		var getPrototype = __webpack_require__(24),
		    isHostObject = __webpack_require__(25),
		    isObjectLike = __webpack_require__(6);
	
		/** `Object#toString` result references. */
		var objectTag = '[object Object]';
	
		/** Used for built-in method references. */
		var objectProto = Object.prototype;
	
		/** Used to resolve the decompiled source of functions. */
		var funcToString = Function.prototype.toString;
	
		/** Used to check objects for own properties. */
		var hasOwnProperty = objectProto.hasOwnProperty;
	
		/** Used to infer the `Object` constructor. */
		var objectCtorString = funcToString.call(Object);
	
		/**
		 * Used to resolve the
		 * [`toStringTag`](http://ecma-international.org/ecma-262/6.0/#sec-object.prototype.tostring)
		 * of values.
		 */
		var objectToString = objectProto.toString;
	
		/**
		 * Checks if `value` is a plain object, that is, an object created by the
		 * `Object` constructor or one with a `[[Prototype]]` of `null`.
		 *
		 * @static
		 * @memberOf _
		 * @since 0.8.0
		 * @category Lang
		 * @param {*} value The value to check.
		 * @returns {boolean} Returns `true` if `value` is a plain object,
		 *  else `false`.
		 * @example
		 *
		 * function Foo() {
		 *   this.a = 1;
		 * }
		 *
		 * _.isPlainObject(new Foo);
		 * // => false
		 *
		 * _.isPlainObject([1, 2, 3]);
		 * // => false
		 *
		 * _.isPlainObject({ 'x': 0, 'y': 0 });
		 * // => true
		 *
		 * _.isPlainObject(Object.create(null));
		 * // => true
		 */
		function isPlainObject(value) {
		  if (!isObjectLike(value) ||
		      objectToString.call(value) != objectTag || isHostObject(value)) {
		    return false;
		  }
		  var proto = getPrototype(value);
		  if (proto === null) {
		    return true;
		  }
		  var Ctor = hasOwnProperty.call(proto, 'constructor') && proto.constructor;
		  return (typeof Ctor == 'function' &&
		    Ctor instanceof Ctor && funcToString.call(Ctor) == objectCtorString);
		}
	
		module.exports = isPlainObject;
	
	
	/***/ },
	/* 192 */
	/***/ function(module, exports, __webpack_require__) {
	
		var isObjectLike = __webpack_require__(6);
	
		/** `Object#toString` result references. */
		var symbolTag = '[object Symbol]';
	
		/** Used for built-in method references. */
		var objectProto = Object.prototype;
	
		/**
		 * Used to resolve the
		 * [`toStringTag`](http://ecma-international.org/ecma-262/6.0/#sec-object.prototype.tostring)
		 * of values.
		 */
		var objectToString = objectProto.toString;
	
		/**
		 * Checks if `value` is classified as a `Symbol` primitive or object.
		 *
		 * @static
		 * @memberOf _
		 * @since 4.0.0
		 * @category Lang
		 * @param {*} value The value to check.
		 * @returns {boolean} Returns `true` if `value` is correctly classified,
		 *  else `false`.
		 * @example
		 *
		 * _.isSymbol(Symbol.iterator);
		 * // => true
		 *
		 * _.isSymbol('abc');
		 * // => false
		 */
		function isSymbol(value) {
		  return typeof value == 'symbol' ||
		    (isObjectLike(value) && objectToString.call(value) == symbolTag);
		}
	
		module.exports = isSymbol;
	
	
	/***/ },
	/* 193 */
	/***/ function(module, exports, __webpack_require__) {
	
		var createRange = __webpack_require__(158);
	
		/**
		 * Creates an array of numbers (positive and/or negative) progressing from
		 * `start` up to, but not including, `end`. A step of `-1` is used if a negative
		 * `start` is specified without an `end` or `step`. If `end` is not specified,
		 * it's set to `start` with `start` then set to `0`.
		 *
		 * **Note:** JavaScript follows the IEEE-754 standard for resolving
		 * floating-point values which can produce unexpected results.
		 *
		 * @static
		 * @since 0.1.0
		 * @memberOf _
		 * @category Util
		 * @param {number} [start=0] The start of the range.
		 * @param {number} end The end of the range.
		 * @param {number} [step=1] The value to increment or decrement by.
		 * @returns {Array} Returns the range of numbers.
		 * @see _.inRange, _.rangeRight
		 * @example
		 *
		 * _.range(4);
		 * // => [0, 1, 2, 3]
		 *
		 * _.range(-4);
		 * // => [0, -1, -2, -3]
		 *
		 * _.range(1, 5);
		 * // => [1, 2, 3, 4]
		 *
		 * _.range(0, 20, 5);
		 * // => [0, 5, 10, 15]
		 *
		 * _.range(0, -4, -1);
		 * // => [0, -1, -2, -3]
		 *
		 * _.range(1, 4, 0);
		 * // => [1, 1, 1]
		 *
		 * _.range(0);
		 * // => []
		 */
		var range = createRange();
	
		module.exports = range;
	
	
	/***/ },
	/* 194 */
	/***/ function(module, exports, __webpack_require__) {
	
		var apply = __webpack_require__(130),
		    toInteger = __webpack_require__(198);
	
		/** Used as the `TypeError` message for "Functions" methods. */
		var FUNC_ERROR_TEXT = 'Expected a function';
	
		/* Built-in method references for those with the same name as other `lodash` methods. */
		var nativeMax = Math.max;
	
		/**
		 * Creates a function that invokes `func` with the `this` binding of the
		 * created function and arguments from `start` and beyond provided as
		 * an array.
		 *
		 * **Note:** This method is based on the
		 * [rest parameter](https://mdn.io/rest_parameters).
		 *
		 * @static
		 * @memberOf _
		 * @since 4.0.0
		 * @category Function
		 * @param {Function} func The function to apply a rest parameter to.
		 * @param {number} [start=func.length-1] The start position of the rest parameter.
		 * @returns {Function} Returns the new function.
		 * @example
		 *
		 * var say = _.rest(function(what, names) {
		 *   return what + ' ' + _.initial(names).join(', ') +
		 *     (_.size(names) > 1 ? ', & ' : '') + _.last(names);
		 * });
		 *
		 * say('hello', 'fred', 'barney', 'pebbles');
		 * // => 'hello fred, barney, & pebbles'
		 */
		function rest(func, start) {
		  if (typeof func != 'function') {
		    throw new TypeError(FUNC_ERROR_TEXT);
		  }
		  start = nativeMax(start === undefined ? (func.length - 1) : toInteger(start), 0);
		  return function() {
		    var args = arguments,
		        index = -1,
		        length = nativeMax(args.length - start, 0),
		        array = Array(length);
	
		    while (++index < length) {
		      array[index] = args[start + index];
		    }
		    switch (start) {
		      case 0: return func.call(this, array);
		      case 1: return func.call(this, args[0], array);
		      case 2: return func.call(this, args[0], args[1], array);
		    }
		    var otherArgs = Array(start + 1);
		    index = -1;
		    while (++index < start) {
		      otherArgs[index] = args[index];
		    }
		    otherArgs[start] = array;
		    return apply(func, this, otherArgs);
		  };
		}
	
		module.exports = rest;
	
	
	/***/ },
	/* 195 */
	/***/ function(module, exports) {
	
		/**
		 * A method that returns a new empty array.
		 *
		 * @static
		 * @memberOf _
		 * @since 4.13.0
		 * @category Util
		 * @returns {Array} Returns the new empty array.
		 * @example
		 *
		 * var arrays = _.times(2, _.stubArray);
		 *
		 * console.log(arrays);
		 * // => [[], []]
		 *
		 * console.log(arrays[0] === arrays[1]);
		 * // => false
		 */
		function stubArray() {
		  return [];
		}
	
		module.exports = stubArray;
	
	
	/***/ },
	/* 196 */
	/***/ function(module, exports) {
	
		/**
		 * A method that returns `false`.
		 *
		 * @static
		 * @memberOf _
		 * @since 4.13.0
		 * @category Util
		 * @returns {boolean} Returns `false`.
		 * @example
		 *
		 * _.times(2, _.stubFalse);
		 * // => [false, false]
		 */
		function stubFalse() {
		  return false;
		}
	
		module.exports = stubFalse;
	
	
	/***/ },
	/* 197 */
	/***/ function(module, exports, __webpack_require__) {
	
		var toNumber = __webpack_require__(59);
	
		/** Used as references for various `Number` constants. */
		var INFINITY = 1 / 0,
		    MAX_INTEGER = 1.7976931348623157e+308;
	
		/**
		 * Converts `value` to a finite number.
		 *
		 * @static
		 * @memberOf _
		 * @since 4.12.0
		 * @category Lang
		 * @param {*} value The value to convert.
		 * @returns {number} Returns the converted number.
		 * @example
		 *
		 * _.toFinite(3.2);
		 * // => 3.2
		 *
		 * _.toFinite(Number.MIN_VALUE);
		 * // => 5e-324
		 *
		 * _.toFinite(Infinity);
		 * // => 1.7976931348623157e+308
		 *
		 * _.toFinite('3.2');
		 * // => 3.2
		 */
		function toFinite(value) {
		  if (!value) {
		    return value === 0 ? value : 0;
		  }
		  value = toNumber(value);
		  if (value === INFINITY || value === -INFINITY) {
		    var sign = (value < 0 ? -1 : 1);
		    return sign * MAX_INTEGER;
		  }
		  return value === value ? value : 0;
		}
	
		module.exports = toFinite;
	
	
	/***/ },
	/* 198 */
	/***/ function(module, exports, __webpack_require__) {
	
		var toFinite = __webpack_require__(197);
	
		/**
		 * Converts `value` to an integer.
		 *
		 * **Note:** This method is loosely based on
		 * [`ToInteger`](http://www.ecma-international.org/ecma-262/6.0/#sec-tointeger).
		 *
		 * @static
		 * @memberOf _
		 * @since 4.0.0
		 * @category Lang
		 * @param {*} value The value to convert.
		 * @returns {number} Returns the converted integer.
		 * @example
		 *
		 * _.toInteger(3.2);
		 * // => 3
		 *
		 * _.toInteger(Number.MIN_VALUE);
		 * // => 0
		 *
		 * _.toInteger(Infinity);
		 * // => 1.7976931348623157e+308
		 *
		 * _.toInteger('3.2');
		 * // => 3
		 */
		function toInteger(value) {
		  var result = toFinite(value),
		      remainder = result % 1;
	
		  return result === result ? (remainder ? result - remainder : result) : 0;
		}
	
		module.exports = toInteger;
	
	
	/***/ },
	/* 199 */
	/***/ function(module, exports, __webpack_require__) {
	
		var copyObject = __webpack_require__(23),
		    keysIn = __webpack_require__(57);
	
		/**
		 * Converts `value` to a plain object flattening inherited enumerable string
		 * keyed properties of `value` to own properties of the plain object.
		 *
		 * @static
		 * @memberOf _
		 * @since 3.0.0
		 * @category Lang
		 * @param {*} value The value to convert.
		 * @returns {Object} Returns the converted plain object.
		 * @example
		 *
		 * function Foo() {
		 *   this.b = 2;
		 * }
		 *
		 * Foo.prototype.c = 3;
		 *
		 * _.assign({ 'a': 1 }, new Foo);
		 * // => { 'a': 1, 'b': 2 }
		 *
		 * _.assign({ 'a': 1 }, _.toPlainObject(new Foo));
		 * // => { 'a': 1, 'b': 2, 'c': 3 }
		 */
		function toPlainObject(value) {
		  return copyObject(value, keysIn(value));
		}
	
		module.exports = toPlainObject;
	
	
	/***/ },
	/* 200 */
	/***/ function(module, exports, __webpack_require__) {
	
		var baseValues = __webpack_require__(146),
		    keys = __webpack_require__(17);
	
		/**
		 * Creates an array of the own enumerable string keyed property values of `object`.
		 *
		 * **Note:** Non-object values are coerced to objects.
		 *
		 * @static
		 * @since 0.1.0
		 * @memberOf _
		 * @category Object
		 * @param {Object} object The object to query.
		 * @returns {Array} Returns the array of property values.
		 * @example
		 *
		 * function Foo() {
		 *   this.a = 1;
		 *   this.b = 2;
		 * }
		 *
		 * Foo.prototype.c = 3;
		 *
		 * _.values(new Foo);
		 * // => [1, 2] (iteration order is not guaranteed)
		 *
		 * _.values('hi');
		 * // => ['h', 'i']
		 */
		function values(object) {
		  return object ? baseValues(object, keys(object)) : [];
		}
	
		module.exports = values;
	
	
	/***/ },
	/* 201 */
	/***/ function(module, exports, __webpack_require__) {
	
		var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;(function (root, factory) {
		  if (true) {
		    // AMD. Register as an anonymous module unless amdModuleId is set
		    !(__WEBPACK_AMD_DEFINE_ARRAY__ = [__webpack_require__(31)], __WEBPACK_AMD_DEFINE_RESULT__ = function (a0) {
		      return (root['DateRange'] = factory(a0));
		    }.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
		  } else if (typeof exports === 'object') {
		    // Node. Does not work with strict CommonJS, but
		    // only CommonJS-like environments that support module.exports,
		    // like Node.
		    module.exports = factory(require("moment"));
		  } else {
		    root['DateRange'] = factory(moment);
		  }
		}(this, function (moment) {
	
		//-----------------------------------------------------------------------------
		// Contstants
		//-----------------------------------------------------------------------------
	
	
	
		var INTERVALS = {
		  year:   true,
		  month:  true,
		  week:   true,
		  day:    true,
		  hour:   true,
		  minute: true,
		  second: true
		};
	
	
		//-----------------------------------------------------------------------------
		// Date Ranges
		//-----------------------------------------------------------------------------
	
		/**
		 * DateRange class to store ranges and query dates.
		 *
		 * @constructor
		 * @param {(Moment|Date)} start Start of interval
		 * @param {(Moment|Date)} end End of interval
		 *//**
		 * DateRange class to store ranges and query dates.
		 *
		 * @constructor
		 * @param {!Array} range Array containing start and end dates.
		 *//**
		 * DateRange class to store ranges and query dates.
		 *
		 * @constructor
		 * @param {!String} range String formatted as an IS0 8601 time interval
		 */
		function DateRange(start, end) {
		  var parts;
		  var s = start;
		  var e = end;
	
		  if (arguments.length === 1 || end === undefined) {
		    if (typeof start === 'object' && start.length === 2) {
		      s = start[0];
		      e = start[1];
		    }
		    else if (typeof start === 'string') {
		      parts = start.split('/');
		      s = parts[0];
		      e = parts[1];
		    }
		  }
	
		  this.start = (s === null) ? moment(-8640000000000000) : moment(s);
		  this.end   = (e === null) ? moment(8640000000000000) : moment(e);
		}
	
		/**
		 * Constructor for prototype.
		 *
		 * @type {DateRange}
		 */
		DateRange.prototype.constructor = DateRange;
	
		/**
		 * Deep clone range.
		 *
		 * @return {!DateRange}
		 */
		DateRange.prototype.clone = function() {
		  return moment().range(this.start, this.end);
		};
	
		/**
		 * Determine if the current interval contains a given moment/date/range.
		 *
		 * @param {(Moment|Date|DateRange)} other Date to check
		 * @param {!boolean} exclusive True if the to value is exclusive
		 *
		 * @return {!boolean}
		 */
		DateRange.prototype.contains = function(other, exclusive) {
		  var start = this.start;
		  var end   = this.end;
	
		  if (other instanceof DateRange) {
		    return start <= other.start && (end > other.end || (end.isSame(other.end) && !exclusive));
		  }
		  else {
		    return start <= other && (end > other || (end.isSame(other) && !exclusive));
		  }
		};
	
		/**
		 * Determine if the current date range overlaps a given date range.
		 *
		 * @param {!DateRange} range Date range to check
		 *
		 * @return {!boolean}
		 */
		DateRange.prototype.overlaps = function(range) {
		  return this.intersect(range) !== null;
		};
	
		/**
		 * Determine the intersecting periods from one or more date ranges.
		 *
		 * @param {!DateRange} other A date range to intersect with this one
		 *
		 * @return {DateRange} Returns the intersecting date or `null` if the ranges do
		 *                     not intersect
		 */
		DateRange.prototype.intersect = function(other) {
		  var start = this.start;
		  var end   = this.end;
	
		  if ((start <= other.start) && (other.start < end) && (end < other.end)) {
		    return new DateRange(other.start, end);
		  }
		  else if ((other.start < start) && (start < other.end) && (other.end <= end)) {
		    return new DateRange(start, other.end);
		  }
		  else if ((other.start < start) && (start <= end) && (end < other.end)) {
		    return this;
		  }
		  else if ((start <= other.start) && (other.start <= other.end) && (other.end <= end)) {
		    return other;
		  }
	
		  return null;
		};
	
		/**
		 * Merge date ranges if they intersect.
		 *
		 * @param {!DateRange} other A date range to add to this one
		 *
		 * @return {DateRange} Returns the new `DateRange` or `null` if they do not
		 *                     overlap
		 */
		DateRange.prototype.add = function(other) {
		  if (this.overlaps(other)) {
		    return new DateRange(moment.min(this.start, other.start), moment.max(this.end, other.end));
		  }
	
		  return null;
		};
	
		/**
		 * Subtract one range from another.
		 *
		 * @param {!DateRange} other A date range to substract from this one
		 *
		 * @return {!Array<DateRange>}
		 */
		DateRange.prototype.subtract = function(other) {
		  var start = this.start;
		  var end   = this.end;
	
		  if (this.intersect(other) === null) {
		    return [this];
		  }
		  else if ((other.start <= start) && (start < end) && (end <= other.end)) {
		    return [];
		  }
		  else if ((other.start <= start) && (start < other.end) && (other.end < end)) {
		    return [new DateRange(other.end, end)];
		  }
		  else if ((start < other.start) && (other.start < end) && (end <= other.end)) {
		    return [new DateRange(start, other.start)];
		  }
		  else if ((start < other.start) && (other.start < other.end) && (other.end < end)) {
		    return [new DateRange(start, other.start), new DateRange(other.end, end)];
		  }
		  else if ((start < other.start) && (other.start < end) && (other.end < end)) {
		    return [new DateRange(start, other.start), new DateRange(other.start, end)];
		  }
		};
	
		/**
		 * Build a n array of dates.
		 *
		 * @param {(!DateRange|String)} range Date range to be used for iteration or
		 *                                    shorthand string (shorthands:
		 *                                    http://momentjs.com/docs/#/manipulating/add/)
		 * @param {!boolean} exclusive Indicate that the end of the range should not
		 *                             be included in the iter.
		 *
		 * @return {!Array}
		 */
		DateRange.prototype.toArray = function(by, exclusive) {
		  var acc = [];
		  this.by(by, function(unit) {
		    acc.push(unit);
		  }, exclusive);
		  return acc;
		};
	
		/**
		 * Iterate over the date range by a given date range, executing a function
		 * for each sub-range.
		 *
		 * @param {(!DateRange|String)} range Date range to be used for iteration or
		 *                                    shorthand string (shorthands:
		 *                                    http://momentjs.com/docs/#/manipulating/add/)
		 * @param {!DateRange~by} hollaback Callback
		 * @param {!boolean} exclusive Indicate that the end of the range should not
		 *                             be included in the iter.
		 *
		 * @return {DateRange} `this`
		 */
		DateRange.prototype.by = function(range, hollaback, exclusive) {
		  if (typeof range === 'string') {
		    _byString.call(this, range, hollaback, exclusive);
		  }
		  else {
		    _byRange.call(this, range, hollaback, exclusive);
		  }
		  return this;
		};
	
	
		/**
		 * Callback executed for each sub-range.
		 *
		 * @callback DateRange~by
		 *
		 * @param {!Moment} current Current moment object for iteration
		 */
	
		/**
		 * @private
		 */
		function _byString(interval, hollaback, exclusive) {
		  var current = moment(this.start);
	
		  while (this.contains(current, exclusive)) {
		    hollaback.call(this, current.clone());
		    current.add(1, interval);
		  }
		}
	
		/**
		 * @private
		 */
		function _byRange(interval, hollaback, exclusive) {
		  var div = this / interval;
		  var l = Math.floor(div);
	
		  if (l === Infinity) { return; }
		  if (l === div && exclusive) {
		    l--;
		  }
	
		  for (var i = 0; i <= l; i++) {
		    hollaback.call(this, moment(this.start.valueOf() + interval.valueOf() * i));
		  }
		}
	
		/**
		 * Date range formatted as an [ISO8601 Time
		 * Interval](http://en.wikipedia.org/wiki/ISO_8601#Time_intervals).
		 *
		 * @return {!String}
		 */
		DateRange.prototype.toString = function() {
		  return this.start.format() + '/' + this.end.format();
		};
	
		/**
		 * Date range in milliseconds. Allows basic coercion math of date ranges.
		 *
		 * @return {!number}
		 */
		DateRange.prototype.valueOf = function() {
		  return this.end - this.start;
		};
	
		/**
		 * Center date of the range.
		 *
		 * @return {!Moment}
		 */
		DateRange.prototype.center = function() {
		  var center = this.start + this.diff() / 2;
		  return moment(center);
		};
	
		/**
		 * Date range toDate
		 *
		 * @return {!Array<Date>}
		 */
		DateRange.prototype.toDate = function() {
		  return [this.start.toDate(), this.end.toDate()];
		};
	
		/**
		 * Determine if this date range is the same as another.
		 *
		 * @param {!DateRange} other Another date range to compare to
		 *
		 * @return {!boolean}
		 */
		DateRange.prototype.isSame = function(other) {
		  return this.start.isSame(other.start) && this.end.isSame(other.end);
		};
	
		/**
		 * The difference of the end vs start.
		 *
		 * @param {number} unit Unit of difference, if no unit is passed in
		 *                      milliseconds are returned. E.g.: `"days"`, `"months"`,
		 *                      etc...
		 *
		 * @return {!number}
		 */
		DateRange.prototype.diff = function(unit) {
		  return this.end.diff(this.start, unit);
		};
	
	
		//-----------------------------------------------------------------------------
		// Moment Extensions
		//-----------------------------------------------------------------------------
	
		/**
		 * Build a date range.
		 *
		 * @param {(Moment|Date)} start Start of range
		 * @param {(Moment|Date)} end End of range
		 *
		 * @this {Moment}
		 *
		 * @return {!DateRange}
		 */
		moment.range = function(start, end) {
		  if (start in INTERVALS) {
		    return new DateRange(moment(this).startOf(start), moment(this).endOf(start));
		  }
		  else {
		    return new DateRange(start, end);
		  }
		};
	
		/**
		 * Expose constructor
		 *
		 * @const
		 */
		moment.range.constructor = DateRange;
	
		/**
		 * @deprecated
		 */
		moment.fn.range = moment.range;
	
		/**
		 * Check if the current moment is within a given date range.
		 *
		 * @param {!DateRange} range Date range to check
		 *
		 * @this {Moment}
		 *
		 * @return {!boolean}
		 */
		moment.fn.within = function(range) {
		  return range.contains(this._d);
		};
	
	
		//-----------------------------------------------------------------------------
		// Export
		//-----------------------------------------------------------------------------
	
	
	
		return DateRange;
	
		}));
	
	
	/***/ },
	/* 202 */
	/***/ function(module, exports) {
	
		module.exports = "\n<div v-if=\"show\"\n  transition=\"fade\"\n  class=\"uk-alert\"\n  :class=\"{\n    'uk-alert-success': color === 'success',\n    'uk-alert-warning': color === 'warning',\n    'uk-alert-danger': color === 'danger',\n    'uk-alert-large': large\n  }\">\n  <a href=\"\" class=\"uk-close\"\n    v-if=\"!block\"\n    @click.prevent=\"show = !show\">\n  </a>\n  <slot></slot>\n</div>\n";
	
	/***/ },
	/* 203 */
	/***/ function(module, exports) {
	
		module.exports = "\n<ul class=\"uk-breadcrumb\">\n  <slot></slot>\n</ul>\n";
	
	/***/ },
	/* 204 */
	/***/ function(module, exports) {
	
		module.exports = "\n<li :class=\"{ 'uk-active': path === $parent.location }\">\n  <span v-if=\"disabled || (path === $parent.location)\">\n    <slot></slot>\n  </span>\n  <a href=\"\" v-else\n    @click.prevent=\"$parent.location = path\">\n    <slot></slot>\n  </a>\n</li>\n";
	
	/***/ },
	/* 205 */
	/***/ function(module, exports) {
	
		module.exports = "\n<button class=\"uk-button\"\n  :class=\"classes\"\n  :disabled=\"disabled\"\n  :type=\"type\">\n  <i v-if=\"iconLeft\"\n    class=\"uk-icon-justify uk-icon-{{ iconLeft }}\">\n  </i>\n  <slot></slot>\n  <i v-if=\"iconRight\"\n    class=\"uk-icon-justify uk-icon-{{ iconRight }}\">\n  </i>\n</button>\n";
	
	/***/ },
	/* 206 */
	/***/ function(module, exports) {
	
		module.exports = "\n<div data-uk-button-checkbox\n  :class=\"{\n    'uk-button-group': group\n  }\">\n  <slot></slot>\n</div>\n";
	
	/***/ },
	/* 207 */
	/***/ function(module, exports) {
	
		module.exports = "\n<a class=\"uk-button\"\n  :href=\"href\"\n  :class=\"classes\">\n  <i v-if=\"iconLeft\"\n    :class=\"iconClass(iconLeft)\">\n  </i>\n  <slot></slot>\n  <i v-if=\"iconRight\"\n    :class=\"iconClass(iconRight)\">\n  </i>\n</a>\n";
	
	/***/ },
	/* 208 */
	/***/ function(module, exports) {
	
		module.exports = "\n<div data-uk-button-radio\n  :class=\"{\n    'uk-button-group': group\n  }\">\n  <slot></slot>\n</div>\n";
	
	/***/ },
	/* 209 */
	/***/ function(module, exports) {
	
		module.exports = "\n<div class=\"uk-datepicker\">\n  <div class=\"uk-datepicker-nav\">\n    <a href=\"\" class=\"uk-datepicker-previous\"\n      v-if=\"isDisplayable(prevMonth)\"\n      @click.prevent=\"date = prevMonth\">\n    </a>\n    <a href=\"\" class=\"uk-datepicker-next\"\n      v-if=\"isDisplayable(nextMonth)\"\n      @click.prevent=\"date = nextMonth\">\n    </a>\n    <div class=\"uk-datepicker-heading\">\n      <span class=\"uk-form-select\">\n        <a href=\"\"\n          v-text=\"date | format 'MMMM'\"\n          @click.prevent>\n        </a>\n        <select v-model=\"month\">\n          <option v-for=\"(m, name) in monthsList\"\n            :value=\"m\"\n            v-text=\"name\">\n          </option>\n        </select>\n      </span>\n      <span class=\"uk-form-select\">\n        <a href=\"\"\n          v-text=\"date | format 'YYYY'\"\n          @click.prevent>\n        </a>\n        <select v-model=\"year\">\n          <option v-for=\"year in yearsList\"\n            :value=\"year\"\n            v-text=\"year\">\n          </option>\n        </select>\n      </span>\n    </div>\n  </div>\n  <table class=\"uk-datepicker-table\">\n    <thead>\n      <tr>\n        <th v-for=\"day in listWeekDays\" v-text=\"day\"></th>\n      </tr>\n    </thead>\n    <tbody>\n      <tr v-for=\"week in matrix\">\n        <td v-for=\"day in week\"\n          track-by=\"$index\">\n          <a href=\"\"\n            :class=\"{\n              'uk-active': isSelected(day),\n              'uk-datepicker-table-disabled': isDisabled(day) && !isSelected(day),\n              'uk-datepicker-table-muted': !isInCurrentMonth(day) || isDisabled(day)\n            }\"\n            @click.prevent=\"$emit('select', day)\"\n            v-text=\"day | format 'D'\">\n          </a>\n        </td>\n      </tr>\n    </tbody>\n  </table>\n</div>\n";
	
	/***/ },
	/* 210 */
	/***/ function(module, exports) {
	
		module.exports = "\n<input type=\"text\"\n  v-el:input\n  v-model=\"value\"\n  @focus=\"show = true\">\n<div class=\"uk-dropdown uk-datepicker\"\n  v-if=\"renderDropdown\"\n  v-el:dropdown\n  :style=\"dropdownCss\">\n  <calendar v-ref:calendar\n    :min=\"minDateMoment\"\n    :max=\"maxDateMoment\"\n    :disabled-dates=\"disabledDates\"\n    :selected-dates=\"selectedDates\"\n    :locale=\"locale\"\n    @select=\"select\"\n    @update=\"$emit('update')\">\n  </calendar>\n</div>\n";
	
	/***/ },
	/* 211 */
	/***/ function(module, exports) {
	
		module.exports = "\n<div class=\"uk-modal\" v-el:modal>\n  <div class=\"uk-modal-dialog\"\n    :class=\"{\n      'uk-modal-dialog-large': large\n    }\">\n    <!-- close button -->\n    <a class=\"uk-modal-close uk-close\"\n      href=\"\"\n      v-if=\"!block && closeBtn\">\n    </a>\n    <!-- header -->\n    <div v-el:header class=\"uk-modal-header\">\n      <slot name=\"header\"></slot>\n    </div>\n    <!-- content -->\n    <div v-el:content class=\"uk-modal-content\"\n      :class=\"{\n        'uk-overflow-container': overflow\n      }\">\n      <slot></slot>\n    </div>\n    <!-- footer -->\n    <div v-el:footer class=\"uk-modal-footer\">\n      <slot name=\"footer\"></slot>\n    </div>\n    <!-- caption -->\n    <div v-el:caption class=\"uk-modal-caption\">\n      <slot name=\"caption\"></slot>\n    </div>\n  </div>\n</div>\n";
	
	/***/ },
	/* 212 */
	/***/ function(module, exports) {
	
		module.exports = "\n<div class=\"uk-modal\" v-el:modal>\n  <div class=\"uk-modal-dialog\">\n    <div class=\"uk-modal-content\">\n      <template v-if=\"text\">{{ text }}</template>\n      <slot v-if=\"!text\"></slot>\n    </div>\n    <div class=\"uk-modal-footer uk-text-right\">\n      <button class=\"uk-button uk-button-primary\"\n        :disabled=\"block\"\n        @click=\"show = false\">\n        Ok\n      </button>\n    </div>\n  </div>\n</div>\n";
	
	/***/ },
	/* 213 */
	/***/ function(module, exports) {
	
		module.exports = "\n<div class=\"uk-modal\" v-el:modal>\n  <div class=\"uk-modal-dialog uk-modal-dialog-blank\">\n    <a href=\"\" class=\"uk-modal-close uk-close uk-close-alt\"></a>\n    <slot></slot>\n  </div>\n</div>\n";
	
	/***/ },
	/* 214 */
	/***/ function(module, exports) {
	
		module.exports = "\n<div class=\"uk-modal\" v-el:modal>\n  <div class=\"uk-modal-dialog\">\n    <div class=\"uk-modal-content\">\n      <slot></slot>\n    </div>\n    <div class=\"uk-modal-footer uk-text-right\">\n      <button class=\"uk-button\"\n        :disabled=\"block\"\n        @click=\"show = false\">\n        Cancel\n      </button>\n      <button class=\"uk-button uk-button-primary\"\n        type=\"button\"\n        :disabled=\"block\"\n        @click=\"confirm()\">\n        OK\n      </button>\n    </div>\n  </div>\n</div>\n";
	
	/***/ },
	/* 215 */
	/***/ function(module, exports) {
	
		module.exports = "\n<div class=\"uk-modal\" v-el:modal>\n  <div class=\"uk-modal-dialog uk-modal-dialog-lightbox\">\n    <a class=\"uk-modal-close uk-close uk-close-alt\"\n      href=\"\"\n      v-if=\"!block && closeBtn\">\n    </a>\n    <slot></slot>\n  </div>\n</div>\n";
	
	/***/ },
	/* 216 */
	/***/ function(module, exports) {
	
		module.exports = "\n<ul class=\"uk-pagination\"\n  :class=\"{\n    'uk-pagination-left': align === 'left',\n    'uk-pagination-right': align === 'right'\n  }\">\n  <li :class=\"{\n    'uk-disabled': !prevPage,\n    'uk-pagination-previous': !compact\n  }\">\n    <!-- firstPage -->\n    <a href=\"\" v-if=\"prevPage\"\n      @click.prevent=\"current = 1\">\n      <i class=\"uk-icon-angle-double-left\"></i>\n    </a>\n    <span v-else>\n      <i class=\"uk-icon-angle-double-left\"></i>\n    </span>\n    <!-- prevPage -->\n    <a href=\"\" v-if=\"prevPage\"\n      @click.prevent=\"current = prevPage\">\n      <i class=\"uk-icon-angle-left\"></i>\n    </a>\n    <span v-else>\n      <i class=\"uk-icon-angle-left\"></i>\n    </span>\n  </li>\n  <li v-for=\"page in prePages\"\n    :class=\"{'uk-active': page === current}\">\n    <!-- content -->\n    <span v-if=\"page === current\" v-text=\"page\"></span>\n    <a href=\"\" v-else\n      @click.prevent=\"current = page\"\n      v-text=\"page\">\n    </a>\n  </li>\n  <li v-if=\"edges < interval.start && (interval.start - edges != 1)\">\n    <span>...</span>\n  </li>\n  <li\n    v-for=\"page in pages\"\n    :class=\"{'uk-active': page === current}\">\n    <!-- content -->\n    <span v-if=\"page === current\" v-text=\"page\"></span>\n    <a v-else\n      href=\"\"\n      @click.prevent=\"current = page\"\n      v-text=\"page\">\n    </a>\n  </li>\n  <li v-if=\"totalPages - edges > interval.end\n    && (totalPages - edges - interval.end != 1)\">\n    <span>...</span>\n  </li>\n  <li v-for=\"page in postPages\"\n    :class=\"{'uk-active': page === current}\">\n    <!-- content -->\n    <span v-if=\"page === current\">\n      {{ page }}\n    </span>\n    <a href=\"\" v-else\n      @click.prevent=\"current = page\"\n      v-text=\"page\">\n    </a>\n  </li>\n  <li :class=\"{\n    'uk-disabled': !nextPage,\n    'uk-pagination-next': !compact\n  }\">\n    <!-- nextPage -->\n    <a href=\"\" v-if=\"nextPage\"\n      @click.prevent=\"current = nextPage\">\n      <i class=\"uk-icon-angle-right\"></i>\n    </a>\n    <span v-else>\n      <i class=\"uk-icon-angle-right\"></i>\n    </span>\n    <!-- last page -->\n    <a href=\"\" v-if=\"nextPage\"\n      @click.prevent=\"current = totalPages\">\n      <i class=\"uk-icon-angle-double-right\"></i>\n    </a>\n    <span v-else>\n      <i class=\"uk-icon-angle-double-right\"></i>\n    </span>\n  </li>\n</ul>\n";
	
	/***/ },
	/* 217 */
	/***/ function(module, exports) {
	
		module.exports = "\n<div class=\"uk-progress\"\n  :class=\"{\n    'uk-progress-success': color === 'success',\n    'uk-progress-warning': color === 'warning',\n    'uk-progress-danger': color === 'danger',\n    'uk-progress-mini': size === 'mini',\n    'uk-progress-small': size === 'small',\n    'uk-progress-striped': stripe,\n    'uk-active': stripe === 'animated'\n  }\">\n  <div class=\"uk-progress-bar\"\n    :style=\"{\n      width: progress + '%'\n    }\">\n    <slot></slot>\n  </div>\n</div>\n";
	
	/***/ },
	/* 218 */
	/***/ function(module, exports) {
	
		module.exports = "\n<ul class=\"uk-subnav\"\n  :class=\"{\n    'uk-subnav-line': line,\n    'uk-subnav-pill': pill\n   }\">\n  <slot></slot>\n</ul>\n";
	
	/***/ },
	/* 219 */
	/***/ function(module, exports) {
	
		module.exports = "\n<li :class=\"{\n  'uk-active': active,\n  'uk-disabled': disabled\n}\">\n  <a href=\"\" @click.prevent=\"!disabled && ($parent.active = this)\">\n    <slot></slot>\n  </a>\n</li>\n";
	
	/***/ },
	/* 220 */
	/***/ function(module, exports) {
	
		module.exports = "\n<ul class=\"uk-switcher\">\n  <slot></slot>\n</ul>\n";
	
	/***/ },
	/* 221 */
	/***/ function(module, exports) {
	
		module.exports = "\n<li><slot></slot></li>\n";
	
	/***/ },
	/* 222 */
	/***/ function(module, exports) {
	
		module.exports = "\n<li><slot></slot></li>\n";
	
	/***/ },
	/* 223 */
	/***/ function(module, exports) {
	
		module.exports = "\n<li :class=\"classes\">\n  <a href=\"\" v-text=\"label\"></a>\n</li>\n";
	
	/***/ },
	/* 224 */
	/***/ function(module, exports) {
	
		module.exports = "\n<div :class=\"{\n  'uk-flex uk-flex-column-reverse': bottom\n}\">\n  <div :class=\"{\n    'uk-tab-center': center,\n    'uk-tab-center-bottom': center && bottom\n  }\">\n    <ul class=\"uk-tab\"\n      :data-uk-tab=\"{ connect: '#' + id } | json\"\n      :class=\"{\n        'uk-tab-grid': width,\n        'uk-tab-flip': flip,\n        'uk-tab-bottom': bottom\n      }\">\n      <tab-header\n        v-for=\"tab in tabs\"\n        :label=\"tab.label\"\n        :width=\"width\"\n        :active=\"tab.active\"\n        :disabled=\"tab.disabled\">\n      </tab-header>\n    </ul>\n  </div>\n  <ul class=\"uk-switcher uk-margin\"\n    :id=\"id\"\n    v-el:tabs-body>\n    <slot></slot>\n  </ul>\n</div>\n";
	
	/***/ },
	/* 225 */
	/***/ function(module, exports) {
	
		module.exports = "\n<div class=\"uk-grid\"\n  :class=\"{\n    'uk-flex uk-flex-row-reverse': align === 'right'\n  }\">\n  <div :class=\"'uk-width-medium-' + headerWidth\">\n    <ul class=\"uk-tab\"\n      :data-uk-tab=\"{ connect: '#' + id } | json\"\n      :class=\"{\n        'uk-tab-left': align === 'left',\n        'uk-tab-right': align === 'right'\n      }\">\n      <tab-header\n        v-for=\"tab in tabs\"\n        :label=\"tab.label\"\n        :disabled=\"tab.disabled\">\n      </tab-header>\n    </ul>\n  </div>\n  <div :class=\"'uk-width-medium-' + bodyWidth\">\n    <ul class=\"uk-switcher uk-margin\"\n      :id=\"id\"\n      v-el:tabs-body>\n      <slot></slot>\n    </ul>\n  </div>\n</div>\n";
	
	/***/ },
	/* 226 */
	/***/ function(module, exports, __webpack_require__) {
	
		var __vue_script__, __vue_template__
		__vue_script__ = __webpack_require__(65)
		if (__vue_script__ &&
		    __vue_script__.__esModule &&
		    Object.keys(__vue_script__).length > 1) {
		  console.warn("[vue-loader] src/Alert.vue: named exports in *.vue files are ignored.")}
		__vue_template__ = __webpack_require__(202)
		module.exports = __vue_script__ || {}
		if (module.exports.__esModule) module.exports = module.exports.default
		if (__vue_template__) {
		(typeof module.exports === "function" ? (module.exports.options || (module.exports.options = {})) : module.exports).template = __vue_template__
		}
		if (false) {(function () {  module.hot.accept()
		  var hotAPI = require("vue-hot-reload-api")
		  hotAPI.install(require("vue"), false)
		  if (!hotAPI.compatible) return
		  var id = "./Alert.vue"
		  if (!module.hot.data) {
		    hotAPI.createRecord(id, module.exports)
		  } else {
		    hotAPI.update(id, module.exports, __vue_template__)
		  }
		})()}
	
	/***/ },
	/* 227 */
	/***/ function(module, exports, __webpack_require__) {
	
		var __vue_script__, __vue_template__
		__vue_script__ = __webpack_require__(66)
		if (__vue_script__ &&
		    __vue_script__.__esModule &&
		    Object.keys(__vue_script__).length > 1) {
		  console.warn("[vue-loader] src/Breadcrumb.vue: named exports in *.vue files are ignored.")}
		__vue_template__ = __webpack_require__(203)
		module.exports = __vue_script__ || {}
		if (module.exports.__esModule) module.exports = module.exports.default
		if (__vue_template__) {
		(typeof module.exports === "function" ? (module.exports.options || (module.exports.options = {})) : module.exports).template = __vue_template__
		}
		if (false) {(function () {  module.hot.accept()
		  var hotAPI = require("vue-hot-reload-api")
		  hotAPI.install(require("vue"), false)
		  if (!hotAPI.compatible) return
		  var id = "./Breadcrumb.vue"
		  if (!module.hot.data) {
		    hotAPI.createRecord(id, module.exports)
		  } else {
		    hotAPI.update(id, module.exports, __vue_template__)
		  }
		})()}
	
	/***/ },
	/* 228 */
	/***/ function(module, exports, __webpack_require__) {
	
		var __vue_script__, __vue_template__
		__vue_script__ = __webpack_require__(67)
		if (__vue_script__ &&
		    __vue_script__.__esModule &&
		    Object.keys(__vue_script__).length > 1) {
		  console.warn("[vue-loader] src/BreadcrumbItem.vue: named exports in *.vue files are ignored.")}
		__vue_template__ = __webpack_require__(204)
		module.exports = __vue_script__ || {}
		if (module.exports.__esModule) module.exports = module.exports.default
		if (__vue_template__) {
		(typeof module.exports === "function" ? (module.exports.options || (module.exports.options = {})) : module.exports).template = __vue_template__
		}
		if (false) {(function () {  module.hot.accept()
		  var hotAPI = require("vue-hot-reload-api")
		  hotAPI.install(require("vue"), false)
		  if (!hotAPI.compatible) return
		  var id = "./BreadcrumbItem.vue"
		  if (!module.hot.data) {
		    hotAPI.createRecord(id, module.exports)
		  } else {
		    hotAPI.update(id, module.exports, __vue_template__)
		  }
		})()}
	
	/***/ },
	/* 229 */
	/***/ function(module, exports, __webpack_require__) {
	
		var __vue_script__, __vue_template__
		__vue_script__ = __webpack_require__(69)
		if (__vue_script__ &&
		    __vue_script__.__esModule &&
		    Object.keys(__vue_script__).length > 1) {
		  console.warn("[vue-loader] src/ButtonCheckbox.vue: named exports in *.vue files are ignored.")}
		__vue_template__ = __webpack_require__(206)
		module.exports = __vue_script__ || {}
		if (module.exports.__esModule) module.exports = module.exports.default
		if (__vue_template__) {
		(typeof module.exports === "function" ? (module.exports.options || (module.exports.options = {})) : module.exports).template = __vue_template__
		}
		if (false) {(function () {  module.hot.accept()
		  var hotAPI = require("vue-hot-reload-api")
		  hotAPI.install(require("vue"), false)
		  if (!hotAPI.compatible) return
		  var id = "./ButtonCheckbox.vue"
		  if (!module.hot.data) {
		    hotAPI.createRecord(id, module.exports)
		  } else {
		    hotAPI.update(id, module.exports, __vue_template__)
		  }
		})()}
	
	/***/ },
	/* 230 */
	/***/ function(module, exports, __webpack_require__) {
	
		var __vue_script__, __vue_template__
		__vue_script__ = __webpack_require__(70)
		if (__vue_script__ &&
		    __vue_script__.__esModule &&
		    Object.keys(__vue_script__).length > 1) {
		  console.warn("[vue-loader] src/ButtonLink.vue: named exports in *.vue files are ignored.")}
		__vue_template__ = __webpack_require__(207)
		module.exports = __vue_script__ || {}
		if (module.exports.__esModule) module.exports = module.exports.default
		if (__vue_template__) {
		(typeof module.exports === "function" ? (module.exports.options || (module.exports.options = {})) : module.exports).template = __vue_template__
		}
		if (false) {(function () {  module.hot.accept()
		  var hotAPI = require("vue-hot-reload-api")
		  hotAPI.install(require("vue"), false)
		  if (!hotAPI.compatible) return
		  var id = "./ButtonLink.vue"
		  if (!module.hot.data) {
		    hotAPI.createRecord(id, module.exports)
		  } else {
		    hotAPI.update(id, module.exports, __vue_template__)
		  }
		})()}
	
	/***/ },
	/* 231 */
	/***/ function(module, exports, __webpack_require__) {
	
		var __vue_script__, __vue_template__
		__vue_script__ = __webpack_require__(71)
		if (__vue_script__ &&
		    __vue_script__.__esModule &&
		    Object.keys(__vue_script__).length > 1) {
		  console.warn("[vue-loader] src/ButtonRadio.vue: named exports in *.vue files are ignored.")}
		__vue_template__ = __webpack_require__(208)
		module.exports = __vue_script__ || {}
		if (module.exports.__esModule) module.exports = module.exports.default
		if (__vue_template__) {
		(typeof module.exports === "function" ? (module.exports.options || (module.exports.options = {})) : module.exports).template = __vue_template__
		}
		if (false) {(function () {  module.hot.accept()
		  var hotAPI = require("vue-hot-reload-api")
		  hotAPI.install(require("vue"), false)
		  if (!hotAPI.compatible) return
		  var id = "./ButtonRadio.vue"
		  if (!module.hot.data) {
		    hotAPI.createRecord(id, module.exports)
		  } else {
		    hotAPI.update(id, module.exports, __vue_template__)
		  }
		})()}
	
	/***/ },
	/* 232 */
	/***/ function(module, exports, __webpack_require__) {
	
		var __vue_script__, __vue_template__
		__vue_script__ = __webpack_require__(73)
		if (__vue_script__ &&
		    __vue_script__.__esModule &&
		    Object.keys(__vue_script__).length > 1) {
		  console.warn("[vue-loader] src/Datepicker.vue: named exports in *.vue files are ignored.")}
		__vue_template__ = __webpack_require__(210)
		module.exports = __vue_script__ || {}
		if (module.exports.__esModule) module.exports = module.exports.default
		if (__vue_template__) {
		(typeof module.exports === "function" ? (module.exports.options || (module.exports.options = {})) : module.exports).template = __vue_template__
		}
		if (false) {(function () {  module.hot.accept()
		  var hotAPI = require("vue-hot-reload-api")
		  hotAPI.install(require("vue"), false)
		  if (!hotAPI.compatible) return
		  var id = "./Datepicker.vue"
		  if (!module.hot.data) {
		    hotAPI.createRecord(id, module.exports)
		  } else {
		    hotAPI.update(id, module.exports, __vue_template__)
		  }
		})()}
	
	/***/ },
	/* 233 */
	/***/ function(module, exports, __webpack_require__) {
	
		var __vue_script__, __vue_template__
		__vue_script__ = __webpack_require__(74)
		if (__vue_script__ &&
		    __vue_script__.__esModule &&
		    Object.keys(__vue_script__).length > 1) {
		  console.warn("[vue-loader] src/Modal.vue: named exports in *.vue files are ignored.")}
		__vue_template__ = __webpack_require__(211)
		module.exports = __vue_script__ || {}
		if (module.exports.__esModule) module.exports = module.exports.default
		if (__vue_template__) {
		(typeof module.exports === "function" ? (module.exports.options || (module.exports.options = {})) : module.exports).template = __vue_template__
		}
		if (false) {(function () {  module.hot.accept()
		  var hotAPI = require("vue-hot-reload-api")
		  hotAPI.install(require("vue"), false)
		  if (!hotAPI.compatible) return
		  var id = "./Modal.vue"
		  if (!module.hot.data) {
		    hotAPI.createRecord(id, module.exports)
		  } else {
		    hotAPI.update(id, module.exports, __vue_template__)
		  }
		})()}
	
	/***/ },
	/* 234 */
	/***/ function(module, exports, __webpack_require__) {
	
		var __vue_script__, __vue_template__
		__vue_script__ = __webpack_require__(75)
		if (__vue_script__ &&
		    __vue_script__.__esModule &&
		    Object.keys(__vue_script__).length > 1) {
		  console.warn("[vue-loader] src/ModalAlert.vue: named exports in *.vue files are ignored.")}
		__vue_template__ = __webpack_require__(212)
		module.exports = __vue_script__ || {}
		if (module.exports.__esModule) module.exports = module.exports.default
		if (__vue_template__) {
		(typeof module.exports === "function" ? (module.exports.options || (module.exports.options = {})) : module.exports).template = __vue_template__
		}
		if (false) {(function () {  module.hot.accept()
		  var hotAPI = require("vue-hot-reload-api")
		  hotAPI.install(require("vue"), false)
		  if (!hotAPI.compatible) return
		  var id = "./ModalAlert.vue"
		  if (!module.hot.data) {
		    hotAPI.createRecord(id, module.exports)
		  } else {
		    hotAPI.update(id, module.exports, __vue_template__)
		  }
		})()}
	
	/***/ },
	/* 235 */
	/***/ function(module, exports, __webpack_require__) {
	
		var __vue_script__, __vue_template__
		__vue_script__ = __webpack_require__(77)
		if (__vue_script__ &&
		    __vue_script__.__esModule &&
		    Object.keys(__vue_script__).length > 1) {
		  console.warn("[vue-loader] src/ModalBlank.vue: named exports in *.vue files are ignored.")}
		__vue_template__ = __webpack_require__(213)
		module.exports = __vue_script__ || {}
		if (module.exports.__esModule) module.exports = module.exports.default
		if (__vue_template__) {
		(typeof module.exports === "function" ? (module.exports.options || (module.exports.options = {})) : module.exports).template = __vue_template__
		}
		if (false) {(function () {  module.hot.accept()
		  var hotAPI = require("vue-hot-reload-api")
		  hotAPI.install(require("vue"), false)
		  if (!hotAPI.compatible) return
		  var id = "./ModalBlank.vue"
		  if (!module.hot.data) {
		    hotAPI.createRecord(id, module.exports)
		  } else {
		    hotAPI.update(id, module.exports, __vue_template__)
		  }
		})()}
	
	/***/ },
	/* 236 */
	/***/ function(module, exports, __webpack_require__) {
	
		var __vue_script__, __vue_template__
		__vue_script__ = __webpack_require__(78)
		if (__vue_script__ &&
		    __vue_script__.__esModule &&
		    Object.keys(__vue_script__).length > 1) {
		  console.warn("[vue-loader] src/ModalConfirm.vue: named exports in *.vue files are ignored.")}
		__vue_template__ = __webpack_require__(214)
		module.exports = __vue_script__ || {}
		if (module.exports.__esModule) module.exports = module.exports.default
		if (__vue_template__) {
		(typeof module.exports === "function" ? (module.exports.options || (module.exports.options = {})) : module.exports).template = __vue_template__
		}
		if (false) {(function () {  module.hot.accept()
		  var hotAPI = require("vue-hot-reload-api")
		  hotAPI.install(require("vue"), false)
		  if (!hotAPI.compatible) return
		  var id = "./ModalConfirm.vue"
		  if (!module.hot.data) {
		    hotAPI.createRecord(id, module.exports)
		  } else {
		    hotAPI.update(id, module.exports, __vue_template__)
		  }
		})()}
	
	/***/ },
	/* 237 */
	/***/ function(module, exports, __webpack_require__) {
	
		var __vue_script__, __vue_template__
		__vue_script__ = __webpack_require__(79)
		if (__vue_script__ &&
		    __vue_script__.__esModule &&
		    Object.keys(__vue_script__).length > 1) {
		  console.warn("[vue-loader] src/ModalLightbox.vue: named exports in *.vue files are ignored.")}
		__vue_template__ = __webpack_require__(215)
		module.exports = __vue_script__ || {}
		if (module.exports.__esModule) module.exports = module.exports.default
		if (__vue_template__) {
		(typeof module.exports === "function" ? (module.exports.options || (module.exports.options = {})) : module.exports).template = __vue_template__
		}
		if (false) {(function () {  module.hot.accept()
		  var hotAPI = require("vue-hot-reload-api")
		  hotAPI.install(require("vue"), false)
		  if (!hotAPI.compatible) return
		  var id = "./ModalLightbox.vue"
		  if (!module.hot.data) {
		    hotAPI.createRecord(id, module.exports)
		  } else {
		    hotAPI.update(id, module.exports, __vue_template__)
		  }
		})()}
	
	/***/ },
	/* 238 */
	/***/ function(module, exports, __webpack_require__) {
	
		var __vue_script__, __vue_template__
		__vue_script__ = __webpack_require__(80)
		if (__vue_script__ &&
		    __vue_script__.__esModule &&
		    Object.keys(__vue_script__).length > 1) {
		  console.warn("[vue-loader] src/Pagination.vue: named exports in *.vue files are ignored.")}
		__vue_template__ = __webpack_require__(216)
		module.exports = __vue_script__ || {}
		if (module.exports.__esModule) module.exports = module.exports.default
		if (__vue_template__) {
		(typeof module.exports === "function" ? (module.exports.options || (module.exports.options = {})) : module.exports).template = __vue_template__
		}
		if (false) {(function () {  module.hot.accept()
		  var hotAPI = require("vue-hot-reload-api")
		  hotAPI.install(require("vue"), false)
		  if (!hotAPI.compatible) return
		  var id = "./Pagination.vue"
		  if (!module.hot.data) {
		    hotAPI.createRecord(id, module.exports)
		  } else {
		    hotAPI.update(id, module.exports, __vue_template__)
		  }
		})()}
	
	/***/ },
	/* 239 */
	/***/ function(module, exports, __webpack_require__) {
	
		var __vue_script__, __vue_template__
		__vue_script__ = __webpack_require__(81)
		if (__vue_script__ &&
		    __vue_script__.__esModule &&
		    Object.keys(__vue_script__).length > 1) {
		  console.warn("[vue-loader] src/Progress.vue: named exports in *.vue files are ignored.")}
		__vue_template__ = __webpack_require__(217)
		module.exports = __vue_script__ || {}
		if (module.exports.__esModule) module.exports = module.exports.default
		if (__vue_template__) {
		(typeof module.exports === "function" ? (module.exports.options || (module.exports.options = {})) : module.exports).template = __vue_template__
		}
		if (false) {(function () {  module.hot.accept()
		  var hotAPI = require("vue-hot-reload-api")
		  hotAPI.install(require("vue"), false)
		  if (!hotAPI.compatible) return
		  var id = "./Progress.vue"
		  if (!module.hot.data) {
		    hotAPI.createRecord(id, module.exports)
		  } else {
		    hotAPI.update(id, module.exports, __vue_template__)
		  }
		})()}
	
	/***/ },
	/* 240 */
	/***/ function(module, exports, __webpack_require__) {
	
		var __vue_script__, __vue_template__
		__vue_script__ = __webpack_require__(82)
		if (__vue_script__ &&
		    __vue_script__.__esModule &&
		    Object.keys(__vue_script__).length > 1) {
		  console.warn("[vue-loader] src/Subnav.vue: named exports in *.vue files are ignored.")}
		__vue_template__ = __webpack_require__(218)
		module.exports = __vue_script__ || {}
		if (module.exports.__esModule) module.exports = module.exports.default
		if (__vue_template__) {
		(typeof module.exports === "function" ? (module.exports.options || (module.exports.options = {})) : module.exports).template = __vue_template__
		}
		if (false) {(function () {  module.hot.accept()
		  var hotAPI = require("vue-hot-reload-api")
		  hotAPI.install(require("vue"), false)
		  if (!hotAPI.compatible) return
		  var id = "./Subnav.vue"
		  if (!module.hot.data) {
		    hotAPI.createRecord(id, module.exports)
		  } else {
		    hotAPI.update(id, module.exports, __vue_template__)
		  }
		})()}
	
	/***/ },
	/* 241 */
	/***/ function(module, exports, __webpack_require__) {
	
		var __vue_script__, __vue_template__
		__vue_script__ = __webpack_require__(83)
		if (__vue_script__ &&
		    __vue_script__.__esModule &&
		    Object.keys(__vue_script__).length > 1) {
		  console.warn("[vue-loader] src/SubnavItem.vue: named exports in *.vue files are ignored.")}
		__vue_template__ = __webpack_require__(219)
		module.exports = __vue_script__ || {}
		if (module.exports.__esModule) module.exports = module.exports.default
		if (__vue_template__) {
		(typeof module.exports === "function" ? (module.exports.options || (module.exports.options = {})) : module.exports).template = __vue_template__
		}
		if (false) {(function () {  module.hot.accept()
		  var hotAPI = require("vue-hot-reload-api")
		  hotAPI.install(require("vue"), false)
		  if (!hotAPI.compatible) return
		  var id = "./SubnavItem.vue"
		  if (!module.hot.data) {
		    hotAPI.createRecord(id, module.exports)
		  } else {
		    hotAPI.update(id, module.exports, __vue_template__)
		  }
		})()}
	
	/***/ },
	/* 242 */
	/***/ function(module, exports, __webpack_require__) {
	
		var __vue_script__, __vue_template__
		__vue_script__ = __webpack_require__(84)
		if (__vue_script__ &&
		    __vue_script__.__esModule &&
		    Object.keys(__vue_script__).length > 1) {
		  console.warn("[vue-loader] src/Switcher.vue: named exports in *.vue files are ignored.")}
		__vue_template__ = __webpack_require__(220)
		module.exports = __vue_script__ || {}
		if (module.exports.__esModule) module.exports = module.exports.default
		if (__vue_template__) {
		(typeof module.exports === "function" ? (module.exports.options || (module.exports.options = {})) : module.exports).template = __vue_template__
		}
		if (false) {(function () {  module.hot.accept()
		  var hotAPI = require("vue-hot-reload-api")
		  hotAPI.install(require("vue"), false)
		  if (!hotAPI.compatible) return
		  var id = "./Switcher.vue"
		  if (!module.hot.data) {
		    hotAPI.createRecord(id, module.exports)
		  } else {
		    hotAPI.update(id, module.exports, __vue_template__)
		  }
		})()}
	
	/***/ },
	/* 243 */
	/***/ function(module, exports, __webpack_require__) {
	
		var __vue_script__, __vue_template__
		__vue_script__ = __webpack_require__(85)
		if (__vue_script__ &&
		    __vue_script__.__esModule &&
		    Object.keys(__vue_script__).length > 1) {
		  console.warn("[vue-loader] src/SwitcherItem.vue: named exports in *.vue files are ignored.")}
		__vue_template__ = __webpack_require__(221)
		module.exports = __vue_script__ || {}
		if (module.exports.__esModule) module.exports = module.exports.default
		if (__vue_template__) {
		(typeof module.exports === "function" ? (module.exports.options || (module.exports.options = {})) : module.exports).template = __vue_template__
		}
		if (false) {(function () {  module.hot.accept()
		  var hotAPI = require("vue-hot-reload-api")
		  hotAPI.install(require("vue"), false)
		  if (!hotAPI.compatible) return
		  var id = "./SwitcherItem.vue"
		  if (!module.hot.data) {
		    hotAPI.createRecord(id, module.exports)
		  } else {
		    hotAPI.update(id, module.exports, __vue_template__)
		  }
		})()}
	
	/***/ },
	/* 244 */
	/***/ function(module, exports, __webpack_require__) {
	
		var __vue_script__, __vue_template__
		__vue_script__ = __webpack_require__(86)
		if (__vue_script__ &&
		    __vue_script__.__esModule &&
		    Object.keys(__vue_script__).length > 1) {
		  console.warn("[vue-loader] src/Tab.vue: named exports in *.vue files are ignored.")}
		__vue_template__ = __webpack_require__(222)
		module.exports = __vue_script__ || {}
		if (module.exports.__esModule) module.exports = module.exports.default
		if (__vue_template__) {
		(typeof module.exports === "function" ? (module.exports.options || (module.exports.options = {})) : module.exports).template = __vue_template__
		}
		if (false) {(function () {  module.hot.accept()
		  var hotAPI = require("vue-hot-reload-api")
		  hotAPI.install(require("vue"), false)
		  if (!hotAPI.compatible) return
		  var id = "./Tab.vue"
		  if (!module.hot.data) {
		    hotAPI.createRecord(id, module.exports)
		  } else {
		    hotAPI.update(id, module.exports, __vue_template__)
		  }
		})()}
	
	/***/ },
	/* 245 */
	/***/ function(module, exports, __webpack_require__) {
	
		var __vue_script__, __vue_template__
		__vue_script__ = __webpack_require__(88)
		if (__vue_script__ &&
		    __vue_script__.__esModule &&
		    Object.keys(__vue_script__).length > 1) {
		  console.warn("[vue-loader] src/Tabs.vue: named exports in *.vue files are ignored.")}
		__vue_template__ = __webpack_require__(224)
		module.exports = __vue_script__ || {}
		if (module.exports.__esModule) module.exports = module.exports.default
		if (__vue_template__) {
		(typeof module.exports === "function" ? (module.exports.options || (module.exports.options = {})) : module.exports).template = __vue_template__
		}
		if (false) {(function () {  module.hot.accept()
		  var hotAPI = require("vue-hot-reload-api")
		  hotAPI.install(require("vue"), false)
		  if (!hotAPI.compatible) return
		  var id = "./Tabs.vue"
		  if (!module.hot.data) {
		    hotAPI.createRecord(id, module.exports)
		  } else {
		    hotAPI.update(id, module.exports, __vue_template__)
		  }
		})()}
	
	/***/ },
	/* 246 */
	/***/ function(module, exports, __webpack_require__) {
	
		var __vue_script__, __vue_template__
		__vue_script__ = __webpack_require__(89)
		if (__vue_script__ &&
		    __vue_script__.__esModule &&
		    Object.keys(__vue_script__).length > 1) {
		  console.warn("[vue-loader] src/TabsVertical.vue: named exports in *.vue files are ignored.")}
		__vue_template__ = __webpack_require__(225)
		module.exports = __vue_script__ || {}
		if (module.exports.__esModule) module.exports = module.exports.default
		if (__vue_template__) {
		(typeof module.exports === "function" ? (module.exports.options || (module.exports.options = {})) : module.exports).template = __vue_template__
		}
		if (false) {(function () {  module.hot.accept()
		  var hotAPI = require("vue-hot-reload-api")
		  hotAPI.install(require("vue"), false)
		  if (!hotAPI.compatible) return
		  var id = "./TabsVertical.vue"
		  if (!module.hot.data) {
		    hotAPI.createRecord(id, module.exports)
		  } else {
		    hotAPI.update(id, module.exports, __vue_template__)
		  }
		})()}
	
	/***/ }
	/******/ ]);

/***/ },
/* 47 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _sortBy2 = __webpack_require__(250);
	
	var _sortBy3 = _interopRequireDefault(_sortBy2);
	
	var _reject2 = __webpack_require__(248);
	
	var _reject3 = _interopRequireDefault(_reject2);
	
	exports.extensions = extensions;
	exports.languages = languages;
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function extensions(_ref) {
	  var products = _ref.products;
	
	  return (0, _sortBy3.default)((0, _reject3.default)(products.extensions, { deprecated: true, installed: false }), function (extension) {
	    return [!extension.installed, !extension.deprecated, !extension.outdated, !extension.subscribed];
	  });
	}
	
	function languages(_ref2) {
	  var products = _ref2.products;
	
	  return (0, _sortBy3.default)(products.languages, ['installed']);
	}

/***/ },
/* 48 */
/***/ function(module, exports) {

	// 7.2.1 RequireObjectCoercible(argument)
	module.exports = function(it){
	  if(it == undefined)throw TypeError("Can't call method on  " + it);
	  return it;
	};

/***/ },
/* 49 */
/***/ function(module, exports) {

	// 7.1.4 ToInteger
	var ceil  = Math.ceil
	  , floor = Math.floor;
	module.exports = function(it){
	  return isNaN(it = +it) ? 0 : (it > 0 ? floor : ceil)(it);
	};

/***/ },
/* 50 */
/***/ function(module, exports, __webpack_require__) {

	// to indexed object, toObject with fallback for non-array-like ES3 strings
	var IObject = __webpack_require__(119)
	  , defined = __webpack_require__(48);
	module.exports = function(it){
	  return IObject(defined(it));
	};

/***/ },
/* 51 */
/***/ function(module, exports, __webpack_require__) {

	var getNative = __webpack_require__(7),
	    root = __webpack_require__(3);
	
	/* Built-in method references that are verified to be native. */
	var Map = getNative(root, 'Map');
	
	module.exports = Map;


/***/ },
/* 52 */
/***/ function(module, exports, __webpack_require__) {

	var root = __webpack_require__(3);
	
	/** Built-in value references. */
	var Uint8Array = root.Uint8Array;
	
	module.exports = Uint8Array;


/***/ },
/* 53 */
/***/ function(module, exports) {

	/**
	 * A specialized version of `_.filter` for arrays without support for
	 * iteratee shorthands.
	 *
	 * @private
	 * @param {Array} [array] The array to iterate over.
	 * @param {Function} predicate The function invoked per iteration.
	 * @returns {Array} Returns the new filtered array.
	 */
	function arrayFilter(array, predicate) {
	  var index = -1,
	      length = array ? array.length : 0,
	      resIndex = 0,
	      result = [];
	
	  while (++index < length) {
	    var value = array[index];
	    if (predicate(value, index, array)) {
	      result[resIndex++] = value;
	    }
	  }
	  return result;
	}
	
	module.exports = arrayFilter;


/***/ },
/* 54 */
/***/ function(module, exports) {

	/**
	 * A specialized version of `_.some` for arrays without support for iteratee
	 * shorthands.
	 *
	 * @private
	 * @param {Array} [array] The array to iterate over.
	 * @param {Function} predicate The function invoked per iteration.
	 * @returns {boolean} Returns `true` if any element passes the predicate check,
	 *  else `false`.
	 */
	function arraySome(array, predicate) {
	  var index = -1,
	      length = array ? array.length : 0;
	
	  while (++index < length) {
	    if (predicate(array[index], index, array)) {
	      return true;
	    }
	  }
	  return false;
	}
	
	module.exports = arraySome;


/***/ },
/* 55 */
/***/ function(module, exports, __webpack_require__) {

	var eq = __webpack_require__(24);
	
	/**
	 * This function is like `assignValue` except that it doesn't assign
	 * `undefined` values.
	 *
	 * @private
	 * @param {Object} object The object to modify.
	 * @param {string} key The key of the property to assign.
	 * @param {*} value The value to assign.
	 */
	function assignMergeValue(object, key, value) {
	  if ((value !== undefined && !eq(object[key], value)) ||
	      (typeof key == 'number' && value === undefined && !(key in object))) {
	    object[key] = value;
	  }
	}
	
	module.exports = assignMergeValue;


/***/ },
/* 56 */
/***/ function(module, exports, __webpack_require__) {

	var eq = __webpack_require__(24);
	
	/** Used for built-in method references. */
	var objectProto = Object.prototype;
	
	/** Used to check objects for own properties. */
	var hasOwnProperty = objectProto.hasOwnProperty;
	
	/**
	 * Assigns `value` to `key` of `object` if the existing value is not equivalent
	 * using [`SameValueZero`](http://ecma-international.org/ecma-262/6.0/#sec-samevaluezero)
	 * for equality comparisons.
	 *
	 * @private
	 * @param {Object} object The object to modify.
	 * @param {string} key The key of the property to assign.
	 * @param {*} value The value to assign.
	 */
	function assignValue(object, key, value) {
	  var objValue = object[key];
	  if (!(hasOwnProperty.call(object, key) && eq(objValue, value)) ||
	      (value === undefined && !(key in object))) {
	    object[key] = value;
	  }
	}
	
	module.exports = assignValue;


/***/ },
/* 57 */
/***/ function(module, exports, __webpack_require__) {

	var baseEach = __webpack_require__(6);
	
	/**
	 * The base implementation of `_.filter` without support for iteratee shorthands.
	 *
	 * @private
	 * @param {Array|Object} collection The collection to iterate over.
	 * @param {Function} predicate The function invoked per iteration.
	 * @returns {Array} Returns the new filtered array.
	 */
	function baseFilter(collection, predicate) {
	  var result = [];
	  baseEach(collection, function(value, index, collection) {
	    if (predicate(value, index, collection)) {
	      result.push(value);
	    }
	  });
	  return result;
	}
	
	module.exports = baseFilter;


/***/ },
/* 58 */
/***/ function(module, exports, __webpack_require__) {

	var arrayPush = __webpack_require__(37),
	    isFlattenable = __webpack_require__(209);
	
	/**
	 * The base implementation of `_.flatten` with support for restricting flattening.
	 *
	 * @private
	 * @param {Array} array The array to flatten.
	 * @param {number} depth The maximum recursion depth.
	 * @param {boolean} [predicate=isFlattenable] The function invoked per iteration.
	 * @param {boolean} [isStrict] Restrict to values that pass `predicate` checks.
	 * @param {Array} [result=[]] The initial result value.
	 * @returns {Array} Returns the new flattened array.
	 */
	function baseFlatten(array, depth, predicate, isStrict, result) {
	  var index = -1,
	      length = array.length;
	
	  predicate || (predicate = isFlattenable);
	  result || (result = []);
	
	  while (++index < length) {
	    var value = array[index];
	    if (depth > 0 && predicate(value)) {
	      if (depth > 1) {
	        // Recursively flatten arrays (susceptible to call stack limits).
	        baseFlatten(value, depth - 1, predicate, isStrict, result);
	      } else {
	        arrayPush(result, value);
	      }
	    } else if (!isStrict) {
	      result[result.length] = value;
	    }
	  }
	  return result;
	}
	
	module.exports = baseFlatten;


/***/ },
/* 59 */
/***/ function(module, exports, __webpack_require__) {

	var baseFor = __webpack_require__(157),
	    keys = __webpack_require__(5);
	
	/**
	 * The base implementation of `_.forOwn` without support for iteratee shorthands.
	 *
	 * @private
	 * @param {Object} object The object to iterate over.
	 * @param {Function} iteratee The function invoked per iteration.
	 * @returns {Object} Returns `object`.
	 */
	function baseForOwn(object, iteratee) {
	  return object && baseFor(object, iteratee, keys);
	}
	
	module.exports = baseForOwn;


/***/ },
/* 60 */
/***/ function(module, exports, __webpack_require__) {

	var castPath = __webpack_require__(67),
	    isKey = __webpack_require__(22),
	    toKey = __webpack_require__(11);
	
	/**
	 * The base implementation of `_.get` without support for default values.
	 *
	 * @private
	 * @param {Object} object The object to query.
	 * @param {Array|string} path The path of the property to get.
	 * @returns {*} Returns the resolved value.
	 */
	function baseGet(object, path) {
	  path = isKey(path, object) ? [path] : castPath(path);
	
	  var index = 0,
	      length = path.length;
	
	  while (object != null && index < length) {
	    object = object[toKey(path[index++])];
	  }
	  return (index && index == length) ? object : undefined;
	}
	
	module.exports = baseGet;


/***/ },
/* 61 */
/***/ function(module, exports, __webpack_require__) {

	var arrayPush = __webpack_require__(37),
	    isArray = __webpack_require__(1);
	
	/**
	 * The base implementation of `getAllKeys` and `getAllKeysIn` which uses
	 * `keysFunc` and `symbolsFunc` to get the enumerable property names and
	 * symbols of `object`.
	 *
	 * @private
	 * @param {Object} object The object to query.
	 * @param {Function} keysFunc The function to get the keys of `object`.
	 * @param {Function} symbolsFunc The function to get the symbols of `object`.
	 * @returns {Array} Returns the array of property names and symbols.
	 */
	function baseGetAllKeys(object, keysFunc, symbolsFunc) {
	  var result = keysFunc(object);
	  return isArray(object) ? result : arrayPush(result, symbolsFunc(object));
	}
	
	module.exports = baseGetAllKeys;


/***/ },
/* 62 */
/***/ function(module, exports, __webpack_require__) {

	var getPrototype = __webpack_require__(18);
	
	/** Used for built-in method references. */
	var objectProto = Object.prototype;
	
	/** Used to check objects for own properties. */
	var hasOwnProperty = objectProto.hasOwnProperty;
	
	/**
	 * The base implementation of `_.has` without support for deep paths.
	 *
	 * @private
	 * @param {Object} [object] The object to query.
	 * @param {Array|string} key The key to check.
	 * @returns {boolean} Returns `true` if `key` exists, else `false`.
	 */
	function baseHas(object, key) {
	  // Avoid a bug in IE 10-11 where objects with a [[Prototype]] of `null`,
	  // that are composed entirely of index properties, return `false` for
	  // `hasOwnProperty` checks of them.
	  return object != null &&
	    (hasOwnProperty.call(object, key) ||
	      (typeof object == 'object' && key in object && getPrototype(object) === null));
	}
	
	module.exports = baseHas;


/***/ },
/* 63 */
/***/ function(module, exports, __webpack_require__) {

	var baseIsEqualDeep = __webpack_require__(159),
	    isObject = __webpack_require__(4),
	    isObjectLike = __webpack_require__(9);
	
	/**
	 * The base implementation of `_.isEqual` which supports partial comparisons
	 * and tracks traversed objects.
	 *
	 * @private
	 * @param {*} value The value to compare.
	 * @param {*} other The other value to compare.
	 * @param {Function} [customizer] The function to customize comparisons.
	 * @param {boolean} [bitmask] The bitmask of comparison flags.
	 *  The bitmask may be composed of the following flags:
	 *     1 - Unordered comparison
	 *     2 - Partial comparison
	 * @param {Object} [stack] Tracks traversed `value` and `other` objects.
	 * @returns {boolean} Returns `true` if the values are equivalent, else `false`.
	 */
	function baseIsEqual(value, other, customizer, bitmask, stack) {
	  if (value === other) {
	    return true;
	  }
	  if (value == null || other == null || (!isObject(value) && !isObjectLike(other))) {
	    return value !== value && other !== other;
	  }
	  return baseIsEqualDeep(value, other, baseIsEqual, customizer, bitmask, stack);
	}
	
	module.exports = baseIsEqual;


/***/ },
/* 64 */
/***/ function(module, exports, __webpack_require__) {

	var baseEach = __webpack_require__(6),
	    isArrayLike = __webpack_require__(8);
	
	/**
	 * The base implementation of `_.map` without support for iteratee shorthands.
	 *
	 * @private
	 * @param {Array|Object} collection The collection to iterate over.
	 * @param {Function} iteratee The function invoked per iteration.
	 * @returns {Array} Returns the new mapped array.
	 */
	function baseMap(collection, iteratee) {
	  var index = -1,
	      result = isArrayLike(collection) ? Array(collection.length) : [];
	
	  baseEach(collection, function(value, key, collection) {
	    result[++index] = iteratee(value, key, collection);
	  });
	  return result;
	}
	
	module.exports = baseMap;


/***/ },
/* 65 */
/***/ function(module, exports, __webpack_require__) {

	var Stack = __webpack_require__(15),
	    arrayEach = __webpack_require__(35),
	    assignMergeValue = __webpack_require__(55),
	    baseMergeDeep = __webpack_require__(166),
	    isArray = __webpack_require__(1),
	    isObject = __webpack_require__(4),
	    isTypedArray = __webpack_require__(43),
	    keysIn = __webpack_require__(44);
	
	/**
	 * The base implementation of `_.merge` without support for multiple sources.
	 *
	 * @private
	 * @param {Object} object The destination object.
	 * @param {Object} source The source object.
	 * @param {number} srcIndex The index of `source`.
	 * @param {Function} [customizer] The function to customize merged values.
	 * @param {Object} [stack] Tracks traversed source values and their merged
	 *  counterparts.
	 */
	function baseMerge(object, source, srcIndex, customizer, stack) {
	  if (object === source) {
	    return;
	  }
	  if (!(isArray(source) || isTypedArray(source))) {
	    var props = keysIn(source);
	  }
	  arrayEach(props || source, function(srcValue, key) {
	    if (props) {
	      key = srcValue;
	      srcValue = source[key];
	    }
	    if (isObject(srcValue)) {
	      stack || (stack = new Stack);
	      baseMergeDeep(object, source, key, srcIndex, baseMerge, customizer, stack);
	    }
	    else {
	      var newValue = customizer
	        ? customizer(object[key], srcValue, (key + ''), object, source, stack)
	        : undefined;
	
	      if (newValue === undefined) {
	        newValue = srcValue;
	      }
	      assignMergeValue(object, key, newValue);
	    }
	  });
	}
	
	module.exports = baseMerge;


/***/ },
/* 66 */
/***/ function(module, exports) {

	/**
	 * The base implementation of `_.property` without support for deep paths.
	 *
	 * @private
	 * @param {string} key The key of the property to get.
	 * @returns {Function} Returns the new accessor function.
	 */
	function baseProperty(key) {
	  return function(object) {
	    return object == null ? undefined : object[key];
	  };
	}
	
	module.exports = baseProperty;


/***/ },
/* 67 */
/***/ function(module, exports, __webpack_require__) {

	var isArray = __webpack_require__(1),
	    stringToPath = __webpack_require__(231);
	
	/**
	 * Casts `value` to a path array if it's not one.
	 *
	 * @private
	 * @param {*} value The value to inspect.
	 * @returns {Array} Returns the cast property path array.
	 */
	function castPath(value) {
	  return isArray(value) ? value : stringToPath(value);
	}
	
	module.exports = castPath;


/***/ },
/* 68 */
/***/ function(module, exports) {

	/**
	 * Copies the values of `source` to `array`.
	 *
	 * @private
	 * @param {Array} source The array to copy values from.
	 * @param {Array} [array=[]] The array to copy values to.
	 * @returns {Array} Returns `array`.
	 */
	function copyArray(source, array) {
	  var index = -1,
	      length = source.length;
	
	  array || (array = Array(length));
	  while (++index < length) {
	    array[index] = source[index];
	  }
	  return array;
	}
	
	module.exports = copyArray;


/***/ },
/* 69 */
/***/ function(module, exports, __webpack_require__) {

	var isIterateeCall = __webpack_require__(21),
	    rest = __webpack_require__(45);
	
	/**
	 * Creates a function like `_.assign`.
	 *
	 * @private
	 * @param {Function} assigner The function to assign values.
	 * @returns {Function} Returns the new assigner function.
	 */
	function createAssigner(assigner) {
	  return rest(function(object, sources) {
	    var index = -1,
	        length = sources.length,
	        customizer = length > 1 ? sources[length - 1] : undefined,
	        guard = length > 2 ? sources[2] : undefined;
	
	    customizer = (assigner.length > 3 && typeof customizer == 'function')
	      ? (length--, customizer)
	      : undefined;
	
	    if (guard && isIterateeCall(sources[0], sources[1], guard)) {
	      customizer = length < 3 ? undefined : customizer;
	      length = 1;
	    }
	    object = Object(object);
	    while (++index < length) {
	      var source = sources[index];
	      if (source) {
	        assigner(object, source, index, customizer);
	      }
	    }
	    return object;
	  });
	}
	
	module.exports = createAssigner;


/***/ },
/* 70 */
/***/ function(module, exports, __webpack_require__) {

	var SetCache = __webpack_require__(144),
	    arraySome = __webpack_require__(54);
	
	/** Used to compose bitmasks for comparison styles. */
	var UNORDERED_COMPARE_FLAG = 1,
	    PARTIAL_COMPARE_FLAG = 2;
	
	/**
	 * A specialized version of `baseIsEqualDeep` for arrays with support for
	 * partial deep comparisons.
	 *
	 * @private
	 * @param {Array} array The array to compare.
	 * @param {Array} other The other array to compare.
	 * @param {Function} equalFunc The function to determine equivalents of values.
	 * @param {Function} customizer The function to customize comparisons.
	 * @param {number} bitmask The bitmask of comparison flags. See `baseIsEqual`
	 *  for more details.
	 * @param {Object} stack Tracks traversed `array` and `other` objects.
	 * @returns {boolean} Returns `true` if the arrays are equivalent, else `false`.
	 */
	function equalArrays(array, other, equalFunc, customizer, bitmask, stack) {
	  var isPartial = bitmask & PARTIAL_COMPARE_FLAG,
	      arrLength = array.length,
	      othLength = other.length;
	
	  if (arrLength != othLength && !(isPartial && othLength > arrLength)) {
	    return false;
	  }
	  // Assume cyclic values are equal.
	  var stacked = stack.get(array);
	  if (stacked) {
	    return stacked == other;
	  }
	  var index = -1,
	      result = true,
	      seen = (bitmask & UNORDERED_COMPARE_FLAG) ? new SetCache : undefined;
	
	  stack.set(array, other);
	
	  // Ignore non-index properties.
	  while (++index < arrLength) {
	    var arrValue = array[index],
	        othValue = other[index];
	
	    if (customizer) {
	      var compared = isPartial
	        ? customizer(othValue, arrValue, index, other, array, stack)
	        : customizer(arrValue, othValue, index, array, other, stack);
	    }
	    if (compared !== undefined) {
	      if (compared) {
	        continue;
	      }
	      result = false;
	      break;
	    }
	    // Recursively compare arrays (susceptible to call stack limits).
	    if (seen) {
	      if (!arraySome(other, function(othValue, othIndex) {
	            if (!seen.has(othIndex) &&
	                (arrValue === othValue || equalFunc(arrValue, othValue, customizer, bitmask, stack))) {
	              return seen.add(othIndex);
	            }
	          })) {
	        result = false;
	        break;
	      }
	    } else if (!(
	          arrValue === othValue ||
	            equalFunc(arrValue, othValue, customizer, bitmask, stack)
	        )) {
	      result = false;
	      break;
	    }
	  }
	  stack['delete'](array);
	  return result;
	}
	
	module.exports = equalArrays;


/***/ },
/* 71 */
/***/ function(module, exports, __webpack_require__) {

	var DataView = __webpack_require__(139),
	    Map = __webpack_require__(51),
	    Promise = __webpack_require__(141),
	    Set = __webpack_require__(143),
	    WeakMap = __webpack_require__(145),
	    toSource = __webpack_require__(77);
	
	/** `Object#toString` result references. */
	var mapTag = '[object Map]',
	    objectTag = '[object Object]',
	    promiseTag = '[object Promise]',
	    setTag = '[object Set]',
	    weakMapTag = '[object WeakMap]';
	
	var dataViewTag = '[object DataView]';
	
	/** Used for built-in method references. */
	var objectProto = Object.prototype;
	
	/**
	 * Used to resolve the
	 * [`toStringTag`](http://ecma-international.org/ecma-262/6.0/#sec-object.prototype.tostring)
	 * of values.
	 */
	var objectToString = objectProto.toString;
	
	/** Used to detect maps, sets, and weakmaps. */
	var dataViewCtorString = toSource(DataView),
	    mapCtorString = toSource(Map),
	    promiseCtorString = toSource(Promise),
	    setCtorString = toSource(Set),
	    weakMapCtorString = toSource(WeakMap);
	
	/**
	 * Gets the `toStringTag` of `value`.
	 *
	 * @private
	 * @param {*} value The value to query.
	 * @returns {string} Returns the `toStringTag`.
	 */
	function getTag(value) {
	  return objectToString.call(value);
	}
	
	// Fallback for data views, maps, sets, and weak maps in IE 11,
	// for data views in Edge, and promises in Node.js.
	if ((DataView && getTag(new DataView(new ArrayBuffer(1))) != dataViewTag) ||
	    (Map && getTag(new Map) != mapTag) ||
	    (Promise && getTag(Promise.resolve()) != promiseTag) ||
	    (Set && getTag(new Set) != setTag) ||
	    (WeakMap && getTag(new WeakMap) != weakMapTag)) {
	  getTag = function(value) {
	    var result = objectToString.call(value),
	        Ctor = result == objectTag ? value.constructor : undefined,
	        ctorString = Ctor ? toSource(Ctor) : undefined;
	
	    if (ctorString) {
	      switch (ctorString) {
	        case dataViewCtorString: return dataViewTag;
	        case mapCtorString: return mapTag;
	        case promiseCtorString: return promiseTag;
	        case setCtorString: return setTag;
	        case weakMapCtorString: return weakMapTag;
	      }
	    }
	    return result;
	  };
	}
	
	module.exports = getTag;


/***/ },
/* 72 */
/***/ function(module, exports, __webpack_require__) {

	var baseTimes = __webpack_require__(173),
	    isArguments = __webpack_require__(25),
	    isArray = __webpack_require__(1),
	    isLength = __webpack_require__(26),
	    isString = __webpack_require__(82);
	
	/**
	 * Creates an array of index keys for `object` values of arrays,
	 * `arguments` objects, and strings, otherwise `null` is returned.
	 *
	 * @private
	 * @param {Object} object The object to query.
	 * @returns {Array|null} Returns index keys, else `null`.
	 */
	function indexKeys(object) {
	  var length = object ? object.length : undefined;
	  if (isLength(length) &&
	      (isArray(object) || isString(object) || isArguments(object))) {
	    return baseTimes(length, String);
	  }
	  return null;
	}
	
	module.exports = indexKeys;


/***/ },
/* 73 */
/***/ function(module, exports, __webpack_require__) {

	var isObject = __webpack_require__(4);
	
	/**
	 * Checks if `value` is suitable for strict equality comparisons, i.e. `===`.
	 *
	 * @private
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` if suitable for strict
	 *  equality comparisons, else `false`.
	 */
	function isStrictComparable(value) {
	  return value === value && !isObject(value);
	}
	
	module.exports = isStrictComparable;


/***/ },
/* 74 */
/***/ function(module, exports) {

	/**
	 * Converts `map` to its key-value pairs.
	 *
	 * @private
	 * @param {Object} map The map to convert.
	 * @returns {Array} Returns the key-value pairs.
	 */
	function mapToArray(map) {
	  var index = -1,
	      result = Array(map.size);
	
	  map.forEach(function(value, key) {
	    result[++index] = [key, value];
	  });
	  return result;
	}
	
	module.exports = mapToArray;


/***/ },
/* 75 */
/***/ function(module, exports) {

	/**
	 * A specialized version of `matchesProperty` for source values suitable
	 * for strict equality comparisons, i.e. `===`.
	 *
	 * @private
	 * @param {string} key The key of the property to get.
	 * @param {*} srcValue The value to match.
	 * @returns {Function} Returns the new spec function.
	 */
	function matchesStrictComparable(key, srcValue) {
	  return function(object) {
	    if (object == null) {
	      return false;
	    }
	    return object[key] === srcValue &&
	      (srcValue !== undefined || (key in Object(object)));
	  };
	}
	
	module.exports = matchesStrictComparable;


/***/ },
/* 76 */
/***/ function(module, exports) {

	/**
	 * Converts `set` to an array of its values.
	 *
	 * @private
	 * @param {Object} set The set to convert.
	 * @returns {Array} Returns the values.
	 */
	function setToArray(set) {
	  var index = -1,
	      result = Array(set.size);
	
	  set.forEach(function(value) {
	    result[++index] = value;
	  });
	  return result;
	}
	
	module.exports = setToArray;


/***/ },
/* 77 */
/***/ function(module, exports) {

	/** Used to resolve the decompiled source of functions. */
	var funcToString = Function.prototype.toString;
	
	/**
	 * Converts `func` to its source code.
	 *
	 * @private
	 * @param {Function} func The function to process.
	 * @returns {string} Returns the source code.
	 */
	function toSource(func) {
	  if (func != null) {
	    try {
	      return funcToString.call(func);
	    } catch (e) {}
	    try {
	      return (func + '');
	    } catch (e) {}
	  }
	  return '';
	}
	
	module.exports = toSource;


/***/ },
/* 78 */
/***/ function(module, exports, __webpack_require__) {

	var createFind = __webpack_require__(191),
	    findIndex = __webpack_require__(235);
	
	/**
	 * Iterates over elements of `collection`, returning the first element
	 * `predicate` returns truthy for. The predicate is invoked with three
	 * arguments: (value, index|key, collection).
	 *
	 * @static
	 * @memberOf _
	 * @since 0.1.0
	 * @category Collection
	 * @param {Array|Object} collection The collection to search.
	 * @param {Array|Function|Object|string} [predicate=_.identity]
	 *  The function invoked per iteration.
	 * @param {number} [fromIndex=0] The index to search from.
	 * @returns {*} Returns the matched element, else `undefined`.
	 * @example
	 *
	 * var users = [
	 *   { 'user': 'barney',  'age': 36, 'active': true },
	 *   { 'user': 'fred',    'age': 40, 'active': false },
	 *   { 'user': 'pebbles', 'age': 1,  'active': true }
	 * ];
	 *
	 * _.find(users, function(o) { return o.age < 40; });
	 * // => object for 'barney'
	 *
	 * // The `_.matches` iteratee shorthand.
	 * _.find(users, { 'age': 1, 'active': true });
	 * // => object for 'pebbles'
	 *
	 * // The `_.matchesProperty` iteratee shorthand.
	 * _.find(users, ['active', false]);
	 * // => object for 'fred'
	 *
	 * // The `_.property` iteratee shorthand.
	 * _.find(users, 'active');
	 * // => object for 'barney'
	 */
	var find = createFind(findIndex);
	
	module.exports = find;


/***/ },
/* 79 */
/***/ function(module, exports, __webpack_require__) {

	var baseGet = __webpack_require__(60);
	
	/**
	 * Gets the value at `path` of `object`. If the resolved value is
	 * `undefined`, the `defaultValue` is used in its place.
	 *
	 * @static
	 * @memberOf _
	 * @since 3.7.0
	 * @category Object
	 * @param {Object} object The object to query.
	 * @param {Array|string} path The path of the property to get.
	 * @param {*} [defaultValue] The value returned for `undefined` resolved values.
	 * @returns {*} Returns the resolved value.
	 * @example
	 *
	 * var object = { 'a': [{ 'b': { 'c': 3 } }] };
	 *
	 * _.get(object, 'a[0].b.c');
	 * // => 3
	 *
	 * _.get(object, ['a', '0', 'b', 'c']);
	 * // => 3
	 *
	 * _.get(object, 'a.b.c', 'default');
	 * // => 'default'
	 */
	function get(object, path, defaultValue) {
	  var result = object == null ? undefined : baseGet(object, path);
	  return result === undefined ? defaultValue : result;
	}
	
	module.exports = get;


/***/ },
/* 80 */
/***/ function(module, exports) {

	/**
	 * This method returns the first argument given to it.
	 *
	 * @static
	 * @since 0.1.0
	 * @memberOf _
	 * @category Util
	 * @param {*} value Any value.
	 * @returns {*} Returns `value`.
	 * @example
	 *
	 * var object = { 'user': 'fred' };
	 *
	 * console.log(_.identity(object) === object);
	 * // => true
	 */
	function identity(value) {
	  return value;
	}
	
	module.exports = identity;


/***/ },
/* 81 */
/***/ function(module, exports, __webpack_require__) {

	var isArrayLike = __webpack_require__(8),
	    isObjectLike = __webpack_require__(9);
	
	/**
	 * This method is like `_.isArrayLike` except that it also checks if `value`
	 * is an object.
	 *
	 * @static
	 * @memberOf _
	 * @since 4.0.0
	 * @category Lang
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is an array-like object,
	 *  else `false`.
	 * @example
	 *
	 * _.isArrayLikeObject([1, 2, 3]);
	 * // => true
	 *
	 * _.isArrayLikeObject(document.body.children);
	 * // => true
	 *
	 * _.isArrayLikeObject('abc');
	 * // => false
	 *
	 * _.isArrayLikeObject(_.noop);
	 * // => false
	 */
	function isArrayLikeObject(value) {
	  return isObjectLike(value) && isArrayLike(value);
	}
	
	module.exports = isArrayLikeObject;


/***/ },
/* 82 */
/***/ function(module, exports, __webpack_require__) {

	var isArray = __webpack_require__(1),
	    isObjectLike = __webpack_require__(9);
	
	/** `Object#toString` result references. */
	var stringTag = '[object String]';
	
	/** Used for built-in method references. */
	var objectProto = Object.prototype;
	
	/**
	 * Used to resolve the
	 * [`toStringTag`](http://ecma-international.org/ecma-262/6.0/#sec-object.prototype.tostring)
	 * of values.
	 */
	var objectToString = objectProto.toString;
	
	/**
	 * Checks if `value` is classified as a `String` primitive or object.
	 *
	 * @static
	 * @since 0.1.0
	 * @memberOf _
	 * @category Lang
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is correctly classified,
	 *  else `false`.
	 * @example
	 *
	 * _.isString('abc');
	 * // => true
	 *
	 * _.isString(1);
	 * // => false
	 */
	function isString(value) {
	  return typeof value == 'string' ||
	    (!isArray(value) && isObjectLike(value) && objectToString.call(value) == stringTag);
	}
	
	module.exports = isString;


/***/ },
/* 83 */
/***/ function(module, exports, __webpack_require__) {

	var baseMerge = __webpack_require__(65),
	    createAssigner = __webpack_require__(69);
	
	/**
	 * This method is like `_.merge` except that it accepts `customizer` which
	 * is invoked to produce the merged values of the destination and source
	 * properties. If `customizer` returns `undefined`, merging is handled by the
	 * method instead. The `customizer` is invoked with seven arguments:
	 * (objValue, srcValue, key, object, source, stack).
	 *
	 * **Note:** This method mutates `object`.
	 *
	 * @static
	 * @memberOf _
	 * @since 4.0.0
	 * @category Object
	 * @param {Object} object The destination object.
	 * @param {...Object} sources The source objects.
	 * @param {Function} customizer The function to customize assigned values.
	 * @returns {Object} Returns `object`.
	 * @example
	 *
	 * function customizer(objValue, srcValue) {
	 *   if (_.isArray(objValue)) {
	 *     return objValue.concat(srcValue);
	 *   }
	 * }
	 *
	 * var object = {
	 *   'fruits': ['apple'],
	 *   'vegetables': ['beet']
	 * };
	 *
	 * var other = {
	 *   'fruits': ['banana'],
	 *   'vegetables': ['carrot']
	 * };
	 *
	 * _.mergeWith(object, other, customizer);
	 * // => { 'fruits': ['apple', 'banana'], 'vegetables': ['beet', 'carrot'] }
	 */
	var mergeWith = createAssigner(function(object, source, srcIndex, customizer) {
	  baseMerge(object, source, srcIndex, customizer);
	});
	
	module.exports = mergeWith;


/***/ },
/* 84 */
/***/ function(module, exports, __webpack_require__) {

	var toFinite = __webpack_require__(253);
	
	/**
	 * Converts `value` to an integer.
	 *
	 * **Note:** This method is loosely based on
	 * [`ToInteger`](http://www.ecma-international.org/ecma-262/6.0/#sec-tointeger).
	 *
	 * @static
	 * @memberOf _
	 * @since 4.0.0
	 * @category Lang
	 * @param {*} value The value to convert.
	 * @returns {number} Returns the converted integer.
	 * @example
	 *
	 * _.toInteger(3.2);
	 * // => 3
	 *
	 * _.toInteger(Number.MIN_VALUE);
	 * // => 0
	 *
	 * _.toInteger(Infinity);
	 * // => 1.7976931348623157e+308
	 *
	 * _.toInteger('3.2');
	 * // => 3
	 */
	function toInteger(value) {
	  var result = toFinite(value),
	      remainder = result % 1;
	
	  return result === result ? (remainder ? result - remainder : result) : 0;
	}
	
	module.exports = toInteger;


/***/ },
/* 85 */
/***/ function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_RESULT__;/*! UIkit 2.26.3 | http://www.getuikit.com | (c) 2014 YOOtheme | MIT License */
	(function(core) {
	
	    if (true) { // AMD
	
	        !(__WEBPACK_AMD_DEFINE_RESULT__ = function(){
	
	            var uikit = window.UIkit || core(window, window.jQuery, window.document);
	
	            uikit.load = function(res, req, onload, config) {
	
	                var resources = res.split(','), load = [], i, base = (config.config && config.config.uikit && config.config.uikit.base ? config.config.uikit.base : "").replace(/\/+$/g, "");
	
	                if (!base) {
	                    throw new Error( "Please define base path to UIkit in the requirejs config." );
	                }
	
	                for (i = 0; i < resources.length; i += 1) {
	                    var resource = resources[i].replace(/\./g, '/');
	                    load.push(base+'/components/'+resource);
	                }
	
	                req(load, function() {
	                    onload(uikit);
	                });
	            };
	
	            return uikit;
	        }.call(exports, __webpack_require__, exports, module), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
	    }
	
	    if (!window.jQuery) {
	        throw new Error( "UIkit requires jQuery" );
	    }
	
	    if (window && window.jQuery) {
	        core(window, window.jQuery, window.document);
	    }
	
	
	})(function(global, $, doc) {
	
	    "use strict";
	
	    var UI = {}, _UI = global.UIkit ? Object.create(global.UIkit) : undefined;
	
	    UI.version = '2.26.3';
	
	    UI.noConflict = function() {
	        // restore UIkit version
	        if (_UI) {
	            global.UIkit = _UI;
	            $.UIkit      = _UI;
	            $.fn.uk      = _UI.fn;
	        }
	
	        return UI;
	    };
	
	    UI.prefix = function(str) {
	        return str;
	    };
	
	    // cache jQuery
	    UI.$ = $;
	
	    UI.$doc  = UI.$(document);
	    UI.$win  = UI.$(window);
	    UI.$html = UI.$('html');
	
	    UI.support = {};
	    UI.support.transition = (function() {
	
	        var transitionEnd = (function() {
	
	            var element = doc.body || doc.documentElement,
	                transEndEventNames = {
	                    WebkitTransition : 'webkitTransitionEnd',
	                    MozTransition    : 'transitionend',
	                    OTransition      : 'oTransitionEnd otransitionend',
	                    transition       : 'transitionend'
	                }, name;
	
	            for (name in transEndEventNames) {
	                if (element.style[name] !== undefined) return transEndEventNames[name];
	            }
	        }());
	
	        return transitionEnd && { end: transitionEnd };
	    })();
	
	    UI.support.animation = (function() {
	
	        var animationEnd = (function() {
	
	            var element = doc.body || doc.documentElement,
	                animEndEventNames = {
	                    WebkitAnimation : 'webkitAnimationEnd',
	                    MozAnimation    : 'animationend',
	                    OAnimation      : 'oAnimationEnd oanimationend',
	                    animation       : 'animationend'
	                }, name;
	
	            for (name in animEndEventNames) {
	                if (element.style[name] !== undefined) return animEndEventNames[name];
	            }
	        }());
	
	        return animationEnd && { end: animationEnd };
	    })();
	
	    // requestAnimationFrame polyfill
	    //https://github.com/darius/requestAnimationFrame
	    (function() {
	
	        Date.now = Date.now || function() { return new Date().getTime(); };
	
	        var vendors = ['webkit', 'moz'];
	        for (var i = 0; i < vendors.length && !window.requestAnimationFrame; ++i) {
	            var vp = vendors[i];
	            window.requestAnimationFrame = window[vp+'RequestAnimationFrame'];
	            window.cancelAnimationFrame = (window[vp+'CancelAnimationFrame']
	                                       || window[vp+'CancelRequestAnimationFrame']);
	        }
	        if (/iP(ad|hone|od).*OS 6/.test(window.navigator.userAgent) // iOS6 is buggy
	            || !window.requestAnimationFrame || !window.cancelAnimationFrame) {
	            var lastTime = 0;
	            window.requestAnimationFrame = function(callback) {
	                var now = Date.now();
	                var nextTime = Math.max(lastTime + 16, now);
	                return setTimeout(function() { callback(lastTime = nextTime); },
	                                  nextTime - now);
	            };
	            window.cancelAnimationFrame = clearTimeout;
	        }
	    }());
	
	    UI.support.touch = (
	        ('ontouchstart' in document) ||
	        (global.DocumentTouch && document instanceof global.DocumentTouch)  ||
	        (global.navigator.msPointerEnabled && global.navigator.msMaxTouchPoints > 0) || //IE 10
	        (global.navigator.pointerEnabled && global.navigator.maxTouchPoints > 0) || //IE >=11
	        false
	    );
	
	    UI.support.mutationobserver = (global.MutationObserver || global.WebKitMutationObserver || null);
	
	    UI.Utils = {};
	
	    UI.Utils.isFullscreen = function() {
	        return document.webkitFullscreenElement || document.mozFullScreenElement || document.msFullscreenElement || document.fullscreenElement || false;
	    };
	
	    UI.Utils.str2json = function(str, notevil) {
	        try {
	            if (notevil) {
	                return JSON.parse(str
	                    // wrap keys without quote with valid double quote
	                    .replace(/([\$\w]+)\s*:/g, function(_, $1){return '"'+$1+'":';})
	                    // replacing single quote wrapped ones to double quote
	                    .replace(/'([^']+)'/g, function(_, $1){return '"'+$1+'"';})
	                );
	            } else {
	                return (new Function("", "var json = " + str + "; return JSON.parse(JSON.stringify(json));"))();
	            }
	        } catch(e) { return false; }
	    };
	
	    UI.Utils.debounce = function(func, wait, immediate) {
	        var timeout;
	        return function() {
	            var context = this, args = arguments;
	            var later = function() {
	                timeout = null;
	                if (!immediate) func.apply(context, args);
	            };
	            var callNow = immediate && !timeout;
	            clearTimeout(timeout);
	            timeout = setTimeout(later, wait);
	            if (callNow) func.apply(context, args);
	        };
	    };
	
	    UI.Utils.throttle = function (func, limit) {
	        var wait = false;
	        return function () {
	            if (!wait) {
	                func.call();
	                wait = true;
	                setTimeout(function () {
	                    wait = false;
	                }, limit);
	            }
	        }
	    };
	
	    UI.Utils.removeCssRules = function(selectorRegEx) {
	        var idx, idxs, stylesheet, _i, _j, _k, _len, _len1, _len2, _ref;
	
	        if(!selectorRegEx) return;
	
	        setTimeout(function(){
	            try {
	              _ref = document.styleSheets;
	              for (_i = 0, _len = _ref.length; _i < _len; _i++) {
	                stylesheet = _ref[_i];
	                idxs = [];
	                stylesheet.cssRules = stylesheet.cssRules;
	                for (idx = _j = 0, _len1 = stylesheet.cssRules.length; _j < _len1; idx = ++_j) {
	                  if (stylesheet.cssRules[idx].type === CSSRule.STYLE_RULE && selectorRegEx.test(stylesheet.cssRules[idx].selectorText)) {
	                    idxs.unshift(idx);
	                  }
	                }
	                for (_k = 0, _len2 = idxs.length; _k < _len2; _k++) {
	                  stylesheet.deleteRule(idxs[_k]);
	                }
	              }
	            } catch (_error) {}
	        }, 0);
	    };
	
	    UI.Utils.isInView = function(element, options) {
	
	        var $element = $(element);
	
	        if (!$element.is(':visible')) {
	            return false;
	        }
	
	        var window_left = UI.$win.scrollLeft(), window_top = UI.$win.scrollTop(), offset = $element.offset(), left = offset.left, top = offset.top;
	
	        options = $.extend({topoffset:0, leftoffset:0}, options);
	
	        if (top + $element.height() >= window_top && top - options.topoffset <= window_top + UI.$win.height() &&
	            left + $element.width() >= window_left && left - options.leftoffset <= window_left + UI.$win.width()) {
	          return true;
	        } else {
	          return false;
	        }
	    };
	
	    UI.Utils.checkDisplay = function(context, initanimation) {
	
	        var elements = UI.$('[data-uk-margin], [data-uk-grid-match], [data-uk-grid-margin], [data-uk-check-display]', context || document), animated;
	
	        if (context && !elements.length) {
	            elements = $(context);
	        }
	
	        elements.trigger('display.uk.check');
	
	        // fix firefox / IE animations
	        if (initanimation) {
	
	            if (typeof(initanimation)!='string') {
	                initanimation = '[class*="uk-animation-"]';
	            }
	
	            elements.find(initanimation).each(function(){
	
	                var ele  = UI.$(this),
	                    cls  = ele.attr('class'),
	                    anim = cls.match(/uk\-animation\-(.+)/);
	
	                ele.removeClass(anim[0]).width();
	
	                ele.addClass(anim[0]);
	            });
	        }
	
	        return elements;
	    };
	
	    UI.Utils.options = function(string) {
	
	        if ($.type(string)!='string') return string;
	
	        if (string.indexOf(':') != -1 && string.trim().substr(-1) != '}') {
	            string = '{'+string+'}';
	        }
	
	        var start = (string ? string.indexOf("{") : -1), options = {};
	
	        if (start != -1) {
	            try {
	                options = UI.Utils.str2json(string.substr(start));
	            } catch (e) {}
	        }
	
	        return options;
	    };
	
	    UI.Utils.animate = function(element, cls) {
	
	        var d = $.Deferred();
	
	        element = UI.$(element);
	
	        element.css('display', 'none').addClass(cls).one(UI.support.animation.end, function() {
	            element.removeClass(cls);
	            d.resolve();
	        });
	
	        element.css('display', '');
	
	        return d.promise();
	    };
	
	    UI.Utils.uid = function(prefix) {
	        return (prefix || 'id') + (new Date().getTime())+"RAND"+(Math.ceil(Math.random() * 100000));
	    };
	
	    UI.Utils.template = function(str, data) {
	
	        var tokens = str.replace(/\n/g, '\\n').replace(/\{\{\{\s*(.+?)\s*\}\}\}/g, "{{!$1}}").split(/(\{\{\s*(.+?)\s*\}\})/g),
	            i=0, toc, cmd, prop, val, fn, output = [], openblocks = 0;
	
	        while(i < tokens.length) {
	
	            toc = tokens[i];
	
	            if(toc.match(/\{\{\s*(.+?)\s*\}\}/)) {
	                i = i + 1;
	                toc  = tokens[i];
	                cmd  = toc[0];
	                prop = toc.substring(toc.match(/^(\^|\#|\!|\~|\:)/) ? 1:0);
	
	                switch(cmd) {
	                    case '~':
	                        output.push("for(var $i=0;$i<"+prop+".length;$i++) { var $item = "+prop+"[$i];");
	                        openblocks++;
	                        break;
	                    case ':':
	                        output.push("for(var $key in "+prop+") { var $val = "+prop+"[$key];");
	                        openblocks++;
	                        break;
	                    case '#':
	                        output.push("if("+prop+") {");
	                        openblocks++;
	                        break;
	                    case '^':
	                        output.push("if(!"+prop+") {");
	                        openblocks++;
	                        break;
	                    case '/':
	                        output.push("}");
	                        openblocks--;
	                        break;
	                    case '!':
	                        output.push("__ret.push("+prop+");");
	                        break;
	                    default:
	                        output.push("__ret.push(escape("+prop+"));");
	                        break;
	                }
	            } else {
	                output.push("__ret.push('"+toc.replace(/\'/g, "\\'")+"');");
	            }
	            i = i + 1;
	        }
	
	        fn  = new Function('$data', [
	            'var __ret = [];',
	            'try {',
	            'with($data){', (!openblocks ? output.join('') : '__ret = ["Not all blocks are closed correctly."]'), '};',
	            '}catch(e){__ret = [e.message];}',
	            'return __ret.join("").replace(/\\n\\n/g, "\\n");',
	            "function escape(html) { return String(html).replace(/&/g, '&amp;').replace(/\"/g, '&quot;').replace(/</g, '&lt;').replace(/>/g, '&gt;');}"
	        ].join("\n"));
	
	        return data ? fn(data) : fn;
	    };
	
	    UI.Utils.events       = {};
	    UI.Utils.events.click = UI.support.touch ? 'tap' : 'click';
	
	    global.UIkit = UI;
	
	    // deprecated
	
	    UI.fn = function(command, options) {
	
	        var args = arguments, cmd = command.match(/^([a-z\-]+)(?:\.([a-z]+))?/i), component = cmd[1], method = cmd[2];
	
	        if (!UI[component]) {
	            $.error("UIkit component [" + component + "] does not exist.");
	            return this;
	        }
	
	        return this.each(function() {
	            var $this = $(this), data = $this.data(component);
	            if (!data) $this.data(component, (data = UI[component](this, method ? undefined : options)));
	            if (method) data[method].apply(data, Array.prototype.slice.call(args, 1));
	        });
	    };
	
	    $.UIkit          = UI;
	    $.fn.uk          = UI.fn;
	
	    UI.langdirection = UI.$html.attr("dir") == "rtl" ? "right" : "left";
	
	    UI.components    = {};
	
	    UI.component = function(name, def) {
	
	        var fn = function(element, options) {
	
	            var $this = this;
	
	            this.UIkit   = UI;
	            this.element = element ? UI.$(element) : null;
	            this.options = $.extend(true, {}, this.defaults, options);
	            this.plugins = {};
	
	            if (this.element) {
	                this.element.data(name, this);
	            }
	
	            this.init();
	
	            (this.options.plugins.length ? this.options.plugins : Object.keys(fn.plugins)).forEach(function(plugin) {
	
	                if (fn.plugins[plugin].init) {
	                    fn.plugins[plugin].init($this);
	                    $this.plugins[plugin] = true;
	                }
	
	            });
	
	            this.trigger('init.uk.component', [name, this]);
	
	            return this;
	        };
	
	        fn.plugins = {};
	
	        $.extend(true, fn.prototype, {
	
	            defaults : {plugins: []},
	
	            boot: function(){},
	            init: function(){},
	
	            on: function(a1,a2,a3){
	                return UI.$(this.element || this).on(a1,a2,a3);
	            },
	
	            one: function(a1,a2,a3){
	                return UI.$(this.element || this).one(a1,a2,a3);
	            },
	
	            off: function(evt){
	                return UI.$(this.element || this).off(evt);
	            },
	
	            trigger: function(evt, params) {
	                return UI.$(this.element || this).trigger(evt, params);
	            },
	
	            find: function(selector) {
	                return UI.$(this.element ? this.element: []).find(selector);
	            },
	
	            proxy: function(obj, methods) {
	
	                var $this = this;
	
	                methods.split(' ').forEach(function(method) {
	                    if (!$this[method]) $this[method] = function() { return obj[method].apply(obj, arguments); };
	                });
	            },
	
	            mixin: function(obj, methods) {
	
	                var $this = this;
	
	                methods.split(' ').forEach(function(method) {
	                    if (!$this[method]) $this[method] = obj[method].bind($this);
	                });
	            },
	
	            option: function() {
	
	                if (arguments.length == 1) {
	                    return this.options[arguments[0]] || undefined;
	                } else if (arguments.length == 2) {
	                    this.options[arguments[0]] = arguments[1];
	                }
	            }
	
	        }, def);
	
	        this.components[name] = fn;
	
	        this[name] = function() {
	
	            var element, options;
	
	            if (arguments.length) {
	
	                switch(arguments.length) {
	                    case 1:
	
	                        if (typeof arguments[0] === "string" || arguments[0].nodeType || arguments[0] instanceof jQuery) {
	                            element = $(arguments[0]);
	                        } else {
	                            options = arguments[0];
	                        }
	
	                        break;
	                    case 2:
	
	                        element = $(arguments[0]);
	                        options = arguments[1];
	                        break;
	                }
	            }
	
	            if (element && element.data(name)) {
	                return element.data(name);
	            }
	
	            return (new UI.components[name](element, options));
	        };
	
	        if (UI.domready) {
	            UI.component.boot(name);
	        }
	
	        return fn;
	    };
	
	    UI.plugin = function(component, name, def) {
	        this.components[component].plugins[name] = def;
	    };
	
	    UI.component.boot = function(name) {
	
	        if (UI.components[name].prototype && UI.components[name].prototype.boot && !UI.components[name].booted) {
	            UI.components[name].prototype.boot.apply(UI, []);
	            UI.components[name].booted = true;
	        }
	    };
	
	    UI.component.bootComponents = function() {
	
	        for (var component in UI.components) {
	            UI.component.boot(component);
	        }
	    };
	
	
	    // DOM mutation save ready helper function
	
	    UI.domObservers = [];
	    UI.domready     = false;
	
	    UI.ready = function(fn) {
	
	        UI.domObservers.push(fn);
	
	        if (UI.domready) {
	            fn(document);
	        }
	    };
	
	    UI.on = function(a1,a2,a3){
	
	        if (a1 && a1.indexOf('ready.uk.dom') > -1 && UI.domready) {
	            a2.apply(UI.$doc);
	        }
	
	        return UI.$doc.on(a1,a2,a3);
	    };
	
	    UI.one = function(a1,a2,a3){
	
	        if (a1 && a1.indexOf('ready.uk.dom') > -1 && UI.domready) {
	            a2.apply(UI.$doc);
	            return UI.$doc;
	        }
	
	        return UI.$doc.one(a1,a2,a3);
	    };
	
	    UI.trigger = function(evt, params) {
	        return UI.$doc.trigger(evt, params);
	    };
	
	    UI.domObserve = function(selector, fn) {
	
	        if(!UI.support.mutationobserver) return;
	
	        fn = fn || function() {};
	
	        UI.$(selector).each(function() {
	
	            var element  = this,
	                $element = UI.$(element);
	
	            if ($element.data('observer')) {
	                return;
	            }
	
	            try {
	
	                var observer = new UI.support.mutationobserver(UI.Utils.debounce(function(mutations) {
	                    fn.apply(element, []);
	                    $element.trigger('changed.uk.dom');
	                }, 50), {childList: true, subtree: true});
	
	                // pass in the target node, as well as the observer options
	                observer.observe(element, { childList: true, subtree: true });
	
	                $element.data('observer', observer);
	
	            } catch(e) {}
	        });
	    };
	
	    UI.init = function(root) {
	
	        root = root || document;
	
	        UI.domObservers.forEach(function(fn){
	            fn(root);
	        });
	    };
	
	    UI.on('domready.uk.dom', function(){
	
	        UI.init();
	
	        if (UI.domready) UI.Utils.checkDisplay();
	    });
	
	    document.addEventListener('DOMContentLoaded', function(){
	
	        var domReady = function() {
	
	            UI.$body = UI.$('body');
	
	            UI.trigger('beforeready.uk.dom');
	
	            UI.component.bootComponents();
	
	            // custom scroll observer
	            requestAnimationFrame((function(){
	
	                var memory = {dir: {x:0, y:0}, x: window.pageXOffset, y:window.pageYOffset};
	
	                var fn = function(){
	                    // reading this (window.page[X|Y]Offset) causes a full page recalc of the layout in Chrome,
	                    // so we only want to do this once
	                    var wpxo = window.pageXOffset;
	                    var wpyo = window.pageYOffset;
	
	                    // Did the scroll position change since the last time we were here?
	                    if (memory.x != wpxo || memory.y != wpyo) {
	
	                        // Set the direction of the scroll and store the new position
	                        if (wpxo != memory.x) {memory.dir.x = wpxo > memory.x ? 1:-1; } else { memory.dir.x = 0; }
	                        if (wpyo != memory.y) {memory.dir.y = wpyo > memory.y ? 1:-1; } else { memory.dir.y = 0; }
	
	                        memory.x = wpxo;
	                        memory.y = wpyo;
	
	                        // Trigger the scroll event, this could probably be sent using memory.clone() but this is
	                        // more explicit and easier to see exactly what is being sent in the event.
	                        UI.$doc.trigger('scrolling.uk.document', [{
	                            "dir": {"x": memory.dir.x, "y": memory.dir.y}, "x": wpxo, "y": wpyo
	                        }]);
	                    }
	
	                    requestAnimationFrame(fn);
	                };
	
	                if (UI.support.touch) {
	                    UI.$html.on('touchmove touchend MSPointerMove MSPointerUp pointermove pointerup', fn);
	                }
	
	                if (memory.x || memory.y) fn();
	
	                return fn;
	
	            })());
	
	            // run component init functions on dom
	            UI.trigger('domready.uk.dom');
	
	            if (UI.support.touch) {
	
	                // remove css hover rules for touch devices
	                // UI.Utils.removeCssRules(/\.uk-(?!navbar).*:hover/);
	
	                // viewport unit fix for uk-height-viewport - should be fixed in iOS 8
	                if (navigator.userAgent.match(/(iPad|iPhone|iPod)/g)) {
	
	                    UI.$win.on('load orientationchange resize', UI.Utils.debounce((function(){
	
	                        var fn = function() {
	                            $('.uk-height-viewport').css('height', window.innerHeight);
	                            return fn;
	                        };
	
	                        return fn();
	
	                    })(), 100));
	                }
	            }
	
	            UI.trigger('afterready.uk.dom');
	
	            // mark that domready is left behind
	            UI.domready = true;
	
	            // auto init js components
	            if (UI.support.mutationobserver) {
	
	                var initFn = UI.Utils.debounce(function(){
	                    requestAnimationFrame(function(){ UI.init(document.body);});
	                }, 10);
	
	                (new UI.support.mutationobserver(function(mutations) {
	
	                    var init = false;
	
	                    mutations.every(function(mutation){
	
	                        if (mutation.type != 'childList') return true;
	
	                        for (var i = 0, node; i < mutation.addedNodes.length; ++i) {
	
	                            node = mutation.addedNodes[i];
	
	                            if (node.outerHTML && node.outerHTML.indexOf('data-uk-') !== -1) {
	                                return (init = true) && false;
	                            }
	                        }
	                        return true;
	                    });
	
	                    if (init) initFn();
	
	                })).observe(document.body, {childList: true, subtree: true});
	            }
	        };
	
	        if (document.readyState == 'complete' || document.readyState == 'interactive') {
	            setTimeout(domReady);
	        }
	
	        return domReady;
	
	    }());
	
	    // add touch identifier class
	    UI.$html.addClass(UI.support.touch ? "uk-touch" : "uk-notouch");
	
	    // add uk-hover class on tap to support overlays on touch devices
	    if (UI.support.touch) {
	
	        var hoverset = false,
	            exclude,
	            hovercls = 'uk-hover',
	            selector = '.uk-overlay, .uk-overlay-hover, .uk-overlay-toggle, .uk-animation-hover, .uk-has-hover';
	
	        UI.$html.on('mouseenter touchstart MSPointerDown pointerdown', selector, function() {
	
	            if (hoverset) $('.'+hovercls).removeClass(hovercls);
	
	            hoverset = $(this).addClass(hovercls);
	
	        }).on('mouseleave touchend MSPointerUp pointerup', function(e) {
	
	            exclude = $(e.target).parents(selector);
	
	            if (hoverset) {
	                hoverset.not(exclude).removeClass(hovercls);
	            }
	        });
	    }
	
	    return UI;
	});
	
	//  Based on Zeptos touch.js
	//  https://raw.github.com/madrobby/zepto/master/src/touch.js
	//  Zepto.js may be freely distributed under the MIT license.
	
	;(function($){
	
	  if ($.fn.swipeLeft) {
	    return;
	  }
	
	
	  var touch = {}, touchTimeout, tapTimeout, swipeTimeout, longTapTimeout, longTapDelay = 750, gesture;
	
	  function swipeDirection(x1, x2, y1, y2) {
	    return Math.abs(x1 - x2) >= Math.abs(y1 - y2) ? (x1 - x2 > 0 ? 'Left' : 'Right') : (y1 - y2 > 0 ? 'Up' : 'Down');
	  }
	
	  function longTap() {
	    longTapTimeout = null;
	    if (touch.last) {
	      if ( touch.el !== undefined ) touch.el.trigger('longTap');
	      touch = {};
	    }
	  }
	
	  function cancelLongTap() {
	    if (longTapTimeout) clearTimeout(longTapTimeout);
	    longTapTimeout = null;
	  }
	
	  function cancelAll() {
	    if (touchTimeout)   clearTimeout(touchTimeout);
	    if (tapTimeout)     clearTimeout(tapTimeout);
	    if (swipeTimeout)   clearTimeout(swipeTimeout);
	    if (longTapTimeout) clearTimeout(longTapTimeout);
	    touchTimeout = tapTimeout = swipeTimeout = longTapTimeout = null;
	    touch = {};
	  }
	
	  function isPrimaryTouch(event){
	    return event.pointerType == event.MSPOINTER_TYPE_TOUCH && event.isPrimary;
	  }
	
	  $(function(){
	    var now, delta, deltaX = 0, deltaY = 0, firstTouch;
	
	    if ('MSGesture' in window) {
	      gesture = new MSGesture();
	      gesture.target = document.body;
	    }
	
	    $(document)
	      .on('MSGestureEnd gestureend', function(e){
	
	        var swipeDirectionFromVelocity = e.originalEvent.velocityX > 1 ? 'Right' : e.originalEvent.velocityX < -1 ? 'Left' : e.originalEvent.velocityY > 1 ? 'Down' : e.originalEvent.velocityY < -1 ? 'Up' : null;
	
	        if (swipeDirectionFromVelocity && touch.el !== undefined) {
	          touch.el.trigger('swipe');
	          touch.el.trigger('swipe'+ swipeDirectionFromVelocity);
	        }
	      })
	      // MSPointerDown: for IE10
	      // pointerdown: for IE11
	      .on('touchstart MSPointerDown pointerdown', function(e){
	
	        if(e.type == 'MSPointerDown' && !isPrimaryTouch(e.originalEvent)) return;
	
	        firstTouch = (e.type == 'MSPointerDown' || e.type == 'pointerdown') ? e : e.originalEvent.touches[0];
	
	        now      = Date.now();
	        delta    = now - (touch.last || now);
	        touch.el = $('tagName' in firstTouch.target ? firstTouch.target : firstTouch.target.parentNode);
	
	        if(touchTimeout) clearTimeout(touchTimeout);
	
	        touch.x1 = firstTouch.pageX;
	        touch.y1 = firstTouch.pageY;
	
	        if (delta > 0 && delta <= 250) touch.isDoubleTap = true;
	
	        touch.last = now;
	        longTapTimeout = setTimeout(longTap, longTapDelay);
	
	        // adds the current touch contact for IE gesture recognition
	        if (gesture && ( e.type == 'MSPointerDown' || e.type == 'pointerdown' || e.type == 'touchstart' ) ) {
	          gesture.addPointer(e.originalEvent.pointerId);
	        }
	
	      })
	      // MSPointerMove: for IE10
	      // pointermove: for IE11
	      .on('touchmove MSPointerMove pointermove', function(e){
	
	        if (e.type == 'MSPointerMove' && !isPrimaryTouch(e.originalEvent)) return;
	
	        firstTouch = (e.type == 'MSPointerMove' || e.type == 'pointermove') ? e : e.originalEvent.touches[0];
	
	        cancelLongTap();
	        touch.x2 = firstTouch.pageX;
	        touch.y2 = firstTouch.pageY;
	
	        deltaX += Math.abs(touch.x1 - touch.x2);
	        deltaY += Math.abs(touch.y1 - touch.y2);
	      })
	      // MSPointerUp: for IE10
	      // pointerup: for IE11
	      .on('touchend MSPointerUp pointerup', function(e){
	
	        if (e.type == 'MSPointerUp' && !isPrimaryTouch(e.originalEvent)) return;
	
	        cancelLongTap();
	
	        // swipe
	        if ((touch.x2 && Math.abs(touch.x1 - touch.x2) > 30) || (touch.y2 && Math.abs(touch.y1 - touch.y2) > 30)){
	
	          swipeTimeout = setTimeout(function() {
	            if ( touch.el !== undefined ) {
	              touch.el.trigger('swipe');
	              touch.el.trigger('swipe' + (swipeDirection(touch.x1, touch.x2, touch.y1, touch.y2)));
	            }
	            touch = {};
	          }, 0);
	
	        // normal tap
	        } else if ('last' in touch) {
	
	          // don't fire tap when delta position changed by more than 30 pixels,
	          // for instance when moving to a point and back to origin
	          if (isNaN(deltaX) || (deltaX < 30 && deltaY < 30)) {
	            // delay by one tick so we can cancel the 'tap' event if 'scroll' fires
	            // ('tap' fires before 'scroll')
	            tapTimeout = setTimeout(function() {
	
	              // trigger universal 'tap' with the option to cancelTouch()
	              // (cancelTouch cancels processing of single vs double taps for faster 'tap' response)
	              var event = $.Event('tap');
	              event.cancelTouch = cancelAll;
	              if ( touch.el !== undefined ) touch.el.trigger(event);
	
	              // trigger double tap immediately
	              if (touch.isDoubleTap) {
	                if ( touch.el !== undefined ) touch.el.trigger('doubleTap');
	                touch = {};
	              }
	
	              // trigger single tap after 250ms of inactivity
	              else {
	                touchTimeout = setTimeout(function(){
	                  touchTimeout = null;
	                  if ( touch.el !== undefined ) touch.el.trigger('singleTap');
	                  touch = {};
	                }, 250);
	              }
	            }, 0);
	          } else {
	            touch = {};
	          }
	          deltaX = deltaY = 0;
	        }
	      })
	      // when the browser window loses focus,
	      // for example when a modal dialog is shown,
	      // cancel all ongoing events
	      .on('touchcancel MSPointerCancel', cancelAll);
	
	    // scrolling the window indicates intention of the user
	    // to scroll, not tap or swipe, so cancel all ongoing events
	    $(window).on('scroll', cancelAll);
	  });
	
	  ['swipe', 'swipeLeft', 'swipeRight', 'swipeUp', 'swipeDown', 'doubleTap', 'tap', 'singleTap', 'longTap'].forEach(function(eventName){
	    $.fn[eventName] = function(callback){ return $(this).on(eventName, callback); };
	  });
	})(jQuery);
	
	(function(UI) {
	
	    "use strict";
	
	    var stacks = [];
	
	    UI.component('stackMargin', {
	
	        defaults: {
	            cls: 'uk-margin-small-top',
	            rowfirst: false,
	            observe: false
	        },
	
	        boot: function() {
	
	            // init code
	            UI.ready(function(context) {
	
	                UI.$("[data-uk-margin]", context).each(function() {
	
	                    var ele = UI.$(this);
	
	                    if (!ele.data("stackMargin")) {
	                        UI.stackMargin(ele, UI.Utils.options(ele.attr("data-uk-margin")));
	                    }
	                });
	            });
	        },
	
	        init: function() {
	
	            var $this = this;
	
	            UI.$win.on('resize orientationchange', (function() {
	
	                var fn = function() {
	                    $this.process();
	                };
	
	                UI.$(function() {
	                    fn();
	                    UI.$win.on("load", fn);
	                });
	
	                return UI.Utils.debounce(fn, 20);
	            })());
	
	            this.on("display.uk.check", function(e) {
	                if (this.element.is(":visible")) this.process();
	            }.bind(this));
	
	            if (this.options.observe) {
	
	                UI.domObserve(this.element, function(e) {
	                    if ($this.element.is(":visible")) $this.process();
	                });
	            }
	
	            stacks.push(this);
	        },
	
	        process: function() {
	
	            var $this = this, columns = this.element.children();
	
	            UI.Utils.stackMargin(columns, this.options);
	
	            if (!this.options.rowfirst || !columns.length) {
	                return this;
	            }
	
	            // Mark first column elements
	            var group = {}, minleft = false;
	
	            columns.removeClass(this.options.rowfirst).each(function(offset, $ele){
	
	                $ele = UI.$(this);
	
	                if (this.style.display != 'none') {
	                    offset = $ele.offset().left;
	                    ((group[offset] = group[offset] || []) && group[offset]).push(this);
	                    minleft = minleft === false ? offset : Math.min(minleft, offset);
	                }
	            });
	
	            UI.$(group[minleft]).addClass(this.options.rowfirst);
	
	            return this;
	        }
	
	    });
	
	
	    // responsive element e.g. iframes
	
	    (function(){
	
	        var elements = [], check = function(ele) {
	
	            if (!ele.is(':visible')) return;
	
	            var width  = ele.parent().width(),
	                iwidth = ele.data('width'),
	                ratio  = (width / iwidth),
	                height = Math.floor(ratio * ele.data('height'));
	
	            ele.css({'height': (width < iwidth) ? height : ele.data('height')});
	        };
	
	        UI.component('responsiveElement', {
	
	            defaults: {},
	
	            boot: function() {
	
	                // init code
	                UI.ready(function(context) {
	
	                    UI.$("iframe.uk-responsive-width, [data-uk-responsive]", context).each(function() {
	
	                        var ele = UI.$(this), obj;
	
	                        if (!ele.data("responsiveElement")) {
	                            obj = UI.responsiveElement(ele, {});
	                        }
	                    });
	                });
	            },
	
	            init: function() {
	
	                var ele = this.element;
	
	                if (ele.attr('width') && ele.attr('height')) {
	
	                    ele.data({
	
	                        'width' : ele.attr('width'),
	                        'height': ele.attr('height')
	
	                    }).on('display.uk.check', function(){
	                        check(ele);
	                    });
	
	                    check(ele);
	
	                    elements.push(ele);
	                }
	            }
	        });
	
	        UI.$win.on('resize load', UI.Utils.debounce(function(){
	
	            elements.forEach(function(ele){
	                check(ele);
	            });
	
	        }, 15));
	
	    })();
	
	
	
	    // helper
	
	    UI.Utils.stackMargin = function(elements, options) {
	
	        options = UI.$.extend({
	            'cls': 'uk-margin-small-top'
	        }, options);
	
	        elements = UI.$(elements).removeClass(options.cls);
	
	        var min = false;
	
	        elements.each(function(offset, height, pos, $ele){
	
	            $ele   = UI.$(this);
	
	            if ($ele.css('display') != 'none') {
	
	                offset = $ele.offset();
	                height = $ele.outerHeight();
	                pos    = offset.top + height;
	
	                $ele.data({
	                    'ukMarginPos': pos,
	                    'ukMarginTop': offset.top
	                });
	
	                if (min === false || (offset.top < min.top) ) {
	
	                    min = {
	                        top  : offset.top,
	                        left : offset.left,
	                        pos  : pos
	                    };
	                }
	            }
	
	        }).each(function($ele) {
	
	            $ele   = UI.$(this);
	
	            if ($ele.css('display') != 'none' && $ele.data('ukMarginTop') > min.top && $ele.data('ukMarginPos') > min.pos) {
	                $ele.addClass(options.cls);
	            }
	        });
	    };
	
	    UI.Utils.matchHeights = function(elements, options) {
	
	        elements = UI.$(elements).css('min-height', '');
	        options  = UI.$.extend({ row : true }, options);
	
	        var matchHeights = function(group){
	
	            if (group.length < 2) return;
	
	            var max = 0;
	
	            group.each(function() {
	                max = Math.max(max, UI.$(this).outerHeight());
	            }).each(function() {
	
	                var element = UI.$(this),
	                    height  = max - (element.css('box-sizing') == 'border-box' ? 0 : (element.outerHeight() - element.height()));
	
	                element.css('min-height', height + 'px');
	            });
	        };
	
	        if (options.row) {
	
	            elements.first().width(); // force redraw
	
	            setTimeout(function(){
	
	                var lastoffset = false, group = [];
	
	                elements.each(function() {
	
	                    var ele = UI.$(this), offset = ele.offset().top;
	
	                    if (offset != lastoffset && group.length) {
	
	                        matchHeights(UI.$(group));
	                        group  = [];
	                        offset = ele.offset().top;
	                    }
	
	                    group.push(ele);
	                    lastoffset = offset;
	                });
	
	                if (group.length) {
	                    matchHeights(UI.$(group));
	                }
	
	            }, 0);
	
	        } else {
	            matchHeights(elements);
	        }
	    };
	
	    (function(cacheSvgs){
	
	        UI.Utils.inlineSvg = function(selector, root) {
	
	            var images = UI.$(selector || 'img[src$=".svg"]', root || document).each(function(){
	
	                var img = UI.$(this),
	                    src = img.attr('src');
	
	                if (!cacheSvgs[src]) {
	
	                    var d = UI.$.Deferred();
	
	                    UI.$.get(src, {nc: Math.random()}, function(data){
	                        d.resolve(UI.$(data).find('svg'));
	                    });
	
	                    cacheSvgs[src] = d.promise();
	                }
	
	                cacheSvgs[src].then(function(svg) {
	
	                    var $svg = UI.$(svg).clone();
	
	                    if (img.attr('id')) $svg.attr('id', img.attr('id'));
	                    if (img.attr('class')) $svg.attr('class', img.attr('class'));
	                    if (img.attr('style')) $svg.attr('style', img.attr('style'));
	
	                    if (img.attr('width')) {
	                        $svg.attr('width', img.attr('width'));
	                        if (!img.attr('height'))  $svg.removeAttr('height');
	                    }
	
	                    if (img.attr('height')){
	                        $svg.attr('height', img.attr('height'));
	                        if (!img.attr('width')) $svg.removeAttr('width');
	                    }
	
	                    img.replaceWith($svg);
	                });
	            });
	        };
	
	        // init code
	        UI.ready(function(context) {
	            UI.Utils.inlineSvg('[data-uk-svg]', context);
	        });
	
	    })({});
	
	})(UIkit);
	
	(function(UI) {
	
	    "use strict";
	
	    UI.component('smoothScroll', {
	
	        boot: function() {
	
	            // init code
	            UI.$html.on("click.smooth-scroll.uikit", "[data-uk-smooth-scroll]", function(e) {
	                var ele = UI.$(this);
	
	                if (!ele.data("smoothScroll")) {
	                    var obj = UI.smoothScroll(ele, UI.Utils.options(ele.attr("data-uk-smooth-scroll")));
	                    ele.trigger("click");
	                }
	
	                return false;
	            });
	        },
	
	        init: function() {
	
	            var $this = this;
	
	            this.on("click", function(e) {
	                e.preventDefault();
	                scrollToElement(UI.$(this.hash).length ? UI.$(this.hash) : UI.$("body"), $this.options);
	            });
	        }
	    });
	
	    function scrollToElement(ele, options) {
	
	        options = UI.$.extend({
	            duration: 1000,
	            transition: 'easeOutExpo',
	            offset: 0,
	            complete: function(){}
	        }, options);
	
	        // get / set parameters
	        var target    = ele.offset().top - options.offset,
	            docheight = UI.$doc.height(),
	            winheight = window.innerHeight;
	
	        if ((target + winheight) > docheight) {
	            target = docheight - winheight;
	        }
	
	        // animate to target, fire callback when done
	        UI.$("html,body").stop().animate({scrollTop: target}, options.duration, options.transition).promise().done(options.complete);
	    }
	
	    UI.Utils.scrollToElement = scrollToElement;
	
	    if (!UI.$.easing.easeOutExpo) {
	        UI.$.easing.easeOutExpo = function(x, t, b, c, d) { return (t == d) ? b + c : c * (-Math.pow(2, -10 * t / d) + 1) + b; };
	    }
	
	})(UIkit);
	
	(function(UI) {
	
	    "use strict";
	
	    var $win           = UI.$win,
	        $doc           = UI.$doc,
	        scrollspies    = [],
	        checkScrollSpy = function() {
	            for(var i=0; i < scrollspies.length; i++) {
	                window.requestAnimationFrame.apply(window, [scrollspies[i].check]);
	            }
	        };
	
	    UI.component('scrollspy', {
	
	        defaults: {
	            "target"     : false,
	            "cls"        : "uk-scrollspy-inview",
	            "initcls"    : "uk-scrollspy-init-inview",
	            "topoffset"  : 0,
	            "leftoffset" : 0,
	            "repeat"     : false,
	            "delay"      : 0
	        },
	
	        boot: function() {
	
	            // listen to scroll and resize
	            $doc.on("scrolling.uk.document", checkScrollSpy);
	            $win.on("load resize orientationchange", UI.Utils.debounce(checkScrollSpy, 50));
	
	            // init code
	            UI.ready(function(context) {
	
	                UI.$("[data-uk-scrollspy]", context).each(function() {
	
	                    var element = UI.$(this);
	
	                    if (!element.data("scrollspy")) {
	                        var obj = UI.scrollspy(element, UI.Utils.options(element.attr("data-uk-scrollspy")));
	                    }
	                });
	            });
	        },
	
	        init: function() {
	
	            var $this = this, inviewstate, initinview, togglecls = this.options.cls.split(/,/), fn = function(){
	
	                var elements     = $this.options.target ? $this.element.find($this.options.target) : $this.element,
	                    delayIdx     = elements.length === 1 ? 1 : 0,
	                    toggleclsIdx = 0;
	
	                elements.each(function(idx){
	
	                    var element     = UI.$(this),
	                        inviewstate = element.data('inviewstate'),
	                        inview      = UI.Utils.isInView(element, $this.options),
	                        toggle      = element.data('ukScrollspyCls') || togglecls[toggleclsIdx].trim();
	
	                    if (inview && !inviewstate && !element.data('scrollspy-idle')) {
	
	                        if (!initinview) {
	                            element.addClass($this.options.initcls);
	                            $this.offset = element.offset();
	                            initinview = true;
	
	                            element.trigger("init.uk.scrollspy");
	                        }
	
	                        element.data('scrollspy-idle', setTimeout(function(){
	
	                            element.addClass("uk-scrollspy-inview").toggleClass(toggle).width();
	                            element.trigger("inview.uk.scrollspy");
	
	                            element.data('scrollspy-idle', false);
	                            element.data('inviewstate', true);
	
	                        }, $this.options.delay * delayIdx));
	
	                        delayIdx++;
	                    }
	
	                    if (!inview && inviewstate && $this.options.repeat) {
	
	                        if (element.data('scrollspy-idle')) {
	                            clearTimeout(element.data('scrollspy-idle'));
	                            element.data('scrollspy-idle', false);
	                        }
	
	                        element.removeClass("uk-scrollspy-inview").toggleClass(toggle);
	                        element.data('inviewstate', false);
	
	                        element.trigger("outview.uk.scrollspy");
	                    }
	
	                    toggleclsIdx = togglecls[toggleclsIdx + 1] ? (toggleclsIdx + 1) : 0;
	
	                });
	            };
	
	            fn();
	
	            this.check = fn;
	
	            scrollspies.push(this);
	        }
	    });
	
	
	    var scrollspynavs = [],
	        checkScrollSpyNavs = function() {
	            for(var i=0; i < scrollspynavs.length; i++) {
	                window.requestAnimationFrame.apply(window, [scrollspynavs[i].check]);
	            }
	        };
	
	    UI.component('scrollspynav', {
	
	        defaults: {
	            "cls"          : 'uk-active',
	            "closest"      : false,
	            "topoffset"    : 0,
	            "leftoffset"   : 0,
	            "smoothscroll" : false
	        },
	
	        boot: function() {
	
	            // listen to scroll and resize
	            $doc.on("scrolling.uk.document", checkScrollSpyNavs);
	            $win.on("resize orientationchange", UI.Utils.debounce(checkScrollSpyNavs, 50));
	
	            // init code
	            UI.ready(function(context) {
	
	                UI.$("[data-uk-scrollspy-nav]", context).each(function() {
	
	                    var element = UI.$(this);
	
	                    if (!element.data("scrollspynav")) {
	                        var obj = UI.scrollspynav(element, UI.Utils.options(element.attr("data-uk-scrollspy-nav")));
	                    }
	                });
	            });
	        },
	
	        init: function() {
	
	            var ids     = [],
	                links   = this.find("a[href^='#']").each(function(){ if(this.getAttribute("href").trim()!=='#') ids.push(this.getAttribute("href")); }),
	                targets = UI.$(ids.join(",")),
	
	                clsActive  = this.options.cls,
	                clsClosest = this.options.closest || this.options.closest;
	
	            var $this = this, inviews, fn = function(){
	
	                inviews = [];
	
	                for (var i=0 ; i < targets.length ; i++) {
	                    if (UI.Utils.isInView(targets.eq(i), $this.options)) {
	                        inviews.push(targets.eq(i));
	                    }
	                }
	
	                if (inviews.length) {
	
	                    var navitems,
	                        scrollTop = $win.scrollTop(),
	                        target = (function(){
	                            for(var i=0; i< inviews.length;i++){
	                                if(inviews[i].offset().top >= scrollTop){
	                                    return inviews[i];
	                                }
	                            }
	                        })();
	
	                    if (!target) return;
	
	                    if ($this.options.closest) {
	                        links.blur().closest(clsClosest).removeClass(clsActive);
	                        navitems = links.filter("a[href='#"+target.attr("id")+"']").closest(clsClosest).addClass(clsActive);
	                    } else {
	                        navitems = links.removeClass(clsActive).filter("a[href='#"+target.attr("id")+"']").addClass(clsActive);
	                    }
	
	                    $this.element.trigger("inview.uk.scrollspynav", [target, navitems]);
	                }
	            };
	
	            if (this.options.smoothscroll && UI.smoothScroll) {
	                links.each(function(){
	                    UI.smoothScroll(this, $this.options.smoothscroll);
	                });
	            }
	
	            fn();
	
	            this.element.data("scrollspynav", this);
	
	            this.check = fn;
	            scrollspynavs.push(this);
	
	        }
	    });
	
	})(UIkit);
	
	(function(UI){
	
	    "use strict";
	
	    var toggles = [];
	
	    UI.component('toggle', {
	
	        defaults: {
	            target    : false,
	            cls       : 'uk-hidden',
	            animation : false,
	            duration  : 200
	        },
	
	        boot: function(){
	
	            // init code
	            UI.ready(function(context) {
	
	                UI.$("[data-uk-toggle]", context).each(function() {
	                    var ele = UI.$(this);
	
	                    if (!ele.data("toggle")) {
	                        var obj = UI.toggle(ele, UI.Utils.options(ele.attr("data-uk-toggle")));
	                    }
	                });
	
	                setTimeout(function(){
	
	                    toggles.forEach(function(toggle){
	                        toggle.getToggles();
	                    });
	
	                }, 0);
	            });
	        },
	
	        init: function() {
	
	            var $this = this;
	
	            this.aria = (this.options.cls.indexOf('uk-hidden') !== -1);
	
	            this.getToggles();
	
	            this.on("click", function(e) {
	                if ($this.element.is('a[href="#"]')) e.preventDefault();
	                $this.toggle();
	            });
	
	            toggles.push(this);
	        },
	
	        toggle: function() {
	
	            if(!this.totoggle.length) return;
	
	            if (this.options.animation && UI.support.animation) {
	
	                var $this = this, animations = this.options.animation.split(',');
	
	                if (animations.length == 1) {
	                    animations[1] = animations[0];
	                }
	
	                animations[0] = animations[0].trim();
	                animations[1] = animations[1].trim();
	
	                this.totoggle.css('animation-duration', this.options.duration+'ms');
	
	                this.totoggle.each(function(){
	
	                    var ele = UI.$(this);
	
	                    if (ele.hasClass($this.options.cls)) {
	
	                        ele.toggleClass($this.options.cls);
	
	                        UI.Utils.animate(ele, animations[0]).then(function(){
	                            ele.css('animation-duration', '');
	                            UI.Utils.checkDisplay(ele);
	                        });
	
	                    } else {
	
	                        UI.Utils.animate(this, animations[1]+' uk-animation-reverse').then(function(){
	                            ele.toggleClass($this.options.cls).css('animation-duration', '');
	                            UI.Utils.checkDisplay(ele);
	                        });
	
	                    }
	
	                });
	
	            } else {
	                this.totoggle.toggleClass(this.options.cls);
	                UI.Utils.checkDisplay(this.totoggle);
	            }
	
	            this.updateAria();
	
	        },
	
	        getToggles: function() {
	            this.totoggle = this.options.target ? UI.$(this.options.target):[];
	            this.updateAria();
	        },
	
	        updateAria: function() {
	            if (this.aria && this.totoggle.length) {
	                this.totoggle.each(function(){
	                    UI.$(this).attr('aria-hidden', UI.$(this).hasClass('uk-hidden'));
	                });
	            }
	        }
	    });
	
	})(UIkit);
	
	(function(UI) {
	
	    "use strict";
	
	    UI.component('alert', {
	
	        defaults: {
	            "fade": true,
	            "duration": 200,
	            "trigger": ".uk-alert-close"
	        },
	
	        boot: function() {
	
	            // init code
	            UI.$html.on("click.alert.uikit", "[data-uk-alert]", function(e) {
	
	                var ele = UI.$(this);
	
	                if (!ele.data("alert")) {
	
	                    var alert = UI.alert(ele, UI.Utils.options(ele.attr("data-uk-alert")));
	
	                    if (UI.$(e.target).is(alert.options.trigger)) {
	                        e.preventDefault();
	                        alert.close();
	                    }
	                }
	            });
	        },
	
	        init: function() {
	
	            var $this = this;
	
	            this.on("click", this.options.trigger, function(e) {
	                e.preventDefault();
	                $this.close();
	            });
	        },
	
	        close: function() {
	
	            var element       = this.trigger("close.uk.alert"),
	                removeElement = function () {
	                    this.trigger("closed.uk.alert").remove();
	                }.bind(this);
	
	            if (this.options.fade) {
	                element.css("overflow", "hidden").css("max-height", element.height()).animate({
	                    "height"         : 0,
	                    "opacity"        : 0,
	                    "padding-top"    : 0,
	                    "padding-bottom" : 0,
	                    "margin-top"     : 0,
	                    "margin-bottom"  : 0
	                }, this.options.duration, removeElement);
	            } else {
	                removeElement();
	            }
	        }
	
	    });
	
	})(UIkit);
	
	(function(UI) {
	
	    "use strict";
	
	    UI.component('buttonRadio', {
	
	        defaults: {
	            "activeClass": 'uk-active',
	            "target": ".uk-button"
	        },
	
	        boot: function() {
	
	            // init code
	            UI.$html.on("click.buttonradio.uikit", "[data-uk-button-radio]", function(e) {
	
	                var ele = UI.$(this);
	
	                if (!ele.data("buttonRadio")) {
	
	                    var obj    = UI.buttonRadio(ele, UI.Utils.options(ele.attr("data-uk-button-radio"))),
	                        target = UI.$(e.target);
	
	                    if (target.is(obj.options.target)) {
	                        target.trigger("click");
	                    }
	                }
	            });
	        },
	
	        init: function() {
	
	            var $this = this;
	
	            // Init ARIA
	            this.find($this.options.target).attr('aria-checked', 'false').filter('.' + $this.options.activeClass).attr('aria-checked', 'true');
	
	            this.on("click", this.options.target, function(e) {
	
	                var ele = UI.$(this);
	
	                if (ele.is('a[href="#"]')) e.preventDefault();
	
	                $this.find($this.options.target).not(ele).removeClass($this.options.activeClass).blur();
	                ele.addClass($this.options.activeClass);
	
	                // Update ARIA
	                $this.find($this.options.target).not(ele).attr('aria-checked', 'false');
	                ele.attr('aria-checked', 'true');
	
	                $this.trigger("change.uk.button", [ele]);
	            });
	
	        },
	
	        getSelected: function() {
	            return this.find('.' + this.options.activeClass);
	        }
	    });
	
	    UI.component('buttonCheckbox', {
	
	        defaults: {
	            "activeClass": 'uk-active',
	            "target": ".uk-button"
	        },
	
	        boot: function() {
	
	            UI.$html.on("click.buttoncheckbox.uikit", "[data-uk-button-checkbox]", function(e) {
	                var ele = UI.$(this);
	
	                if (!ele.data("buttonCheckbox")) {
	
	                    var obj    = UI.buttonCheckbox(ele, UI.Utils.options(ele.attr("data-uk-button-checkbox"))),
	                        target = UI.$(e.target);
	
	                    if (target.is(obj.options.target)) {
	                        target.trigger("click");
	                    }
	                }
	            });
	        },
	
	        init: function() {
	
	            var $this = this;
	
	            // Init ARIA
	            this.find($this.options.target).attr('aria-checked', 'false').filter('.' + $this.options.activeClass).attr('aria-checked', 'true');
	
	            this.on("click", this.options.target, function(e) {
	                var ele = UI.$(this);
	
	                if (ele.is('a[href="#"]')) e.preventDefault();
	
	                ele.toggleClass($this.options.activeClass).blur();
	
	                // Update ARIA
	                ele.attr('aria-checked', ele.hasClass($this.options.activeClass));
	
	                $this.trigger("change.uk.button", [ele]);
	            });
	
	        },
	
	        getSelected: function() {
	            return this.find('.' + this.options.activeClass);
	        }
	    });
	
	
	    UI.component('button', {
	
	        defaults: {},
	
	        boot: function() {
	
	            UI.$html.on("click.button.uikit", "[data-uk-button]", function(e) {
	                var ele = UI.$(this);
	
	                if (!ele.data("button")) {
	
	                    var obj = UI.button(ele, UI.Utils.options(ele.attr("data-uk-button")));
	                    ele.trigger("click");
	                }
	            });
	        },
	
	        init: function() {
	
	            var $this = this;
	
	            // Init ARIA
	            this.element.attr('aria-pressed', this.element.hasClass("uk-active"));
	
	            this.on("click", function(e) {
	
	                if ($this.element.is('a[href="#"]')) e.preventDefault();
	
	                $this.toggle();
	                $this.trigger("change.uk.button", [$this.element.blur().hasClass("uk-active")]);
	            });
	
	        },
	
	        toggle: function() {
	            this.element.toggleClass("uk-active");
	
	            // Update ARIA
	            this.element.attr('aria-pressed', this.element.hasClass("uk-active"));
	        }
	    });
	
	})(UIkit);
	
	
	(function(UI) {
	
	    "use strict";
	
	    var active = false, hoverIdle, flips = {
	        'x': {
	            "bottom-left"   : 'bottom-right',
	            "bottom-right"  : 'bottom-left',
	            "bottom-center" : 'bottom-center',
	            "top-left"      : 'top-right',
	            "top-right"     : 'top-left',
	            "top-center"    : 'top-center',
	            "left-top"      : 'right-top',
	            "left-bottom"   : 'right-bottom',
	            "left-center"   : 'right-center',
	            "right-top"     : 'left-top',
	            "right-bottom"  : 'left-bottom',
	            "right-center"  : 'left-center'
	        },
	        'y': {
	            "bottom-left"   : 'top-left',
	            "bottom-right"  : 'top-right',
	            "bottom-center" : 'top-center',
	            "top-left"      : 'bottom-left',
	            "top-right"     : 'bottom-right',
	            "top-center"    : 'bottom-center',
	            "left-top"      : 'left-bottom',
	            "left-bottom"   : 'left-top',
	            "left-center"   : 'left-center',
	            "right-top"     : 'right-bottom',
	            "right-bottom"  : 'right-top',
	            "right-center"  : 'right-center'
	        },
	        'xy': {
	            "bottom-left"   : 'top-right',
	            "bottom-right"  : 'top-left',
	            "bottom-center" : 'top-center',
	            "top-left"      : 'bottom-right',
	            "top-right"     : 'bottom-left',
	            "top-center"    : 'bottom-center',
	            "left-top"      : 'right-bottom',
	            "left-bottom"   : 'right-top',
	            "left-center"   : 'right-center',
	            "right-top"     : 'left-bottom',
	            "right-bottom"  : 'left-top',
	            "right-center"  : 'left-center'
	        }
	    };
	
	    UI.component('dropdown', {
	
	        defaults: {
	           'mode'            : 'hover',
	           'pos'             : 'bottom-left',
	           'offset'          : 0,
	           'remaintime'      : 800,
	           'justify'         : false,
	           'boundary'        : UI.$win,
	           'delay'           : 0,
	           'dropdownSelector': '.uk-dropdown,.uk-dropdown-blank',
	           'hoverDelayIdle'  : 250,
	           'preventflip'     : false
	        },
	
	        remainIdle: false,
	
	        boot: function() {
	
	            var triggerevent = UI.support.touch ? "click" : "mouseenter";
	
	            // init code
	            UI.$html.on(triggerevent+".dropdown.uikit", "[data-uk-dropdown]", function(e) {
	
	                var ele = UI.$(this);
	
	                if (!ele.data("dropdown")) {
	
	                    var dropdown = UI.dropdown(ele, UI.Utils.options(ele.attr("data-uk-dropdown")));
	
	                    if (triggerevent=="click" || (triggerevent=="mouseenter" && dropdown.options.mode=="hover")) {
	                        dropdown.element.trigger(triggerevent);
	                    }
	
	                    if (dropdown.element.find(dropdown.options.dropdownSelector).length) {
	                        e.preventDefault();
	                    }
	                }
	            });
	        },
	
	        init: function() {
	
	            var $this = this;
	
	            this.dropdown     = this.find(this.options.dropdownSelector);
	            this.offsetParent = this.dropdown.parents().filter(function() {
	                return UI.$.inArray(UI.$(this).css('position'), ['relative', 'fixed', 'absolute']) !== -1;
	            }).slice(0,1);
	
	            this.centered  = this.dropdown.hasClass('uk-dropdown-center');
	            this.justified = this.options.justify ? UI.$(this.options.justify) : false;
	
	            this.boundary  = UI.$(this.options.boundary);
	
	            if (!this.boundary.length) {
	                this.boundary = UI.$win;
	            }
	
	            // legacy DEPRECATED!
	            if (this.dropdown.hasClass('uk-dropdown-up')) {
	                this.options.pos = 'top-left';
	            }
	            if (this.dropdown.hasClass('uk-dropdown-flip')) {
	                this.options.pos = this.options.pos.replace('left','right');
	            }
	            if (this.dropdown.hasClass('uk-dropdown-center')) {
	                this.options.pos = this.options.pos.replace(/(left|right)/,'center');
	            }
	            //-- end legacy
	
	            // Init ARIA
	            this.element.attr('aria-haspopup', 'true');
	            this.element.attr('aria-expanded', this.element.hasClass("uk-open"));
	
	            if (this.options.mode == "click" || UI.support.touch) {
	
	                this.on("click.uk.dropdown", function(e) {
	
	                    var $target = UI.$(e.target);
	
	                    if (!$target.parents($this.options.dropdownSelector).length) {
	
	                        if ($target.is("a[href='#']") || $target.parent().is("a[href='#']") || ($this.dropdown.length && !$this.dropdown.is(":visible")) ){
	                            e.preventDefault();
	                        }
	
	                        $target.blur();
	                    }
	
	                    if (!$this.element.hasClass('uk-open')) {
	
	                        $this.show();
	
	                    } else {
	
	                        if (!$this.dropdown.find(e.target).length || $target.is(".uk-dropdown-close") || $target.parents(".uk-dropdown-close").length) {
	                            $this.hide();
	                        }
	                    }
	                });
	
	            } else {
	
	                this.on("mouseenter", function(e) {
	
	                    $this.trigger('pointerenter.uk.dropdown', [$this]);
	
	                    if ($this.remainIdle) {
	                        clearTimeout($this.remainIdle);
	                    }
	
	                    if (hoverIdle) {
	                        clearTimeout(hoverIdle);
	                    }
	
	                    if (active && active == $this) {
	                        return;
	                    }
	
	                    // pseudo manuAim
	                    if (active && active != $this) {
	
	                        hoverIdle = setTimeout(function() {
	                            hoverIdle = setTimeout($this.show.bind($this), $this.options.delay);
	                        }, $this.options.hoverDelayIdle);
	
	                    } else {
	
	                        hoverIdle = setTimeout($this.show.bind($this), $this.options.delay);
	                    }
	
	                }).on("mouseleave", function() {
	
	                    if (hoverIdle) {
	                        clearTimeout(hoverIdle);
	                    }
	
	                    $this.remainIdle = setTimeout(function() {
	                        if (active && active == $this) $this.hide();
	                    }, $this.options.remaintime);
	
	                    $this.trigger('pointerleave.uk.dropdown', [$this]);
	
	                }).on("click", function(e){
	
	                    var $target = UI.$(e.target);
	
	                    if ($this.remainIdle) {
	                        clearTimeout($this.remainIdle);
	                    }
	
	                    if (active && active == $this) {
	                        if (!$this.dropdown.find(e.target).length || $target.is(".uk-dropdown-close") || $target.parents(".uk-dropdown-close").length) {
	                            $this.hide();
	                        }
	                        return;
	                    }
	
	                    if ($target.is("a[href='#']") || $target.parent().is("a[href='#']")){
	                        e.preventDefault();
	                    }
	
	                    $this.show();
	                });
	            }
	        },
	
	        show: function(){
	
	            UI.$html.off("click.outer.dropdown");
	
	            if (active && active != this) {
	                active.hide(true);
	            }
	
	            if (hoverIdle) {
	                clearTimeout(hoverIdle);
	            }
	
	            this.trigger('beforeshow.uk.dropdown', [this]);
	
	            this.checkDimensions();
	            this.element.addClass('uk-open');
	
	            // Update ARIA
	            this.element.attr('aria-expanded', 'true');
	
	            this.trigger('show.uk.dropdown', [this]);
	
	            UI.Utils.checkDisplay(this.dropdown, true);
	            active = this;
	
	            this.registerOuterClick();
	        },
	
	        hide: function(force) {
	
	            this.trigger('beforehide.uk.dropdown', [this, force]);
	
	            this.element.removeClass('uk-open');
	
	            if (this.remainIdle) {
	                clearTimeout(this.remainIdle);
	            }
	
	            this.remainIdle = false;
	
	            // Update ARIA
	            this.element.attr('aria-expanded', 'false');
	
	            this.trigger('hide.uk.dropdown', [this, force]);
	
	            if (active == this) active = false;
	        },
	
	        registerOuterClick: function(){
	
	            var $this = this;
	
	            UI.$html.off("click.outer.dropdown");
	
	            setTimeout(function() {
	
	                UI.$html.on("click.outer.dropdown", function(e) {
	
	                    if (hoverIdle) {
	                        clearTimeout(hoverIdle);
	                    }
	
	                    var $target = UI.$(e.target);
	
	                    if (active == $this && !$this.element.find(e.target).length) {
	                        $this.hide(true);
	                        UI.$html.off("click.outer.dropdown");
	                    }
	                });
	            }, 10);
	        },
	
	        checkDimensions: function() {
	
	            if (!this.dropdown.length) return;
	
	            // reset
	            this.dropdown.removeClass('uk-dropdown-top uk-dropdown-bottom uk-dropdown-left uk-dropdown-right uk-dropdown-stack').css({
	                'top-left':'',
	                'left':'',
	                'margin-left' :'',
	                'margin-right':''
	            });
	
	            if (this.justified && this.justified.length) {
	                this.dropdown.css("min-width", "");
	            }
	
	            var $this          = this,
	                pos            = UI.$.extend({}, this.offsetParent.offset(), {width: this.offsetParent[0].offsetWidth, height: this.offsetParent[0].offsetHeight}),
	                posoffset      = this.options.offset,
	                dropdown       = this.dropdown,
	                offset         = dropdown.show().offset() || {left: 0, top: 0},
	                width          = dropdown.outerWidth(),
	                height         = dropdown.outerHeight(),
	                boundarywidth  = this.boundary.width(),
	                boundaryoffset = this.boundary[0] !== window && this.boundary.offset() ? this.boundary.offset(): {top:0, left:0},
	                dpos           = this.options.pos;
	
	            var variants =  {
	                    "bottom-left"   : {top: 0 + pos.height + posoffset, left: 0},
	                    "bottom-right"  : {top: 0 + pos.height + posoffset, left: 0 + pos.width - width},
	                    "bottom-center" : {top: 0 + pos.height + posoffset, left: 0 + pos.width / 2 - width / 2},
	                    "top-left"      : {top: 0 - height - posoffset, left: 0},
	                    "top-right"     : {top: 0 - height - posoffset, left: 0 + pos.width - width},
	                    "top-center"    : {top: 0 - height - posoffset, left: 0 + pos.width / 2 - width / 2},
	                    "left-top"      : {top: 0, left: 0 - width - posoffset},
	                    "left-bottom"   : {top: 0 + pos.height - height, left: 0 - width - posoffset},
	                    "left-center"   : {top: 0 + pos.height / 2 - height / 2, left: 0 - width - posoffset},
	                    "right-top"     : {top: 0, left: 0 + pos.width + posoffset},
	                    "right-bottom"  : {top: 0 + pos.height - height, left: 0 + pos.width + posoffset},
	                    "right-center"  : {top: 0 + pos.height / 2 - height / 2, left: 0 + pos.width + posoffset}
	                },
	                css = {},
	                pp;
	
	            pp = dpos.split('-');
	            css = variants[dpos] ? variants[dpos] : variants['bottom-left'];
	
	            // justify dropdown
	            if (this.justified && this.justified.length) {
	                justify(dropdown.css({left:0}), this.justified, boundarywidth);
	            } else {
	
	                if (this.options.preventflip !== true) {
	
	                    var fdpos;
	
	                    switch(this.checkBoundary(pos.left + css.left, pos.top + css.top, width, height, boundarywidth)) {
	                        case "x":
	                            if(this.options.preventflip !=='x') fdpos = flips['x'][dpos] || 'right-top';
	                            break;
	                        case "y":
	                            if(this.options.preventflip !=='y') fdpos = flips['y'][dpos] || 'top-left';
	                            break;
	                        case "xy":
	                            if(!this.options.preventflip) fdpos = flips['xy'][dpos] || 'right-bottom';
	                            break;
	                    }
	
	                    if (fdpos) {
	
	                        pp  = fdpos.split('-');
	                        css = variants[fdpos] ? variants[fdpos] : variants['bottom-left'];
	
	                        // check flipped
	                        if (this.checkBoundary(pos.left + css.left, pos.top + css.top, width, height, boundarywidth)) {
	                            pp  = dpos.split('-');
	                            css = variants[dpos] ? variants[dpos] : variants['bottom-left'];
	                        }
	                    }
	                }
	            }
	
	            if (width > boundarywidth) {
	                dropdown.addClass("uk-dropdown-stack");
	                this.trigger('stack.uk.dropdown', [this]);
	            }
	
	            dropdown.css(css).css("display", "").addClass('uk-dropdown-'+pp[0]);
	        },
	
	        checkBoundary: function(left, top, width, height, boundarywidth) {
	
	            var axis = "";
	
	            if (left < 0 || ((left - UI.$win.scrollLeft())+width) > boundarywidth) {
	               axis += "x";
	            }
	
	            if ((top - UI.$win.scrollTop()) < 0 || ((top - UI.$win.scrollTop())+height) > window.innerHeight) {
	               axis += "y";
	            }
	
	            return axis;
	        }
	    });
	
	
	    UI.component('dropdownOverlay', {
	
	        defaults: {
	           'justify' : false,
	           'cls'     : '',
	           'duration': 200
	        },
	
	        boot: function() {
	
	            // init code
	            UI.ready(function(context) {
	
	                UI.$("[data-uk-dropdown-overlay]", context).each(function() {
	                    var ele = UI.$(this);
	
	                    if (!ele.data("dropdownOverlay")) {
	                        UI.dropdownOverlay(ele, UI.Utils.options(ele.attr("data-uk-dropdown-overlay")));
	                    }
	                });
	            });
	        },
	
	        init: function() {
	
	            var $this = this;
	
	            this.justified = this.options.justify ? UI.$(this.options.justify) : false;
	            this.overlay   = this.element.find('uk-dropdown-overlay');
	
	            if (!this.overlay.length) {
	                this.overlay = UI.$('<div class="uk-dropdown-overlay"></div>').appendTo(this.element);
	            }
	
	            this.overlay.addClass(this.options.cls);
	
	            this.on({
	
	                'beforeshow.uk.dropdown': function(e, dropdown) {
	                    $this.dropdown = dropdown;
	
	                    if ($this.justified && $this.justified.length) {
	                        justify($this.overlay.css({'display':'block', 'margin-left':'','margin-right':''}), $this.justified, $this.justified.outerWidth());
	                    }
	                },
	
	                'show.uk.dropdown': function(e, dropdown) {
	
	                    var h = $this.dropdown.dropdown.outerHeight(true);
	
	                    $this.dropdown.element.removeClass('uk-open');
	
	                    $this.overlay.stop().css('display', 'block').animate({height: h}, $this.options.duration, function() {
	
	                       $this.dropdown.dropdown.css('visibility', '');
	                       $this.dropdown.element.addClass('uk-open');
	
	                       UI.Utils.checkDisplay($this.dropdown.dropdown, true);
	                    });
	
	                    $this.pointerleave = false;
	                },
	
	                'hide.uk.dropdown': function() {
	                    $this.overlay.stop().animate({height: 0}, $this.options.duration);
	                },
	
	                'pointerenter.uk.dropdown': function(e, dropdown) {
	                    clearTimeout($this.remainIdle);
	                },
	
	                'pointerleave.uk.dropdown': function(e, dropdown) {
	                    $this.pointerleave = true;
	                }
	            });
	
	
	            this.overlay.on({
	
	                'mouseenter': function() {
	                    if ($this.remainIdle) {
	                        clearTimeout($this.dropdown.remainIdle);
	                        clearTimeout($this.remainIdle);
	                    }
	                },
	
	                'mouseleave': function(){
	
	                    if ($this.pointerleave && active) {
	
	                        $this.remainIdle = setTimeout(function() {
	                           if(active) active.hide();
	                        }, active.options.remaintime);
	                    }
	                }
	            })
	        }
	
	    });
	
	
	    function justify(ele, justifyTo, boundarywidth, offset) {
	
	        ele           = UI.$(ele);
	        justifyTo     = UI.$(justifyTo);
	        boundarywidth = boundarywidth || window.innerWidth;
	        offset        = offset || ele.offset();
	
	        if (justifyTo.length) {
	
	            var jwidth = justifyTo.outerWidth();
	
	            ele.css("min-width", jwidth);
	
	            if (UI.langdirection == 'right') {
	
	                var right1   = boundarywidth - (justifyTo.offset().left + jwidth),
	                    right2   = boundarywidth - (ele.offset().left + ele.outerWidth());
	
	                ele.css("margin-right", right1 - right2);
	
	            } else {
	                ele.css("margin-left", justifyTo.offset().left - offset.left);
	            }
	        }
	    }
	
	})(UIkit);
	
	(function(UI) {
	
	    "use strict";
	
	    var grids = [];
	
	    UI.component('gridMatchHeight', {
	
	        defaults: {
	            "target"        : false,
	            "row"           : true,
	            "ignorestacked" : false,
	            "observe"       : false
	        },
	
	        boot: function() {
	
	            // init code
	            UI.ready(function(context) {
	
	                UI.$("[data-uk-grid-match]", context).each(function() {
	                    var grid = UI.$(this), obj;
	
	                    if (!grid.data("gridMatchHeight")) {
	                        obj = UI.gridMatchHeight(grid, UI.Utils.options(grid.attr("data-uk-grid-match")));
	                    }
	                });
	            });
	        },
	
	        init: function() {
	
	            var $this = this;
	
	            this.columns  = this.element.children();
	            this.elements = this.options.target ? this.find(this.options.target) : this.columns;
	
	            if (!this.columns.length) return;
	
	            UI.$win.on('load resize orientationchange', (function() {
	
	                var fn = function() {
	                    if ($this.element.is(":visible")) $this.match();
	                };
	
	                UI.$(function() { fn(); });
	
	                return UI.Utils.debounce(fn, 50);
	            })());
	
	            if (this.options.observe) {
	
	                UI.domObserve(this.element, function(e) {
	                    if ($this.element.is(":visible")) $this.match();
	                });
	            }
	
	            this.on("display.uk.check", function(e) {
	                if(this.element.is(":visible")) this.match();
	            }.bind(this));
	
	            grids.push(this);
	        },
	
	        match: function() {
	
	            var firstvisible = this.columns.filter(":visible:first");
	
	            if (!firstvisible.length) return;
	
	            var stacked = Math.ceil(100 * parseFloat(firstvisible.css('width')) / parseFloat(firstvisible.parent().css('width'))) >= 100;
	
	            if (stacked && !this.options.ignorestacked) {
	                this.revert();
	            } else {
	                UI.Utils.matchHeights(this.elements, this.options);
	            }
	
	            return this;
	        },
	
	        revert: function() {
	            this.elements.css('min-height', '');
	            return this;
	        }
	    });
	
	    UI.component('gridMargin', {
	
	        defaults: {
	            cls      : 'uk-grid-margin',
	            rowfirst : 'uk-row-first'
	        },
	
	        boot: function() {
	
	            // init code
	            UI.ready(function(context) {
	
	                UI.$("[data-uk-grid-margin]", context).each(function() {
	                    var grid = UI.$(this), obj;
	
	                    if (!grid.data("gridMargin")) {
	                        obj = UI.gridMargin(grid, UI.Utils.options(grid.attr("data-uk-grid-margin")));
	                    }
	                });
	            });
	        },
	
	        init: function() {
	
	            var stackMargin = UI.stackMargin(this.element, this.options);
	        }
	    });
	
	})(UIkit);
	
	(function(UI) {
	
	    "use strict";
	
	    var active = false, activeCount = 0, $html = UI.$html, body;
	
	    UI.$win.on("resize orientationchange", UI.Utils.debounce(function(){
	        UI.$('.uk-modal.uk-open').each(function(){
	            UI.$(this).data('modal').resize();
	        });
	    }, 150));
	
	    UI.component('modal', {
	
	        defaults: {
	            keyboard: true,
	            bgclose: true,
	            minScrollHeight: 150,
	            center: false,
	            modal: true
	        },
	
	        scrollable: false,
	        transition: false,
	        hasTransitioned: true,
	
	        init: function() {
	
	            if (!body) body = UI.$('body');
	
	            if (!this.element.length) return;
	
	            var $this = this;
	
	            this.paddingdir = "padding-" + (UI.langdirection == 'left' ? "right":"left");
	            this.dialog     = this.find(".uk-modal-dialog");
	
	            this.active     = false;
	
	            // Update ARIA
	            this.element.attr('aria-hidden', this.element.hasClass("uk-open"));
	
	            this.on("click", ".uk-modal-close", function(e) {
	                e.preventDefault();
	                $this.hide();
	            }).on("click", function(e) {
	
	                var target = UI.$(e.target);
	
	                if (target[0] == $this.element[0] && $this.options.bgclose) {
	                    $this.hide();
	                }
	            });
	
	            UI.domObserve(this.element, function(e) { $this.resize(); });
	        },
	
	        toggle: function() {
	            return this[this.isActive() ? "hide" : "show"]();
	        },
	
	        show: function() {
	
	            if (!this.element.length) return;
	
	            var $this = this;
	
	            if (this.isActive()) return;
	
	            if (this.options.modal && active) {
	                active.hide(true);
	            }
	
	            this.element.removeClass("uk-open").show();
	            this.resize(true);
	
	            if (this.options.modal) {
	                active = this;
	            }
	
	            this.active = true;
	
	            activeCount++;
	
	            if (UI.support.transition) {
	                this.hasTransitioned = false;
	                this.element.one(UI.support.transition.end, function(){
	                    $this.hasTransitioned = true;
	                }).addClass("uk-open");
	            } else {
	                this.element.addClass("uk-open");
	            }
	
	            $html.addClass("uk-modal-page").height(); // force browser engine redraw
	
	            // Update ARIA
	            this.element.attr('aria-hidden', 'false');
	
	            this.element.trigger("show.uk.modal");
	
	            UI.Utils.checkDisplay(this.dialog, true);
	
	            return this;
	        },
	
	        hide: function(force) {
	
	            if (!force && UI.support.transition && this.hasTransitioned) {
	
	                var $this = this;
	
	                this.one(UI.support.transition.end, function() {
	                    $this._hide();
	                }).removeClass("uk-open");
	
	            } else {
	
	                this._hide();
	            }
	
	            return this;
	        },
	
	        resize: function(force) {
	
	            if (!this.isActive() && !force) return;
	
	            var bodywidth  = body.width();
	
	            this.scrollbarwidth = window.innerWidth - bodywidth;
	
	            body.css(this.paddingdir, this.scrollbarwidth);
	
	            this.element.css('overflow-y', this.scrollbarwidth ? 'scroll' : 'auto');
	
	            if (!this.updateScrollable() && this.options.center) {
	
	                var dh  = this.dialog.outerHeight(),
	                pad = parseInt(this.dialog.css('margin-top'), 10) + parseInt(this.dialog.css('margin-bottom'), 10);
	
	                if ((dh + pad) < window.innerHeight) {
	                    this.dialog.css({'top': (window.innerHeight/2 - dh/2) - pad });
	                } else {
	                    this.dialog.css({'top': ''});
	                }
	            }
	        },
	
	        updateScrollable: function() {
	
	            // has scrollable?
	            var scrollable = this.dialog.find('.uk-overflow-container:visible:first');
	
	            if (scrollable.length) {
	
	                scrollable.css('height', 0);
	
	                var offset = Math.abs(parseInt(this.dialog.css('margin-top'), 10)),
	                dh     = this.dialog.outerHeight(),
	                wh     = window.innerHeight,
	                h      = wh - 2*(offset < 20 ? 20:offset) - dh;
	
	                scrollable.css({
	                    'max-height': (h < this.options.minScrollHeight ? '':h),
	                    'height':''
	                });
	
	                return true;
	            }
	
	            return false;
	        },
	
	        _hide: function() {
	
	            this.active = false;
	            if (activeCount > 0) activeCount--;
	            else activeCount = 0;
	
	            this.element.hide().removeClass('uk-open');
	
	            // Update ARIA
	            this.element.attr('aria-hidden', 'true');
	
	            if (!activeCount) {
	                $html.removeClass('uk-modal-page');
	                body.css(this.paddingdir, "");
	            }
	
	            if (active===this) active = false;
	
	            this.trigger('hide.uk.modal');
	        },
	
	        isActive: function() {
	            return this.element.hasClass('uk-open');
	        }
	
	    });
	
	    UI.component('modalTrigger', {
	
	        boot: function() {
	
	            // init code
	            UI.$html.on("click.modal.uikit", "[data-uk-modal]", function(e) {
	
	                var ele = UI.$(this);
	
	                if (ele.is("a")) {
	                    e.preventDefault();
	                }
	
	                if (!ele.data("modalTrigger")) {
	                    var modal = UI.modalTrigger(ele, UI.Utils.options(ele.attr("data-uk-modal")));
	                    modal.show();
	                }
	
	            });
	
	            // close modal on esc button
	            UI.$html.on('keydown.modal.uikit', function (e) {
	
	                if (active && e.keyCode === 27 && active.options.keyboard) { // ESC
	                    e.preventDefault();
	                    active.hide();
	                }
	            });
	        },
	
	        init: function() {
	
	            var $this = this;
	
	            this.options = UI.$.extend({
	                "target": $this.element.is("a") ? $this.element.attr("href") : false
	            }, this.options);
	
	            this.modal = UI.modal(this.options.target, this.options);
	
	            this.on("click", function(e) {
	                e.preventDefault();
	                $this.show();
	            });
	
	            //methods
	            this.proxy(this.modal, "show hide isActive");
	        }
	    });
	
	    UI.modal.dialog = function(content, options) {
	
	        var modal = UI.modal(UI.$(UI.modal.dialog.template).appendTo("body"), options);
	
	        modal.on("hide.uk.modal", function(){
	            if (modal.persist) {
	                modal.persist.appendTo(modal.persist.data("modalPersistParent"));
	                modal.persist = false;
	            }
	            modal.element.remove();
	        });
	
	        setContent(content, modal);
	
	        return modal;
	    };
	
	    UI.modal.dialog.template = '<div class="uk-modal"><div class="uk-modal-dialog" style="min-height:0;"></div></div>';
	
	    UI.modal.alert = function(content, options) {
	
	        options = UI.$.extend(true, {bgclose:false, keyboard:false, modal:false, labels:UI.modal.labels}, options);
	
	        var modal = UI.modal.dialog(([
	            '<div class="uk-margin uk-modal-content">'+String(content)+'</div>',
	            '<div class="uk-modal-footer uk-text-right"><button class="uk-button uk-button-primary uk-modal-close">'+options.labels.Ok+'</button></div>'
	        ]).join(""), options);
	
	        modal.on('show.uk.modal', function(){
	            setTimeout(function(){
	                modal.element.find('button:first').focus();
	            }, 50);
	        });
	
	        return modal.show();
	    };
	
	    UI.modal.confirm = function(content, onconfirm, oncancel) {
	
	        var options = arguments.length > 1 && arguments[arguments.length-1] ? arguments[arguments.length-1] : {};
	
	        onconfirm = UI.$.isFunction(onconfirm) ? onconfirm : function(){};
	        oncancel  = UI.$.isFunction(oncancel) ? oncancel : function(){};
	        options   = UI.$.extend(true, {bgclose:false, keyboard:false, modal:false, labels:UI.modal.labels}, UI.$.isFunction(options) ? {}:options);
	
	        var modal = UI.modal.dialog(([
	            '<div class="uk-margin uk-modal-content">'+String(content)+'</div>',
	            '<div class="uk-modal-footer uk-text-right"><button class="uk-button js-modal-confirm-cancel">'+options.labels.Cancel+'</button> <button class="uk-button uk-button-primary js-modal-confirm">'+options.labels.Ok+'</button></div>'
	        ]).join(""), options);
	
	        modal.element.find(".js-modal-confirm, .js-modal-confirm-cancel").on("click", function(){
	            UI.$(this).is('.js-modal-confirm') ? onconfirm() : oncancel();
	            modal.hide();
	        });
	
	        modal.on('show.uk.modal', function(){
	            setTimeout(function(){
	                modal.element.find('.js-modal-confirm').focus();
	            }, 50);
	        });
	
	        return modal.show();
	    };
	
	    UI.modal.prompt = function(text, value, onsubmit, options) {
	
	        onsubmit = UI.$.isFunction(onsubmit) ? onsubmit : function(value){};
	        options  = UI.$.extend(true, {bgclose:false, keyboard:false, modal:false, labels:UI.modal.labels}, options);
	
	        var modal = UI.modal.dialog(([
	            text ? '<div class="uk-modal-content uk-form">'+String(text)+'</div>':'',
	            '<div class="uk-margin-small-top uk-modal-content uk-form"><p><input type="text" class="uk-width-1-1"></p></div>',
	            '<div class="uk-modal-footer uk-text-right"><button class="uk-button uk-modal-close">'+options.labels.Cancel+'</button> <button class="uk-button uk-button-primary js-modal-ok">'+options.labels.Ok+'</button></div>'
	        ]).join(""), options),
	
	        input = modal.element.find("input[type='text']").val(value || '').on('keyup', function(e){
	            if (e.keyCode == 13) {
	                modal.element.find(".js-modal-ok").trigger('click');
	            }
	        });
	
	        modal.element.find(".js-modal-ok").on("click", function(){
	            if (onsubmit(input.val())!==false){
	                modal.hide();
	            }
	        });
	
	        modal.on('show.uk.modal', function(){
	            setTimeout(function(){
	                input.focus();
	            }, 50);
	        });
	
	        return modal.show();
	    };
	
	    UI.modal.blockUI = function(content, options) {
	
	        var modal = UI.modal.dialog(([
	            '<div class="uk-margin uk-modal-content">'+String(content || '<div class="uk-text-center">...</div>')+'</div>'
	        ]).join(""), UI.$.extend({bgclose:false, keyboard:false, modal:false}, options));
	
	        modal.content = modal.element.find('.uk-modal-content:first');
	
	        return modal.show();
	    };
	
	
	    UI.modal.labels = {
	        'Ok': 'Ok',
	        'Cancel': 'Cancel'
	    };
	
	
	    // helper functions
	    function setContent(content, modal){
	
	        if(!modal) return;
	
	        if (typeof content === 'object') {
	
	            // convert DOM object to a jQuery object
	            content = content instanceof jQuery ? content : UI.$(content);
	
	            if(content.parent().length) {
	                modal.persist = content;
	                modal.persist.data("modalPersistParent", content.parent());
	            }
	        }else if (typeof content === 'string' || typeof content === 'number') {
	                // just insert the data as innerHTML
	                content = UI.$('<div></div>').html(content);
	        }else {
	                // unsupported data type!
	                content = UI.$('<div></div>').html('UIkit.modal Error: Unsupported data type: ' + typeof content);
	        }
	
	        content.appendTo(modal.element.find('.uk-modal-dialog'));
	
	        return modal;
	    }
	
	})(UIkit);
	
	(function(UI) {
	
	    "use strict";
	
	    UI.component('nav', {
	
	        defaults: {
	            "toggle": ">li.uk-parent > a[href='#']",
	            "lists": ">li.uk-parent > ul",
	            "multiple": false
	        },
	
	        boot: function() {
	
	            // init code
	            UI.ready(function(context) {
	
	                UI.$("[data-uk-nav]", context).each(function() {
	                    var nav = UI.$(this);
	
	                    if (!nav.data("nav")) {
	                        var obj = UI.nav(nav, UI.Utils.options(nav.attr("data-uk-nav")));
	                    }
	                });
	            });
	        },
	
	        init: function() {
	
	            var $this = this;
	
	            this.on("click.uk.nav", this.options.toggle, function(e) {
	                e.preventDefault();
	                var ele = UI.$(this);
	                $this.open(ele.parent()[0] == $this.element[0] ? ele : ele.parent("li"));
	            });
	
	            this.find(this.options.lists).each(function() {
	                var $ele   = UI.$(this),
	                    parent = $ele.parent(),
	                    active = parent.hasClass("uk-active");
	
	                $ele.wrap('<div style="overflow:hidden;height:0;position:relative;"></div>');
	                parent.data("list-container", $ele.parent()[active ? 'removeClass':'addClass']('uk-hidden'));
	
	                // Init ARIA
	                parent.attr('aria-expanded', parent.hasClass("uk-open"));
	
	                if (active) $this.open(parent, true);
	            });
	
	        },
	
	        open: function(li, noanimation) {
	
	            var $this = this, element = this.element, $li = UI.$(li), $container = $li.data('list-container');
	
	            if (!this.options.multiple) {
	
	                element.children('.uk-open').not(li).each(function() {
	
	                    var ele = UI.$(this);
	
	                    if (ele.data('list-container')) {
	                        ele.data('list-container').stop().animate({height: 0}, function() {
	                            UI.$(this).parent().removeClass('uk-open').end().addClass('uk-hidden');
	                        });
	                    }
	                });
	            }
	
	            $li.toggleClass('uk-open');
	
	            // Update ARIA
	            $li.attr('aria-expanded', $li.hasClass('uk-open'));
	
	            if ($container) {
	
	                if ($li.hasClass('uk-open')) {
	                    $container.removeClass('uk-hidden');
	                }
	
	                if (noanimation) {
	
	                    $container.stop().height($li.hasClass('uk-open') ? 'auto' : 0);
	
	                    if (!$li.hasClass('uk-open')) {
	                        $container.addClass('uk-hidden');
	                    }
	
	                    this.trigger('display.uk.check');
	
	                } else {
	
	                    $container.stop().animate({
	                        height: ($li.hasClass('uk-open') ? getHeight($container.find('ul:first')) : 0)
	                    }, function() {
	
	                        if (!$li.hasClass('uk-open')) {
	                            $container.addClass('uk-hidden');
	                        } else {
	                            $container.css('height', '');
	                        }
	
	                        $this.trigger('display.uk.check');
	                    });
	                }
	            }
	        }
	    });
	
	
	    // helper
	
	    function getHeight(ele) {
	        var $ele = UI.$(ele), height = "auto";
	
	        if ($ele.is(":visible")) {
	            height = $ele.outerHeight();
	        } else {
	            var tmp = {
	                position: $ele.css("position"),
	                visibility: $ele.css("visibility"),
	                display: $ele.css("display")
	            };
	
	            height = $ele.css({position: 'absolute', visibility: 'hidden', display: 'block'}).outerHeight();
	
	            $ele.css(tmp); // reset element
	        }
	
	        return height;
	    }
	
	})(UIkit);
	
	(function(UI) {
	
	    "use strict";
	
	    var scrollpos = {x: window.scrollX, y: window.scrollY},
	        $win      = UI.$win,
	        $doc      = UI.$doc,
	        $html     = UI.$html,
	        Offcanvas = {
	
	        show: function(element) {
	
	            element = UI.$(element);
	
	            if (!element.length) return;
	
	            var $body     = UI.$('body'),
	                bar       = element.find(".uk-offcanvas-bar:first"),
	                rtl       = (UI.langdirection == "right"),
	                flip      = bar.hasClass("uk-offcanvas-bar-flip") ? -1:1,
	                dir       = flip * (rtl ? -1 : 1),
	
	                scrollbarwidth =  window.innerWidth - $body.width();
	
	            scrollpos = {x: window.pageXOffset, y: window.pageYOffset};
	
	            element.addClass("uk-active");
	
	            $body.css({"width": window.innerWidth - scrollbarwidth, "height": window.innerHeight}).addClass("uk-offcanvas-page");
	            $body.css((rtl ? "margin-right" : "margin-left"), (rtl ? -1 : 1) * (bar.outerWidth() * dir)).width(); // .width() - force redraw
	
	            $html.css('margin-top', scrollpos.y * -1);
	
	            bar.addClass("uk-offcanvas-bar-show");
	
	            this._initElement(element);
	
	            bar.trigger('show.uk.offcanvas', [element, bar]);
	
	            // Update ARIA
	            element.attr('aria-hidden', 'false');
	        },
	
	        hide: function(force) {
	
	            var $body = UI.$('body'),
	                panel = UI.$(".uk-offcanvas.uk-active"),
	                rtl   = (UI.langdirection == "right"),
	                bar   = panel.find(".uk-offcanvas-bar:first"),
	                finalize = function() {
	                    $body.removeClass("uk-offcanvas-page").css({"width": "", "height": "", "margin-left": "", "margin-right": ""});
	                    panel.removeClass("uk-active");
	
	                    bar.removeClass("uk-offcanvas-bar-show");
	                    $html.css('margin-top', '');
	                    window.scrollTo(scrollpos.x, scrollpos.y);
	                    bar.trigger('hide.uk.offcanvas', [panel, bar]);
	
	                    // Update ARIA
	                    panel.attr('aria-hidden', 'true');
	                };
	
	            if (!panel.length) return;
	
	            if (UI.support.transition && !force) {
	
	                $body.one(UI.support.transition.end, function() {
	                    finalize();
	                }).css((rtl ? "margin-right" : "margin-left"), "");
	
	                setTimeout(function(){
	                    bar.removeClass("uk-offcanvas-bar-show");
	                }, 0);
	
	            } else {
	                finalize();
	            }
	        },
	
	        _initElement: function(element) {
	
	            if (element.data("OffcanvasInit")) return;
	
	            element.on("click.uk.offcanvas swipeRight.uk.offcanvas swipeLeft.uk.offcanvas", function(e) {
	
	                var target = UI.$(e.target);
	
	                if (!e.type.match(/swipe/)) {
	
	                    if (!target.hasClass("uk-offcanvas-close")) {
	                        if (target.hasClass("uk-offcanvas-bar")) return;
	                        if (target.parents(".uk-offcanvas-bar:first").length) return;
	                    }
	                }
	
	                e.stopImmediatePropagation();
	                Offcanvas.hide();
	            });
	
	            element.on("click", "a[href*='#']", function(e){
	
	                var link = UI.$(this),
	                    href = link.attr("href");
	
	                if (href == "#") {
	                    return;
	                }
	
	                UI.$doc.one('hide.uk.offcanvas', function() {
	
	                    var target;
	
	                    try {
	                        target = UI.$(link[0].hash);
	                    } catch (e){
	                        target = '';
	                    }
	
	                    if (!target.length) {
	                        target = UI.$('[name="'+link[0].hash.replace('#','')+'"]');
	                    }
	
	                    if (target.length && UI.Utils.scrollToElement) {
	                        UI.Utils.scrollToElement(target, UI.Utils.options(link.attr('data-uk-smooth-scroll') || '{}'));
	                    } else {
	                        window.location.href = href;
	                    }
	                });
	
	                Offcanvas.hide();
	            });
	
	            element.data("OffcanvasInit", true);
	        }
	    };
	
	    UI.component('offcanvasTrigger', {
	
	        boot: function() {
	
	            // init code
	            $html.on("click.offcanvas.uikit", "[data-uk-offcanvas]", function(e) {
	
	                e.preventDefault();
	
	                var ele = UI.$(this);
	
	                if (!ele.data("offcanvasTrigger")) {
	                    var obj = UI.offcanvasTrigger(ele, UI.Utils.options(ele.attr("data-uk-offcanvas")));
	                    ele.trigger("click");
	                }
	            });
	
	            $html.on('keydown.uk.offcanvas', function(e) {
	
	                if (e.keyCode === 27) { // ESC
	                    Offcanvas.hide();
	                }
	            });
	        },
	
	        init: function() {
	
	            var $this = this;
	
	            this.options = UI.$.extend({
	                "target": $this.element.is("a") ? $this.element.attr("href") : false
	            }, this.options);
	
	            this.on("click", function(e) {
	                e.preventDefault();
	                Offcanvas.show($this.options.target);
	            });
	        }
	    });
	
	    UI.offcanvas = Offcanvas;
	
	})(UIkit);
	
	(function(UI) {
	
	    "use strict";
	
	    var Animations;
	
	    UI.component('switcher', {
	
	        defaults: {
	            connect   : false,
	            toggle    : ">*",
	            active    : 0,
	            animation : false,
	            duration  : 200,
	            swiping   : true
	        },
	
	        animating: false,
	
	        boot: function() {
	
	            // init code
	            UI.ready(function(context) {
	
	                UI.$("[data-uk-switcher]", context).each(function() {
	                    var switcher = UI.$(this);
	
	                    if (!switcher.data("switcher")) {
	                        var obj = UI.switcher(switcher, UI.Utils.options(switcher.attr("data-uk-switcher")));
	                    }
	                });
	            });
	        },
	
	        init: function() {
	
	            var $this = this;
	
	            this.on("click.uk.switcher", this.options.toggle, function(e) {
	                e.preventDefault();
	                $this.show(this);
	            });
	
	            if (this.options.connect) {
	
	                this.connect = UI.$(this.options.connect);
	
	                this.connect.children().removeClass("uk-active");
	
	                // delegate switch commands within container content
	                if (this.connect.length) {
	
	                    // Init ARIA for connect
	                    this.connect.children().attr('aria-hidden', 'true');
	
	                    this.connect.on("click", '[data-uk-switcher-item]', function(e) {
	
	                        e.preventDefault();
	
	                        var item = UI.$(this).attr('data-uk-switcher-item');
	
	                        if ($this.index == item) return;
	
	                        switch(item) {
	                            case 'next':
	                            case 'previous':
	                                $this.show($this.index + (item=='next' ? 1:-1));
	                                break;
	                            default:
	                                $this.show(parseInt(item, 10));
	                        }
	                    });
	
	                    if (this.options.swiping) {
	
	                        this.connect.on('swipeRight swipeLeft', function(e) {
	                            e.preventDefault();
	                            if(!window.getSelection().toString()) {
	                                $this.show($this.index + (e.type == 'swipeLeft' ? 1 : -1));
	                            }
	                        });
	                    }
	                }
	
	                var toggles = this.find(this.options.toggle),
	                    active  = toggles.filter(".uk-active");
	
	                if (active.length) {
	                    this.show(active, false);
	                } else {
	
	                    if (this.options.active===false) return;
	
	                    active = toggles.eq(this.options.active);
	                    this.show(active.length ? active : toggles.eq(0), false);
	                }
	
	                // Init ARIA for toggles
	                toggles.not(active).attr('aria-expanded', 'false');
	                active.attr('aria-expanded', 'true');
	            }
	
	        },
	
	        show: function(tab, animate) {
	
	            if (this.animating) {
	                return;
	            }
	
	            if (isNaN(tab)) {
	                tab = UI.$(tab);
	            } else {
	
	                var toggles = this.find(this.options.toggle);
	
	                tab = tab < 0 ? toggles.length-1 : tab;
	                tab = toggles.eq(toggles[tab] ? tab : 0);
	            }
	
	            var $this     = this,
	                toggles   = this.find(this.options.toggle),
	                active    = UI.$(tab),
	                animation = Animations[this.options.animation] || function(current, next) {
	
	                    if (!$this.options.animation) {
	                        return Animations.none.apply($this);
	                    }
	
	                    var anim = $this.options.animation.split(',');
	
	                    if (anim.length == 1) {
	                        anim[1] = anim[0];
	                    }
	
	                    anim[0] = anim[0].trim();
	                    anim[1] = anim[1].trim();
	
	                    return coreAnimation.apply($this, [anim, current, next]);
	                };
	
	            if (animate===false || !UI.support.animation) {
	                animation = Animations.none;
	            }
	
	            if (active.hasClass("uk-disabled")) return;
	
	            // Update ARIA for Toggles
	            toggles.attr('aria-expanded', 'false');
	            active.attr('aria-expanded', 'true');
	
	            toggles.filter(".uk-active").removeClass("uk-active");
	            active.addClass("uk-active");
	
	            if (this.options.connect && this.connect.length) {
	
	                this.index = this.find(this.options.toggle).index(active);
	
	                if (this.index == -1 ) {
	                    this.index = 0;
	                }
	
	                this.connect.each(function() {
	
	                    var container = UI.$(this),
	                        children  = UI.$(container.children()),
	                        current   = UI.$(children.filter('.uk-active')),
	                        next      = UI.$(children.eq($this.index));
	
	                        $this.animating = true;
	
	                        animation.apply($this, [current, next]).then(function(){
	
	                            current.removeClass("uk-active");
	                            next.addClass("uk-active");
	
	                            // Update ARIA for connect
	                            current.attr('aria-hidden', 'true');
	                            next.attr('aria-hidden', 'false');
	
	                            UI.Utils.checkDisplay(next, true);
	
	                            $this.animating = false;
	
	                        });
	                });
	            }
	
	            this.trigger("show.uk.switcher", [active]);
	        }
	    });
	
	    Animations = {
	
	        'none': function() {
	            var d = UI.$.Deferred();
	            d.resolve();
	            return d.promise();
	        },
	
	        'fade': function(current, next) {
	            return coreAnimation.apply(this, ['uk-animation-fade', current, next]);
	        },
	
	        'slide-bottom': function(current, next) {
	            return coreAnimation.apply(this, ['uk-animation-slide-bottom', current, next]);
	        },
	
	        'slide-top': function(current, next) {
	            return coreAnimation.apply(this, ['uk-animation-slide-top', current, next]);
	        },
	
	        'slide-vertical': function(current, next, dir) {
	
	            var anim = ['uk-animation-slide-top', 'uk-animation-slide-bottom'];
	
	            if (current && current.index() > next.index()) {
	                anim.reverse();
	            }
	
	            return coreAnimation.apply(this, [anim, current, next]);
	        },
	
	        'slide-left': function(current, next) {
	            return coreAnimation.apply(this, ['uk-animation-slide-left', current, next]);
	        },
	
	        'slide-right': function(current, next) {
	            return coreAnimation.apply(this, ['uk-animation-slide-right', current, next]);
	        },
	
	        'slide-horizontal': function(current, next, dir) {
	
	            var anim = ['uk-animation-slide-right', 'uk-animation-slide-left'];
	
	            if (current && current.index() > next.index()) {
	                anim.reverse();
	            }
	
	            return coreAnimation.apply(this, [anim, current, next]);
	        },
	
	        'scale': function(current, next) {
	            return coreAnimation.apply(this, ['uk-animation-scale-up', current, next]);
	        }
	    };
	
	    UI.switcher.animations = Animations;
	
	
	    // helpers
	
	    function coreAnimation(cls, current, next) {
	
	        var d = UI.$.Deferred(), clsIn = cls, clsOut = cls, release;
	
	        if (next[0]===current[0]) {
	            d.resolve();
	            return d.promise();
	        }
	
	        if (typeof(cls) == 'object') {
	            clsIn  = cls[0];
	            clsOut = cls[1] || cls[0];
	        }
	
	        UI.$body.css('overflow-x', 'hidden'); // fix scroll jumping in iOS
	
	        release = function() {
	
	            if (current) current.hide().removeClass('uk-active '+clsOut+' uk-animation-reverse');
	
	            next.addClass(clsIn).one(UI.support.animation.end, function() {
	
	                next.removeClass(''+clsIn+'').css({opacity:'', display:''});
	
	                d.resolve();
	
	                UI.$body.css('overflow-x', '');
	
	                if (current) current.css({opacity:'', display:''});
	
	            }.bind(this)).show();
	        };
	
	        next.css('animation-duration', this.options.duration+'ms');
	
	        if (current && current.length) {
	
	            current.css('animation-duration', this.options.duration+'ms');
	
	            current.css('display', 'none').addClass(clsOut+' uk-animation-reverse').one(UI.support.animation.end, function() {
	                release();
	            }.bind(this)).css('display', '');
	
	        } else {
	            next.addClass('uk-active');
	            release();
	        }
	
	        return d.promise();
	    }
	
	})(UIkit);
	
	(function(UI) {
	
	    "use strict";
	
	    UI.component('tab', {
	
	        defaults: {
	            'target'    : '>li:not(.uk-tab-responsive, .uk-disabled)',
	            'connect'   : false,
	            'active'    : 0,
	            'animation' : false,
	            'duration'  : 200,
	            'swiping'   : true
	        },
	
	        boot: function() {
	
	            // init code
	            UI.ready(function(context) {
	
	                UI.$("[data-uk-tab]", context).each(function() {
	
	                    var tab = UI.$(this);
	
	                    if (!tab.data("tab")) {
	                        var obj = UI.tab(tab, UI.Utils.options(tab.attr("data-uk-tab")));
	                    }
	                });
	            });
	        },
	
	        init: function() {
	
	            var $this = this;
	
	            this.current = false;
	
	            this.on("click.uk.tab", this.options.target, function(e) {
	
	                e.preventDefault();
	
	                if ($this.switcher && $this.switcher.animating) {
	                    return;
	                }
	
	                var current = $this.find($this.options.target).not(this);
	
	                current.removeClass("uk-active").blur();
	
	                $this.trigger("change.uk.tab", [UI.$(this).addClass("uk-active"), $this.current]);
	
	                $this.current = UI.$(this);
	
	                // Update ARIA
	                if (!$this.options.connect) {
	                    current.attr('aria-expanded', 'false');
	                    UI.$(this).attr('aria-expanded', 'true');
	                }
	            });
	
	            if (this.options.connect) {
	                this.connect = UI.$(this.options.connect);
	            }
	
	            // init responsive tab
	            this.responsivetab = UI.$('<li class="uk-tab-responsive uk-active"><a></a></li>').append('<div class="uk-dropdown uk-dropdown-small"><ul class="uk-nav uk-nav-dropdown"></ul><div>');
	
	            this.responsivetab.dropdown = this.responsivetab.find('.uk-dropdown');
	            this.responsivetab.lst      = this.responsivetab.dropdown.find('ul');
	            this.responsivetab.caption  = this.responsivetab.find('a:first');
	
	            if (this.element.hasClass("uk-tab-bottom")) this.responsivetab.dropdown.addClass("uk-dropdown-up");
	
	            // handle click
	            this.responsivetab.lst.on('click.uk.tab', 'a', function(e) {
	
	                e.preventDefault();
	                e.stopPropagation();
	
	                var link = UI.$(this);
	
	                $this.element.children('li:not(.uk-tab-responsive)').eq(link.data('index')).trigger('click');
	            });
	
	            this.on('show.uk.switcher change.uk.tab', function(e, tab) {
	                $this.responsivetab.caption.html(tab.text());
	            });
	
	            this.element.append(this.responsivetab);
	
	            // init UIkit components
	            if (this.options.connect) {
	                this.switcher = UI.switcher(this.element, {
	                    'toggle'    : '>li:not(.uk-tab-responsive)',
	                    'connect'   : this.options.connect,
	                    'active'    : this.options.active,
	                    'animation' : this.options.animation,
	                    'duration'  : this.options.duration,
	                    'swiping'   : this.options.swiping
	                });
	            }
	
	            UI.dropdown(this.responsivetab, {"mode": "click", "preventflip": "y"});
	
	            // init
	            $this.trigger("change.uk.tab", [this.element.find(this.options.target).not('.uk-tab-responsive').filter('.uk-active')]);
	
	            this.check();
	
	            UI.$win.on('resize orientationchange', UI.Utils.debounce(function(){
	                if ($this.element.is(":visible"))  $this.check();
	            }, 100));
	
	            this.on('display.uk.check', function(){
	                if ($this.element.is(":visible"))  $this.check();
	            });
	        },
	
	        check: function() {
	
	            var children = this.element.children('li:not(.uk-tab-responsive)').removeClass('uk-hidden');
	
	            if (!children.length) {
	                this.responsivetab.addClass('uk-hidden');
	                return;
	            }
	
	            var top          = (children.eq(0).offset().top + Math.ceil(children.eq(0).height()/2)),
	                doresponsive = false,
	                item, link, clone;
	
	            this.responsivetab.lst.empty();
	
	            children.each(function(){
	
	                if (UI.$(this).offset().top > top) {
	                    doresponsive = true;
	                }
	            });
	
	            if (doresponsive) {
	
	                for (var i = 0; i < children.length; i++) {
	
	                    item  = UI.$(children.eq(i));
	                    link  = item.find('a');
	
	                    if (item.css('float') != 'none' && !item.attr('uk-dropdown')) {
	
	                        if (!item.hasClass('uk-disabled')) {
	
	                            clone = item[0].outerHTML.replace('<a ', '<a data-index="'+i+'" ');
	
	                            this.responsivetab.lst.append(clone);
	                        }
	
	                        item.addClass('uk-hidden');
	                    }
	                }
	            }
	
	            this.responsivetab[this.responsivetab.lst.children('li').length ? 'removeClass':'addClass']('uk-hidden');
	        }
	    });
	
	})(UIkit);
	
	(function(UI){
	
	    "use strict";
	
	    UI.component('cover', {
	
	        defaults: {
	            automute : true
	        },
	
	        boot: function() {
	
	            // auto init
	            UI.ready(function(context) {
	
	                UI.$("[data-uk-cover]", context).each(function(){
	
	                    var ele = UI.$(this);
	
	                    if(!ele.data("cover")) {
	                        var plugin = UI.cover(ele, UI.Utils.options(ele.attr("data-uk-cover")));
	                    }
	                });
	            });
	        },
	
	        init: function() {
	
	            this.parent = this.element.parent();
	
	            UI.$win.on('load resize orientationchange', UI.Utils.debounce(function(){
	                this.check();
	            }.bind(this), 100));
	
	            this.on("display.uk.check", function(e) {
	                if(this.element.is(":visible")) this.check();
	            }.bind(this));
	
	            this.check();
	
	            if (this.element.is('iframe') && this.options.automute) {
	
	                var src = this.element.attr('src');
	
	                this.element.attr('src', '').on('load', function(){
	
	                    this.contentWindow.postMessage('{ "event": "command", "func": "mute", "method":"setVolume", "value":0}', '*');
	
	                }).attr('src', [src, (src.indexOf('?') > -1 ? '&':'?'), 'enablejsapi=1&api=1'].join(''));
	            }
	        },
	
	        check: function() {
	
	            this.element.css({
	                'width'  : '',
	                'height' : ''
	            });
	
	            this.dimension = {w: this.element.width(), h: this.element.height()};
	
	            if (this.element.attr('width') && !isNaN(this.element.attr('width'))) {
	                this.dimension.w = this.element.attr('width');
	            }
	
	            if (this.element.attr('height') && !isNaN(this.element.attr('height'))) {
	                this.dimension.h = this.element.attr('height');
	            }
	
	            this.ratio     = this.dimension.w / this.dimension.h;
	
	            var w = this.parent.width(), h = this.parent.height(), width, height;
	
	            // if element height < parent height (gap underneath)
	            if ((w / this.ratio) < h) {
	
	                width  = Math.ceil(h * this.ratio);
	                height = h;
	
	            // element width < parent width (gap to right)
	            } else {
	
	                width  = w;
	                height = Math.ceil(w / this.ratio);
	            }
	
	            this.element.css({
	                'width'  : width,
	                'height' : height
	            });
	        }
	    });
	
	})(UIkit);


/***/ },
/* 86 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _vue = __webpack_require__(10);
	
	var _vue2 = _interopRequireDefault(_vue);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = {
	  login: function login(username, password, cb, errorCb) {
	    return _vue2.default.http.get('zoolanders/login', { username: username, password: password }).then(function (_ref) {
	      var data = _ref.data;
	      return cb(data);
	    }, function (response) {
	      return errorCb(response);
	    });
	  },
	  logout: function logout(cb, errorCb) {
	    return _vue2.default.http.get('zoolanders/logout').then(cb, function (response) {
	      return errorCb(response);
	    });
	  }
	};

/***/ },
/* 87 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _vue = __webpack_require__(10);
	
	var _vue2 = _interopRequireDefault(_vue);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = {
	  retrieve: function retrieve(force, cb, errorCb) {
	    return _vue2.default.http.get('extensions/retrieve', { force: force ? 1 : 0 }).then(function (_ref) {
	      var data = _ref.data;
	      return cb(data);
	    }, function (response) {
	      return errorCb(response);
	    });
	  },
	  download: function download(extensions, cb, errorCb) {
	    return _vue2.default.http.get('extensions/download', { extensions: extensions }).then(function (_ref2) {
	      var data = _ref2.data;
	      return cb(data.downloadUrl);
	    }, function (response) {
	      return errorCb(response);
	    });
	  },
	  install: function install(extensions, cb, errorCb) {
	    return _vue2.default.http.get('extensions/install', { extensions: extensions }).then(function (_ref3) {
	      var data = _ref3.data;
	      return cb(data);
	    }, function (response) {
	      return errorCb(response);
	    });
	  },
	  uninstall: function uninstall(extensions, cb, errorCb) {
	    return _vue2.default.http.get('extensions/uninstall', { extensions: extensions }).then(cb, function (response) {
	      return errorCb(response);
	    });
	  },
	  toggle: function toggle(extensions, cb, errorCb) {
	    return _vue2.default.http.get('extensions/toggle', { extensions: extensions }).then(function (_ref4) {
	      var data = _ref4.data;
	      return cb(data);
	    }, function (response) {
	      return errorCb(response);
	    });
	  }
	};

/***/ },
/* 88 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _vue = __webpack_require__(10);
	
	var _vue2 = _interopRequireDefault(_vue);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = {
	  retrieve: function retrieve(force, cb, errorCb) {
	    return _vue2.default.http.get('languages/retrieve', { force: force ? 1 : 0 }).then(function (_ref) {
	      var data = _ref.data;
	      return cb(data);
	    }, function (response) {
	      return errorCb(response);
	    });
	  },
	  download: function download(language, cb, errorCb) {
	    return _vue2.default.http.get('languages/download', { languages: [language] }).then(function (_ref2) {
	      var data = _ref2.data;
	      return cb(data.downloadUrl);
	    }, function (response) {
	      return errorCb(response);
	    });
	  },
	  install: function install(language, cb, errorCb) {
	    return _vue2.default.http.get('languages/install', { languages: [language] }).then(function (_ref3) {
	      var data = _ref3.data;
	      return cb(data);
	    }, function (response) {
	      return errorCb(response);
	    });
	  },
	  uninstall: function uninstall(language, cb, errorCb) {
	    return _vue2.default.http.get('languages/uninstall', { languages: [language] }).then(cb, function (response) {
	      return errorCb(response);
	    });
	  }
	};

/***/ },
/* 89 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _vue = __webpack_require__(10);
	
	var _vue2 = _interopRequireDefault(_vue);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var FragmentFactory = _vue2.default.FragmentFactory;
	var remove = _vue2.default.util.remove;
	var createAnchor = _vue2.default.util.createAnchor;
	
	exports.default = {
	  terminal: true,
	  bind: function bind() {
	    if (this.el.__vue__) {
	      return _vue2.default.util.warn('v-inject="' + this.expression + '"' + ' cannot be used on an instance root element.');
	    }
	    var container = this.arg ? document.getElementById(this.arg) : document.body;
	    if (container) {
	      this.anchor = createAnchor('v-inject');
	      container.appendChild(this.anchor);
	      remove(this.el);
	      var factory = new FragmentFactory(this.vm, this.el);
	      this.frag = factory.create(this._host, this._scope, this._frag);
	      this.frag.before(this.anchor);
	    }
	  },
	  unbind: function unbind() {
	    this.frag.remove();
	    remove(this.anchor);
	  }
	};

/***/ },
/* 90 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _map2 = __webpack_require__(241);
	
	var _map3 = _interopRequireDefault(_map2);
	
	exports.retrieve = retrieve;
	exports.download = download;
	exports.install = install;
	exports.uninstall = uninstall;
	exports.toggle = toggle;
	
	var _extensions = __webpack_require__(87);
	
	var _extensions2 = _interopRequireDefault(_extensions);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function retrieve(_ref) {
	  var dispatch = _ref.dispatch;
	  var force = arguments.length <= 1 || arguments[1] === undefined ? false : arguments[1];
	
	  return _extensions2.default.retrieve(force, function (data) {
	    return dispatch('RECEIVE_PRODUCTS_STATE', data);
	  }, function (response) {
	    return dispatch('SHOW_MODAL', {
	      text: response.data.message,
	      requestError: response.data.error,
	      icon: ['uk-icon-times', 'uk-text-danger']
	    });
	  });
	}
	
	function download(_ref2, extensions) {
	  var dispatch = _ref2.dispatch;
	
	  dispatch('SHOW_MODAL', { spinner: true, block: true });
	  return _extensions2.default.download(extensions, function (downloadUrl) {
	    dispatch('SHOW_MODAL', {
	      text: 'The download should start shortly, otherwise click\n          <a href="' + downloadUrl + '">here</a>.',
	      icon: ['uk-icon-cloud-download']
	    });
	    if (downloadUrl) {
	      window.location.href = downloadUrl;
	    }
	  }, function (response) {
	    return dispatch('SHOW_MODAL', {
	      text: response.data.message,
	      requestError: response.data.error,
	      icon: ['uk-icon-times', 'uk-text-danger']
	    });
	  });
	}
	
	function install(_ref3, name) {
	  var dispatch = _ref3.dispatch;
	
	  dispatch('SHOW_MODAL', { spinner: true, block: true });
	  return _extensions2.default.install(name, function (installed) {
	    dispatch('MERGE_EXTENSIONS', installed);
	    dispatch('SHOW_MODAL', {
	      text: 'Installed succesfully',
	      icon: ['uk-icon-check', 'uk-text-success']
	    });
	  }, function (response) {
	    return dispatch('SHOW_MODAL', {
	      text: response.data.message,
	      requestError: response.data.error,
	      icon: ['uk-icon-times', 'uk-text-danger']
	    });
	  });
	}
	
	function uninstall(_ref4, extensions) {
	  var dispatch = _ref4.dispatch;
	
	  dispatch('SHOW_MODAL', { spinner: true, block: true });
	  return _extensions2.default.uninstall(extensions, function () {
	    dispatch('MERGE_EXTENSIONS', (0, _map3.default)(extensions, function (name) {
	      return { name: name, installed: false, installedVersion: '' };
	    }));
	    dispatch('SHOW_MODAL', {
	      text: 'Uninstalled succesfully',
	      icon: ['uk-icon-check', 'uk-text-success']
	    });
	  }, function (response) {
	    return dispatch('SHOW_MODAL', {
	      text: response.data.message,
	      requestError: response.data.error,
	      icon: ['uk-icon-times', 'uk-text-danger']
	    });
	  });
	}
	
	function toggle(_ref5, extensions) {
	  var dispatch = _ref5.dispatch;
	  var state = _ref5.state;
	
	  return _extensions2.default.toggle(extensions, function (installed) {
	    return dispatch('MERGE_EXTENSIONS', installed);
	  }, function (response) {
	    return dispatch('SHOW_MODAL', {
	      text: response.data.message,
	      requestError: response.data.error,
	      icon: ['uk-icon-times', 'uk-text-danger']
	    });
	  });
	}

/***/ },
/* 91 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.retrieve = retrieve;
	exports.download = download;
	exports.install = install;
	exports.uninstall = uninstall;
	
	var _languages = __webpack_require__(88);
	
	var _languages2 = _interopRequireDefault(_languages);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function retrieve(_ref) {
	  var dispatch = _ref.dispatch;
	  var force = arguments.length <= 1 || arguments[1] === undefined ? false : arguments[1];
	
	  return _languages2.default.retrieve(force, function (data) {
	    return dispatch('RECEIVE_PRODUCTS_STATE', data);
	  }, function (response) {
	    return dispatch('SHOW_MODAL', {
	      text: response.data.message,
	      requestError: response.data.error,
	      icon: ['uk-icon-times', 'uk-text-danger']
	    });
	  });
	}
	
	function download(_ref2, language) {
	  var dispatch = _ref2.dispatch;
	
	  dispatch('SHOW_MODAL', { spinner: true, block: true });
	  return _languages2.default.download(language, function (downloadUrl) {
	    dispatch('SHOW_MODAL', {
	      text: 'The download should start shortly, otherwise click\n          <a href="' + downloadUrl + '">here</a>.',
	      icon: ['uk-icon-cloud-download']
	    });
	    if (downloadUrl) {
	      window.location.href = downloadUrl;
	    }
	  }, function (response) {
	    return dispatch('SHOW_MODAL', {
	      text: response.data.message,
	      requestError: response.data.error,
	      icon: ['uk-icon-times', 'uk-text-danger']
	    });
	  });
	}
	
	function install(_ref3, language) {
	  var dispatch = _ref3.dispatch;
	
	  dispatch('SHOW_MODAL', { spinner: true, block: true });
	  return _languages2.default.install(language, function (installed) {
	    dispatch('MERGE_LANGUAGES', installed);
	    dispatch('SHOW_MODAL', {
	      text: 'Installed succesfully',
	      icon: ['uk-icon-check', 'uk-text-success']
	    });
	  }, function (response) {
	    return dispatch('SHOW_MODAL', {
	      text: response.data.message,
	      requestError: response.data.error,
	      icon: ['uk-icon-times', 'uk-text-danger']
	    });
	  });
	}
	
	function uninstall(_ref4, code) {
	  var dispatch = _ref4.dispatch;
	  var state = _ref4.state;
	
	  dispatch('SHOW_MODAL', { spinner: true, block: true });
	  return _languages2.default.uninstall(code, function () {
	    dispatch('MERGE_LANGUAGES', [{ code: code, installed: false }]);
	    dispatch('SHOW_MODAL', {
	      text: 'Uninstalled succesfully',
	      icon: ['uk-icon-check', 'uk-text-success']
	    });
	  }, function (response) {
	    return dispatch('SHOW_MODAL', {
	      text: response.data.message,
	      requestError: response.data.error,
	      icon: ['uk-icon-times', 'uk-text-danger']
	    });
	  });
	}

/***/ },
/* 92 */
/***/ function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	var state = {
	  show: false,
	  text: '',
	  icon: '',
	  block: false,
	  spinner: false,
	  requestError: ''
	};
	
	var defaults = {
	  text: '',
	  icon: '',
	  block: false,
	  spinner: false,
	  requestError: false
	};
	
	var mutations = {
	  SHOW_MODAL: function SHOW_MODAL(state) {
	    var _ref = arguments.length <= 1 || arguments[1] === undefined ? defaults : arguments[1];
	
	    var _ref$text = _ref.text;
	    var text = _ref$text === undefined ? defaults.text : _ref$text;
	    var _ref$icon = _ref.icon;
	    var icon = _ref$icon === undefined ? defaults.icon : _ref$icon;
	    var _ref$block = _ref.block;
	    var block = _ref$block === undefined ? defaults.block : _ref$block;
	    var _ref$spinner = _ref.spinner;
	    var spinner = _ref$spinner === undefined ? defaults.spinner : _ref$spinner;
	    var _ref$requestError = _ref.requestError;
	    var requestError = _ref$requestError === undefined ? defaults.requestError : _ref$requestError;
	
	    state.show = true;
	    state.text = text;
	    state.icon = icon;
	    state.block = block;
	    state.spinner = spinner;
	    state.requestError = requestError;
	  },
	  HIDE_MODAL: function HIDE_MODAL(state) {
	    state.show = false;
	    state.text = '';
	    state.block = false;
	    state.spinner = false;
	    state.requestError = '';
	  }
	};
	
	exports.default = {
	  state: state,
	  mutations: mutations
	};

/***/ },
/* 93 */
/***/ function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	var state = {
	  show: false,
	  text: '',
	  icon: ''
	};
	
	var defaults = {
	  text: '',
	  icon: ''
	};
	
	var mutations = {
	  SHOW_MODAL_CONFIRM: function SHOW_MODAL_CONFIRM(state) {
	    var _ref = arguments.length <= 1 || arguments[1] === undefined ? defaults : arguments[1];
	
	    var _ref$text = _ref.text;
	    var text = _ref$text === undefined ? defaults.text : _ref$text;
	    var _ref$icon = _ref.icon;
	    var icon = _ref$icon === undefined ? defaults.icon : _ref$icon;
	
	    state.show = true;
	    state.text = text;
	    state.icon = icon;
	  },
	  HIDE_MODAL_CONFIRM: function HIDE_MODAL_CONFIRM(state) {
	    state.show = false;
	  }
	};
	
	exports.default = {
	  state: state,
	  mutations: mutations
	};

/***/ },
/* 94 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _each2 = __webpack_require__(232);
	
	var _each3 = _interopRequireDefault(_each2);
	
	var _find2 = __webpack_require__(78);
	
	var _find3 = _interopRequireDefault(_find2);
	
	var _isArray2 = __webpack_require__(1);
	
	var _isArray3 = _interopRequireDefault(_isArray2);
	
	var _mergeWith2 = __webpack_require__(83);
	
	var _mergeWith3 = _interopRequireDefault(_mergeWith2);
	
	var _merge2 = __webpack_require__(244);
	
	var _merge3 = _interopRequireDefault(_merge2);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var state = {
	  extensions: [],
	  languages: [],
	  subscriptions: [],
	  server: {
	    offline: false,
	    status: ''
	  },
	  view: 'tm-spinner',
	  authentication: {
	    show: false,
	    status: false,
	    user: '',
	    message: ''
	  }
	};
	
	var mutations = {
	  RECEIVE_PRODUCTS_STATE: function RECEIVE_PRODUCTS_STATE(state, newstate) {
	    (0, _mergeWith3.default)(state, newstate, function (objValue, srcValue) {
	      if ((0, _isArray3.default)(objValue)) {
	        return srcValue;
	      }
	    });
	  },
	  SET_VIEW: function SET_VIEW(state, view) {
	    state.view = view;
	  },
	  MERGE_EXTENSIONS: function MERGE_EXTENSIONS(state, extensions) {
	    (0, _each3.default)(extensions, function (extension) {
	      var found = (0, _find3.default)(state.extensions, ['name', extension.name]);
	      if (found) {
	        var index = state.extensions.indexOf(found);
	        state.extensions.$set(index, (0, _merge3.default)({}, found, extension));
	      }
	    });
	  },
	  MERGE_LANGUAGES: function MERGE_LANGUAGES(state, languages) {
	    (0, _each3.default)(languages, function (language) {
	      var found = (0, _find3.default)(state.languages, ['code', language.code]);
	      if (found) {
	        var index = state.languages.indexOf(found);
	        state.languages.$set(index, (0, _merge3.default)({}, found, language));
	      }
	    });
	  },
	  SHOW_AUTH: function SHOW_AUTH(state) {
	    state.authentication.show = true;
	  },
	  HIDE_AUTH: function HIDE_AUTH(state) {
	    state.authentication.show = false;
	  },
	  LOGIN_REQUEST: function LOGIN_REQUEST(state) {
	    state.authentication.message = 'Authenticating...';
	  },
	  LOGIN_SUCCESS: function LOGIN_SUCCESS(state, user) {
	    state.authentication.status = true;
	    state.authentication.user = user;
	    state.authentication.message = '';
	  },
	  LOGIN_FAILURE: function LOGIN_FAILURE(state, message) {
	    state.authentication.status = false;
	    state.authentication.message = message;
	  },
	  LOGOUT: function LOGOUT(state) {
	    state.authentication.status = false;
	    state.authentication.user = '';
	  }
	};
	
	exports.default = {
	  state: state,
	  mutations: mutations
	};

/***/ },
/* 95 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _isArray2 = __webpack_require__(1);
	
	var _isArray3 = _interopRequireDefault(_isArray2);
	
	var _mergeWith2 = __webpack_require__(83);
	
	var _mergeWith3 = _interopRequireDefault(_mergeWith2);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = {
	  RECEIVE_INIT_STATE: function RECEIVE_INIT_STATE(state, newstate) {
	    (0, _mergeWith3.default)(state, newstate, function (objValue, srcValue) {
	      if ((0, _isArray3.default)(objValue)) {
	        return srcValue;
	      }
	    });
	  }
	};

/***/ },
/* 96 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _vue = __webpack_require__(10);
	
	var _vue2 = _interopRequireDefault(_vue);
	
	var _vuex = __webpack_require__(279);
	
	var _vuex2 = _interopRequireDefault(_vuex);
	
	var _products = __webpack_require__(94);
	
	var _products2 = _interopRequireDefault(_products);
	
	var _modal = __webpack_require__(92);
	
	var _modal2 = _interopRequireDefault(_modal);
	
	var _modalConfirm = __webpack_require__(93);
	
	var _modalConfirm2 = _interopRequireDefault(_modalConfirm);
	
	var _logger = __webpack_require__(277);
	
	var _logger2 = _interopRequireDefault(_logger);
	
	var _mutations = __webpack_require__(95);
	
	var _mutations2 = _interopRequireDefault(_mutations);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var debug = ("production") !== 'production';
	_vue2.default.config.debug = debug;
	
	var store = new _vuex2.default.Store({
	  state: {
	    menu: []
	  },
	  modules: {
	    products: _products2.default,
	    modal: _modal2.default,
	    modalConfirm: _modalConfirm2.default
	  },
	  mutations: _mutations2.default,
	  strict: debug,
	  middlewares: debug ? [(0, _logger2.default)()] : []
	});
	
	if (false) {
	  module.hot.accept(['./mutations', './modules/products', './modules/modal'], function () {
	    var mutations = require('./mutations').default;
	    var products = require('./modules/products').default;
	    var modal = require('./modules/modal').default;
	    store.hotUpdate({
	      mutations: mutations,
	      modules: {
	        products: products,
	        modal: modal
	      }
	    });
	  });
	}
	
	exports.default = store;

/***/ },
/* 97 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _store = __webpack_require__(96);
	
	var _store2 = _interopRequireDefault(_store);
	
	var _Products = __webpack_require__(268);
	
	var _Products2 = _interopRequireDefault(_Products);
	
	var _TmModal = __webpack_require__(275);
	
	var _TmModal2 = _interopRequireDefault(_TmModal);
	
	var _Authentication = __webpack_require__(269);
	
	var _Authentication2 = _interopRequireDefault(_Authentication);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = {
	  components: {
	    Products: _Products2.default,
	    TmModal: _TmModal2.default,
	    Authentication: _Authentication2.default
	  },
	  store: _store2.default,
	  props: {
	    state: {
	      type: Object,
	      required: true
	    }
	  },
	  data: function data() {
	    return {
	      requestErrorVisible: false
	    };
	  },
	  vuex: {
	    getters: {
	      modal: function modal(state) {
	        return state.modal;
	      },
	      modalConfirm: function modalConfirm(state) {
	        return state.modalConfirm;
	      },
	      modalAuth: function modalAuth(state) {
	        return state.products.authentication;
	      }
	    },
	    actions: {
	      initState: function initState(_ref, state) {
	        var dispatch = _ref.dispatch;
	
	        dispatch('RECEIVE_INIT_STATE', state);
	      },
	      hideModals: function hideModals(_ref2) {
	        var dispatch = _ref2.dispatch;
	
	        if (this.modalConfirm.show) {
	          dispatch('HIDE_MODAL_CONFIRM');
	        }
	        if (this.modalAuth.show) {
	          dispatch('HIDE_AUTH');
	        }
	        if (this.modal.show) {
	          dispatch('HIDE_MODAL');
	        }
	      }
	    }
	  },
	  created: function created() {
	    this.initState(this.state);
	  }
	};

/***/ },
/* 98 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _Extensions = __webpack_require__(271);
	
	var _Extensions2 = _interopRequireDefault(_Extensions);
	
	var _Languages = __webpack_require__(273);
	
	var _Languages2 = _interopRequireDefault(_Languages);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = {
	  components: {
	    Extensions: _Extensions2.default,
	    Languages: _Languages2.default
	  },
	  data: function data() {
	    return {
	      localMenu: ['extensions', 'languages']
	    };
	  },
	  vuex: {
	    getters: {
	      view: function view(state) {
	        return state.products.view;
	      },
	      server: function server(state) {
	        return state.products.server;
	      },
	      menu: function menu(state) {
	        return state.menu;
	      }
	    },
	    actions: {
	      switchView: function switchView(_ref, view) {
	        var dispatch = _ref.dispatch;
	
	        dispatch('SET_VIEW', 'tm-spinner');
	        setTimeout(function () {
	          dispatch('SET_VIEW', view);
	        }, 1);
	      }
	    }
	  },
	  ready: function ready() {
	    this.switchView('extensions');
	  }
	};

/***/ },
/* 99 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _get2 = __webpack_require__(79);
	
	var _get3 = _interopRequireDefault(_get2);
	
	var _authentication = __webpack_require__(27);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = {
	  data: function data() {
	    return {
	      username: '',
	      password: ''
	    };
	  },
	  vuex: {
	    getters: {
	      auth: function auth(state) {
	        return state.products.authentication;
	      }
	    },
	    actions: {
	      login: _authentication.login,
	      logout: _authentication.logout
	    }
	  },
	  watch: {
	    'auth.show': function authShow() {
	      if (this.auth.show === false) {
	        this.$resetValidation();
	      }
	    }
	  },
	  filters: {
	    validate: function validate(cb) {
	      var _this = this;
	
	      return function () {
	        return _this.$validation.valid ? cb() : _this.$validate(true);
	      };
	    }
	  },
	  methods: {
	    validateField: function validateField(field) {
	      return (0, _get3.default)(this.$validation, field + '.touched') && (0, _get3.default)(this.$validation, field + '.invalid');
	    }
	  }
	};

/***/ },
/* 100 */
/***/ function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = {
	  name: 'Extension',
	  props: {
	    name: {
	      type: String,
	      required: true
	    },
	    title: {
	      type: String,
	      required: true
	    },
	    type: {
	      type: String,
	      required: true
	    },
	    url: {
	      type: String,
	      required: true
	    },
	    installed: {
	      type: Boolean,
	      default: false
	    },
	    installedVersion: {
	      type: String,
	      default: ''
	    },
	    deprecated: {
	      type: Boolean,
	      default: false
	    },
	    subscribed: {
	      type: Boolean,
	      default: false
	    },
	    downloadUrl: {
	      type: String,
	      default: ''
	    },
	    enabled: {
	      type: Boolean,
	      default: true
	    },
	    version: {
	      type: String,
	      default: ''
	    },
	    outdated: {
	      type: [Boolean],
	      default: false
	    },
	    selected: {
	      type: Boolean,
	      default: false
	    },
	    offline: {
	      type: Boolean,
	      default: false
	    }
	  },
	  computed: {
	    operative: function operative() {
	      return this.installed || this.subscribed;
	    },
	    isMobile: function isMobile() {
	      return window.screen.width <= 960;
	    }
	  }
	};

/***/ },
/* 101 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _keys = __webpack_require__(106);
	
	var _keys2 = _interopRequireDefault(_keys);
	
	var _mapKeys3 = __webpack_require__(242);
	
	var _mapKeys4 = _interopRequireDefault(_mapKeys3);
	
	var _groupBy3 = __webpack_require__(237);
	
	var _groupBy4 = _interopRequireDefault(_groupBy3);
	
	var _pickBy3 = __webpack_require__(246);
	
	var _pickBy4 = _interopRequireDefault(_pickBy3);
	
	var _pick3 = __webpack_require__(245);
	
	var _pick4 = _interopRequireDefault(_pick3);
	
	var _find3 = __webpack_require__(78);
	
	var _find4 = _interopRequireDefault(_find3);
	
	var _some3 = __webpack_require__(249);
	
	var _some4 = _interopRequireDefault(_some3);
	
	var _every3 = __webpack_require__(233);
	
	var _every4 = _interopRequireDefault(_every3);
	
	var _filter3 = __webpack_require__(234);
	
	var _filter4 = _interopRequireDefault(_filter3);
	
	var _Extension = __webpack_require__(270);
	
	var _Extension2 = _interopRequireDefault(_Extension);
	
	var _authentication = __webpack_require__(27);
	
	var _getters = __webpack_require__(47);
	
	var _extensions = __webpack_require__(90);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = {
	  name: 'extensions',
	  activate: function activate(done) {
	    this.retrieve().then(function () {
	      return done();
	    });
	  },
	  components: { Extension: _Extension2.default },
	  watch: {
	    'authenticated': function authenticated() {
	      this.reload();
	    }
	  },
	  data: function data() {
	    return {
	      selection: {},
	      filters: {
	        installed: false,
	        outdated: false,
	        subscribed: false,
	        enabled: false
	      }
	    };
	  },
	  vuex: {
	    getters: {
	      extensionsList: _getters.extensions,
	      authenticated: function authenticated(state) {
	        return state.products.authentication.status;
	      },
	      view: function view(state) {
	        return state.products.view;
	      },
	      server: function server(state) {
	        return state.products.server;
	      }
	    },
	    actions: {
	      showAuth: _authentication.show,
	      retrieve: _extensions.retrieve,
	      download: _extensions.download,
	      install: _extensions.install,
	      doUninstall: _extensions.uninstall,
	      toggle: _extensions.toggle,
	      promptConfirm: function promptConfirm(_ref, text) {
	        var dispatch = _ref.dispatch;
	
	        dispatch('SHOW_MODAL_CONFIRM', { text: text,
	          icon: ['uk-icon-exclamation', 'uk-text-warning']
	        });
	      },
	      reload: function reload(_ref2) {
	        var dispatch = _ref2.dispatch;
	
	        dispatch('SHOW_MODAL', { spinner: true, block: true });
	        this.retrieve(true).then(function () {
	          return dispatch('HIDE_MODAL');
	        });
	      }
	    }
	  },
	  computed: {
	    filtered: function filtered() {
	      return (0, _keys2.default)((0, _pickBy4.default)(this.filters)).length;
	    },
	    displayed: function displayed() {
	      return this.view === this.$options.name;
	    },
	    extensions: function extensions() {
	      return this.filters ? (0, _filter4.default)(this.extensionsList, (0, _pickBy4.default)(this.filters)) : this.extensionsList;
	    },
	    grouped: function grouped() {
	      return (0, _mapKeys4.default)((0, _pick4.default)((0, _groupBy4.default)(this.extensions, 'type'), ['Core', 'Element', 'Plugin', 'Module', 'App']), function (value, key) {
	        return key === 'Core' ? 'Core' : key + 's';
	      });
	    },
	
	    selectable: function selectable() {
	      return (0, _filter4.default)(this.extensions, function (ext) {
	        return ext.installed || ext.subscribed;
	      });
	    },
	    selected: function selected() {
	      var selected = (0, _keys2.default)((0, _pickBy4.default)(this.selection));
	      return (0, _filter4.default)(this.selectable, function (ext) {
	        return selected.indexOf(ext.name) !== -1;
	      }).map(function (ext) {
	        return ext.name;
	      });
	    }
	  },
	  methods: {
	    getSelection: function getSelection(filter) {
	      return (0, _filter4.default)(this.extensions, filter).map(function (ext) {
	        return ext.name;
	      });
	    },
	    uninstall: function uninstall(extensions) {
	      var _this = this;
	
	      this.$once('modal:confirmed', function () {
	        return _this.doUninstall(extensions);
	      });
	      var msg = extensions.length > 1 ? 'You are about to uninstall ' + extensions.length + ' extensions' : 'You are about to uninstall\n            ' + (0, _find4.default)(this.extensions, ['name', extensions[0]]).title;
	      this.promptConfirm(msg);
	    },
	
	    validateSelected: function validateSelected(action) {
	      var _this2 = this;
	
	      if (!this.selected.length || this.server.offline) {
	        return false;
	      }
	
	      var extensions = (0, _filter4.default)(this.extensions, function (ext) {
	        return _this2.selected.indexOf(ext.name) !== -1;
	      });
	      switch (action) {
	        case 'uninstall':
	          return !(0, _some4.default)(extensions, ['type', 'Core']) && (0, _every4.default)(extensions, { installed: true });
	        case 'toggle':
	          return (0, _every4.default)(extensions, { type: 'Plugin', installed: true });
	        case 'download':
	        case 'install':
	          return (0, _every4.default)(extensions, 'subscribed') && (0, _filter4.default)(extensions, { type: 'Element' }).length < 2;
	      }
	    }
	  }
	};

/***/ },
/* 102 */
/***/ function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = {
	  props: {
	    name: {
	      type: String,
	      required: true
	    },
	    completed: {
	      type: Number,
	      coerce: function coerce(value) {
	        return parseInt(value);
	      }
	    },
	    installed: {
	      type: Boolean,
	      default: false
	    },
	    installedVersion: {
	      type: Number,
	      default: 0
	    },
	    timestamp: {
	      type: [Number, Boolean],
	      default: false
	    },
	    code: {
	      type: String,
	      required: true
	    },
	    download: {
	      type: Function,
	      required: true
	    },
	    install: {
	      type: Function,
	      required: true
	    },
	    uninstall: {
	      type: Function,
	      required: true
	    },
	    server: {
	      type: Object,
	      required: true
	    }
	  },
	  computed: {
	    url: function url() {
	      var base = 'https://www.transifex.com/joolanders/zoolanders';
	      return this.isKnown ? base + '/translate/#' + this.code : base;
	    },
	    isOutdated: function isOutdated() {
	      return this.installedVersion !== this.timestamp;
	    },
	    isKnown: function isKnown() {
	      return !this.server.offline && this.timestamp && this.completed;
	    }
	  }
	};

/***/ },
/* 103 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _Language = __webpack_require__(272);
	
	var _Language2 = _interopRequireDefault(_Language);
	
	var _getters = __webpack_require__(47);
	
	var _authentication = __webpack_require__(27);
	
	var _languages = __webpack_require__(91);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = {
	  name: 'languages',
	  activate: function activate(done) {
	    this.retrieve().then(function () {
	      return done();
	    });
	  },
	  components: { Language: _Language2.default },
	  vuex: {
	    getters: {
	      languages: _getters.languages,
	      server: function server(state) {
	        return state.products.server;
	      },
	      view: function view(state) {
	        return state.products.view;
	      },
	      authenticated: function authenticated(state) {
	        return state.products.authentication.status;
	      }
	    },
	    actions: {
	      showAuth: _authentication.show,
	      retrieve: _languages.retrieve,
	      download: _languages.download,
	      install: _languages.install,
	      uninstall: _languages.uninstall,
	      promptConfirm: function promptConfirm(_ref, text) {
	        var dispatch = _ref.dispatch;
	
	        dispatch('SHOW_MODAL_CONFIRM', { text: text,
	          icon: ['uk-icon-exclamation', 'uk-text-warning']
	        });
	      },
	      reload: function reload(_ref2) {
	        var dispatch = _ref2.dispatch;
	
	        dispatch('SHOW_MODAL', { spinner: true, block: true });
	        this.retrieve(true).then(function () {
	          return dispatch('HIDE_MODAL');
	        });
	      }
	    }
	  },
	  computed: {
	    displayed: function displayed() {
	      return this.view === this.$options.name;
	    }
	  },
	  methods: {
	    confirmUninstall: function confirmUninstall(code, name) {
	      var _this = this;
	
	      this.$once('modal:confirmed', function () {
	        _this.uninstall(code);
	      });
	      this.promptConfirm('You are about to uninstall ' + name + ' Language Pack');
	    }
	  }
	};

/***/ },
/* 104 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _vuikit = __webpack_require__(46);
	
	exports.default = {
	  extends: _vuikit.Button,
	  props: {
	    half: {
	      type: Boolean,
	      default: false
	    },
	    title: {
	      type: String,
	      default: ''
	    },
	    size: {
	      type: String,
	      default: 'mini'
	    },
	    icon: {
	      type: String,
	      default: ''
	    },
	    href: {
	      type: String,
	      default: ''
	    },
	    text: {
	      type: String,
	      default: ''
	    }
	  },
	  methods: {
	    clicked: function clicked() {
	      if (this.href) {
	        window.open(this.href, '_blank');
	      }
	    }
	  }
	};

/***/ },
/* 105 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _vuikit = __webpack_require__(46);
	
	exports.default = {
	  extends: _vuikit.Modal,
	  data: function data() {
	    return {
	      requestErrorVisible: false
	    };
	  },
	  props: {
	    requestError: {
	      type: [String, Boolean],
	      default: ''
	    },
	    icon: {
	      type: [String, Array],
	      default: ''
	    },
	    text: {
	      type: String,
	      default: ''
	    },
	    spinner: {
	      type: Boolean,
	      default: false
	    }
	  }
	};

/***/ },
/* 106 */
/***/ function(module, exports, __webpack_require__) {

	module.exports = { "default": __webpack_require__(107), __esModule: true };

/***/ },
/* 107 */
/***/ function(module, exports, __webpack_require__) {

	__webpack_require__(132);
	module.exports = __webpack_require__(28).Object.keys;

/***/ },
/* 108 */
/***/ function(module, exports) {

	module.exports = function(it){
	  if(typeof it != 'function')throw TypeError(it + ' is not a function!');
	  return it;
	};

/***/ },
/* 109 */
/***/ function(module, exports, __webpack_require__) {

	var isObject = __webpack_require__(32);
	module.exports = function(it){
	  if(!isObject(it))throw TypeError(it + ' is not an object!');
	  return it;
	};

/***/ },
/* 110 */
/***/ function(module, exports, __webpack_require__) {

	// false -> Array#indexOf
	// true  -> Array#includes
	var toIObject = __webpack_require__(50)
	  , toLength  = __webpack_require__(128)
	  , toIndex   = __webpack_require__(127);
	module.exports = function(IS_INCLUDES){
	  return function($this, el, fromIndex){
	    var O      = toIObject($this)
	      , length = toLength(O.length)
	      , index  = toIndex(fromIndex, length)
	      , value;
	    // Array#includes uses SameValueZero equality algorithm
	    if(IS_INCLUDES && el != el)while(length > index){
	      value = O[index++];
	      if(value != value)return true;
	    // Array#toIndex ignores holes, Array#includes - not
	    } else for(;length > index; index++)if(IS_INCLUDES || index in O){
	      if(O[index] === el)return IS_INCLUDES || index || 0;
	    } return !IS_INCLUDES && -1;
	  };
	};

/***/ },
/* 111 */
/***/ function(module, exports) {

	var toString = {}.toString;
	
	module.exports = function(it){
	  return toString.call(it).slice(8, -1);
	};

/***/ },
/* 112 */
/***/ function(module, exports, __webpack_require__) {

	// optional / simple context binding
	var aFunction = __webpack_require__(108);
	module.exports = function(fn, that, length){
	  aFunction(fn);
	  if(that === undefined)return fn;
	  switch(length){
	    case 1: return function(a){
	      return fn.call(that, a);
	    };
	    case 2: return function(a, b){
	      return fn.call(that, a, b);
	    };
	    case 3: return function(a, b, c){
	      return fn.call(that, a, b, c);
	    };
	  }
	  return function(/* ...args */){
	    return fn.apply(that, arguments);
	  };
	};

/***/ },
/* 113 */
/***/ function(module, exports, __webpack_require__) {

	var isObject = __webpack_require__(32)
	  , document = __webpack_require__(31).document
	  // in old IE typeof document.createElement is 'object'
	  , is = isObject(document) && isObject(document.createElement);
	module.exports = function(it){
	  return is ? document.createElement(it) : {};
	};

/***/ },
/* 114 */
/***/ function(module, exports) {

	// IE 8- don't enum bug keys
	module.exports = (
	  'constructor,hasOwnProperty,isPrototypeOf,propertyIsEnumerable,toLocaleString,toString,valueOf'
	).split(',');

/***/ },
/* 115 */
/***/ function(module, exports, __webpack_require__) {

	var global    = __webpack_require__(31)
	  , core      = __webpack_require__(28)
	  , ctx       = __webpack_require__(112)
	  , hide      = __webpack_require__(117)
	  , PROTOTYPE = 'prototype';
	
	var $export = function(type, name, source){
	  var IS_FORCED = type & $export.F
	    , IS_GLOBAL = type & $export.G
	    , IS_STATIC = type & $export.S
	    , IS_PROTO  = type & $export.P
	    , IS_BIND   = type & $export.B
	    , IS_WRAP   = type & $export.W
	    , exports   = IS_GLOBAL ? core : core[name] || (core[name] = {})
	    , expProto  = exports[PROTOTYPE]
	    , target    = IS_GLOBAL ? global : IS_STATIC ? global[name] : (global[name] || {})[PROTOTYPE]
	    , key, own, out;
	  if(IS_GLOBAL)source = name;
	  for(key in source){
	    // contains in native
	    own = !IS_FORCED && target && target[key] !== undefined;
	    if(own && key in exports)continue;
	    // export native or passed
	    out = own ? target[key] : source[key];
	    // prevent global pollution for namespaces
	    exports[key] = IS_GLOBAL && typeof target[key] != 'function' ? source[key]
	    // bind timers to global for call from export context
	    : IS_BIND && own ? ctx(out, global)
	    // wrap global constructors for prevent change them in library
	    : IS_WRAP && target[key] == out ? (function(C){
	      var F = function(a, b, c){
	        if(this instanceof C){
	          switch(arguments.length){
	            case 0: return new C;
	            case 1: return new C(a);
	            case 2: return new C(a, b);
	          } return new C(a, b, c);
	        } return C.apply(this, arguments);
	      };
	      F[PROTOTYPE] = C[PROTOTYPE];
	      return F;
	    // make static versions for prototype methods
	    })(out) : IS_PROTO && typeof out == 'function' ? ctx(Function.call, out) : out;
	    // export proto methods to core.%CONSTRUCTOR%.methods.%NAME%
	    if(IS_PROTO){
	      (exports.virtual || (exports.virtual = {}))[key] = out;
	      // export proto methods to core.%CONSTRUCTOR%.prototype.%NAME%
	      if(type & $export.R && expProto && !expProto[key])hide(expProto, key, out);
	    }
	  }
	};
	// type bitmap
	$export.F = 1;   // forced
	$export.G = 2;   // global
	$export.S = 4;   // static
	$export.P = 8;   // proto
	$export.B = 16;  // bind
	$export.W = 32;  // wrap
	$export.U = 64;  // safe
	$export.R = 128; // real proto method for `library` 
	module.exports = $export;

/***/ },
/* 116 */
/***/ function(module, exports) {

	var hasOwnProperty = {}.hasOwnProperty;
	module.exports = function(it, key){
	  return hasOwnProperty.call(it, key);
	};

/***/ },
/* 117 */
/***/ function(module, exports, __webpack_require__) {

	var dP         = __webpack_require__(120)
	  , createDesc = __webpack_require__(124);
	module.exports = __webpack_require__(29) ? function(object, key, value){
	  return dP.f(object, key, createDesc(1, value));
	} : function(object, key, value){
	  object[key] = value;
	  return object;
	};

/***/ },
/* 118 */
/***/ function(module, exports, __webpack_require__) {

	module.exports = !__webpack_require__(29) && !__webpack_require__(30)(function(){
	  return Object.defineProperty(__webpack_require__(113)('div'), 'a', {get: function(){ return 7; }}).a != 7;
	});

/***/ },
/* 119 */
/***/ function(module, exports, __webpack_require__) {

	// fallback for non-array-like ES3 and non-enumerable old V8 strings
	var cof = __webpack_require__(111);
	module.exports = Object('z').propertyIsEnumerable(0) ? Object : function(it){
	  return cof(it) == 'String' ? it.split('') : Object(it);
	};

/***/ },
/* 120 */
/***/ function(module, exports, __webpack_require__) {

	var anObject       = __webpack_require__(109)
	  , IE8_DOM_DEFINE = __webpack_require__(118)
	  , toPrimitive    = __webpack_require__(130)
	  , dP             = Object.defineProperty;
	
	exports.f = __webpack_require__(29) ? Object.defineProperty : function defineProperty(O, P, Attributes){
	  anObject(O);
	  P = toPrimitive(P, true);
	  anObject(Attributes);
	  if(IE8_DOM_DEFINE)try {
	    return dP(O, P, Attributes);
	  } catch(e){ /* empty */ }
	  if('get' in Attributes || 'set' in Attributes)throw TypeError('Accessors not supported!');
	  if('value' in Attributes)O[P] = Attributes.value;
	  return O;
	};

/***/ },
/* 121 */
/***/ function(module, exports, __webpack_require__) {

	var has          = __webpack_require__(116)
	  , toIObject    = __webpack_require__(50)
	  , arrayIndexOf = __webpack_require__(110)(false)
	  , IE_PROTO     = __webpack_require__(125)('IE_PROTO');
	
	module.exports = function(object, names){
	  var O      = toIObject(object)
	    , i      = 0
	    , result = []
	    , key;
	  for(key in O)if(key != IE_PROTO)has(O, key) && result.push(key);
	  // Don't enum bug & hidden keys
	  while(names.length > i)if(has(O, key = names[i++])){
	    ~arrayIndexOf(result, key) || result.push(key);
	  }
	  return result;
	};

/***/ },
/* 122 */
/***/ function(module, exports, __webpack_require__) {

	// 19.1.2.14 / 15.2.3.14 Object.keys(O)
	var $keys       = __webpack_require__(121)
	  , enumBugKeys = __webpack_require__(114);
	
	module.exports = Object.keys || function keys(O){
	  return $keys(O, enumBugKeys);
	};

/***/ },
/* 123 */
/***/ function(module, exports, __webpack_require__) {

	// most Object methods by ES6 should accept primitives
	var $export = __webpack_require__(115)
	  , core    = __webpack_require__(28)
	  , fails   = __webpack_require__(30);
	module.exports = function(KEY, exec){
	  var fn  = (core.Object || {})[KEY] || Object[KEY]
	    , exp = {};
	  exp[KEY] = exec(fn);
	  $export($export.S + $export.F * fails(function(){ fn(1); }), 'Object', exp);
	};

/***/ },
/* 124 */
/***/ function(module, exports) {

	module.exports = function(bitmap, value){
	  return {
	    enumerable  : !(bitmap & 1),
	    configurable: !(bitmap & 2),
	    writable    : !(bitmap & 4),
	    value       : value
	  };
	};

/***/ },
/* 125 */
/***/ function(module, exports, __webpack_require__) {

	var shared = __webpack_require__(126)('keys')
	  , uid    = __webpack_require__(131);
	module.exports = function(key){
	  return shared[key] || (shared[key] = uid(key));
	};

/***/ },
/* 126 */
/***/ function(module, exports, __webpack_require__) {

	var global = __webpack_require__(31)
	  , SHARED = '__core-js_shared__'
	  , store  = global[SHARED] || (global[SHARED] = {});
	module.exports = function(key){
	  return store[key] || (store[key] = {});
	};

/***/ },
/* 127 */
/***/ function(module, exports, __webpack_require__) {

	var toInteger = __webpack_require__(49)
	  , max       = Math.max
	  , min       = Math.min;
	module.exports = function(index, length){
	  index = toInteger(index);
	  return index < 0 ? max(index + length, 0) : min(index, length);
	};

/***/ },
/* 128 */
/***/ function(module, exports, __webpack_require__) {

	// 7.1.15 ToLength
	var toInteger = __webpack_require__(49)
	  , min       = Math.min;
	module.exports = function(it){
	  return it > 0 ? min(toInteger(it), 0x1fffffffffffff) : 0; // pow(2, 53) - 1 == 9007199254740991
	};

/***/ },
/* 129 */
/***/ function(module, exports, __webpack_require__) {

	// 7.1.13 ToObject(argument)
	var defined = __webpack_require__(48);
	module.exports = function(it){
	  return Object(defined(it));
	};

/***/ },
/* 130 */
/***/ function(module, exports, __webpack_require__) {

	// 7.1.1 ToPrimitive(input [, PreferredType])
	var isObject = __webpack_require__(32);
	// instead of the ES6 spec version, we didn't implement @@toPrimitive case
	// and the second argument - flag - preferred type is a string
	module.exports = function(it, S){
	  if(!isObject(it))return it;
	  var fn, val;
	  if(S && typeof (fn = it.toString) == 'function' && !isObject(val = fn.call(it)))return val;
	  if(typeof (fn = it.valueOf) == 'function' && !isObject(val = fn.call(it)))return val;
	  if(!S && typeof (fn = it.toString) == 'function' && !isObject(val = fn.call(it)))return val;
	  throw TypeError("Can't convert object to primitive value");
	};

/***/ },
/* 131 */
/***/ function(module, exports) {

	var id = 0
	  , px = Math.random();
	module.exports = function(key){
	  return 'Symbol('.concat(key === undefined ? '' : key, ')_', (++id + px).toString(36));
	};

/***/ },
/* 132 */
/***/ function(module, exports, __webpack_require__) {

	// 19.1.2.14 Object.keys(O)
	var toObject = __webpack_require__(129)
	  , $keys    = __webpack_require__(122);
	
	__webpack_require__(123)('keys', function(){
	  return function keys(it){
	    return $keys(toObject(it));
	  };
	});

/***/ },
/* 133 */
/***/ function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ },
/* 134 */
/***/ function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ },
/* 135 */
/***/ function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ },
/* 136 */
/***/ function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ },
/* 137 */
/***/ function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ },
/* 138 */
/***/ function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ },
/* 139 */
/***/ function(module, exports, __webpack_require__) {

	var getNative = __webpack_require__(7),
	    root = __webpack_require__(3);
	
	/* Built-in method references that are verified to be native. */
	var DataView = getNative(root, 'DataView');
	
	module.exports = DataView;


/***/ },
/* 140 */
/***/ function(module, exports, __webpack_require__) {

	var hashClear = __webpack_require__(201),
	    hashDelete = __webpack_require__(202),
	    hashGet = __webpack_require__(203),
	    hashHas = __webpack_require__(204),
	    hashSet = __webpack_require__(205);
	
	/**
	 * Creates a hash object.
	 *
	 * @private
	 * @constructor
	 * @param {Array} [entries] The key-value pairs to cache.
	 */
	function Hash(entries) {
	  var index = -1,
	      length = entries ? entries.length : 0;
	
	  this.clear();
	  while (++index < length) {
	    var entry = entries[index];
	    this.set(entry[0], entry[1]);
	  }
	}
	
	// Add methods to `Hash`.
	Hash.prototype.clear = hashClear;
	Hash.prototype['delete'] = hashDelete;
	Hash.prototype.get = hashGet;
	Hash.prototype.has = hashHas;
	Hash.prototype.set = hashSet;
	
	module.exports = Hash;


/***/ },
/* 141 */
/***/ function(module, exports, __webpack_require__) {

	var getNative = __webpack_require__(7),
	    root = __webpack_require__(3);
	
	/* Built-in method references that are verified to be native. */
	var Promise = getNative(root, 'Promise');
	
	module.exports = Promise;


/***/ },
/* 142 */
/***/ function(module, exports, __webpack_require__) {

	var root = __webpack_require__(3);
	
	/** Built-in value references. */
	var Reflect = root.Reflect;
	
	module.exports = Reflect;


/***/ },
/* 143 */
/***/ function(module, exports, __webpack_require__) {

	var getNative = __webpack_require__(7),
	    root = __webpack_require__(3);
	
	/* Built-in method references that are verified to be native. */
	var Set = getNative(root, 'Set');
	
	module.exports = Set;


/***/ },
/* 144 */
/***/ function(module, exports, __webpack_require__) {

	var MapCache = __webpack_require__(33),
	    setCacheAdd = __webpack_require__(224),
	    setCacheHas = __webpack_require__(225);
	
	/**
	 *
	 * Creates an array cache object to store unique values.
	 *
	 * @private
	 * @constructor
	 * @param {Array} [values] The values to cache.
	 */
	function SetCache(values) {
	  var index = -1,
	      length = values ? values.length : 0;
	
	  this.__data__ = new MapCache;
	  while (++index < length) {
	    this.add(values[index]);
	  }
	}
	
	// Add methods to `SetCache`.
	SetCache.prototype.add = SetCache.prototype.push = setCacheAdd;
	SetCache.prototype.has = setCacheHas;
	
	module.exports = SetCache;


/***/ },
/* 145 */
/***/ function(module, exports, __webpack_require__) {

	var getNative = __webpack_require__(7),
	    root = __webpack_require__(3);
	
	/* Built-in method references that are verified to be native. */
	var WeakMap = getNative(root, 'WeakMap');
	
	module.exports = WeakMap;


/***/ },
/* 146 */
/***/ function(module, exports) {

	/**
	 * Adds the key-value `pair` to `map`.
	 *
	 * @private
	 * @param {Object} map The map to modify.
	 * @param {Array} pair The key-value pair to add.
	 * @returns {Object} Returns `map`.
	 */
	function addMapEntry(map, pair) {
	  // Don't return `Map#set` because it doesn't return the map instance in IE 11.
	  map.set(pair[0], pair[1]);
	  return map;
	}
	
	module.exports = addMapEntry;


/***/ },
/* 147 */
/***/ function(module, exports) {

	/**
	 * Adds `value` to `set`.
	 *
	 * @private
	 * @param {Object} set The set to modify.
	 * @param {*} value The value to add.
	 * @returns {Object} Returns `set`.
	 */
	function addSetEntry(set, value) {
	  set.add(value);
	  return set;
	}
	
	module.exports = addSetEntry;


/***/ },
/* 148 */
/***/ function(module, exports) {

	/**
	 * A faster alternative to `Function#apply`, this function invokes `func`
	 * with the `this` binding of `thisArg` and the arguments of `args`.
	 *
	 * @private
	 * @param {Function} func The function to invoke.
	 * @param {*} thisArg The `this` binding of `func`.
	 * @param {Array} args The arguments to invoke `func` with.
	 * @returns {*} Returns the result of `func`.
	 */
	function apply(func, thisArg, args) {
	  var length = args.length;
	  switch (length) {
	    case 0: return func.call(thisArg);
	    case 1: return func.call(thisArg, args[0]);
	    case 2: return func.call(thisArg, args[0], args[1]);
	    case 3: return func.call(thisArg, args[0], args[1], args[2]);
	  }
	  return func.apply(thisArg, args);
	}
	
	module.exports = apply;


/***/ },
/* 149 */
/***/ function(module, exports) {

	/**
	 * A specialized version of `baseAggregator` for arrays.
	 *
	 * @private
	 * @param {Array} [array] The array to iterate over.
	 * @param {Function} setter The function to set `accumulator` values.
	 * @param {Function} iteratee The iteratee to transform keys.
	 * @param {Object} accumulator The initial aggregated object.
	 * @returns {Function} Returns `accumulator`.
	 */
	function arrayAggregator(array, setter, iteratee, accumulator) {
	  var index = -1,
	      length = array ? array.length : 0;
	
	  while (++index < length) {
	    var value = array[index];
	    setter(accumulator, value, iteratee(value), array);
	  }
	  return accumulator;
	}
	
	module.exports = arrayAggregator;


/***/ },
/* 150 */
/***/ function(module, exports) {

	/**
	 * A specialized version of `_.every` for arrays without support for
	 * iteratee shorthands.
	 *
	 * @private
	 * @param {Array} [array] The array to iterate over.
	 * @param {Function} predicate The function invoked per iteration.
	 * @returns {boolean} Returns `true` if all elements pass the predicate check,
	 *  else `false`.
	 */
	function arrayEvery(array, predicate) {
	  var index = -1,
	      length = array ? array.length : 0;
	
	  while (++index < length) {
	    if (!predicate(array[index], index, array)) {
	      return false;
	    }
	  }
	  return true;
	}
	
	module.exports = arrayEvery;


/***/ },
/* 151 */
/***/ function(module, exports, __webpack_require__) {

	var baseEach = __webpack_require__(6);
	
	/**
	 * Aggregates elements of `collection` on `accumulator` with keys transformed
	 * by `iteratee` and values set by `setter`.
	 *
	 * @private
	 * @param {Array|Object} collection The collection to iterate over.
	 * @param {Function} setter The function to set `accumulator` values.
	 * @param {Function} iteratee The iteratee to transform keys.
	 * @param {Object} accumulator The initial aggregated object.
	 * @returns {Function} Returns `accumulator`.
	 */
	function baseAggregator(collection, setter, iteratee, accumulator) {
	  baseEach(collection, function(value, key, collection) {
	    setter(accumulator, value, iteratee(value), collection);
	  });
	  return accumulator;
	}
	
	module.exports = baseAggregator;


/***/ },
/* 152 */
/***/ function(module, exports, __webpack_require__) {

	var copyObject = __webpack_require__(40),
	    keys = __webpack_require__(5);
	
	/**
	 * The base implementation of `_.assign` without support for multiple sources
	 * or `customizer` functions.
	 *
	 * @private
	 * @param {Object} object The destination object.
	 * @param {Object} source The source object.
	 * @returns {Object} Returns `object`.
	 */
	function baseAssign(object, source) {
	  return object && copyObject(source, keys(source), object);
	}
	
	module.exports = baseAssign;


/***/ },
/* 153 */
/***/ function(module, exports, __webpack_require__) {

	var Stack = __webpack_require__(15),
	    arrayEach = __webpack_require__(35),
	    assignValue = __webpack_require__(56),
	    baseAssign = __webpack_require__(152),
	    cloneBuffer = __webpack_require__(177),
	    copyArray = __webpack_require__(68),
	    copySymbols = __webpack_require__(186),
	    getAllKeys = __webpack_require__(194),
	    getTag = __webpack_require__(71),
	    initCloneArray = __webpack_require__(206),
	    initCloneByTag = __webpack_require__(207),
	    initCloneObject = __webpack_require__(208),
	    isArray = __webpack_require__(1),
	    isBuffer = __webpack_require__(239),
	    isHostObject = __webpack_require__(19),
	    isObject = __webpack_require__(4),
	    keys = __webpack_require__(5);
	
	/** `Object#toString` result references. */
	var argsTag = '[object Arguments]',
	    arrayTag = '[object Array]',
	    boolTag = '[object Boolean]',
	    dateTag = '[object Date]',
	    errorTag = '[object Error]',
	    funcTag = '[object Function]',
	    genTag = '[object GeneratorFunction]',
	    mapTag = '[object Map]',
	    numberTag = '[object Number]',
	    objectTag = '[object Object]',
	    regexpTag = '[object RegExp]',
	    setTag = '[object Set]',
	    stringTag = '[object String]',
	    symbolTag = '[object Symbol]',
	    weakMapTag = '[object WeakMap]';
	
	var arrayBufferTag = '[object ArrayBuffer]',
	    dataViewTag = '[object DataView]',
	    float32Tag = '[object Float32Array]',
	    float64Tag = '[object Float64Array]',
	    int8Tag = '[object Int8Array]',
	    int16Tag = '[object Int16Array]',
	    int32Tag = '[object Int32Array]',
	    uint8Tag = '[object Uint8Array]',
	    uint8ClampedTag = '[object Uint8ClampedArray]',
	    uint16Tag = '[object Uint16Array]',
	    uint32Tag = '[object Uint32Array]';
	
	/** Used to identify `toStringTag` values supported by `_.clone`. */
	var cloneableTags = {};
	cloneableTags[argsTag] = cloneableTags[arrayTag] =
	cloneableTags[arrayBufferTag] = cloneableTags[dataViewTag] =
	cloneableTags[boolTag] = cloneableTags[dateTag] =
	cloneableTags[float32Tag] = cloneableTags[float64Tag] =
	cloneableTags[int8Tag] = cloneableTags[int16Tag] =
	cloneableTags[int32Tag] = cloneableTags[mapTag] =
	cloneableTags[numberTag] = cloneableTags[objectTag] =
	cloneableTags[regexpTag] = cloneableTags[setTag] =
	cloneableTags[stringTag] = cloneableTags[symbolTag] =
	cloneableTags[uint8Tag] = cloneableTags[uint8ClampedTag] =
	cloneableTags[uint16Tag] = cloneableTags[uint32Tag] = true;
	cloneableTags[errorTag] = cloneableTags[funcTag] =
	cloneableTags[weakMapTag] = false;
	
	/**
	 * The base implementation of `_.clone` and `_.cloneDeep` which tracks
	 * traversed objects.
	 *
	 * @private
	 * @param {*} value The value to clone.
	 * @param {boolean} [isDeep] Specify a deep clone.
	 * @param {boolean} [isFull] Specify a clone including symbols.
	 * @param {Function} [customizer] The function to customize cloning.
	 * @param {string} [key] The key of `value`.
	 * @param {Object} [object] The parent object of `value`.
	 * @param {Object} [stack] Tracks traversed objects and their clone counterparts.
	 * @returns {*} Returns the cloned value.
	 */
	function baseClone(value, isDeep, isFull, customizer, key, object, stack) {
	  var result;
	  if (customizer) {
	    result = object ? customizer(value, key, object, stack) : customizer(value);
	  }
	  if (result !== undefined) {
	    return result;
	  }
	  if (!isObject(value)) {
	    return value;
	  }
	  var isArr = isArray(value);
	  if (isArr) {
	    result = initCloneArray(value);
	    if (!isDeep) {
	      return copyArray(value, result);
	    }
	  } else {
	    var tag = getTag(value),
	        isFunc = tag == funcTag || tag == genTag;
	
	    if (isBuffer(value)) {
	      return cloneBuffer(value, isDeep);
	    }
	    if (tag == objectTag || tag == argsTag || (isFunc && !object)) {
	      if (isHostObject(value)) {
	        return object ? value : {};
	      }
	      result = initCloneObject(isFunc ? {} : value);
	      if (!isDeep) {
	        return copySymbols(value, baseAssign(result, value));
	      }
	    } else {
	      if (!cloneableTags[tag]) {
	        return object ? value : {};
	      }
	      result = initCloneByTag(value, tag, baseClone, isDeep);
	    }
	  }
	  // Check for circular references and return its corresponding clone.
	  stack || (stack = new Stack);
	  var stacked = stack.get(value);
	  if (stacked) {
	    return stacked;
	  }
	  stack.set(value, result);
	
	  if (!isArr) {
	    var props = isFull ? getAllKeys(value) : keys(value);
	  }
	  // Recursively populate clone (susceptible to call stack limits).
	  arrayEach(props || value, function(subValue, key) {
	    if (props) {
	      key = subValue;
	      subValue = value[key];
	    }
	    assignValue(result, key, baseClone(subValue, isDeep, isFull, customizer, key, value, stack));
	  });
	  return result;
	}
	
	module.exports = baseClone;


/***/ },
/* 154 */
/***/ function(module, exports, __webpack_require__) {

	var isObject = __webpack_require__(4);
	
	/** Built-in value references. */
	var objectCreate = Object.create;
	
	/**
	 * The base implementation of `_.create` without support for assigning
	 * properties to the created object.
	 *
	 * @private
	 * @param {Object} prototype The object to inherit from.
	 * @returns {Object} Returns the new object.
	 */
	function baseCreate(proto) {
	  return isObject(proto) ? objectCreate(proto) : {};
	}
	
	module.exports = baseCreate;


/***/ },
/* 155 */
/***/ function(module, exports, __webpack_require__) {

	var baseEach = __webpack_require__(6);
	
	/**
	 * The base implementation of `_.every` without support for iteratee shorthands.
	 *
	 * @private
	 * @param {Array|Object} collection The collection to iterate over.
	 * @param {Function} predicate The function invoked per iteration.
	 * @returns {boolean} Returns `true` if all elements pass the predicate check,
	 *  else `false`
	 */
	function baseEvery(collection, predicate) {
	  var result = true;
	  baseEach(collection, function(value, index, collection) {
	    result = !!predicate(value, index, collection);
	    return result;
	  });
	  return result;
	}
	
	module.exports = baseEvery;


/***/ },
/* 156 */
/***/ function(module, exports) {

	/**
	 * The base implementation of `_.findIndex` and `_.findLastIndex` without
	 * support for iteratee shorthands.
	 *
	 * @private
	 * @param {Array} array The array to search.
	 * @param {Function} predicate The function invoked per iteration.
	 * @param {number} fromIndex The index to search from.
	 * @param {boolean} [fromRight] Specify iterating from right to left.
	 * @returns {number} Returns the index of the matched value, else `-1`.
	 */
	function baseFindIndex(array, predicate, fromIndex, fromRight) {
	  var length = array.length,
	      index = fromIndex + (fromRight ? 1 : -1);
	
	  while ((fromRight ? index-- : ++index < length)) {
	    if (predicate(array[index], index, array)) {
	      return index;
	    }
	  }
	  return -1;
	}
	
	module.exports = baseFindIndex;


/***/ },
/* 157 */
/***/ function(module, exports, __webpack_require__) {

	var createBaseFor = __webpack_require__(190);
	
	/**
	 * The base implementation of `baseForOwn` which iterates over `object`
	 * properties returned by `keysFunc` and invokes `iteratee` for each property.
	 * Iteratee functions may exit iteration early by explicitly returning `false`.
	 *
	 * @private
	 * @param {Object} object The object to iterate over.
	 * @param {Function} iteratee The function invoked per iteration.
	 * @param {Function} keysFunc The function to get the keys of `object`.
	 * @returns {Object} Returns `object`.
	 */
	var baseFor = createBaseFor();
	
	module.exports = baseFor;


/***/ },
/* 158 */
/***/ function(module, exports) {

	/**
	 * The base implementation of `_.hasIn` without support for deep paths.
	 *
	 * @private
	 * @param {Object} [object] The object to query.
	 * @param {Array|string} key The key to check.
	 * @returns {boolean} Returns `true` if `key` exists, else `false`.
	 */
	function baseHasIn(object, key) {
	  return object != null && key in Object(object);
	}
	
	module.exports = baseHasIn;


/***/ },
/* 159 */
/***/ function(module, exports, __webpack_require__) {

	var Stack = __webpack_require__(15),
	    equalArrays = __webpack_require__(70),
	    equalByTag = __webpack_require__(192),
	    equalObjects = __webpack_require__(193),
	    getTag = __webpack_require__(71),
	    isArray = __webpack_require__(1),
	    isHostObject = __webpack_require__(19),
	    isTypedArray = __webpack_require__(43);
	
	/** Used to compose bitmasks for comparison styles. */
	var PARTIAL_COMPARE_FLAG = 2;
	
	/** `Object#toString` result references. */
	var argsTag = '[object Arguments]',
	    arrayTag = '[object Array]',
	    objectTag = '[object Object]';
	
	/** Used for built-in method references. */
	var objectProto = Object.prototype;
	
	/** Used to check objects for own properties. */
	var hasOwnProperty = objectProto.hasOwnProperty;
	
	/**
	 * A specialized version of `baseIsEqual` for arrays and objects which performs
	 * deep comparisons and tracks traversed objects enabling objects with circular
	 * references to be compared.
	 *
	 * @private
	 * @param {Object} object The object to compare.
	 * @param {Object} other The other object to compare.
	 * @param {Function} equalFunc The function to determine equivalents of values.
	 * @param {Function} [customizer] The function to customize comparisons.
	 * @param {number} [bitmask] The bitmask of comparison flags. See `baseIsEqual`
	 *  for more details.
	 * @param {Object} [stack] Tracks traversed `object` and `other` objects.
	 * @returns {boolean} Returns `true` if the objects are equivalent, else `false`.
	 */
	function baseIsEqualDeep(object, other, equalFunc, customizer, bitmask, stack) {
	  var objIsArr = isArray(object),
	      othIsArr = isArray(other),
	      objTag = arrayTag,
	      othTag = arrayTag;
	
	  if (!objIsArr) {
	    objTag = getTag(object);
	    objTag = objTag == argsTag ? objectTag : objTag;
	  }
	  if (!othIsArr) {
	    othTag = getTag(other);
	    othTag = othTag == argsTag ? objectTag : othTag;
	  }
	  var objIsObj = objTag == objectTag && !isHostObject(object),
	      othIsObj = othTag == objectTag && !isHostObject(other),
	      isSameTag = objTag == othTag;
	
	  if (isSameTag && !objIsObj) {
	    stack || (stack = new Stack);
	    return (objIsArr || isTypedArray(object))
	      ? equalArrays(object, other, equalFunc, customizer, bitmask, stack)
	      : equalByTag(object, other, objTag, equalFunc, customizer, bitmask, stack);
	  }
	  if (!(bitmask & PARTIAL_COMPARE_FLAG)) {
	    var objIsWrapped = objIsObj && hasOwnProperty.call(object, '__wrapped__'),
	        othIsWrapped = othIsObj && hasOwnProperty.call(other, '__wrapped__');
	
	    if (objIsWrapped || othIsWrapped) {
	      var objUnwrapped = objIsWrapped ? object.value() : object,
	          othUnwrapped = othIsWrapped ? other.value() : other;
	
	      stack || (stack = new Stack);
	      return equalFunc(objUnwrapped, othUnwrapped, customizer, bitmask, stack);
	    }
	  }
	  if (!isSameTag) {
	    return false;
	  }
	  stack || (stack = new Stack);
	  return equalObjects(object, other, equalFunc, customizer, bitmask, stack);
	}
	
	module.exports = baseIsEqualDeep;


/***/ },
/* 160 */
/***/ function(module, exports, __webpack_require__) {

	var Stack = __webpack_require__(15),
	    baseIsEqual = __webpack_require__(63);
	
	/** Used to compose bitmasks for comparison styles. */
	var UNORDERED_COMPARE_FLAG = 1,
	    PARTIAL_COMPARE_FLAG = 2;
	
	/**
	 * The base implementation of `_.isMatch` without support for iteratee shorthands.
	 *
	 * @private
	 * @param {Object} object The object to inspect.
	 * @param {Object} source The object of property values to match.
	 * @param {Array} matchData The property names, values, and compare flags to match.
	 * @param {Function} [customizer] The function to customize comparisons.
	 * @returns {boolean} Returns `true` if `object` is a match, else `false`.
	 */
	function baseIsMatch(object, source, matchData, customizer) {
	  var index = matchData.length,
	      length = index,
	      noCustomizer = !customizer;
	
	  if (object == null) {
	    return !length;
	  }
	  object = Object(object);
	  while (index--) {
	    var data = matchData[index];
	    if ((noCustomizer && data[2])
	          ? data[1] !== object[data[0]]
	          : !(data[0] in object)
	        ) {
	      return false;
	    }
	  }
	  while (++index < length) {
	    data = matchData[index];
	    var key = data[0],
	        objValue = object[key],
	        srcValue = data[1];
	
	    if (noCustomizer && data[2]) {
	      if (objValue === undefined && !(key in object)) {
	        return false;
	      }
	    } else {
	      var stack = new Stack;
	      if (customizer) {
	        var result = customizer(objValue, srcValue, key, object, source, stack);
	      }
	      if (!(result === undefined
	            ? baseIsEqual(srcValue, objValue, customizer, UNORDERED_COMPARE_FLAG | PARTIAL_COMPARE_FLAG, stack)
	            : result
	          )) {
	        return false;
	      }
	    }
	  }
	  return true;
	}
	
	module.exports = baseIsMatch;


/***/ },
/* 161 */
/***/ function(module, exports, __webpack_require__) {

	var isFunction = __webpack_require__(12),
	    isHostObject = __webpack_require__(19),
	    isMasked = __webpack_require__(212),
	    isObject = __webpack_require__(4),
	    toSource = __webpack_require__(77);
	
	/**
	 * Used to match `RegExp`
	 * [syntax characters](http://ecma-international.org/ecma-262/6.0/#sec-patterns).
	 */
	var reRegExpChar = /[\\^$.*+?()[\]{}|]/g;
	
	/** Used to detect host constructors (Safari). */
	var reIsHostCtor = /^\[object .+?Constructor\]$/;
	
	/** Used for built-in method references. */
	var objectProto = Object.prototype;
	
	/** Used to resolve the decompiled source of functions. */
	var funcToString = Function.prototype.toString;
	
	/** Used to check objects for own properties. */
	var hasOwnProperty = objectProto.hasOwnProperty;
	
	/** Used to detect if a method is native. */
	var reIsNative = RegExp('^' +
	  funcToString.call(hasOwnProperty).replace(reRegExpChar, '\\$&')
	  .replace(/hasOwnProperty|(function).*?(?=\\\()| for .+?(?=\\\])/g, '$1.*?') + '$'
	);
	
	/**
	 * The base implementation of `_.isNative` without bad shim checks.
	 *
	 * @private
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is a native function,
	 *  else `false`.
	 */
	function baseIsNative(value) {
	  if (!isObject(value) || isMasked(value)) {
	    return false;
	  }
	  var pattern = (isFunction(value) || isHostObject(value)) ? reIsNative : reIsHostCtor;
	  return pattern.test(toSource(value));
	}
	
	module.exports = baseIsNative;


/***/ },
/* 162 */
/***/ function(module, exports) {

	/* Built-in method references for those with the same name as other `lodash` methods. */
	var nativeKeys = Object.keys;
	
	/**
	 * The base implementation of `_.keys` which doesn't skip the constructor
	 * property of prototypes or treat sparse arrays as dense.
	 *
	 * @private
	 * @param {Object} object The object to query.
	 * @returns {Array} Returns the array of property names.
	 */
	function baseKeys(object) {
	  return nativeKeys(Object(object));
	}
	
	module.exports = baseKeys;


/***/ },
/* 163 */
/***/ function(module, exports, __webpack_require__) {

	var Reflect = __webpack_require__(142),
	    iteratorToArray = __webpack_require__(213);
	
	/** Used for built-in method references. */
	var objectProto = Object.prototype;
	
	/** Built-in value references. */
	var enumerate = Reflect ? Reflect.enumerate : undefined,
	    propertyIsEnumerable = objectProto.propertyIsEnumerable;
	
	/**
	 * The base implementation of `_.keysIn` which doesn't skip the constructor
	 * property of prototypes or treat sparse arrays as dense.
	 *
	 * @private
	 * @param {Object} object The object to query.
	 * @returns {Array} Returns the array of property names.
	 */
	function baseKeysIn(object) {
	  object = object == null ? object : Object(object);
	
	  var result = [];
	  for (var key in object) {
	    result.push(key);
	  }
	  return result;
	}
	
	// Fallback for IE < 9 with es6-shim.
	if (enumerate && !propertyIsEnumerable.call({ 'valueOf': 1 }, 'valueOf')) {
	  baseKeysIn = function(object) {
	    return iteratorToArray(enumerate(object));
	  };
	}
	
	module.exports = baseKeysIn;


/***/ },
/* 164 */
/***/ function(module, exports, __webpack_require__) {

	var baseIsMatch = __webpack_require__(160),
	    getMatchData = __webpack_require__(197),
	    matchesStrictComparable = __webpack_require__(75);
	
	/**
	 * The base implementation of `_.matches` which doesn't clone `source`.
	 *
	 * @private
	 * @param {Object} source The object of property values to match.
	 * @returns {Function} Returns the new spec function.
	 */
	function baseMatches(source) {
	  var matchData = getMatchData(source);
	  if (matchData.length == 1 && matchData[0][2]) {
	    return matchesStrictComparable(matchData[0][0], matchData[0][1]);
	  }
	  return function(object) {
	    return object === source || baseIsMatch(object, source, matchData);
	  };
	}
	
	module.exports = baseMatches;


/***/ },
/* 165 */
/***/ function(module, exports, __webpack_require__) {

	var baseIsEqual = __webpack_require__(63),
	    get = __webpack_require__(79),
	    hasIn = __webpack_require__(238),
	    isKey = __webpack_require__(22),
	    isStrictComparable = __webpack_require__(73),
	    matchesStrictComparable = __webpack_require__(75),
	    toKey = __webpack_require__(11);
	
	/** Used to compose bitmasks for comparison styles. */
	var UNORDERED_COMPARE_FLAG = 1,
	    PARTIAL_COMPARE_FLAG = 2;
	
	/**
	 * The base implementation of `_.matchesProperty` which doesn't clone `srcValue`.
	 *
	 * @private
	 * @param {string} path The path of the property to get.
	 * @param {*} srcValue The value to match.
	 * @returns {Function} Returns the new spec function.
	 */
	function baseMatchesProperty(path, srcValue) {
	  if (isKey(path) && isStrictComparable(srcValue)) {
	    return matchesStrictComparable(toKey(path), srcValue);
	  }
	  return function(object) {
	    var objValue = get(object, path);
	    return (objValue === undefined && objValue === srcValue)
	      ? hasIn(object, path)
	      : baseIsEqual(srcValue, objValue, undefined, UNORDERED_COMPARE_FLAG | PARTIAL_COMPARE_FLAG);
	  };
	}
	
	module.exports = baseMatchesProperty;


/***/ },
/* 166 */
/***/ function(module, exports, __webpack_require__) {

	var assignMergeValue = __webpack_require__(55),
	    baseClone = __webpack_require__(153),
	    copyArray = __webpack_require__(68),
	    isArguments = __webpack_require__(25),
	    isArray = __webpack_require__(1),
	    isArrayLikeObject = __webpack_require__(81),
	    isFunction = __webpack_require__(12),
	    isObject = __webpack_require__(4),
	    isPlainObject = __webpack_require__(240),
	    isTypedArray = __webpack_require__(43),
	    toPlainObject = __webpack_require__(255);
	
	/**
	 * A specialized version of `baseMerge` for arrays and objects which performs
	 * deep merges and tracks traversed objects enabling objects with circular
	 * references to be merged.
	 *
	 * @private
	 * @param {Object} object The destination object.
	 * @param {Object} source The source object.
	 * @param {string} key The key of the value to merge.
	 * @param {number} srcIndex The index of `source`.
	 * @param {Function} mergeFunc The function to merge values.
	 * @param {Function} [customizer] The function to customize assigned values.
	 * @param {Object} [stack] Tracks traversed source values and their merged
	 *  counterparts.
	 */
	function baseMergeDeep(object, source, key, srcIndex, mergeFunc, customizer, stack) {
	  var objValue = object[key],
	      srcValue = source[key],
	      stacked = stack.get(srcValue);
	
	  if (stacked) {
	    assignMergeValue(object, key, stacked);
	    return;
	  }
	  var newValue = customizer
	    ? customizer(objValue, srcValue, (key + ''), object, source, stack)
	    : undefined;
	
	  var isCommon = newValue === undefined;
	
	  if (isCommon) {
	    newValue = srcValue;
	    if (isArray(srcValue) || isTypedArray(srcValue)) {
	      if (isArray(objValue)) {
	        newValue = objValue;
	      }
	      else if (isArrayLikeObject(objValue)) {
	        newValue = copyArray(objValue);
	      }
	      else {
	        isCommon = false;
	        newValue = baseClone(srcValue, true);
	      }
	    }
	    else if (isPlainObject(srcValue) || isArguments(srcValue)) {
	      if (isArguments(objValue)) {
	        newValue = toPlainObject(objValue);
	      }
	      else if (!isObject(objValue) || (srcIndex && isFunction(objValue))) {
	        isCommon = false;
	        newValue = baseClone(srcValue, true);
	      }
	      else {
	        newValue = objValue;
	      }
	    }
	    else {
	      isCommon = false;
	    }
	  }
	  stack.set(srcValue, newValue);
	
	  if (isCommon) {
	    // Recursively merge objects and arrays (susceptible to call stack limits).
	    mergeFunc(newValue, srcValue, srcIndex, customizer, stack);
	  }
	  stack['delete'](srcValue);
	  assignMergeValue(object, key, newValue);
	}
	
	module.exports = baseMergeDeep;


/***/ },
/* 167 */
/***/ function(module, exports, __webpack_require__) {

	var arrayMap = __webpack_require__(36),
	    baseIteratee = __webpack_require__(2),
	    baseMap = __webpack_require__(64),
	    baseSortBy = __webpack_require__(172),
	    baseUnary = __webpack_require__(175),
	    compareMultiple = __webpack_require__(185),
	    identity = __webpack_require__(80);
	
	/**
	 * The base implementation of `_.orderBy` without param guards.
	 *
	 * @private
	 * @param {Array|Object} collection The collection to iterate over.
	 * @param {Function[]|Object[]|string[]} iteratees The iteratees to sort by.
	 * @param {string[]} orders The sort orders of `iteratees`.
	 * @returns {Array} Returns the new sorted array.
	 */
	function baseOrderBy(collection, iteratees, orders) {
	  var index = -1;
	  iteratees = arrayMap(iteratees.length ? iteratees : [identity], baseUnary(baseIteratee));
	
	  var result = baseMap(collection, function(value, key, collection) {
	    var criteria = arrayMap(iteratees, function(iteratee) {
	      return iteratee(value);
	    });
	    return { 'criteria': criteria, 'index': ++index, 'value': value };
	  });
	
	  return baseSortBy(result, function(object, other) {
	    return compareMultiple(object, other, orders);
	  });
	}
	
	module.exports = baseOrderBy;


/***/ },
/* 168 */
/***/ function(module, exports, __webpack_require__) {

	var arrayReduce = __webpack_require__(38);
	
	/**
	 * The base implementation of `_.pick` without support for individual
	 * property identifiers.
	 *
	 * @private
	 * @param {Object} object The source object.
	 * @param {string[]} props The property identifiers to pick.
	 * @returns {Object} Returns the new object.
	 */
	function basePick(object, props) {
	  object = Object(object);
	  return arrayReduce(props, function(result, key) {
	    if (key in object) {
	      result[key] = object[key];
	    }
	    return result;
	  }, {});
	}
	
	module.exports = basePick;


/***/ },
/* 169 */
/***/ function(module, exports, __webpack_require__) {

	var getAllKeysIn = __webpack_require__(195);
	
	/**
	 * The base implementation of  `_.pickBy` without support for iteratee shorthands.
	 *
	 * @private
	 * @param {Object} object The source object.
	 * @param {Function} predicate The function invoked per property.
	 * @returns {Object} Returns the new object.
	 */
	function basePickBy(object, predicate) {
	  var index = -1,
	      props = getAllKeysIn(object),
	      length = props.length,
	      result = {};
	
	  while (++index < length) {
	    var key = props[index],
	        value = object[key];
	
	    if (predicate(value, key)) {
	      result[key] = value;
	    }
	  }
	  return result;
	}
	
	module.exports = basePickBy;


/***/ },
/* 170 */
/***/ function(module, exports, __webpack_require__) {

	var baseGet = __webpack_require__(60);
	
	/**
	 * A specialized version of `baseProperty` which supports deep paths.
	 *
	 * @private
	 * @param {Array|string} path The path of the property to get.
	 * @returns {Function} Returns the new accessor function.
	 */
	function basePropertyDeep(path) {
	  return function(object) {
	    return baseGet(object, path);
	  };
	}
	
	module.exports = basePropertyDeep;


/***/ },
/* 171 */
/***/ function(module, exports, __webpack_require__) {

	var baseEach = __webpack_require__(6);
	
	/**
	 * The base implementation of `_.some` without support for iteratee shorthands.
	 *
	 * @private
	 * @param {Array|Object} collection The collection to iterate over.
	 * @param {Function} predicate The function invoked per iteration.
	 * @returns {boolean} Returns `true` if any element passes the predicate check,
	 *  else `false`.
	 */
	function baseSome(collection, predicate) {
	  var result;
	
	  baseEach(collection, function(value, index, collection) {
	    result = predicate(value, index, collection);
	    return !result;
	  });
	  return !!result;
	}
	
	module.exports = baseSome;


/***/ },
/* 172 */
/***/ function(module, exports) {

	/**
	 * The base implementation of `_.sortBy` which uses `comparer` to define the
	 * sort order of `array` and replaces criteria objects with their corresponding
	 * values.
	 *
	 * @private
	 * @param {Array} array The array to sort.
	 * @param {Function} comparer The function to define sort order.
	 * @returns {Array} Returns `array`.
	 */
	function baseSortBy(array, comparer) {
	  var length = array.length;
	
	  array.sort(comparer);
	  while (length--) {
	    array[length] = array[length].value;
	  }
	  return array;
	}
	
	module.exports = baseSortBy;


/***/ },
/* 173 */
/***/ function(module, exports) {

	/**
	 * The base implementation of `_.times` without support for iteratee shorthands
	 * or max array length checks.
	 *
	 * @private
	 * @param {number} n The number of times to invoke `iteratee`.
	 * @param {Function} iteratee The function invoked per iteration.
	 * @returns {Array} Returns the array of results.
	 */
	function baseTimes(n, iteratee) {
	  var index = -1,
	      result = Array(n);
	
	  while (++index < n) {
	    result[index] = iteratee(index);
	  }
	  return result;
	}
	
	module.exports = baseTimes;


/***/ },
/* 174 */
/***/ function(module, exports, __webpack_require__) {

	var Symbol = __webpack_require__(34),
	    isSymbol = __webpack_require__(13);
	
	/** Used as references for various `Number` constants. */
	var INFINITY = 1 / 0;
	
	/** Used to convert symbols to primitives and strings. */
	var symbolProto = Symbol ? Symbol.prototype : undefined,
	    symbolToString = symbolProto ? symbolProto.toString : undefined;
	
	/**
	 * The base implementation of `_.toString` which doesn't convert nullish
	 * values to empty strings.
	 *
	 * @private
	 * @param {*} value The value to process.
	 * @returns {string} Returns the string.
	 */
	function baseToString(value) {
	  // Exit early for strings to avoid a performance hit in some environments.
	  if (typeof value == 'string') {
	    return value;
	  }
	  if (isSymbol(value)) {
	    return symbolToString ? symbolToString.call(value) : '';
	  }
	  var result = (value + '');
	  return (result == '0' && (1 / value) == -INFINITY) ? '-0' : result;
	}
	
	module.exports = baseToString;


/***/ },
/* 175 */
/***/ function(module, exports) {

	/**
	 * The base implementation of `_.unary` without support for storing wrapper metadata.
	 *
	 * @private
	 * @param {Function} func The function to cap arguments for.
	 * @returns {Function} Returns the new capped function.
	 */
	function baseUnary(func) {
	  return function(value) {
	    return func(value);
	  };
	}
	
	module.exports = baseUnary;


/***/ },
/* 176 */
/***/ function(module, exports) {

	/**
	 * Checks if `value` is a global object.
	 *
	 * @private
	 * @param {*} value The value to check.
	 * @returns {null|Object} Returns `value` if it's a global object, else `null`.
	 */
	function checkGlobal(value) {
	  return (value && value.Object === Object) ? value : null;
	}
	
	module.exports = checkGlobal;


/***/ },
/* 177 */
/***/ function(module, exports) {

	/**
	 * Creates a clone of  `buffer`.
	 *
	 * @private
	 * @param {Buffer} buffer The buffer to clone.
	 * @param {boolean} [isDeep] Specify a deep clone.
	 * @returns {Buffer} Returns the cloned buffer.
	 */
	function cloneBuffer(buffer, isDeep) {
	  if (isDeep) {
	    return buffer.slice();
	  }
	  var result = new buffer.constructor(buffer.length);
	  buffer.copy(result);
	  return result;
	}
	
	module.exports = cloneBuffer;


/***/ },
/* 178 */
/***/ function(module, exports, __webpack_require__) {

	var cloneArrayBuffer = __webpack_require__(39);
	
	/**
	 * Creates a clone of `dataView`.
	 *
	 * @private
	 * @param {Object} dataView The data view to clone.
	 * @param {boolean} [isDeep] Specify a deep clone.
	 * @returns {Object} Returns the cloned data view.
	 */
	function cloneDataView(dataView, isDeep) {
	  var buffer = isDeep ? cloneArrayBuffer(dataView.buffer) : dataView.buffer;
	  return new dataView.constructor(buffer, dataView.byteOffset, dataView.byteLength);
	}
	
	module.exports = cloneDataView;


/***/ },
/* 179 */
/***/ function(module, exports, __webpack_require__) {

	var addMapEntry = __webpack_require__(146),
	    arrayReduce = __webpack_require__(38),
	    mapToArray = __webpack_require__(74);
	
	/**
	 * Creates a clone of `map`.
	 *
	 * @private
	 * @param {Object} map The map to clone.
	 * @param {Function} cloneFunc The function to clone values.
	 * @param {boolean} [isDeep] Specify a deep clone.
	 * @returns {Object} Returns the cloned map.
	 */
	function cloneMap(map, isDeep, cloneFunc) {
	  var array = isDeep ? cloneFunc(mapToArray(map), true) : mapToArray(map);
	  return arrayReduce(array, addMapEntry, new map.constructor);
	}
	
	module.exports = cloneMap;


/***/ },
/* 180 */
/***/ function(module, exports) {

	/** Used to match `RegExp` flags from their coerced string values. */
	var reFlags = /\w*$/;
	
	/**
	 * Creates a clone of `regexp`.
	 *
	 * @private
	 * @param {Object} regexp The regexp to clone.
	 * @returns {Object} Returns the cloned regexp.
	 */
	function cloneRegExp(regexp) {
	  var result = new regexp.constructor(regexp.source, reFlags.exec(regexp));
	  result.lastIndex = regexp.lastIndex;
	  return result;
	}
	
	module.exports = cloneRegExp;


/***/ },
/* 181 */
/***/ function(module, exports, __webpack_require__) {

	var addSetEntry = __webpack_require__(147),
	    arrayReduce = __webpack_require__(38),
	    setToArray = __webpack_require__(76);
	
	/**
	 * Creates a clone of `set`.
	 *
	 * @private
	 * @param {Object} set The set to clone.
	 * @param {Function} cloneFunc The function to clone values.
	 * @param {boolean} [isDeep] Specify a deep clone.
	 * @returns {Object} Returns the cloned set.
	 */
	function cloneSet(set, isDeep, cloneFunc) {
	  var array = isDeep ? cloneFunc(setToArray(set), true) : setToArray(set);
	  return arrayReduce(array, addSetEntry, new set.constructor);
	}
	
	module.exports = cloneSet;


/***/ },
/* 182 */
/***/ function(module, exports, __webpack_require__) {

	var Symbol = __webpack_require__(34);
	
	/** Used to convert symbols to primitives and strings. */
	var symbolProto = Symbol ? Symbol.prototype : undefined,
	    symbolValueOf = symbolProto ? symbolProto.valueOf : undefined;
	
	/**
	 * Creates a clone of the `symbol` object.
	 *
	 * @private
	 * @param {Object} symbol The symbol object to clone.
	 * @returns {Object} Returns the cloned symbol object.
	 */
	function cloneSymbol(symbol) {
	  return symbolValueOf ? Object(symbolValueOf.call(symbol)) : {};
	}
	
	module.exports = cloneSymbol;


/***/ },
/* 183 */
/***/ function(module, exports, __webpack_require__) {

	var cloneArrayBuffer = __webpack_require__(39);
	
	/**
	 * Creates a clone of `typedArray`.
	 *
	 * @private
	 * @param {Object} typedArray The typed array to clone.
	 * @param {boolean} [isDeep] Specify a deep clone.
	 * @returns {Object} Returns the cloned typed array.
	 */
	function cloneTypedArray(typedArray, isDeep) {
	  var buffer = isDeep ? cloneArrayBuffer(typedArray.buffer) : typedArray.buffer;
	  return new typedArray.constructor(buffer, typedArray.byteOffset, typedArray.length);
	}
	
	module.exports = cloneTypedArray;


/***/ },
/* 184 */
/***/ function(module, exports, __webpack_require__) {

	var isSymbol = __webpack_require__(13);
	
	/**
	 * Compares values to sort them in ascending order.
	 *
	 * @private
	 * @param {*} value The value to compare.
	 * @param {*} other The other value to compare.
	 * @returns {number} Returns the sort order indicator for `value`.
	 */
	function compareAscending(value, other) {
	  if (value !== other) {
	    var valIsDefined = value !== undefined,
	        valIsNull = value === null,
	        valIsReflexive = value === value,
	        valIsSymbol = isSymbol(value);
	
	    var othIsDefined = other !== undefined,
	        othIsNull = other === null,
	        othIsReflexive = other === other,
	        othIsSymbol = isSymbol(other);
	
	    if ((!othIsNull && !othIsSymbol && !valIsSymbol && value > other) ||
	        (valIsSymbol && othIsDefined && othIsReflexive && !othIsNull && !othIsSymbol) ||
	        (valIsNull && othIsDefined && othIsReflexive) ||
	        (!valIsDefined && othIsReflexive) ||
	        !valIsReflexive) {
	      return 1;
	    }
	    if ((!valIsNull && !valIsSymbol && !othIsSymbol && value < other) ||
	        (othIsSymbol && valIsDefined && valIsReflexive && !valIsNull && !valIsSymbol) ||
	        (othIsNull && valIsDefined && valIsReflexive) ||
	        (!othIsDefined && valIsReflexive) ||
	        !othIsReflexive) {
	      return -1;
	    }
	  }
	  return 0;
	}
	
	module.exports = compareAscending;


/***/ },
/* 185 */
/***/ function(module, exports, __webpack_require__) {

	var compareAscending = __webpack_require__(184);
	
	/**
	 * Used by `_.orderBy` to compare multiple properties of a value to another
	 * and stable sort them.
	 *
	 * If `orders` is unspecified, all values are sorted in ascending order. Otherwise,
	 * specify an order of "desc" for descending or "asc" for ascending sort order
	 * of corresponding values.
	 *
	 * @private
	 * @param {Object} object The object to compare.
	 * @param {Object} other The other object to compare.
	 * @param {boolean[]|string[]} orders The order to sort by for each property.
	 * @returns {number} Returns the sort order indicator for `object`.
	 */
	function compareMultiple(object, other, orders) {
	  var index = -1,
	      objCriteria = object.criteria,
	      othCriteria = other.criteria,
	      length = objCriteria.length,
	      ordersLength = orders.length;
	
	  while (++index < length) {
	    var result = compareAscending(objCriteria[index], othCriteria[index]);
	    if (result) {
	      if (index >= ordersLength) {
	        return result;
	      }
	      var order = orders[index];
	      return result * (order == 'desc' ? -1 : 1);
	    }
	  }
	  // Fixes an `Array#sort` bug in the JS engine embedded in Adobe applications
	  // that causes it, under certain circumstances, to provide the same value for
	  // `object` and `other`. See https://github.com/jashkenas/underscore/pull/1247
	  // for more details.
	  //
	  // This also ensures a stable sort in V8 and other engines.
	  // See https://bugs.chromium.org/p/v8/issues/detail?id=90 for more details.
	  return object.index - other.index;
	}
	
	module.exports = compareMultiple;


/***/ },
/* 186 */
/***/ function(module, exports, __webpack_require__) {

	var copyObject = __webpack_require__(40),
	    getSymbols = __webpack_require__(41);
	
	/**
	 * Copies own symbol properties of `source` to `object`.
	 *
	 * @private
	 * @param {Object} source The object to copy symbols from.
	 * @param {Object} [object={}] The object to copy symbols to.
	 * @returns {Object} Returns `object`.
	 */
	function copySymbols(source, object) {
	  return copyObject(source, getSymbols(source), object);
	}
	
	module.exports = copySymbols;


/***/ },
/* 187 */
/***/ function(module, exports, __webpack_require__) {

	var root = __webpack_require__(3);
	
	/** Used to detect overreaching core-js shims. */
	var coreJsData = root['__core-js_shared__'];
	
	module.exports = coreJsData;


/***/ },
/* 188 */
/***/ function(module, exports, __webpack_require__) {

	var arrayAggregator = __webpack_require__(149),
	    baseAggregator = __webpack_require__(151),
	    baseIteratee = __webpack_require__(2),
	    isArray = __webpack_require__(1);
	
	/**
	 * Creates a function like `_.groupBy`.
	 *
	 * @private
	 * @param {Function} setter The function to set accumulator values.
	 * @param {Function} [initializer] The accumulator object initializer.
	 * @returns {Function} Returns the new aggregator function.
	 */
	function createAggregator(setter, initializer) {
	  return function(collection, iteratee) {
	    var func = isArray(collection) ? arrayAggregator : baseAggregator,
	        accumulator = initializer ? initializer() : {};
	
	    return func(collection, setter, baseIteratee(iteratee), accumulator);
	  };
	}
	
	module.exports = createAggregator;


/***/ },
/* 189 */
/***/ function(module, exports, __webpack_require__) {

	var isArrayLike = __webpack_require__(8);
	
	/**
	 * Creates a `baseEach` or `baseEachRight` function.
	 *
	 * @private
	 * @param {Function} eachFunc The function to iterate over a collection.
	 * @param {boolean} [fromRight] Specify iterating from right to left.
	 * @returns {Function} Returns the new base function.
	 */
	function createBaseEach(eachFunc, fromRight) {
	  return function(collection, iteratee) {
	    if (collection == null) {
	      return collection;
	    }
	    if (!isArrayLike(collection)) {
	      return eachFunc(collection, iteratee);
	    }
	    var length = collection.length,
	        index = fromRight ? length : -1,
	        iterable = Object(collection);
	
	    while ((fromRight ? index-- : ++index < length)) {
	      if (iteratee(iterable[index], index, iterable) === false) {
	        break;
	      }
	    }
	    return collection;
	  };
	}
	
	module.exports = createBaseEach;


/***/ },
/* 190 */
/***/ function(module, exports) {

	/**
	 * Creates a base function for methods like `_.forIn` and `_.forOwn`.
	 *
	 * @private
	 * @param {boolean} [fromRight] Specify iterating from right to left.
	 * @returns {Function} Returns the new base function.
	 */
	function createBaseFor(fromRight) {
	  return function(object, iteratee, keysFunc) {
	    var index = -1,
	        iterable = Object(object),
	        props = keysFunc(object),
	        length = props.length;
	
	    while (length--) {
	      var key = props[fromRight ? length : ++index];
	      if (iteratee(iterable[key], key, iterable) === false) {
	        break;
	      }
	    }
	    return object;
	  };
	}
	
	module.exports = createBaseFor;


/***/ },
/* 191 */
/***/ function(module, exports, __webpack_require__) {

	var baseIteratee = __webpack_require__(2),
	    isArrayLike = __webpack_require__(8),
	    keys = __webpack_require__(5);
	
	/**
	 * Creates a `_.find` or `_.findLast` function.
	 *
	 * @private
	 * @param {Function} findIndexFunc The function to find the collection index.
	 * @returns {Function} Returns the new find function.
	 */
	function createFind(findIndexFunc) {
	  return function(collection, predicate, fromIndex) {
	    var iterable = Object(collection);
	    predicate = baseIteratee(predicate, 3);
	    if (!isArrayLike(collection)) {
	      var props = keys(collection);
	    }
	    var index = findIndexFunc(props || collection, function(value, key) {
	      if (props) {
	        key = value;
	        value = iterable[key];
	      }
	      return predicate(value, key, iterable);
	    }, fromIndex);
	    return index > -1 ? collection[props ? props[index] : index] : undefined;
	  };
	}
	
	module.exports = createFind;


/***/ },
/* 192 */
/***/ function(module, exports, __webpack_require__) {

	var Symbol = __webpack_require__(34),
	    Uint8Array = __webpack_require__(52),
	    equalArrays = __webpack_require__(70),
	    mapToArray = __webpack_require__(74),
	    setToArray = __webpack_require__(76);
	
	/** Used to compose bitmasks for comparison styles. */
	var UNORDERED_COMPARE_FLAG = 1,
	    PARTIAL_COMPARE_FLAG = 2;
	
	/** `Object#toString` result references. */
	var boolTag = '[object Boolean]',
	    dateTag = '[object Date]',
	    errorTag = '[object Error]',
	    mapTag = '[object Map]',
	    numberTag = '[object Number]',
	    regexpTag = '[object RegExp]',
	    setTag = '[object Set]',
	    stringTag = '[object String]',
	    symbolTag = '[object Symbol]';
	
	var arrayBufferTag = '[object ArrayBuffer]',
	    dataViewTag = '[object DataView]';
	
	/** Used to convert symbols to primitives and strings. */
	var symbolProto = Symbol ? Symbol.prototype : undefined,
	    symbolValueOf = symbolProto ? symbolProto.valueOf : undefined;
	
	/**
	 * A specialized version of `baseIsEqualDeep` for comparing objects of
	 * the same `toStringTag`.
	 *
	 * **Note:** This function only supports comparing values with tags of
	 * `Boolean`, `Date`, `Error`, `Number`, `RegExp`, or `String`.
	 *
	 * @private
	 * @param {Object} object The object to compare.
	 * @param {Object} other The other object to compare.
	 * @param {string} tag The `toStringTag` of the objects to compare.
	 * @param {Function} equalFunc The function to determine equivalents of values.
	 * @param {Function} customizer The function to customize comparisons.
	 * @param {number} bitmask The bitmask of comparison flags. See `baseIsEqual`
	 *  for more details.
	 * @param {Object} stack Tracks traversed `object` and `other` objects.
	 * @returns {boolean} Returns `true` if the objects are equivalent, else `false`.
	 */
	function equalByTag(object, other, tag, equalFunc, customizer, bitmask, stack) {
	  switch (tag) {
	    case dataViewTag:
	      if ((object.byteLength != other.byteLength) ||
	          (object.byteOffset != other.byteOffset)) {
	        return false;
	      }
	      object = object.buffer;
	      other = other.buffer;
	
	    case arrayBufferTag:
	      if ((object.byteLength != other.byteLength) ||
	          !equalFunc(new Uint8Array(object), new Uint8Array(other))) {
	        return false;
	      }
	      return true;
	
	    case boolTag:
	    case dateTag:
	      // Coerce dates and booleans to numbers, dates to milliseconds and
	      // booleans to `1` or `0` treating invalid dates coerced to `NaN` as
	      // not equal.
	      return +object == +other;
	
	    case errorTag:
	      return object.name == other.name && object.message == other.message;
	
	    case numberTag:
	      // Treat `NaN` vs. `NaN` as equal.
	      return (object != +object) ? other != +other : object == +other;
	
	    case regexpTag:
	    case stringTag:
	      // Coerce regexes to strings and treat strings, primitives and objects,
	      // as equal. See http://www.ecma-international.org/ecma-262/6.0/#sec-regexp.prototype.tostring
	      // for more details.
	      return object == (other + '');
	
	    case mapTag:
	      var convert = mapToArray;
	
	    case setTag:
	      var isPartial = bitmask & PARTIAL_COMPARE_FLAG;
	      convert || (convert = setToArray);
	
	      if (object.size != other.size && !isPartial) {
	        return false;
	      }
	      // Assume cyclic values are equal.
	      var stacked = stack.get(object);
	      if (stacked) {
	        return stacked == other;
	      }
	      bitmask |= UNORDERED_COMPARE_FLAG;
	      stack.set(object, other);
	
	      // Recursively compare objects (susceptible to call stack limits).
	      return equalArrays(convert(object), convert(other), equalFunc, customizer, bitmask, stack);
	
	    case symbolTag:
	      if (symbolValueOf) {
	        return symbolValueOf.call(object) == symbolValueOf.call(other);
	      }
	  }
	  return false;
	}
	
	module.exports = equalByTag;


/***/ },
/* 193 */
/***/ function(module, exports, __webpack_require__) {

	var baseHas = __webpack_require__(62),
	    keys = __webpack_require__(5);
	
	/** Used to compose bitmasks for comparison styles. */
	var PARTIAL_COMPARE_FLAG = 2;
	
	/**
	 * A specialized version of `baseIsEqualDeep` for objects with support for
	 * partial deep comparisons.
	 *
	 * @private
	 * @param {Object} object The object to compare.
	 * @param {Object} other The other object to compare.
	 * @param {Function} equalFunc The function to determine equivalents of values.
	 * @param {Function} customizer The function to customize comparisons.
	 * @param {number} bitmask The bitmask of comparison flags. See `baseIsEqual`
	 *  for more details.
	 * @param {Object} stack Tracks traversed `object` and `other` objects.
	 * @returns {boolean} Returns `true` if the objects are equivalent, else `false`.
	 */
	function equalObjects(object, other, equalFunc, customizer, bitmask, stack) {
	  var isPartial = bitmask & PARTIAL_COMPARE_FLAG,
	      objProps = keys(object),
	      objLength = objProps.length,
	      othProps = keys(other),
	      othLength = othProps.length;
	
	  if (objLength != othLength && !isPartial) {
	    return false;
	  }
	  var index = objLength;
	  while (index--) {
	    var key = objProps[index];
	    if (!(isPartial ? key in other : baseHas(other, key))) {
	      return false;
	    }
	  }
	  // Assume cyclic values are equal.
	  var stacked = stack.get(object);
	  if (stacked) {
	    return stacked == other;
	  }
	  var result = true;
	  stack.set(object, other);
	
	  var skipCtor = isPartial;
	  while (++index < objLength) {
	    key = objProps[index];
	    var objValue = object[key],
	        othValue = other[key];
	
	    if (customizer) {
	      var compared = isPartial
	        ? customizer(othValue, objValue, key, other, object, stack)
	        : customizer(objValue, othValue, key, object, other, stack);
	    }
	    // Recursively compare objects (susceptible to call stack limits).
	    if (!(compared === undefined
	          ? (objValue === othValue || equalFunc(objValue, othValue, customizer, bitmask, stack))
	          : compared
	        )) {
	      result = false;
	      break;
	    }
	    skipCtor || (skipCtor = key == 'constructor');
	  }
	  if (result && !skipCtor) {
	    var objCtor = object.constructor,
	        othCtor = other.constructor;
	
	    // Non `Object` object instances with different constructors are not equal.
	    if (objCtor != othCtor &&
	        ('constructor' in object && 'constructor' in other) &&
	        !(typeof objCtor == 'function' && objCtor instanceof objCtor &&
	          typeof othCtor == 'function' && othCtor instanceof othCtor)) {
	      result = false;
	    }
	  }
	  stack['delete'](object);
	  return result;
	}
	
	module.exports = equalObjects;


/***/ },
/* 194 */
/***/ function(module, exports, __webpack_require__) {

	var baseGetAllKeys = __webpack_require__(61),
	    getSymbols = __webpack_require__(41),
	    keys = __webpack_require__(5);
	
	/**
	 * Creates an array of own enumerable property names and symbols of `object`.
	 *
	 * @private
	 * @param {Object} object The object to query.
	 * @returns {Array} Returns the array of property names and symbols.
	 */
	function getAllKeys(object) {
	  return baseGetAllKeys(object, keys, getSymbols);
	}
	
	module.exports = getAllKeys;


/***/ },
/* 195 */
/***/ function(module, exports, __webpack_require__) {

	var baseGetAllKeys = __webpack_require__(61),
	    getSymbolsIn = __webpack_require__(198),
	    keysIn = __webpack_require__(44);
	
	/**
	 * Creates an array of own and inherited enumerable property names and
	 * symbols of `object`.
	 *
	 * @private
	 * @param {Object} object The object to query.
	 * @returns {Array} Returns the array of property names and symbols.
	 */
	function getAllKeysIn(object) {
	  return baseGetAllKeys(object, keysIn, getSymbolsIn);
	}
	
	module.exports = getAllKeysIn;


/***/ },
/* 196 */
/***/ function(module, exports, __webpack_require__) {

	var baseProperty = __webpack_require__(66);
	
	/**
	 * Gets the "length" property value of `object`.
	 *
	 * **Note:** This function is used to avoid a
	 * [JIT bug](https://bugs.webkit.org/show_bug.cgi?id=142792) that affects
	 * Safari on at least iOS 8.1-8.3 ARM64.
	 *
	 * @private
	 * @param {Object} object The object to query.
	 * @returns {*} Returns the "length" value.
	 */
	var getLength = baseProperty('length');
	
	module.exports = getLength;


/***/ },
/* 197 */
/***/ function(module, exports, __webpack_require__) {

	var isStrictComparable = __webpack_require__(73),
	    keys = __webpack_require__(5);
	
	/**
	 * Gets the property names, values, and compare flags of `object`.
	 *
	 * @private
	 * @param {Object} object The object to query.
	 * @returns {Array} Returns the match data of `object`.
	 */
	function getMatchData(object) {
	  var result = keys(object),
	      length = result.length;
	
	  while (length--) {
	    var key = result[length],
	        value = object[key];
	
	    result[length] = [key, value, isStrictComparable(value)];
	  }
	  return result;
	}
	
	module.exports = getMatchData;


/***/ },
/* 198 */
/***/ function(module, exports, __webpack_require__) {

	var arrayPush = __webpack_require__(37),
	    getPrototype = __webpack_require__(18),
	    getSymbols = __webpack_require__(41);
	
	/** Built-in value references. */
	var getOwnPropertySymbols = Object.getOwnPropertySymbols;
	
	/**
	 * Creates an array of the own and inherited enumerable symbol properties
	 * of `object`.
	 *
	 * @private
	 * @param {Object} object The object to query.
	 * @returns {Array} Returns the array of symbols.
	 */
	var getSymbolsIn = !getOwnPropertySymbols ? getSymbols : function(object) {
	  var result = [];
	  while (object) {
	    arrayPush(result, getSymbols(object));
	    object = getPrototype(object);
	  }
	  return result;
	};
	
	module.exports = getSymbolsIn;


/***/ },
/* 199 */
/***/ function(module, exports) {

	/**
	 * Gets the value at `key` of `object`.
	 *
	 * @private
	 * @param {Object} [object] The object to query.
	 * @param {string} key The key of the property to get.
	 * @returns {*} Returns the property value.
	 */
	function getValue(object, key) {
	  return object == null ? undefined : object[key];
	}
	
	module.exports = getValue;


/***/ },
/* 200 */
/***/ function(module, exports, __webpack_require__) {

	var castPath = __webpack_require__(67),
	    isArguments = __webpack_require__(25),
	    isArray = __webpack_require__(1),
	    isIndex = __webpack_require__(20),
	    isKey = __webpack_require__(22),
	    isLength = __webpack_require__(26),
	    isString = __webpack_require__(82),
	    toKey = __webpack_require__(11);
	
	/**
	 * Checks if `path` exists on `object`.
	 *
	 * @private
	 * @param {Object} object The object to query.
	 * @param {Array|string} path The path to check.
	 * @param {Function} hasFunc The function to check properties.
	 * @returns {boolean} Returns `true` if `path` exists, else `false`.
	 */
	function hasPath(object, path, hasFunc) {
	  path = isKey(path, object) ? [path] : castPath(path);
	
	  var result,
	      index = -1,
	      length = path.length;
	
	  while (++index < length) {
	    var key = toKey(path[index]);
	    if (!(result = object != null && hasFunc(object, key))) {
	      break;
	    }
	    object = object[key];
	  }
	  if (result) {
	    return result;
	  }
	  var length = object ? object.length : 0;
	  return !!length && isLength(length) && isIndex(key, length) &&
	    (isArray(object) || isString(object) || isArguments(object));
	}
	
	module.exports = hasPath;


/***/ },
/* 201 */
/***/ function(module, exports, __webpack_require__) {

	var nativeCreate = __webpack_require__(23);
	
	/**
	 * Removes all key-value entries from the hash.
	 *
	 * @private
	 * @name clear
	 * @memberOf Hash
	 */
	function hashClear() {
	  this.__data__ = nativeCreate ? nativeCreate(null) : {};
	}
	
	module.exports = hashClear;


/***/ },
/* 202 */
/***/ function(module, exports) {

	/**
	 * Removes `key` and its value from the hash.
	 *
	 * @private
	 * @name delete
	 * @memberOf Hash
	 * @param {Object} hash The hash to modify.
	 * @param {string} key The key of the value to remove.
	 * @returns {boolean} Returns `true` if the entry was removed, else `false`.
	 */
	function hashDelete(key) {
	  return this.has(key) && delete this.__data__[key];
	}
	
	module.exports = hashDelete;


/***/ },
/* 203 */
/***/ function(module, exports, __webpack_require__) {

	var nativeCreate = __webpack_require__(23);
	
	/** Used to stand-in for `undefined` hash values. */
	var HASH_UNDEFINED = '__lodash_hash_undefined__';
	
	/** Used for built-in method references. */
	var objectProto = Object.prototype;
	
	/** Used to check objects for own properties. */
	var hasOwnProperty = objectProto.hasOwnProperty;
	
	/**
	 * Gets the hash value for `key`.
	 *
	 * @private
	 * @name get
	 * @memberOf Hash
	 * @param {string} key The key of the value to get.
	 * @returns {*} Returns the entry value.
	 */
	function hashGet(key) {
	  var data = this.__data__;
	  if (nativeCreate) {
	    var result = data[key];
	    return result === HASH_UNDEFINED ? undefined : result;
	  }
	  return hasOwnProperty.call(data, key) ? data[key] : undefined;
	}
	
	module.exports = hashGet;


/***/ },
/* 204 */
/***/ function(module, exports, __webpack_require__) {

	var nativeCreate = __webpack_require__(23);
	
	/** Used for built-in method references. */
	var objectProto = Object.prototype;
	
	/** Used to check objects for own properties. */
	var hasOwnProperty = objectProto.hasOwnProperty;
	
	/**
	 * Checks if a hash value for `key` exists.
	 *
	 * @private
	 * @name has
	 * @memberOf Hash
	 * @param {string} key The key of the entry to check.
	 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
	 */
	function hashHas(key) {
	  var data = this.__data__;
	  return nativeCreate ? data[key] !== undefined : hasOwnProperty.call(data, key);
	}
	
	module.exports = hashHas;


/***/ },
/* 205 */
/***/ function(module, exports, __webpack_require__) {

	var nativeCreate = __webpack_require__(23);
	
	/** Used to stand-in for `undefined` hash values. */
	var HASH_UNDEFINED = '__lodash_hash_undefined__';
	
	/**
	 * Sets the hash `key` to `value`.
	 *
	 * @private
	 * @name set
	 * @memberOf Hash
	 * @param {string} key The key of the value to set.
	 * @param {*} value The value to set.
	 * @returns {Object} Returns the hash instance.
	 */
	function hashSet(key, value) {
	  var data = this.__data__;
	  data[key] = (nativeCreate && value === undefined) ? HASH_UNDEFINED : value;
	  return this;
	}
	
	module.exports = hashSet;


/***/ },
/* 206 */
/***/ function(module, exports) {

	/** Used for built-in method references. */
	var objectProto = Object.prototype;
	
	/** Used to check objects for own properties. */
	var hasOwnProperty = objectProto.hasOwnProperty;
	
	/**
	 * Initializes an array clone.
	 *
	 * @private
	 * @param {Array} array The array to clone.
	 * @returns {Array} Returns the initialized clone.
	 */
	function initCloneArray(array) {
	  var length = array.length,
	      result = array.constructor(length);
	
	  // Add properties assigned by `RegExp#exec`.
	  if (length && typeof array[0] == 'string' && hasOwnProperty.call(array, 'index')) {
	    result.index = array.index;
	    result.input = array.input;
	  }
	  return result;
	}
	
	module.exports = initCloneArray;


/***/ },
/* 207 */
/***/ function(module, exports, __webpack_require__) {

	var cloneArrayBuffer = __webpack_require__(39),
	    cloneDataView = __webpack_require__(178),
	    cloneMap = __webpack_require__(179),
	    cloneRegExp = __webpack_require__(180),
	    cloneSet = __webpack_require__(181),
	    cloneSymbol = __webpack_require__(182),
	    cloneTypedArray = __webpack_require__(183);
	
	/** `Object#toString` result references. */
	var boolTag = '[object Boolean]',
	    dateTag = '[object Date]',
	    mapTag = '[object Map]',
	    numberTag = '[object Number]',
	    regexpTag = '[object RegExp]',
	    setTag = '[object Set]',
	    stringTag = '[object String]',
	    symbolTag = '[object Symbol]';
	
	var arrayBufferTag = '[object ArrayBuffer]',
	    dataViewTag = '[object DataView]',
	    float32Tag = '[object Float32Array]',
	    float64Tag = '[object Float64Array]',
	    int8Tag = '[object Int8Array]',
	    int16Tag = '[object Int16Array]',
	    int32Tag = '[object Int32Array]',
	    uint8Tag = '[object Uint8Array]',
	    uint8ClampedTag = '[object Uint8ClampedArray]',
	    uint16Tag = '[object Uint16Array]',
	    uint32Tag = '[object Uint32Array]';
	
	/**
	 * Initializes an object clone based on its `toStringTag`.
	 *
	 * **Note:** This function only supports cloning values with tags of
	 * `Boolean`, `Date`, `Error`, `Number`, `RegExp`, or `String`.
	 *
	 * @private
	 * @param {Object} object The object to clone.
	 * @param {string} tag The `toStringTag` of the object to clone.
	 * @param {Function} cloneFunc The function to clone values.
	 * @param {boolean} [isDeep] Specify a deep clone.
	 * @returns {Object} Returns the initialized clone.
	 */
	function initCloneByTag(object, tag, cloneFunc, isDeep) {
	  var Ctor = object.constructor;
	  switch (tag) {
	    case arrayBufferTag:
	      return cloneArrayBuffer(object);
	
	    case boolTag:
	    case dateTag:
	      return new Ctor(+object);
	
	    case dataViewTag:
	      return cloneDataView(object, isDeep);
	
	    case float32Tag: case float64Tag:
	    case int8Tag: case int16Tag: case int32Tag:
	    case uint8Tag: case uint8ClampedTag: case uint16Tag: case uint32Tag:
	      return cloneTypedArray(object, isDeep);
	
	    case mapTag:
	      return cloneMap(object, isDeep, cloneFunc);
	
	    case numberTag:
	    case stringTag:
	      return new Ctor(object);
	
	    case regexpTag:
	      return cloneRegExp(object);
	
	    case setTag:
	      return cloneSet(object, isDeep, cloneFunc);
	
	    case symbolTag:
	      return cloneSymbol(object);
	  }
	}
	
	module.exports = initCloneByTag;


/***/ },
/* 208 */
/***/ function(module, exports, __webpack_require__) {

	var baseCreate = __webpack_require__(154),
	    getPrototype = __webpack_require__(18),
	    isPrototype = __webpack_require__(42);
	
	/**
	 * Initializes an object clone.
	 *
	 * @private
	 * @param {Object} object The object to clone.
	 * @returns {Object} Returns the initialized clone.
	 */
	function initCloneObject(object) {
	  return (typeof object.constructor == 'function' && !isPrototype(object))
	    ? baseCreate(getPrototype(object))
	    : {};
	}
	
	module.exports = initCloneObject;


/***/ },
/* 209 */
/***/ function(module, exports, __webpack_require__) {

	var isArguments = __webpack_require__(25),
	    isArray = __webpack_require__(1);
	
	/**
	 * Checks if `value` is a flattenable `arguments` object or array.
	 *
	 * @private
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is flattenable, else `false`.
	 */
	function isFlattenable(value) {
	  return isArray(value) || isArguments(value);
	}
	
	module.exports = isFlattenable;


/***/ },
/* 210 */
/***/ function(module, exports, __webpack_require__) {

	var isArray = __webpack_require__(1),
	    isFunction = __webpack_require__(12);
	
	/**
	 * Checks if `value` is a flattenable array and not a `_.matchesProperty`
	 * iteratee shorthand.
	 *
	 * @private
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is flattenable, else `false`.
	 */
	function isFlattenableIteratee(value) {
	  return isArray(value) && !(value.length == 2 && !isFunction(value[0]));
	}
	
	module.exports = isFlattenableIteratee;


/***/ },
/* 211 */
/***/ function(module, exports) {

	/**
	 * Checks if `value` is suitable for use as unique object key.
	 *
	 * @private
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is suitable, else `false`.
	 */
	function isKeyable(value) {
	  var type = typeof value;
	  return (type == 'string' || type == 'number' || type == 'symbol' || type == 'boolean')
	    ? (value !== '__proto__')
	    : (value === null);
	}
	
	module.exports = isKeyable;


/***/ },
/* 212 */
/***/ function(module, exports, __webpack_require__) {

	var coreJsData = __webpack_require__(187);
	
	/** Used to detect methods masquerading as native. */
	var maskSrcKey = (function() {
	  var uid = /[^.]+$/.exec(coreJsData && coreJsData.keys && coreJsData.keys.IE_PROTO || '');
	  return uid ? ('Symbol(src)_1.' + uid) : '';
	}());
	
	/**
	 * Checks if `func` has its source masked.
	 *
	 * @private
	 * @param {Function} func The function to check.
	 * @returns {boolean} Returns `true` if `func` is masked, else `false`.
	 */
	function isMasked(func) {
	  return !!maskSrcKey && (maskSrcKey in func);
	}
	
	module.exports = isMasked;


/***/ },
/* 213 */
/***/ function(module, exports) {

	/**
	 * Converts `iterator` to an array.
	 *
	 * @private
	 * @param {Object} iterator The iterator to convert.
	 * @returns {Array} Returns the converted array.
	 */
	function iteratorToArray(iterator) {
	  var data,
	      result = [];
	
	  while (!(data = iterator.next()).done) {
	    result.push(data.value);
	  }
	  return result;
	}
	
	module.exports = iteratorToArray;


/***/ },
/* 214 */
/***/ function(module, exports) {

	/**
	 * Removes all key-value entries from the list cache.
	 *
	 * @private
	 * @name clear
	 * @memberOf ListCache
	 */
	function listCacheClear() {
	  this.__data__ = [];
	}
	
	module.exports = listCacheClear;


/***/ },
/* 215 */
/***/ function(module, exports, __webpack_require__) {

	var assocIndexOf = __webpack_require__(16);
	
	/** Used for built-in method references. */
	var arrayProto = Array.prototype;
	
	/** Built-in value references. */
	var splice = arrayProto.splice;
	
	/**
	 * Removes `key` and its value from the list cache.
	 *
	 * @private
	 * @name delete
	 * @memberOf ListCache
	 * @param {string} key The key of the value to remove.
	 * @returns {boolean} Returns `true` if the entry was removed, else `false`.
	 */
	function listCacheDelete(key) {
	  var data = this.__data__,
	      index = assocIndexOf(data, key);
	
	  if (index < 0) {
	    return false;
	  }
	  var lastIndex = data.length - 1;
	  if (index == lastIndex) {
	    data.pop();
	  } else {
	    splice.call(data, index, 1);
	  }
	  return true;
	}
	
	module.exports = listCacheDelete;


/***/ },
/* 216 */
/***/ function(module, exports, __webpack_require__) {

	var assocIndexOf = __webpack_require__(16);
	
	/**
	 * Gets the list cache value for `key`.
	 *
	 * @private
	 * @name get
	 * @memberOf ListCache
	 * @param {string} key The key of the value to get.
	 * @returns {*} Returns the entry value.
	 */
	function listCacheGet(key) {
	  var data = this.__data__,
	      index = assocIndexOf(data, key);
	
	  return index < 0 ? undefined : data[index][1];
	}
	
	module.exports = listCacheGet;


/***/ },
/* 217 */
/***/ function(module, exports, __webpack_require__) {

	var assocIndexOf = __webpack_require__(16);
	
	/**
	 * Checks if a list cache value for `key` exists.
	 *
	 * @private
	 * @name has
	 * @memberOf ListCache
	 * @param {string} key The key of the entry to check.
	 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
	 */
	function listCacheHas(key) {
	  return assocIndexOf(this.__data__, key) > -1;
	}
	
	module.exports = listCacheHas;


/***/ },
/* 218 */
/***/ function(module, exports, __webpack_require__) {

	var assocIndexOf = __webpack_require__(16);
	
	/**
	 * Sets the list cache `key` to `value`.
	 *
	 * @private
	 * @name set
	 * @memberOf ListCache
	 * @param {string} key The key of the value to set.
	 * @param {*} value The value to set.
	 * @returns {Object} Returns the list cache instance.
	 */
	function listCacheSet(key, value) {
	  var data = this.__data__,
	      index = assocIndexOf(data, key);
	
	  if (index < 0) {
	    data.push([key, value]);
	  } else {
	    data[index][1] = value;
	  }
	  return this;
	}
	
	module.exports = listCacheSet;


/***/ },
/* 219 */
/***/ function(module, exports, __webpack_require__) {

	var Hash = __webpack_require__(140),
	    ListCache = __webpack_require__(14),
	    Map = __webpack_require__(51);
	
	/**
	 * Removes all key-value entries from the map.
	 *
	 * @private
	 * @name clear
	 * @memberOf MapCache
	 */
	function mapCacheClear() {
	  this.__data__ = {
	    'hash': new Hash,
	    'map': new (Map || ListCache),
	    'string': new Hash
	  };
	}
	
	module.exports = mapCacheClear;


/***/ },
/* 220 */
/***/ function(module, exports, __webpack_require__) {

	var getMapData = __webpack_require__(17);
	
	/**
	 * Removes `key` and its value from the map.
	 *
	 * @private
	 * @name delete
	 * @memberOf MapCache
	 * @param {string} key The key of the value to remove.
	 * @returns {boolean} Returns `true` if the entry was removed, else `false`.
	 */
	function mapCacheDelete(key) {
	  return getMapData(this, key)['delete'](key);
	}
	
	module.exports = mapCacheDelete;


/***/ },
/* 221 */
/***/ function(module, exports, __webpack_require__) {

	var getMapData = __webpack_require__(17);
	
	/**
	 * Gets the map value for `key`.
	 *
	 * @private
	 * @name get
	 * @memberOf MapCache
	 * @param {string} key The key of the value to get.
	 * @returns {*} Returns the entry value.
	 */
	function mapCacheGet(key) {
	  return getMapData(this, key).get(key);
	}
	
	module.exports = mapCacheGet;


/***/ },
/* 222 */
/***/ function(module, exports, __webpack_require__) {

	var getMapData = __webpack_require__(17);
	
	/**
	 * Checks if a map value for `key` exists.
	 *
	 * @private
	 * @name has
	 * @memberOf MapCache
	 * @param {string} key The key of the entry to check.
	 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
	 */
	function mapCacheHas(key) {
	  return getMapData(this, key).has(key);
	}
	
	module.exports = mapCacheHas;


/***/ },
/* 223 */
/***/ function(module, exports, __webpack_require__) {

	var getMapData = __webpack_require__(17);
	
	/**
	 * Sets the map `key` to `value`.
	 *
	 * @private
	 * @name set
	 * @memberOf MapCache
	 * @param {string} key The key of the value to set.
	 * @param {*} value The value to set.
	 * @returns {Object} Returns the map cache instance.
	 */
	function mapCacheSet(key, value) {
	  getMapData(this, key).set(key, value);
	  return this;
	}
	
	module.exports = mapCacheSet;


/***/ },
/* 224 */
/***/ function(module, exports) {

	/** Used to stand-in for `undefined` hash values. */
	var HASH_UNDEFINED = '__lodash_hash_undefined__';
	
	/**
	 * Adds `value` to the array cache.
	 *
	 * @private
	 * @name add
	 * @memberOf SetCache
	 * @alias push
	 * @param {*} value The value to cache.
	 * @returns {Object} Returns the cache instance.
	 */
	function setCacheAdd(value) {
	  this.__data__.set(value, HASH_UNDEFINED);
	  return this;
	}
	
	module.exports = setCacheAdd;


/***/ },
/* 225 */
/***/ function(module, exports) {

	/**
	 * Checks if `value` is in the array cache.
	 *
	 * @private
	 * @name has
	 * @memberOf SetCache
	 * @param {*} value The value to search for.
	 * @returns {number} Returns `true` if `value` is found, else `false`.
	 */
	function setCacheHas(value) {
	  return this.__data__.has(value);
	}
	
	module.exports = setCacheHas;


/***/ },
/* 226 */
/***/ function(module, exports, __webpack_require__) {

	var ListCache = __webpack_require__(14);
	
	/**
	 * Removes all key-value entries from the stack.
	 *
	 * @private
	 * @name clear
	 * @memberOf Stack
	 */
	function stackClear() {
	  this.__data__ = new ListCache;
	}
	
	module.exports = stackClear;


/***/ },
/* 227 */
/***/ function(module, exports) {

	/**
	 * Removes `key` and its value from the stack.
	 *
	 * @private
	 * @name delete
	 * @memberOf Stack
	 * @param {string} key The key of the value to remove.
	 * @returns {boolean} Returns `true` if the entry was removed, else `false`.
	 */
	function stackDelete(key) {
	  return this.__data__['delete'](key);
	}
	
	module.exports = stackDelete;


/***/ },
/* 228 */
/***/ function(module, exports) {

	/**
	 * Gets the stack value for `key`.
	 *
	 * @private
	 * @name get
	 * @memberOf Stack
	 * @param {string} key The key of the value to get.
	 * @returns {*} Returns the entry value.
	 */
	function stackGet(key) {
	  return this.__data__.get(key);
	}
	
	module.exports = stackGet;


/***/ },
/* 229 */
/***/ function(module, exports) {

	/**
	 * Checks if a stack value for `key` exists.
	 *
	 * @private
	 * @name has
	 * @memberOf Stack
	 * @param {string} key The key of the entry to check.
	 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
	 */
	function stackHas(key) {
	  return this.__data__.has(key);
	}
	
	module.exports = stackHas;


/***/ },
/* 230 */
/***/ function(module, exports, __webpack_require__) {

	var ListCache = __webpack_require__(14),
	    MapCache = __webpack_require__(33);
	
	/** Used as the size to enable large array optimizations. */
	var LARGE_ARRAY_SIZE = 200;
	
	/**
	 * Sets the stack `key` to `value`.
	 *
	 * @private
	 * @name set
	 * @memberOf Stack
	 * @param {string} key The key of the value to set.
	 * @param {*} value The value to set.
	 * @returns {Object} Returns the stack cache instance.
	 */
	function stackSet(key, value) {
	  var cache = this.__data__;
	  if (cache instanceof ListCache && cache.__data__.length == LARGE_ARRAY_SIZE) {
	    cache = this.__data__ = new MapCache(cache.__data__);
	  }
	  cache.set(key, value);
	  return this;
	}
	
	module.exports = stackSet;


/***/ },
/* 231 */
/***/ function(module, exports, __webpack_require__) {

	var memoize = __webpack_require__(243),
	    toString = __webpack_require__(256);
	
	/** Used to match property names within property paths. */
	var rePropName = /[^.[\]]+|\[(?:(-?\d+(?:\.\d+)?)|(["'])((?:(?!\2)[^\\]|\\.)*?)\2)\]|(?=(\.|\[\])(?:\4|$))/g;
	
	/** Used to match backslashes in property paths. */
	var reEscapeChar = /\\(\\)?/g;
	
	/**
	 * Converts `string` to a property path array.
	 *
	 * @private
	 * @param {string} string The string to convert.
	 * @returns {Array} Returns the property path array.
	 */
	var stringToPath = memoize(function(string) {
	  var result = [];
	  toString(string).replace(rePropName, function(match, number, quote, string) {
	    result.push(quote ? string.replace(reEscapeChar, '$1') : (number || match));
	  });
	  return result;
	});
	
	module.exports = stringToPath;


/***/ },
/* 232 */
/***/ function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__(236);


/***/ },
/* 233 */
/***/ function(module, exports, __webpack_require__) {

	var arrayEvery = __webpack_require__(150),
	    baseEvery = __webpack_require__(155),
	    baseIteratee = __webpack_require__(2),
	    isArray = __webpack_require__(1),
	    isIterateeCall = __webpack_require__(21);
	
	/**
	 * Checks if `predicate` returns truthy for **all** elements of `collection`.
	 * Iteration is stopped once `predicate` returns falsey. The predicate is
	 * invoked with three arguments: (value, index|key, collection).
	 *
	 * @static
	 * @memberOf _
	 * @since 0.1.0
	 * @category Collection
	 * @param {Array|Object} collection The collection to iterate over.
	 * @param {Array|Function|Object|string} [predicate=_.identity]
	 *  The function invoked per iteration.
	 * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
	 * @returns {boolean} Returns `true` if all elements pass the predicate check,
	 *  else `false`.
	 * @example
	 *
	 * _.every([true, 1, null, 'yes'], Boolean);
	 * // => false
	 *
	 * var users = [
	 *   { 'user': 'barney', 'age': 36, 'active': false },
	 *   { 'user': 'fred',   'age': 40, 'active': false }
	 * ];
	 *
	 * // The `_.matches` iteratee shorthand.
	 * _.every(users, { 'user': 'barney', 'active': false });
	 * // => false
	 *
	 * // The `_.matchesProperty` iteratee shorthand.
	 * _.every(users, ['active', false]);
	 * // => true
	 *
	 * // The `_.property` iteratee shorthand.
	 * _.every(users, 'active');
	 * // => false
	 */
	function every(collection, predicate, guard) {
	  var func = isArray(collection) ? arrayEvery : baseEvery;
	  if (guard && isIterateeCall(collection, predicate, guard)) {
	    predicate = undefined;
	  }
	  return func(collection, baseIteratee(predicate, 3));
	}
	
	module.exports = every;


/***/ },
/* 234 */
/***/ function(module, exports, __webpack_require__) {

	var arrayFilter = __webpack_require__(53),
	    baseFilter = __webpack_require__(57),
	    baseIteratee = __webpack_require__(2),
	    isArray = __webpack_require__(1);
	
	/**
	 * Iterates over elements of `collection`, returning an array of all elements
	 * `predicate` returns truthy for. The predicate is invoked with three
	 * arguments: (value, index|key, collection).
	 *
	 * @static
	 * @memberOf _
	 * @since 0.1.0
	 * @category Collection
	 * @param {Array|Object} collection The collection to iterate over.
	 * @param {Array|Function|Object|string} [predicate=_.identity]
	 *  The function invoked per iteration.
	 * @returns {Array} Returns the new filtered array.
	 * @see _.reject
	 * @example
	 *
	 * var users = [
	 *   { 'user': 'barney', 'age': 36, 'active': true },
	 *   { 'user': 'fred',   'age': 40, 'active': false }
	 * ];
	 *
	 * _.filter(users, function(o) { return !o.active; });
	 * // => objects for ['fred']
	 *
	 * // The `_.matches` iteratee shorthand.
	 * _.filter(users, { 'age': 36, 'active': true });
	 * // => objects for ['barney']
	 *
	 * // The `_.matchesProperty` iteratee shorthand.
	 * _.filter(users, ['active', false]);
	 * // => objects for ['fred']
	 *
	 * // The `_.property` iteratee shorthand.
	 * _.filter(users, 'active');
	 * // => objects for ['barney']
	 */
	function filter(collection, predicate) {
	  var func = isArray(collection) ? arrayFilter : baseFilter;
	  return func(collection, baseIteratee(predicate, 3));
	}
	
	module.exports = filter;


/***/ },
/* 235 */
/***/ function(module, exports, __webpack_require__) {

	var baseFindIndex = __webpack_require__(156),
	    baseIteratee = __webpack_require__(2),
	    toInteger = __webpack_require__(84);
	
	/* Built-in method references for those with the same name as other `lodash` methods. */
	var nativeMax = Math.max;
	
	/**
	 * This method is like `_.find` except that it returns the index of the first
	 * element `predicate` returns truthy for instead of the element itself.
	 *
	 * @static
	 * @memberOf _
	 * @since 1.1.0
	 * @category Array
	 * @param {Array} array The array to search.
	 * @param {Array|Function|Object|string} [predicate=_.identity]
	 *  The function invoked per iteration.
	 * @param {number} [fromIndex=0] The index to search from.
	 * @returns {number} Returns the index of the found element, else `-1`.
	 * @example
	 *
	 * var users = [
	 *   { 'user': 'barney',  'active': false },
	 *   { 'user': 'fred',    'active': false },
	 *   { 'user': 'pebbles', 'active': true }
	 * ];
	 *
	 * _.findIndex(users, function(o) { return o.user == 'barney'; });
	 * // => 0
	 *
	 * // The `_.matches` iteratee shorthand.
	 * _.findIndex(users, { 'user': 'fred', 'active': false });
	 * // => 1
	 *
	 * // The `_.matchesProperty` iteratee shorthand.
	 * _.findIndex(users, ['active', false]);
	 * // => 0
	 *
	 * // The `_.property` iteratee shorthand.
	 * _.findIndex(users, 'active');
	 * // => 2
	 */
	function findIndex(array, predicate, fromIndex) {
	  var length = array ? array.length : 0;
	  if (!length) {
	    return -1;
	  }
	  var index = fromIndex == null ? 0 : toInteger(fromIndex);
	  if (index < 0) {
	    index = nativeMax(length + index, 0);
	  }
	  return baseFindIndex(array, baseIteratee(predicate, 3), index);
	}
	
	module.exports = findIndex;


/***/ },
/* 236 */
/***/ function(module, exports, __webpack_require__) {

	var arrayEach = __webpack_require__(35),
	    baseEach = __webpack_require__(6),
	    baseIteratee = __webpack_require__(2),
	    isArray = __webpack_require__(1);
	
	/**
	 * Iterates over elements of `collection` and invokes `iteratee` for each element.
	 * The iteratee is invoked with three arguments: (value, index|key, collection).
	 * Iteratee functions may exit iteration early by explicitly returning `false`.
	 *
	 * **Note:** As with other "Collections" methods, objects with a "length"
	 * property are iterated like arrays. To avoid this behavior use `_.forIn`
	 * or `_.forOwn` for object iteration.
	 *
	 * @static
	 * @memberOf _
	 * @since 0.1.0
	 * @alias each
	 * @category Collection
	 * @param {Array|Object} collection The collection to iterate over.
	 * @param {Function} [iteratee=_.identity] The function invoked per iteration.
	 * @returns {Array|Object} Returns `collection`.
	 * @see _.forEachRight
	 * @example
	 *
	 * _([1, 2]).forEach(function(value) {
	 *   console.log(value);
	 * });
	 * // => Logs `1` then `2`.
	 *
	 * _.forEach({ 'a': 1, 'b': 2 }, function(value, key) {
	 *   console.log(key);
	 * });
	 * // => Logs 'a' then 'b' (iteration order is not guaranteed).
	 */
	function forEach(collection, iteratee) {
	  var func = isArray(collection) ? arrayEach : baseEach;
	  return func(collection, baseIteratee(iteratee, 3));
	}
	
	module.exports = forEach;


/***/ },
/* 237 */
/***/ function(module, exports, __webpack_require__) {

	var createAggregator = __webpack_require__(188);
	
	/** Used for built-in method references. */
	var objectProto = Object.prototype;
	
	/** Used to check objects for own properties. */
	var hasOwnProperty = objectProto.hasOwnProperty;
	
	/**
	 * Creates an object composed of keys generated from the results of running
	 * each element of `collection` thru `iteratee`. The order of grouped values
	 * is determined by the order they occur in `collection`. The corresponding
	 * value of each key is an array of elements responsible for generating the
	 * key. The iteratee is invoked with one argument: (value).
	 *
	 * @static
	 * @memberOf _
	 * @since 0.1.0
	 * @category Collection
	 * @param {Array|Object} collection The collection to iterate over.
	 * @param {Array|Function|Object|string} [iteratee=_.identity]
	 *  The iteratee to transform keys.
	 * @returns {Object} Returns the composed aggregate object.
	 * @example
	 *
	 * _.groupBy([6.1, 4.2, 6.3], Math.floor);
	 * // => { '4': [4.2], '6': [6.1, 6.3] }
	 *
	 * // The `_.property` iteratee shorthand.
	 * _.groupBy(['one', 'two', 'three'], 'length');
	 * // => { '3': ['one', 'two'], '5': ['three'] }
	 */
	var groupBy = createAggregator(function(result, value, key) {
	  if (hasOwnProperty.call(result, key)) {
	    result[key].push(value);
	  } else {
	    result[key] = [value];
	  }
	});
	
	module.exports = groupBy;


/***/ },
/* 238 */
/***/ function(module, exports, __webpack_require__) {

	var baseHasIn = __webpack_require__(158),
	    hasPath = __webpack_require__(200);
	
	/**
	 * Checks if `path` is a direct or inherited property of `object`.
	 *
	 * @static
	 * @memberOf _
	 * @since 4.0.0
	 * @category Object
	 * @param {Object} object The object to query.
	 * @param {Array|string} path The path to check.
	 * @returns {boolean} Returns `true` if `path` exists, else `false`.
	 * @example
	 *
	 * var object = _.create({ 'a': _.create({ 'b': 2 }) });
	 *
	 * _.hasIn(object, 'a');
	 * // => true
	 *
	 * _.hasIn(object, 'a.b');
	 * // => true
	 *
	 * _.hasIn(object, ['a', 'b']);
	 * // => true
	 *
	 * _.hasIn(object, 'b');
	 * // => false
	 */
	function hasIn(object, path) {
	  return object != null && hasPath(object, path, baseHasIn);
	}
	
	module.exports = hasIn;


/***/ },
/* 239 */
/***/ function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(module) {var root = __webpack_require__(3),
	    stubFalse = __webpack_require__(252);
	
	/** Detect free variable `exports`. */
	var freeExports = typeof exports == 'object' && exports;
	
	/** Detect free variable `module`. */
	var freeModule = freeExports && typeof module == 'object' && module;
	
	/** Detect the popular CommonJS extension `module.exports`. */
	var moduleExports = freeModule && freeModule.exports === freeExports;
	
	/** Built-in value references. */
	var Buffer = moduleExports ? root.Buffer : undefined;
	
	/**
	 * Checks if `value` is a buffer.
	 *
	 * @static
	 * @memberOf _
	 * @since 4.3.0
	 * @category Lang
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is a buffer, else `false`.
	 * @example
	 *
	 * _.isBuffer(new Buffer(2));
	 * // => true
	 *
	 * _.isBuffer(new Uint8Array(2));
	 * // => false
	 */
	var isBuffer = !Buffer ? stubFalse : function(value) {
	  return value instanceof Buffer;
	};
	
	module.exports = isBuffer;
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(278)(module)))

/***/ },
/* 240 */
/***/ function(module, exports, __webpack_require__) {

	var getPrototype = __webpack_require__(18),
	    isHostObject = __webpack_require__(19),
	    isObjectLike = __webpack_require__(9);
	
	/** `Object#toString` result references. */
	var objectTag = '[object Object]';
	
	/** Used for built-in method references. */
	var objectProto = Object.prototype;
	
	/** Used to resolve the decompiled source of functions. */
	var funcToString = Function.prototype.toString;
	
	/** Used to check objects for own properties. */
	var hasOwnProperty = objectProto.hasOwnProperty;
	
	/** Used to infer the `Object` constructor. */
	var objectCtorString = funcToString.call(Object);
	
	/**
	 * Used to resolve the
	 * [`toStringTag`](http://ecma-international.org/ecma-262/6.0/#sec-object.prototype.tostring)
	 * of values.
	 */
	var objectToString = objectProto.toString;
	
	/**
	 * Checks if `value` is a plain object, that is, an object created by the
	 * `Object` constructor or one with a `[[Prototype]]` of `null`.
	 *
	 * @static
	 * @memberOf _
	 * @since 0.8.0
	 * @category Lang
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is a plain object,
	 *  else `false`.
	 * @example
	 *
	 * function Foo() {
	 *   this.a = 1;
	 * }
	 *
	 * _.isPlainObject(new Foo);
	 * // => false
	 *
	 * _.isPlainObject([1, 2, 3]);
	 * // => false
	 *
	 * _.isPlainObject({ 'x': 0, 'y': 0 });
	 * // => true
	 *
	 * _.isPlainObject(Object.create(null));
	 * // => true
	 */
	function isPlainObject(value) {
	  if (!isObjectLike(value) ||
	      objectToString.call(value) != objectTag || isHostObject(value)) {
	    return false;
	  }
	  var proto = getPrototype(value);
	  if (proto === null) {
	    return true;
	  }
	  var Ctor = hasOwnProperty.call(proto, 'constructor') && proto.constructor;
	  return (typeof Ctor == 'function' &&
	    Ctor instanceof Ctor && funcToString.call(Ctor) == objectCtorString);
	}
	
	module.exports = isPlainObject;


/***/ },
/* 241 */
/***/ function(module, exports, __webpack_require__) {

	var arrayMap = __webpack_require__(36),
	    baseIteratee = __webpack_require__(2),
	    baseMap = __webpack_require__(64),
	    isArray = __webpack_require__(1);
	
	/**
	 * Creates an array of values by running each element in `collection` thru
	 * `iteratee`. The iteratee is invoked with three arguments:
	 * (value, index|key, collection).
	 *
	 * Many lodash methods are guarded to work as iteratees for methods like
	 * `_.every`, `_.filter`, `_.map`, `_.mapValues`, `_.reject`, and `_.some`.
	 *
	 * The guarded methods are:
	 * `ary`, `chunk`, `curry`, `curryRight`, `drop`, `dropRight`, `every`,
	 * `fill`, `invert`, `parseInt`, `random`, `range`, `rangeRight`, `repeat`,
	 * `sampleSize`, `slice`, `some`, `sortBy`, `split`, `take`, `takeRight`,
	 * `template`, `trim`, `trimEnd`, `trimStart`, and `words`
	 *
	 * @static
	 * @memberOf _
	 * @since 0.1.0
	 * @category Collection
	 * @param {Array|Object} collection The collection to iterate over.
	 * @param {Array|Function|Object|string} [iteratee=_.identity]
	 *  The function invoked per iteration.
	 * @returns {Array} Returns the new mapped array.
	 * @example
	 *
	 * function square(n) {
	 *   return n * n;
	 * }
	 *
	 * _.map([4, 8], square);
	 * // => [16, 64]
	 *
	 * _.map({ 'a': 4, 'b': 8 }, square);
	 * // => [16, 64] (iteration order is not guaranteed)
	 *
	 * var users = [
	 *   { 'user': 'barney' },
	 *   { 'user': 'fred' }
	 * ];
	 *
	 * // The `_.property` iteratee shorthand.
	 * _.map(users, 'user');
	 * // => ['barney', 'fred']
	 */
	function map(collection, iteratee) {
	  var func = isArray(collection) ? arrayMap : baseMap;
	  return func(collection, baseIteratee(iteratee, 3));
	}
	
	module.exports = map;


/***/ },
/* 242 */
/***/ function(module, exports, __webpack_require__) {

	var baseForOwn = __webpack_require__(59),
	    baseIteratee = __webpack_require__(2);
	
	/**
	 * The opposite of `_.mapValues`; this method creates an object with the
	 * same values as `object` and keys generated by running each own enumerable
	 * string keyed property of `object` thru `iteratee`. The iteratee is invoked
	 * with three arguments: (value, key, object).
	 *
	 * @static
	 * @memberOf _
	 * @since 3.8.0
	 * @category Object
	 * @param {Object} object The object to iterate over.
	 * @param {Array|Function|Object|string} [iteratee=_.identity]
	 *  The function invoked per iteration.
	 * @returns {Object} Returns the new mapped object.
	 * @see _.mapValues
	 * @example
	 *
	 * _.mapKeys({ 'a': 1, 'b': 2 }, function(value, key) {
	 *   return key + value;
	 * });
	 * // => { 'a1': 1, 'b2': 2 }
	 */
	function mapKeys(object, iteratee) {
	  var result = {};
	  iteratee = baseIteratee(iteratee, 3);
	
	  baseForOwn(object, function(value, key, object) {
	    result[iteratee(value, key, object)] = value;
	  });
	  return result;
	}
	
	module.exports = mapKeys;


/***/ },
/* 243 */
/***/ function(module, exports, __webpack_require__) {

	var MapCache = __webpack_require__(33);
	
	/** Used as the `TypeError` message for "Functions" methods. */
	var FUNC_ERROR_TEXT = 'Expected a function';
	
	/**
	 * Creates a function that memoizes the result of `func`. If `resolver` is
	 * provided, it determines the cache key for storing the result based on the
	 * arguments provided to the memoized function. By default, the first argument
	 * provided to the memoized function is used as the map cache key. The `func`
	 * is invoked with the `this` binding of the memoized function.
	 *
	 * **Note:** The cache is exposed as the `cache` property on the memoized
	 * function. Its creation may be customized by replacing the `_.memoize.Cache`
	 * constructor with one whose instances implement the
	 * [`Map`](http://ecma-international.org/ecma-262/6.0/#sec-properties-of-the-map-prototype-object)
	 * method interface of `delete`, `get`, `has`, and `set`.
	 *
	 * @static
	 * @memberOf _
	 * @since 0.1.0
	 * @category Function
	 * @param {Function} func The function to have its output memoized.
	 * @param {Function} [resolver] The function to resolve the cache key.
	 * @returns {Function} Returns the new memoized function.
	 * @example
	 *
	 * var object = { 'a': 1, 'b': 2 };
	 * var other = { 'c': 3, 'd': 4 };
	 *
	 * var values = _.memoize(_.values);
	 * values(object);
	 * // => [1, 2]
	 *
	 * values(other);
	 * // => [3, 4]
	 *
	 * object.a = 2;
	 * values(object);
	 * // => [1, 2]
	 *
	 * // Modify the result cache.
	 * values.cache.set(object, ['a', 'b']);
	 * values(object);
	 * // => ['a', 'b']
	 *
	 * // Replace `_.memoize.Cache`.
	 * _.memoize.Cache = WeakMap;
	 */
	function memoize(func, resolver) {
	  if (typeof func != 'function' || (resolver && typeof resolver != 'function')) {
	    throw new TypeError(FUNC_ERROR_TEXT);
	  }
	  var memoized = function() {
	    var args = arguments,
	        key = resolver ? resolver.apply(this, args) : args[0],
	        cache = memoized.cache;
	
	    if (cache.has(key)) {
	      return cache.get(key);
	    }
	    var result = func.apply(this, args);
	    memoized.cache = cache.set(key, result);
	    return result;
	  };
	  memoized.cache = new (memoize.Cache || MapCache);
	  return memoized;
	}
	
	// Assign cache to `_.memoize`.
	memoize.Cache = MapCache;
	
	module.exports = memoize;


/***/ },
/* 244 */
/***/ function(module, exports, __webpack_require__) {

	var baseMerge = __webpack_require__(65),
	    createAssigner = __webpack_require__(69);
	
	/**
	 * This method is like `_.assign` except that it recursively merges own and
	 * inherited enumerable string keyed properties of source objects into the
	 * destination object. Source properties that resolve to `undefined` are
	 * skipped if a destination value exists. Array and plain object properties
	 * are merged recursively. Other objects and value types are overridden by
	 * assignment. Source objects are applied from left to right. Subsequent
	 * sources overwrite property assignments of previous sources.
	 *
	 * **Note:** This method mutates `object`.
	 *
	 * @static
	 * @memberOf _
	 * @since 0.5.0
	 * @category Object
	 * @param {Object} object The destination object.
	 * @param {...Object} [sources] The source objects.
	 * @returns {Object} Returns `object`.
	 * @example
	 *
	 * var users = {
	 *   'data': [{ 'user': 'barney' }, { 'user': 'fred' }]
	 * };
	 *
	 * var ages = {
	 *   'data': [{ 'age': 36 }, { 'age': 40 }]
	 * };
	 *
	 * _.merge(users, ages);
	 * // => { 'data': [{ 'user': 'barney', 'age': 36 }, { 'user': 'fred', 'age': 40 }] }
	 */
	var merge = createAssigner(function(object, source, srcIndex) {
	  baseMerge(object, source, srcIndex);
	});
	
	module.exports = merge;


/***/ },
/* 245 */
/***/ function(module, exports, __webpack_require__) {

	var arrayMap = __webpack_require__(36),
	    baseFlatten = __webpack_require__(58),
	    basePick = __webpack_require__(168),
	    rest = __webpack_require__(45),
	    toKey = __webpack_require__(11);
	
	/**
	 * Creates an object composed of the picked `object` properties.
	 *
	 * @static
	 * @since 0.1.0
	 * @memberOf _
	 * @category Object
	 * @param {Object} object The source object.
	 * @param {...(string|string[])} [props] The property identifiers to pick.
	 * @returns {Object} Returns the new object.
	 * @example
	 *
	 * var object = { 'a': 1, 'b': '2', 'c': 3 };
	 *
	 * _.pick(object, ['a', 'c']);
	 * // => { 'a': 1, 'c': 3 }
	 */
	var pick = rest(function(object, props) {
	  return object == null ? {} : basePick(object, arrayMap(baseFlatten(props, 1), toKey));
	});
	
	module.exports = pick;


/***/ },
/* 246 */
/***/ function(module, exports, __webpack_require__) {

	var baseIteratee = __webpack_require__(2),
	    basePickBy = __webpack_require__(169);
	
	/**
	 * Creates an object composed of the `object` properties `predicate` returns
	 * truthy for. The predicate is invoked with two arguments: (value, key).
	 *
	 * @static
	 * @memberOf _
	 * @since 4.0.0
	 * @category Object
	 * @param {Object} object The source object.
	 * @param {Array|Function|Object|string} [predicate=_.identity]
	 *  The function invoked per property.
	 * @returns {Object} Returns the new object.
	 * @example
	 *
	 * var object = { 'a': 1, 'b': '2', 'c': 3 };
	 *
	 * _.pickBy(object, _.isNumber);
	 * // => { 'a': 1, 'c': 3 }
	 */
	function pickBy(object, predicate) {
	  return object == null ? {} : basePickBy(object, baseIteratee(predicate));
	}
	
	module.exports = pickBy;


/***/ },
/* 247 */
/***/ function(module, exports, __webpack_require__) {

	var baseProperty = __webpack_require__(66),
	    basePropertyDeep = __webpack_require__(170),
	    isKey = __webpack_require__(22),
	    toKey = __webpack_require__(11);
	
	/**
	 * Creates a function that returns the value at `path` of a given object.
	 *
	 * @static
	 * @memberOf _
	 * @since 2.4.0
	 * @category Util
	 * @param {Array|string} path The path of the property to get.
	 * @returns {Function} Returns the new accessor function.
	 * @example
	 *
	 * var objects = [
	 *   { 'a': { 'b': 2 } },
	 *   { 'a': { 'b': 1 } }
	 * ];
	 *
	 * _.map(objects, _.property('a.b'));
	 * // => [2, 1]
	 *
	 * _.map(_.sortBy(objects, _.property(['a', 'b'])), 'a.b');
	 * // => [1, 2]
	 */
	function property(path) {
	  return isKey(path) ? baseProperty(toKey(path)) : basePropertyDeep(path);
	}
	
	module.exports = property;


/***/ },
/* 248 */
/***/ function(module, exports, __webpack_require__) {

	var arrayFilter = __webpack_require__(53),
	    baseFilter = __webpack_require__(57),
	    baseIteratee = __webpack_require__(2),
	    isArray = __webpack_require__(1);
	
	/**
	 * The opposite of `_.filter`; this method returns the elements of `collection`
	 * that `predicate` does **not** return truthy for.
	 *
	 * @static
	 * @memberOf _
	 * @since 0.1.0
	 * @category Collection
	 * @param {Array|Object} collection The collection to iterate over.
	 * @param {Array|Function|Object|string} [predicate=_.identity]
	 *  The function invoked per iteration.
	 * @returns {Array} Returns the new filtered array.
	 * @see _.filter
	 * @example
	 *
	 * var users = [
	 *   { 'user': 'barney', 'age': 36, 'active': false },
	 *   { 'user': 'fred',   'age': 40, 'active': true }
	 * ];
	 *
	 * _.reject(users, function(o) { return !o.active; });
	 * // => objects for ['fred']
	 *
	 * // The `_.matches` iteratee shorthand.
	 * _.reject(users, { 'age': 40, 'active': true });
	 * // => objects for ['barney']
	 *
	 * // The `_.matchesProperty` iteratee shorthand.
	 * _.reject(users, ['active', false]);
	 * // => objects for ['fred']
	 *
	 * // The `_.property` iteratee shorthand.
	 * _.reject(users, 'active');
	 * // => objects for ['barney']
	 */
	function reject(collection, predicate) {
	  var func = isArray(collection) ? arrayFilter : baseFilter;
	  predicate = baseIteratee(predicate, 3);
	  return func(collection, function(value, index, collection) {
	    return !predicate(value, index, collection);
	  });
	}
	
	module.exports = reject;


/***/ },
/* 249 */
/***/ function(module, exports, __webpack_require__) {

	var arraySome = __webpack_require__(54),
	    baseIteratee = __webpack_require__(2),
	    baseSome = __webpack_require__(171),
	    isArray = __webpack_require__(1),
	    isIterateeCall = __webpack_require__(21);
	
	/**
	 * Checks if `predicate` returns truthy for **any** element of `collection`.
	 * Iteration is stopped once `predicate` returns truthy. The predicate is
	 * invoked with three arguments: (value, index|key, collection).
	 *
	 * @static
	 * @memberOf _
	 * @since 0.1.0
	 * @category Collection
	 * @param {Array|Object} collection The collection to iterate over.
	 * @param {Array|Function|Object|string} [predicate=_.identity]
	 *  The function invoked per iteration.
	 * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
	 * @returns {boolean} Returns `true` if any element passes the predicate check,
	 *  else `false`.
	 * @example
	 *
	 * _.some([null, 0, 'yes', false], Boolean);
	 * // => true
	 *
	 * var users = [
	 *   { 'user': 'barney', 'active': true },
	 *   { 'user': 'fred',   'active': false }
	 * ];
	 *
	 * // The `_.matches` iteratee shorthand.
	 * _.some(users, { 'user': 'barney', 'active': false });
	 * // => false
	 *
	 * // The `_.matchesProperty` iteratee shorthand.
	 * _.some(users, ['active', false]);
	 * // => true
	 *
	 * // The `_.property` iteratee shorthand.
	 * _.some(users, 'active');
	 * // => true
	 */
	function some(collection, predicate, guard) {
	  var func = isArray(collection) ? arraySome : baseSome;
	  if (guard && isIterateeCall(collection, predicate, guard)) {
	    predicate = undefined;
	  }
	  return func(collection, baseIteratee(predicate, 3));
	}
	
	module.exports = some;


/***/ },
/* 250 */
/***/ function(module, exports, __webpack_require__) {

	var baseFlatten = __webpack_require__(58),
	    baseOrderBy = __webpack_require__(167),
	    isArray = __webpack_require__(1),
	    isFlattenableIteratee = __webpack_require__(210),
	    isIterateeCall = __webpack_require__(21),
	    rest = __webpack_require__(45);
	
	/**
	 * Creates an array of elements, sorted in ascending order by the results of
	 * running each element in a collection thru each iteratee. This method
	 * performs a stable sort, that is, it preserves the original sort order of
	 * equal elements. The iteratees are invoked with one argument: (value).
	 *
	 * @static
	 * @memberOf _
	 * @since 0.1.0
	 * @category Collection
	 * @param {Array|Object} collection The collection to iterate over.
	 * @param {...(Array|Array[]|Function|Function[]|Object|Object[]|string|string[])}
	 *  [iteratees=[_.identity]] The iteratees to sort by.
	 * @returns {Array} Returns the new sorted array.
	 * @example
	 *
	 * var users = [
	 *   { 'user': 'fred',   'age': 48 },
	 *   { 'user': 'barney', 'age': 36 },
	 *   { 'user': 'fred',   'age': 40 },
	 *   { 'user': 'barney', 'age': 34 }
	 * ];
	 *
	 * _.sortBy(users, function(o) { return o.user; });
	 * // => objects for [['barney', 36], ['barney', 34], ['fred', 48], ['fred', 40]]
	 *
	 * _.sortBy(users, ['user', 'age']);
	 * // => objects for [['barney', 34], ['barney', 36], ['fred', 40], ['fred', 48]]
	 *
	 * _.sortBy(users, 'user', function(o) {
	 *   return Math.floor(o.age / 10);
	 * });
	 * // => objects for [['barney', 36], ['barney', 34], ['fred', 48], ['fred', 40]]
	 */
	var sortBy = rest(function(collection, iteratees) {
	  if (collection == null) {
	    return [];
	  }
	  var length = iteratees.length;
	  if (length > 1 && isIterateeCall(collection, iteratees[0], iteratees[1])) {
	    iteratees = [];
	  } else if (length > 2 && isIterateeCall(iteratees[0], iteratees[1], iteratees[2])) {
	    iteratees = [iteratees[0]];
	  }
	  iteratees = (iteratees.length == 1 && isArray(iteratees[0]))
	    ? iteratees[0]
	    : baseFlatten(iteratees, 1, isFlattenableIteratee);
	
	  return baseOrderBy(collection, iteratees, []);
	});
	
	module.exports = sortBy;


/***/ },
/* 251 */
/***/ function(module, exports) {

	/**
	 * A method that returns a new empty array.
	 *
	 * @static
	 * @memberOf _
	 * @since 4.13.0
	 * @category Util
	 * @returns {Array} Returns the new empty array.
	 * @example
	 *
	 * var arrays = _.times(2, _.stubArray);
	 *
	 * console.log(arrays);
	 * // => [[], []]
	 *
	 * console.log(arrays[0] === arrays[1]);
	 * // => false
	 */
	function stubArray() {
	  return [];
	}
	
	module.exports = stubArray;


/***/ },
/* 252 */
/***/ function(module, exports) {

	/**
	 * A method that returns `false`.
	 *
	 * @static
	 * @memberOf _
	 * @since 4.13.0
	 * @category Util
	 * @returns {boolean} Returns `false`.
	 * @example
	 *
	 * _.times(2, _.stubFalse);
	 * // => [false, false]
	 */
	function stubFalse() {
	  return false;
	}
	
	module.exports = stubFalse;


/***/ },
/* 253 */
/***/ function(module, exports, __webpack_require__) {

	var toNumber = __webpack_require__(254);
	
	/** Used as references for various `Number` constants. */
	var INFINITY = 1 / 0,
	    MAX_INTEGER = 1.7976931348623157e+308;
	
	/**
	 * Converts `value` to a finite number.
	 *
	 * @static
	 * @memberOf _
	 * @since 4.12.0
	 * @category Lang
	 * @param {*} value The value to convert.
	 * @returns {number} Returns the converted number.
	 * @example
	 *
	 * _.toFinite(3.2);
	 * // => 3.2
	 *
	 * _.toFinite(Number.MIN_VALUE);
	 * // => 5e-324
	 *
	 * _.toFinite(Infinity);
	 * // => 1.7976931348623157e+308
	 *
	 * _.toFinite('3.2');
	 * // => 3.2
	 */
	function toFinite(value) {
	  if (!value) {
	    return value === 0 ? value : 0;
	  }
	  value = toNumber(value);
	  if (value === INFINITY || value === -INFINITY) {
	    var sign = (value < 0 ? -1 : 1);
	    return sign * MAX_INTEGER;
	  }
	  return value === value ? value : 0;
	}
	
	module.exports = toFinite;


/***/ },
/* 254 */
/***/ function(module, exports, __webpack_require__) {

	var isFunction = __webpack_require__(12),
	    isObject = __webpack_require__(4),
	    isSymbol = __webpack_require__(13);
	
	/** Used as references for various `Number` constants. */
	var NAN = 0 / 0;
	
	/** Used to match leading and trailing whitespace. */
	var reTrim = /^\s+|\s+$/g;
	
	/** Used to detect bad signed hexadecimal string values. */
	var reIsBadHex = /^[-+]0x[0-9a-f]+$/i;
	
	/** Used to detect binary string values. */
	var reIsBinary = /^0b[01]+$/i;
	
	/** Used to detect octal string values. */
	var reIsOctal = /^0o[0-7]+$/i;
	
	/** Built-in method references without a dependency on `root`. */
	var freeParseInt = parseInt;
	
	/**
	 * Converts `value` to a number.
	 *
	 * @static
	 * @memberOf _
	 * @since 4.0.0
	 * @category Lang
	 * @param {*} value The value to process.
	 * @returns {number} Returns the number.
	 * @example
	 *
	 * _.toNumber(3.2);
	 * // => 3.2
	 *
	 * _.toNumber(Number.MIN_VALUE);
	 * // => 5e-324
	 *
	 * _.toNumber(Infinity);
	 * // => Infinity
	 *
	 * _.toNumber('3.2');
	 * // => 3.2
	 */
	function toNumber(value) {
	  if (typeof value == 'number') {
	    return value;
	  }
	  if (isSymbol(value)) {
	    return NAN;
	  }
	  if (isObject(value)) {
	    var other = isFunction(value.valueOf) ? value.valueOf() : value;
	    value = isObject(other) ? (other + '') : other;
	  }
	  if (typeof value != 'string') {
	    return value === 0 ? value : +value;
	  }
	  value = value.replace(reTrim, '');
	  var isBinary = reIsBinary.test(value);
	  return (isBinary || reIsOctal.test(value))
	    ? freeParseInt(value.slice(2), isBinary ? 2 : 8)
	    : (reIsBadHex.test(value) ? NAN : +value);
	}
	
	module.exports = toNumber;


/***/ },
/* 255 */
/***/ function(module, exports, __webpack_require__) {

	var copyObject = __webpack_require__(40),
	    keysIn = __webpack_require__(44);
	
	/**
	 * Converts `value` to a plain object flattening inherited enumerable string
	 * keyed properties of `value` to own properties of the plain object.
	 *
	 * @static
	 * @memberOf _
	 * @since 3.0.0
	 * @category Lang
	 * @param {*} value The value to convert.
	 * @returns {Object} Returns the converted plain object.
	 * @example
	 *
	 * function Foo() {
	 *   this.b = 2;
	 * }
	 *
	 * Foo.prototype.c = 3;
	 *
	 * _.assign({ 'a': 1 }, new Foo);
	 * // => { 'a': 1, 'b': 2 }
	 *
	 * _.assign({ 'a': 1 }, _.toPlainObject(new Foo));
	 * // => { 'a': 1, 'b': 2, 'c': 3 }
	 */
	function toPlainObject(value) {
	  return copyObject(value, keysIn(value));
	}
	
	module.exports = toPlainObject;


/***/ },
/* 256 */
/***/ function(module, exports, __webpack_require__) {

	var baseToString = __webpack_require__(174);
	
	/**
	 * Converts `value` to a string. An empty string is returned for `null`
	 * and `undefined` values. The sign of `-0` is preserved.
	 *
	 * @static
	 * @memberOf _
	 * @since 4.0.0
	 * @category Lang
	 * @param {*} value The value to process.
	 * @returns {string} Returns the string.
	 * @example
	 *
	 * _.toString(null);
	 * // => ''
	 *
	 * _.toString(-0);
	 * // => '-0'
	 *
	 * _.toString([1, 2, 3]);
	 * // => '1,2,3'
	 */
	function toString(value) {
	  return value == null ? '' : baseToString(value);
	}
	
	module.exports = toString;


/***/ },
/* 257 */
/***/ function(module, exports) {

	module.exports = "<div class=zl-am> <vk-modal :show=modalAuth.show @hide=hideModals> <authentication></authentication> </vk-modal> <tm-modal :show=modal.show :block=modal.block :icon=modal.icon :text=modal.text :spinner=modal.spinner :request-error=modal.requestError @hide=hideModals> </tm-modal> <vk-modal-confirm :show=modalConfirm.show :text=modalConfirm.text :icon=modalConfirm.icon @hide=hideModals @confirm=\"$broadcast('modal:confirmed')\"> </vk-modal-confirm> <products></products> </div>";

/***/ },
/* 258 */
/***/ function(module, exports) {

	module.exports = "<div class=zl-admin-products> <ul class=\"uk-subnav uk-subnav-pill uk-flex-center uk-margin-large-bottom\"> <li v-for=\"item in localMenu\" :class=\"{'uk-active': view === item}\" @click.prevent=switchView(item)> <a href=\"\" v-text=\"item | capitalize\"></a> </li> <li v-for=\"item in menu\"> <a :href=item.link v-text=item.name></a> </li> </ul> <div class=\"uk-margin uk-text-warning uk-text-center\" v-if=server.offline v-html=\"server.status\n      ? server.status\n      : `We are experiencing temporal connection issues with our server.\n        If it persist, please contact our support.`\"> </div> <component :is=view keep-alive transition=fade transition-mode=out-in> </component> </div>";

/***/ },
/* 259 */
/***/ function(module, exports) {

	module.exports = "<div> <div v-if=auth.status class=\"uk-text-center uk-flex-item-1\"> Authenticated as {{ auth.user }} <tm-button class=\"uk-button-danger uk-margin-left\" icon=sign-out title=\"Sign Out\" @click=logout> </tm-button> </div> <validator name=validation> <form v-if=!auth.status class=\"uk-form uk-flex uk-flex-middle uk-flex-space-between\" @submit.prevent=\"login(username, password) | validate\"> <div class=\"uk-grid uk-grid-small uk-flex-item-1\" data-uk-grid-margin> <div class=\"uk-width-large-1-3 uk-width-medium-1-1\"> <input autofocus class=\"uk-width-1-1 uk-form-small\" :class=\"{'uk-form-danger': validateField('username')}\" type=text placeholder=Username v-model=username v-validate:username=\"['required']\"> </div> <div class=\"uk-width-large-1-3 uk-width-medium-1-1\"> <input class=\"uk-width-1-1 uk-form-small\" :class=\"{'uk-form-danger': validateField('password')}\" type=password placeholder=Password v-model=password v-validate:password=\"['required']\"> </div> <div class=\"uk-width-large-1-3 uk-width-medium-1-1 uk-flex uk-flex-middle\"> <tm-button class=uk-align-center type=submit style=primary icon=sign-in title=\"Sign In\"> </tm-button> </div> </div> </form> </validator> <div v-if=auth.message class=\"uk-text-center uk-margin-top\" v-text=auth.message> </div> </div>";

/***/ },
/* 260 */
/***/ function(module, exports) {

	module.exports = "<div class=\"tm-row uk-flex uk-flex-wrap uk-flex-middle uk-visible-hover-inline\" :class=\"{ 'uk-text-muted': !subscribed && !installed }\" @click=\"operative && (selected = !selected)\"> <div class=\"uk-width-large-4-10 uk-width-medium-1-2 uk-width-small-1-2 uk-text-truncate tm-cursor-default\"> <span class=uk-icon-justify> <i v-if=\"operative && !selected && !isMobile\" :class=\"{\n          'tm-visible-toggle': !selected,\n          'uk-text-success': installed && enabled && !deprecated,\n          'uk-text-warning': installed && enabled && outdated && !deprecated,\n          'uk-text-danger': installed && enabled && deprecated,\n          'uk-icon-check': installed,\n          'uk-icon-level-down': outdated,\n          'uk-icon-exclamation': deprecated,\n          'uk-icon-unlock uk-text-muted': subscribed && !installed\n        }\"> </i> <i v-if=operative :class=\"{\n          'uk-hidden': !selected && !isMobile,\n          'uk-icon-square-o': !selected,\n          'uk-icon-check-square-o': selected\n        }\"> </i> <i v-else class=uk-icon-lock></i> </span> {{ title }} </div> <div class=\"uk-width-large-2-10 uk-width-small-1-2 uk-text-center tm-medium-right uk-hidden-medium\" :class=\"{\n      'uk-text-success': installed && enabled,\n      'uk-text-warning': outdated && enabled,\n      'uk-text-danger': deprecated && enabled\n    }\"> {{ installed ? installedVersion : version }} <span v-if=\"installed && outdated\"> / {{ version }} </span> </div> <div class=\"uk-width-large-4-10 uk-width-medium-1-2 uk-flex uk-flex-inline uk-flex-right uk-hidden-small\"> <tm-button v-if=\"type !== 'Core' && installed\" class=\"uk-invisible uk-button-danger uk-margin-small-left\" icon=trash-o :title=\"'Uninstall'\" @click.stop=$parent.uninstall([name])> </tm-button> <tm-button v-if=\"installed && (type === 'Plugin' || type === 'Extension') && type !== 'Core'\" class=uk-margin-small-left :class=\"{\n        'uk-invisible': !deprecated,\n        'uk-button-primary': deprecated\n      }\" :icon=\"enabled ? 'toggle-on' : 'toggle-off'\" :title=\"'Toggle Status'\" @click.stop=$parent.toggle([name])> </tm-button> <div v-if=subscribed class=\"uk-button-group uk-margin-small-left\"> <tm-button half :disabled=offline style=primary icon=download :title=\"'Download'\" @click.stop=$parent.download([name])> </tm-button> <tm-button half :disabled=offline style=primary :icon=\"!outdated && installed\n          ? 'retweet'\n          : 'bolt'\" :title=\"!outdated && installed\n          ? 'Reinstall'\n          : (installed ? 'Update' : 'Install')\" @click.stop=$parent.install([name])> </tm-button> </div> <tm-button v-if=\"!subscribed && !deprecated\" class=\"uk-button-primary uk-margin-small-left\" icon=ticket title=Subscribe :href=url> </tm-button> </div> <div class=\"uk-width-1-1 uk-margin-small-top\"><hr></div> </div>";

/***/ },
/* 261 */
/***/ function(module, exports) {

	module.exports = "<div> <div class=uk-grid v-show=displayed data-uk-grid-margin v-inject:toolbar> <div class=\"uk-width-large-2-3 uk-text-left\"> <div class=uk-grid data-uk-grid-margin> <div class=\"uk-width-medium-1-3 uk-width-small-1-1 tm-filter-bulk-width\"> <div class=uk-button-group> <tm-button disabled=disabled class=tm-button-medium-half> <i class=\"uk-icon-filter uk-hidden-large\"></i> <span class=uk-visible-large>Filter by</span> </tm-button> <tm-button half :style=\"filters.installed ? 'primary' : ''\" title=Installed icon=bolt @click=\"filters.installed = !filters.installed\"> </tm-button> <tm-button half :style=\"filters.outdated ? 'primary' : ''\" title=Outdated icon=level-down @click=\"filters.outdated = !filters.outdated\"> </tm-button> <tm-button half v-if=authenticated :style=\"filters.subscribed ? 'primary' : ''\" title=Subscribed icon=ticket @click=\"filters.subscribed = !filters.subscribed\"> </tm-button> </div> </div> <div class=\"uk-width-medium-1-3 uk-width-small-1-1 tm-filter-bulk-width\"> <div class=uk-button-group> <tm-button disabled=disabled class=tm-button-medium-half> <i class=\"uk-icon-check-circle-o uk-hidden-large\"></i> <span class=uk-visible-large>Bulk</span> </tm-button> <tm-button half style=primary :disabled=\"selected.length !== 0 && !validateSelected('download')\" title=\"Download all or selected\" icon=download @click=\"selected.length\n                ? download(selected)\n                : download(getSelection({ subscribed: true, outdated: true }))\"> </tm-button> <tm-button half style=primary :disabled=\"selected.length !== 0 && !validateSelected('install')\" :icon=\"'bolt'\" title=\"Install/Update all or selected\" @click=\"selected.length\n                ? install(selected)\n                : install(getSelection({ subscribed: true }))\"> </tm-button> <tm-button half style=primary :disabled=\"!validateSelected('toggle')\" title=\"Toggle selected\" icon=toggle-on @click=toggle(selected)> </tm-button> <tm-button half style=danger :disabled=\"!validateSelected('uninstall')\" title=\"Uninstall selected\" icon=trash-o @click=uninstall(selected)> </tm-button> <tm-button class=\"uk-hidden-large tm-button-medium-half\" v-show=selected.length title=\"Clear selection\" icon=times @click=\"selection = {}\"> </tm-button> </div> <tm-button half class=uk-visible-large v-show=selected.length title=\"Clear selection\" icon=times @click=\"selection = {}\"> </tm-button> </div> </div> </div> <div class=\"uk-width-large-1-3 uk-width-medium-1-3 uk-width-small-1-1 tm-large-right\"> <tm-button :disabled=server.offline title=\"Authenticate yourself\" :text=\"authenticated ? 'Authenticated' : 'Authenticate'\" @click=showAuth> </tm-button> <tm-button :disabled=server.offline title=\"Reload extensions list\" text=Reload @click=reload> </tm-button> </div> </div> <template v-for=\"(group, extensions) in grouped\"> <div class=\"uk-margin-large-top uk-text-bold\" v-text=group> </div> <extension v-for=\"ext in extensions\" track-by=name :type=ext.type :name=ext.name :title=ext.title :price=ext.price :version=ext.version :url=ext.url :installed=ext.installed :installed-version=ext.installedVersion :outdated=ext.outdated :core=ext.core :deprecated=ext.deprecated :enabled=ext.enabled :subscribed=ext.subscribed :download-url=ext.downloadUrl :selected.sync=selection[ext.name] :offline=server.offline> </extension> </template> </div>";

/***/ },
/* 262 */
/***/ function(module, exports) {

	module.exports = "<div class=\"tm-row uk-flex uk-flex-wrap uk-flex-middle uk-visible-hover-inline\" :class=\"{ 'uk-text-muted': !installed }\"> <div class=\"uk-width-large-4-10 uk-width-medium-1-2 uk-width-small-1-2 uk-text-truncate\"> <span :title=\"installed && isOutdated\n        ? 'The installed package is Outdated'\n        : !isKnown && !server.offline\n        ? 'This language has no started translations. Be the first one!'\n        : false\" data-uk-tooltip> <i class=uk-icon-justify :class=\"{\n          'uk-icon-check': installed && !isOutdated,\n          'uk-icon-level-down': installed && isOutdated,\n          'uk-icon-question': !isKnown && !server.offline,\n          'uk-text-success': installed && !isOutdated,\n          'uk-text-warning': installed && isOutdated,\n        }\"> </i> {{ name }} </span> </div> <div class=\"uk-width-large-2-10 uk-width-small-1-2 uk-text-center uk-hidden-medium tm-medium-right\" :class=\"{\n      'uk-text-success': completed >= 80,\n      'uk-text-warning': completed >= 30 && completed < 80,\n      'uk-text-danger': completed < 30\n    }\" title=\"Translation Progress\" data-uk-tooltip=\"{ delay: 500 }\" v-text=\"completed\n      ? completed + '%'\n      : ''\"> </div> <div class=\"uk-width-large-4-10 uk-width-medium-1-2 uk-flex uk-flex-inline uk-flex-right uk-hidden-small\"> <tm-button v-if=installed class=\"uk-invisible uk-button-danger uk-margin-small-left\" icon=trash-o title=Uninstall @click=\"uninstall(code, name)\"> </tm-button> <tm-button class=uk-margin-small-left :class=\"{\n        'uk-button-primary': !isKnown ,\n        'uk-invisible': isKnown\n      }\" icon=pencil :title=\"'Contribute'\" :href=url> </tm-button> <tm-button v-if=isKnown :disabled=server.offline class=\"uk-invisible uk-margin-small-left\" icon=download :title=\"'Download'\" @click=download(code)> </tm-button> <tm-button v-if=isKnown class=uk-margin-small-left style=primary :disabled=server.offline icon=bolt :icon=\"!isOutdated && installed ? 'retweet' : 'bolt'\" :title=\"!isOutdated && installed ? 'Reinstall' : (installed ? 'Update' : 'Install')\" @click=install(code)> </tm-button> </div> <div class=\"uk-width-1-1 uk-margin-small-top\"><hr></div> </div>";

/***/ },
/* 263 */
/***/ function(module, exports) {

	module.exports = "<div> <div class=tm-large-right v-show=displayed v-inject:toolbar> <tm-button :disabled=server.offline @click=showAuth :text=\"authenticated ? 'Authenticated' : 'Authenticate'\"> </tm-button> <tm-button :disabled=server.offline @click=reload text=Reload> </tm-button> <tm-button class=\"uk-visible-large uk-button-primary\" title=\"The Main Language Manager\" href=https://www.transifex.com/projects/p/zoolanders text=Transifex> </tm-button> </div> <div v-if=!languages.length class=\"uk-text-center uk-text-warning\"> Before proceeding please install the desired Joomla's language packs within the Joomla Language Manager. </div> <language v-for=\"lang in languages\" :name=lang.name :code=lang.code :completed=lang.completed :timestamp=lang.timestamp :installed=lang.installed :installed-version=lang.installedVersion :server=server :download=download :install=install :uninstall=confirmUninstall> </language> </div>";

/***/ },
/* 264 */
/***/ function(module, exports) {

	module.exports = "<button class=uk-button @click=clicked :class=\"[classes, {\n    'tm-button-half': half\n  }]\" :disabled=disabled :type=type :title=\"disabled ? '' : title\" :data-uk-tooltip=\"disabled ? false : '{ delay: 500 }'\"> <i v-if=icon class=\"uk-icon-justify uk-icon-{{ icon }}\"></i> {{ text }} <slot></slot> </button>";

/***/ },
/* 265 */
/***/ function(module, exports) {

	module.exports = "<div class=uk-modal v-el:modal> <div class=uk-modal-dialog :class=\"{\n      'uk-modal-dialog-large': large\n    }\"> <a href=\"\" class=\"uk-modal-close uk-close\" v-if=\"!block && !hideClose\"> </a> <div v-el:content class=uk-modal-content :class=\"{\n        'uk-overflow-container': overflow\n      }\"> <tm-spinner v-if=spinner></tm-spinner> <div v-else class=\"uk-modal-content uk-flex uk-flex-middle\"> <i class=\"uk-icon-large uk-icon-justify uk-margin-right\" v-if=icon.length :class=icon> </i> <span v-html=text></span> </div> </div> <div v-el:footer class=uk-modal-footer v-if=requestError :class=\"{\n        'uk-text-right': !requestErrorVisible\n      }\"> <tm-button v-if=!requestErrorVisible @click=\"requestErrorVisible = true\" text=\"Show details\"> </tm-button> <div v-else v-text=requestError></div> </div> </div> </div>";

/***/ },
/* 266 */
/***/ function(module, exports) {

	module.exports = "<div class=zl-admin-spinner> <div class=rect1></div> <div class=rect2></div> <div class=rect3></div> <div class=rect4></div> <div class=rect5></div> </div>";

/***/ },
/* 267 */
/***/ function(module, exports, __webpack_require__) {

	var __vue_script__, __vue_template__
	__webpack_require__(136)
	__vue_script__ = __webpack_require__(97)
	__vue_template__ = __webpack_require__(257)
	module.exports = __vue_script__ || {}
	if (module.exports.__esModule) module.exports = module.exports.default
	if (__vue_template__) {
	(typeof module.exports === "function" ? (module.exports.options || (module.exports.options = {})) : module.exports).template = __vue_template__
	}


/***/ },
/* 268 */
/***/ function(module, exports, __webpack_require__) {

	var __vue_script__, __vue_template__
	__webpack_require__(137)
	__vue_script__ = __webpack_require__(98)
	__vue_template__ = __webpack_require__(258)
	module.exports = __vue_script__ || {}
	if (module.exports.__esModule) module.exports = module.exports.default
	if (__vue_template__) {
	(typeof module.exports === "function" ? (module.exports.options || (module.exports.options = {})) : module.exports).template = __vue_template__
	}


/***/ },
/* 269 */
/***/ function(module, exports, __webpack_require__) {

	var __vue_script__, __vue_template__
	__vue_script__ = __webpack_require__(99)
	__vue_template__ = __webpack_require__(259)
	module.exports = __vue_script__ || {}
	if (module.exports.__esModule) module.exports = module.exports.default
	if (__vue_template__) {
	(typeof module.exports === "function" ? (module.exports.options || (module.exports.options = {})) : module.exports).template = __vue_template__
	}


/***/ },
/* 270 */
/***/ function(module, exports, __webpack_require__) {

	var __vue_script__, __vue_template__
	__webpack_require__(133)
	__vue_script__ = __webpack_require__(100)
	__vue_template__ = __webpack_require__(260)
	module.exports = __vue_script__ || {}
	if (module.exports.__esModule) module.exports = module.exports.default
	if (__vue_template__) {
	(typeof module.exports === "function" ? (module.exports.options || (module.exports.options = {})) : module.exports).template = __vue_template__
	}


/***/ },
/* 271 */
/***/ function(module, exports, __webpack_require__) {

	var __vue_script__, __vue_template__
	__webpack_require__(134)
	__vue_script__ = __webpack_require__(101)
	__vue_template__ = __webpack_require__(261)
	module.exports = __vue_script__ || {}
	if (module.exports.__esModule) module.exports = module.exports.default
	if (__vue_template__) {
	(typeof module.exports === "function" ? (module.exports.options || (module.exports.options = {})) : module.exports).template = __vue_template__
	}


/***/ },
/* 272 */
/***/ function(module, exports, __webpack_require__) {

	var __vue_script__, __vue_template__
	__webpack_require__(135)
	__vue_script__ = __webpack_require__(102)
	__vue_template__ = __webpack_require__(262)
	module.exports = __vue_script__ || {}
	if (module.exports.__esModule) module.exports = module.exports.default
	if (__vue_template__) {
	(typeof module.exports === "function" ? (module.exports.options || (module.exports.options = {})) : module.exports).template = __vue_template__
	}


/***/ },
/* 273 */
/***/ function(module, exports, __webpack_require__) {

	var __vue_script__, __vue_template__
	__vue_script__ = __webpack_require__(103)
	__vue_template__ = __webpack_require__(263)
	module.exports = __vue_script__ || {}
	if (module.exports.__esModule) module.exports = module.exports.default
	if (__vue_template__) {
	(typeof module.exports === "function" ? (module.exports.options || (module.exports.options = {})) : module.exports).template = __vue_template__
	}


/***/ },
/* 274 */
/***/ function(module, exports, __webpack_require__) {

	var __vue_script__, __vue_template__
	__vue_script__ = __webpack_require__(104)
	__vue_template__ = __webpack_require__(264)
	module.exports = __vue_script__ || {}
	if (module.exports.__esModule) module.exports = module.exports.default
	if (__vue_template__) {
	(typeof module.exports === "function" ? (module.exports.options || (module.exports.options = {})) : module.exports).template = __vue_template__
	}


/***/ },
/* 275 */
/***/ function(module, exports, __webpack_require__) {

	var __vue_script__, __vue_template__
	__vue_script__ = __webpack_require__(105)
	__vue_template__ = __webpack_require__(265)
	module.exports = __vue_script__ || {}
	if (module.exports.__esModule) module.exports = module.exports.default
	if (__vue_template__) {
	(typeof module.exports === "function" ? (module.exports.options || (module.exports.options = {})) : module.exports).template = __vue_template__
	}


/***/ },
/* 276 */
/***/ function(module, exports, __webpack_require__) {

	var __vue_script__, __vue_template__
	__webpack_require__(138)
	__vue_template__ = __webpack_require__(266)
	module.exports = __vue_script__ || {}
	if (module.exports.__esModule) module.exports = module.exports.default
	if (__vue_template__) {
	(typeof module.exports === "function" ? (module.exports.options || (module.exports.options = {})) : module.exports).template = __vue_template__
	}


/***/ },
/* 277 */
/***/ function(module, exports) {

	'use strict';
	
	// Credits: borrowed code from fcomb/redux-logger
	
	function createLogger() {
	  var _ref = arguments.length <= 0 || arguments[0] === undefined ? {} : arguments[0];
	
	  var _ref$collapsed = _ref.collapsed;
	  var collapsed = _ref$collapsed === undefined ? true : _ref$collapsed;
	  var _ref$transformer = _ref.transformer;
	  var transformer = _ref$transformer === undefined ? function (state) {
	    return state;
	  } : _ref$transformer;
	  var _ref$mutationTransfor = _ref.mutationTransformer;
	  var mutationTransformer = _ref$mutationTransfor === undefined ? function (mut) {
	    return mut;
	  } : _ref$mutationTransfor;
	
	  return {
	    snapshot: true,
	    onMutation: function onMutation(mutation, nextState, prevState) {
	      if (typeof console === 'undefined') {
	        return;
	      }
	      var time = new Date();
	      var formattedTime = ' @ ' + pad(time.getHours(), 2) + ':' + pad(time.getMinutes(), 2) + ':' + pad(time.getSeconds(), 2) + '.' + pad(time.getMilliseconds(), 3);
	      var formattedMutation = mutationTransformer(mutation);
	      var message = 'mutation ' + mutation.type + formattedTime;
	      var startMessage = collapsed ? console.groupCollapsed : console.group;
	
	      // render
	      try {
	        startMessage.call(console, message);
	      } catch (e) {
	        console.log(message);
	      }
	
	      console.log('%c prev state', 'color: #9E9E9E; font-weight: bold', prevState);
	      console.log('%c mutation', 'color: #03A9F4; font-weight: bold', formattedMutation);
	      console.log('%c next state', 'color: #4CAF50; font-weight: bold', nextState);
	
	      try {
	        console.groupEnd();
	      } catch (e) {
	        console.log('—— log end ——');
	      }
	    }
	  };
	}
	
	function repeat(str, times) {
	  return new Array(times + 1).join(str);
	}
	
	function pad(num, maxLength) {
	  return repeat('0', maxLength - num.toString().length) + num;
	}
	
	module.exports = createLogger;

/***/ },
/* 278 */
/***/ function(module, exports) {

	module.exports = function(module) {
		if(!module.webpackPolyfill) {
			module.deprecate = function() {};
			module.paths = [];
			// module.parent = undefined by default
			module.children = [];
			module.webpackPolyfill = 1;
		}
		return module;
	}


/***/ },
/* 279 */
/***/ function(module, exports) {

	module.exports = Vuex;

/***/ }
/******/ ]);


/** WEBPACK FOOTER **
 ** /manager.js
 **/